/* Bacci Kid Heartopedia engine asset  .  bacci-brave.js
   v44.0  .  2026-07-01 (v43.4 Teen Brave plus Supreme Simulation Layer)
   This build (intro polish): longer settle before the film (settleMs 2200) so
   the eye lands first; the intro no longer closes on a near-miss click (only
   Skip or Esc, unless CINEMATIC.tapToSkip true); a catchy "Watch the intro"
   replay button beside the switches, plus window.BKCinematic.play() for a
   custom hero button. Carries v43.3 shared motion level (window.BKMotion:
   Calm/Standard/Immersive, device default, opt-in Immersive AR on-ramp),
   v43.2 reduced-motion play, v43.1 final film + royal surround.
   Dr. Jamie J. Karia, DSW, LCSW  .  baccikid.com  .  zero em or en dashes. */
/* ===== EDIT  ===  CONFIG  ===  THE ONLY PART YOU TOUCH  === EDIT ===== */
const BK_HX_CONFIG = {
  SEO: {
    title: "Brave . The Bacci Kid Heartopedia, Entry 002 . Cinematic Feelings Coloring for Teens",
    description: "Color young Teen Bacci, read a cinematic emotional-learning story, meet the Hype Cheerleader Crew, and step into the Bacci Kid museum portals. A creative feelings experience by Dr. Jamie J. Karia, DSW, LCSW.",
  },
  LINKS: {
    trailer: "",                                              // paste a Bacci Kid cartoon trailer video URL (mp4 or YouTube) and a Watch the Trailer button appears
    mainHub: "/pages/bacci-kid-heartopedia-main-hub",        // Back to the main color hub (the real handle you will lock into)
    kpotHub: "/pages/kpot-main-hub",                          // Back to the KPOT hub
    wheel: "/pages/colour-to-wear-today",                     // the Spin a Feeling doorway
    bonusGames: [                                              // the glowing game buttons (add or remove freely; each can carry its own icon and tint)
      { label:"The Playful Pounce · Vol 1", url:"/pages/extra-games-01", icon:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Awesome_Extra_Credit_Bonus_only.png?v=1772751096", tint:"" },
      { label:"The Lucky Leap · Vol 2", url:"/pages/extra-bonus-games-02", icon:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Congratulations_You_won_this_Prize_only_1.png?v=1772482245", tint:"alt" }
    ],
    freePack: "/pages/free-coloring-pack",                    // adults only signup
    scanUrl: "https://baccikid.com/pages/bacci-kid-heartopedia-main-hub",
    disclaimerUrl: "",                                        // leave empty so the button opens the in page note card
    disclaimerFullUrl: "/pages/disclaimer",
    countdown: ""                                             // the countdown premiere page for the Next Tuesday lock card (empty keeps the card quiet)
  },
  qrImage: "",

  /* THE TUESDAY SHELF. Every entry this tier has ever had, newest first.
     Each Tuesday, add one line. here:true marks this page. Thumbs lazy
     load, so the shelf never slows the page. */
  GALLERY: [
    { entry:"002", name:"Brave", emoji:"🦁", here:true, url:"", thumb:"" }
    /* next Tuesday, add the new one above this line, for example:
    { entry:"003", name:"Calm", emoji:"🌊", url:"/pages/your-next-entry", thumb:"https://cdn.shopify.com/...png" } */
  ],

  /* THE BACCI ICON SET. Your own characters instead of plain emojis.
     Leave any slot empty ("") and that button keeps its emoji. */
  ICONS: {
    lesson:    "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/15_2a7a5ecd-79bd-4738-beaa-56e399ebe2da.png?v=1781223893",
    museum:    "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/mirror_card_onlly.png?v=1781224007",
    adventure: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/wild_card_only.png?v=1781224089",
    kpotLogo:  "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Kpot-Logo.svg?v=1762906411",
    notify:    "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Sensory_Sound_only.png?v=1781224664",
    soundOn:   "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/What_music_do_you_like_to_start_your_day_with_only_b798fa41-b929-452e-88f9-9c8d1b506941.png?v=1781225374",
    checkin:   "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Can_you_please_share_your_feelings_03de94c8-25ee-4fb7-8a50-95ed7329eb1b.png?v=1781225458"
  },

  /* v22 HYPE CHEERLEADER MODE. Tap the glowing button and a Bright Sparks
     cheerleader slides up with some hype, stays a moment, then waves off.
     Add or remove characters and lines freely. */
  HYPE: {
    enabled: true,
    crewName: "Hype Cheerleader Crew",
    button: "📣 Hype me!",
    characters: [
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/pineapple_3.png?v=1772514492", name:"Pretty Pineapple",
        lines:["You are one of a kind, just like me! 🍍","Sweet work, superstar! ✨","Stand tall and shine! 🍍💛"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Apple_1.png?v=1772514418", name:"Awesome Apple",
        lines:["You are awesome to the core! 🍎","One brave color at a time! ❤️","Crunch! That was brilliant! 🍎✨"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/kiwi.png?v=1772507636", name:"Kind Kiwi",
        lines:["Kindness looks beautiful on you! 🥝","Your heart is doing great things 💚","Small and mighty, just like me! 🥝"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/cherry.png?v=1772507937", name:"Cool Cherry",
        lines:["Stay cool, you are doing amazing! 🍒","Coolest artist on the block! 😎","Twice as sweet, that is you! 🍒🍒"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/watermelon.png?v=1772508065", name:"Wonderful Watermelon",
        lines:["You are wonderful, through and through! 🍉","So refreshing to watch you create! 💚","Big heart, big art! 🍉"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/orange.png?v=1772508932", name:"Optimistic Orange",
        lines:["The bright side looks good on you! 🍊","Keep that sunny spirit going! ☀️","You light up the page! 🍊"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/grape.png?v=1772514249", name:"Famous Grape",
        lines:["You are a star in the making! 🍇","A bunch of talent, that is you! 💜","Famously fabulous work! 🍇✨"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/lemon.png?v=1772514182", name:"Lovely Lemon",
        lines:["When life gives you colors, shine! 🍋","Zesty and bright, just like you! 💛","Lovely choice, artist! 🍋"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/banana_1.png?v=1772481971", name:"Brave Banana",
        lines:["Look how brave you are! 🍌","You can do hard things, I just saw it! 💪","Top banana, that is you! 🍌"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/carrot.png?v=1772508863", name:"Classic Carrot",
        lines:["A classic masterpiece in the making! 🥕","You see so clearly, keep going! 👀","Rooting for you, always! 🥕"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/corn_1.png?v=1772509376", name:"Calm Corn",
        lines:["Nice and calm, you have got this 🌽","One gentle step at a time 💛","So peaceful to watch you work 🌽"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Broccoli.png?v=1772508767", name:"Genius Broccoli",
        lines:["Now THAT is a genius color choice! 🥦","Your brain and heart make magic 💚","Brilliant, simply brilliant! 🥦✨"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/beet.png?v=1772484527", name:"Beautiful Beet",
        lines:["You cannot be beat! 💜","Beautiful inside and out! ✨","Your colors make my heart happy 💗"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/spinach.png?v=1772507066", name:"Sparkling Spinach",
        lines:["You are absolutely sparkling today! ✨","Strong and shining, that is you! 💚","I am cheering so hard right now! 📣"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/artichoke_1.png?v=1772506273", name:"Accepted Artichoke",
        lines:["You belong here, exactly as you are 💚","Layer by layer, you shine 💛","So glad you came to color today!"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/7_2b2eab4c-fd1e-4b45-80f2-f5daa3958e72.png?v=1771114553", name:"Laughing Bacci", lines:["Your joy is contagious! 😄","That made my whiskers wiggle! 😹","Keep that smile going! 😄💛"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/1_5656d832-41fc-4366-8abe-4aae6ec1bb6a.png?v=1771114552", name:"Excited Bacci", lines:["WOW! Look at you go! ✨","I literally cannot sit still, this is SO good! 🎉","Best part of my whole day, seeing this! ⭐"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/grateful_2_1.png?v=1772506520", name:"Grateful Bacci", lines:["I am so grateful for YOU 💜","Thank you for being here today 🙏💛","You make this world warmer 💜"] },
      { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Bacci_0267ead1-4c48-4782-9276-7dc98f8c204b.png?v=1760395200", name:"MVP Bacci", lines:["You are the real MVP! ⭐","Champions take their time, just like you 🏆","Proud of you. Truly. ⭐💛"] }
    ],
    phrases: [
      "Look at you go! 🌟", "Your colors are glowing! ✨", "So brave, so bright! 💜",
      "That is YOUR masterpiece! 🎨", "The Bright Sparks see you shining! 📣",
      "One color at a time, superstar! 🌈", "Bacci is cheering for you! 🐾",
      "Wow, that choice! Chef kiss! 💋", "Keep going, the museum is waiting! 🖼️",
      "You make Tuesdays magical! 🎉"
    ]
  },

  /* v22 motion magic. tilt: the coloring paper leans gently toward your cursor,
     and freezes the moment you start coloring so your lines stay perfect.
     coinSpin: a slow spinning gold phoenix coin on the bonus game buttons. */
  FX: { tilt: true, coinSpin: true },

  /* THE STICKER LIBRARY. Parked here, ready for the sticker book phase.
     The kitty voice ribbons, in one place. */
  STICKER_LIBRARY: [
    { name:"Kitty Cat Whisper",          url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Kitty_cat_whisper_b8ed4ee1-bfd7-4159-8bfa-42b634b7a98c.png?v=1781224178" },
    { name:"Kitty Cat Indoor Meows",     url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Kitty_cat_indoor_meows_5f1d56da-1190-46aa-95e4-0fcac46d272c.png?v=1781224178" },
    { name:"Kitty Cat Outdoor Meows",    url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Kitty_cat_outdoor_meows_Converted_1fd0033d-45a0-49dc-9142-8bf1a4934211.png?v=1781224178" },
    { name:"Kitty Cat Speaker Meows",    url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Kitty_cat_speaker_meows_Converted_d2f7ba38-66b1-44e3-98f5-839b4bd3c94f.png?v=1781224178" },
    { name:"Shh Kitty Cat Silence",      url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Shh_kitty_cat_silence_ceef92d1-a287-4c18-81ec-ef8a6aa96262.png?v=1781224178" },
    { name:"Kitty Cat Table Meows",      url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Kitty_cat_table_meows_260d5198-c6b5-4482-857c-78e2ab5de8e3.png?v=1781224178" },
    { name:"Kitty Cat Active Listening", url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Kitty_cat_active_listening_d3781044-8a71-4fc6-b5d1-2989ff65e368.png?v=1781224178" }
  ],

  /* THE AUTHOR'S NOTE in the museum. One line, swap any time. */
  MUSEUM_NOTE: "Dr. Jamie sends you positive energy. I cannot wait to see what you create next. Keep coloring with your whole heart.",

  /* THE MUSEUM ROOM. Paste the Shopify CDN URL of your Bacci Kid Museum
     artwork (the one with the four empty gold frames) into backgroundUrl
     and the museum popup becomes a real room: the artist's saved pieces
     hang inside those exact frames. Fill all four to earn the Museum
     Sticker. portalUrl can point at a simple Coming Soon page for the
     Museum Portals world; leave it empty to hide the door. The frames
     numbers are measured from the artwork itself; do not change them
     unless you swap the artwork. */
  MUSEUM_ROOM: {
    backgroundUrl: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/ChatGPT_Image_Jun_7_2026_02_16_06_AM_10.png?v=1780813120",
    portalUrl: "/pages/bacci-kid-museum-portals",
    portalLabel: "🏛️ Explore the Museum Portals",
    stickerName: "The Museum Sticker",
    frames: [
      { left:11.2, top:25.6, width:14.3, height:23.2 },
      { left:74.1, top:25.2, width:14.8, height:23.7 },
      { left:6.1,  top:63.4, width:15.2, height:24.5 },
      { left:78.2, top:63.4, width:15.5, height:24.5 }
    ]
  },

  /* SEE IT FRAMED. The square jewel frame for the preview popup.
     Swap the URL for any square frame in the Library; inset is that
     frame's video inset number. */
  PREVIEW_FRAME: {
    url: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/baroque-gold-portal-frame-transparent_1.png?v=1781114714",
    inset: 17
  },
  /* v27: the rotating frame gallery. Every "See it framed" shows the next jewel
     frame, so each reveal feels new. Each frame carries its own window inset
     (the Library's video inset numbers). Remove any line to retire a frame. */
  PREVIEW_FRAMES: [
    { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/baroque-gold-portal-frame-transparent_1.png?v=1781114714", inset:17 },
    { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/01-celestial-crown-ultra-bling-frame-transparent_1.png?v=1781114715", inset:24 },
    { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/02-royal-diamond-palace-ultra-bling-frame-transparent_1.png?v=1781114714", inset:21 },
    { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/03-ruby-sapphire-regal-ultra-bling-frame-transparent_2.png?v=1781114714", inset:19.5 },
    { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/04-diamond-frost-moonstone-ultra-bling-frame-transparent_1.png?v=1781114716", inset:22.5 },
    { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/05-solar-topaz-sunburst-ultra-bling-frame-transparent__3.png?v=1781114714", inset:21.5 },
    { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/06-cosmic-amethyst-royal-ultra-bling-frame-transparent__1.png?v=1781114715", inset:22.5 },
    { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/07-lotus-mandala-jewel-ultra-bling-frame-transparent_1.png?v=1781114715", inset:21.5 },
    { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/08-rose-gold-couture-diamond-ultra-bling-frame-transparent_1.png?v=1781114715", inset:22 },
    { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/09-byzantine-cathedral-jewel-ultra-bling-frame-transparent_1.png?v=1781114714", inset:23 },
    { url:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/10-futuristic-hologold-diamond-ultra-bling-frame-transparent_1.png?v=1781114715", inset:24.5 }
  ],

  /* The black and white (fillable) line art for this episode. Matches the colored example. */
  lineArtUrl: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Bacci_Kid_Superhero_Coloring_Page_HighRes_Black_LineArt_Transparent_4.png?v=1781066164",

  /* Optional intro clip that plays in the canvas box before coloring (the "Bring me to life" moment). Leave empty to skip it. */
  videoUrl: "https://cdn.shopify.com/videos/c/o/v/c925f4719b3242babece1c91d4fde8fa.mp4",
  videoCTA: "Bring me to life",

  /* THE CINEMATIC INTRO. A full screen brand film that plays once per visitor
     before the page, with a Skip button visible from the first second. Reusable:
     paste this same block, with the same storageKey, into any hub or page that
     uses this engine, and a visitor sees it only once across the whole site.
     enabled:false turns it off. oncePerVisitor:false plays it every time. */
  CINEMATIC: {
    enabled: true,
    url: "https://cdn.shopify.com/videos/c/o/v/ba80cd1b60e447df92601185648c4b01.mp4",
    poster: "",
    oncePerVisitor: true,
    storageKey: "bk_cinematic_seen",
    skipLabel: "Skip ›  건너뛰기",
    soundLabel: "🔊 Sound  소리",
    /* THE ROYAL SURROUND (the cinematic frame around the film). */
    fit: "contain",     /* contain keeps the whole film and shows the portal; cover fills and crops the edges */
    portal: true,       /* cosmic depth, a rotating aura, a pulsing glow, drifting light motes */
    columns: true,      /* the grand gold light pillars on the left and right */
    emerge: true,       /* the film glides gently forward, the coming toward you feeling */
    settleMs: 2200,     /* the calm hold before the film begins, so the eye can settle. Raise for a longer pause. */
    tapToSkip: false,   /* false: only the Skip button or Esc closes it (no accidental dismiss from a near-miss click). true: a click anywhere closes it. */
    replayButton: true, /* a catchy "Watch the intro" button beside the language and motion switches, to summon the full film any time */
    replayLabel: "✨ Watch the intro  ·  소개 영상",
    reducedMotionSkip: false  /* false: reduced-motion visitors still see the film on a calm, static surround. true: skip the intro entirely for them */
  },

  /* THE SHARED MOTION LEVEL. One dial every page with significant motion reads
     (this intro now; the enter portal, the framed clips, and the subhubs as they
     are wired). Three levels: calm, standard, immersive. The default ALWAYS
     follows the visitor's device: a reduced-motion device starts on calm and
     still sees the film. immersive is opt in only, never forced. It is the on
     ramp to the Step Inside rung (parallax and tilt now, AR and VR later). */
  MOTION: {
    enabled: true,
    default: "auto",          /* auto follows the device. Or force "calm" / "standard" (never auto-force "immersive"). */
    showToggle: true,         /* the small in-experience toggle that sits beside the language switch */
    label: "Motion",
    calmLabel: "🍃 Calm",
    standardLabel: "✨ Standard",
    immersiveLabel: "🌀 Immersive",
    immersiveNote: "Step Inside · AR coming",   /* a transparent hook, shown on the immersive option. No fake VR button. */
    storageKey: "bk_motion_level"
  },

  /* The colored version, Bacci's original vision. Powers the preview toggle and the fade. Leave empty to hide the toggle. */
  coloredUrl: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Bacci_Kid_Superhero_Colored_Example_HighRes_Transparent_1.png?v=1781064665",

  /* The gold Phoenix, used as the certificate seal and the congrats Phoenix.
     NOTE: the old ChatGPT_..._05_09_58_PM_5 link resolves to the Good Morning Sunshine cat in the store, so we use the real gold Phoenix logo. */
  emblemUrl: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/logo_gold_concept_50_29ce2fb7-038b-4996-aabb-e5d1f4224489.png?v=1760460576",

  /* The branding crest at the top of the page. Defaults to the Phoenix. Put any hi-res PNG here. */
  crestUrl: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/logo_gold_concept_50_29ce2fb7-038b-4996-aabb-e5d1f4224489.png?v=1760460576",

  /* The icon inside the Bonus Family Games button (the Awesome Extra Credit coins bag). Its own slot so it never reuses the certificate seal. */
  bonusIcon: "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Awesome_Extra_Credit_Bonus_only.png?v=1772751096",

  ENTRY: {
    number: "002",
    word: "Brave",
    ko: "용감", pron: "yong gam",
    tier: "Teens",
    /* the captivating hook line under the title */
    hook: "Brave is not feeling no fear. It is turning around when you hear someone crying, even when that someone is you.",
    /* THE STORYLINE (locked, from the cheat sheet) */
    story: "The first time Bacci jumped through time, the world tore open like light through a curtain. One blink, he was small. The next, he was tall. He landed on a rooftop he had never seen. The city glowed for miles below him. Not one soul in it knew his name. His new heart felt too big for his chest. It pounded. His eyes flickered from green to a frightened gray, the way they always do when he is afraid. Then he heard it. Crying. He turned. There, in a small pool of moonlight, sat a kitten. Tiny. Shaking. A little crooked tail curled behind it. Bacci knew that tail. He knew that kitten. It was him. The younger him. The one the world had once called wrong. The little one looked up. They laughed at me, he whispered. Because I am different. Every part of teen Bacci wanted to run. He did not have the right words. He did not feel ready. He was not even sure he was brave. But the small one needed someone. So Bacci knelt down into the light. He let his hands shake. He let the fear stay right where it was. Then he said the truest thing he knew. The thing they laughed at is the thing that will make you fly. The kitten blinked. Its crooked tail lifted, just a little. And right there, scared and far from home, Bacci finally understood the secret almost no one says out loud. Brave is not feeling no fear. Brave is turning around when you hear someone crying. Even when that someone is you. His eyes warmed back to green. The gold on his chest caught the light. Across time, a small kitten with a crooked tail began to believe he would grow into someone strong. He was right. He grew into you.",
    /* the warm off ramp, ends on the open door, never on the worry */
    closing: "Bacci kept this story because it helped him on the days that felt too big. Maybe one day it helps you. Maybe it does not. Either way, it is yours now. There is more whenever you want it. More feelings to color. More of Bacci's crew to meet. A new story every Tuesday. The door is open. Come back any time you like.",
    feelsLike: "A steady warmth in the chest. A quiet I can do this, even while your tummy flutters and your hands feel buzzy. Brave is not the absence of fear. It is doing the kind, true thing while the fear is still in the room.",
    whenYouFeelIt: "The first day. Raising your hand. Saying sorry first. Standing up for a friend. Trying the hard thing one more time after it did not work.",
    funFact: "Fun fact: being brave and being scared make your heart beat the same fast way. Your body cannot always tell them apart, which is exactly why you can feel both at once and still go.",
    worldNote: "In Korean, brave is 용감 (yong-gam). Around the world, courage almost never means fearless. It means the heart that moves anyway.",
    worldKo: "용감",        // the word to pronounce out loud in this section
    worldRom: "yong-gam",   // how to say it
    worldEn: "brave",       // the English meaning spoken after
    prompt: "Name one brave thing you did this week, even a tiny one. What did your body feel right before you did it?",
    bacciLine: "Bacci says: brave is a muscle. Every small try makes it bigger. I have seen yours. You already have it."
  },
  MANTRA: "I can feel afraid and be brave at the same time. I take the next small step.",
  FUNFACTS: [
    "Fun fact: being brave and being scared make your heart beat the same fast way. That is why you can feel both at once and still go.",
    "Fun fact: courage grows by use. Scientists find that doing one small scary thing makes the next one feel a little easier. Brave is a muscle.",
    "Fun fact: taking one slow breath before a hard moment tells your body you are safe enough to be brave. Breathe, then go."
  ],
  NEXT: "Curious",
  BADGE: { emoji:"🦁", name:"Brave", earnAfter:6,
           image:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/images-2_08.png?v=1781283291",
           earnMsg:"You earned the Brave sticker for noticing courage, the kind that feels the fear and steps forward anyway. That is real emotional skill." },

  /* curated palettes (paste more from your Cozy CONFIG anytime) */
  PALETTES: [
    { name:"Feelings", colors:["#14A8A6","#E23744","#FFC542","#FF6FAE","#7FE3D2","#A06CF0","#FFB07A","#5BB8FF","#FFD6E7","#FF8A3D","#0D5B5E","#FFFFFF"] },
    { name:"Soft and Peaceful", colors:["#FFC2DE","#F6BEF0","#DCBEFF","#C2CCFF","#B8E2FF","#B0F0E6","#C6F7C9","#FFF1A6","#FFD9B0","#FF9EC4","#FFFFFF"] },
    { name:"Bold and Brave", colors:["#0D5B5E","#148A86","#1E2A6B","#6A1B9A","#B5184E","#E23744","#FF6F3C","#D4A437","#2E7DA8","#04161A","#F4ECD8"] },
    { name:"Tokyo Neon", colors:["#19E0E8","#18FFC2","#B6FF1A","#FFE600","#FF8A00","#FF2D78","#FF61E6","#C04CFD","#7A3CFF","#2D6BFF","#0B1026"] },
    { name:"Candy Pop", colors:["#FF6FAE","#FF9CC7","#E93F82","#FF7A59","#FFB347","#FFD54A","#7CE0B0","#5BC8FF","#8E7CFF","#B68CFF","#FFFFFF"] },
    { name:"Ocean Dream", colors:["#083D44","#0D5B5E","#148A86","#00C6C6","#7FE0D6","#5BC8FF","#2E7DA8","#FFD54A","#FF8C69","#FF6FAE","#FFF7EC"] },
    { name:"Golden Hour", colors:["#7A3B12","#C75146","#D4A437","#E6C47A","#F4A259","#FF8C69","#FF6F91","#E93F82","#FFB6A3","#FFE8C7","#FFFFFF"] },
    { name:"Bacci Signature", colors:["#04161A","#083D44","#0D5B5E","#148A86","#00C6C6","#7FE0D6","#C9F3EB","#A7E8B0","#5FC98C","#2E7DA8","#5BC8FF","#9FB4F2","#B6A6E8","#C9A0E0","#FFE600","#FFD54A","#E6C47A","#FF9E3D","#FF7A59","#FFD6E7","#FF6FAE","#E93F82","#E23744","#FFF7EC"] },
    { name:"K-Pop Idol", colors:["#FF4FA0","#FF6FAE","#FF8FC4","#FFB3D9","#E93F82","#C04CFD","#A24CF0","#8A5CF0","#7A3CFF","#2D6BFF","#3AA0FF","#19C3D8","#00E5FF","#18FFC2","#B6FF1A","#FFE600","#FF6F3C","#FFFFFF"] },
    { name:"Fandom Lights", colors:["#2ECC71","#39FF6A","#19C3D8","#2D6BFF","#7A3CFF","#A24CF0","#C04CFD","#FF2FB3","#FF6FAE","#FFC400","#FFE600","#FF6F3C","#E23744","#FFFFFF"] },
    { name:"Seoul Neon Nights", colors:["#0B1026","#FF2D78","#FF61E6","#FF2FB3","#C04CFD","#7A3CFF","#2D6BFF","#00E5FF","#19FFD0","#39FF6A","#B6FF1A","#FFE600","#FF8A00","#FFFFFF"] },
    { name:"Holographic Candy", colors:["#FF8FD0","#FFB3E6","#C9A6FF","#A6C8FF","#A6F0FF","#B6FFE0","#D6FFB0","#FFF3A6","#FFC9A6","#FF9EC4","#9ED8FF","#C6A6FF","#FFFFFF"] },
    { name:"Full Spectrum", colors:["#000000","#5A5A5A","#9B9B9B","#FFFFFF","#E23744","#FF6F3C","#FFB400","#FFE600","#8BC34A","#1FA37A","#19C3D8","#2D6BFF","#6A3CFF","#A24CF0","#FF6FAE","#E93F82","#7A3B12"] }
  ],
  /* colors are feelings: each carries a unique Bacci Kid name, an emotion, Korean, and a voice */
  FEELINGS: {
    "#14A8A6":{name:"Calm Tide",     feel:"Calm",     ko:"평온",   rom:"pyeong-on"},
    "#E23744":{name:"Brave Ember",   feel:"Brave",    ko:"용감",   rom:"yong-gam"},
    "#FFC542":{name:"Sunbeam Joy",   feel:"Joy",      ko:"기쁨",   rom:"gi-ppeum"},
    "#FF6FAE":{name:"Kindness Bloom",feel:"Kind",     ko:"친절",   rom:"chin-jeol"},
    "#7FE3D2":{name:"Hope Mist",     feel:"Hope",     ko:"희망",   rom:"hui-mang"},
    "#A06CF0":{name:"Wonder Violet", feel:"Curious",  ko:"호기심", rom:"ho-gi-sim"},
    "#FFB07A":{name:"Cozy Glow",     feel:"Cozy",     ko:"아늑함", rom:"a-neuk-ham"},
    "#5BB8FF":{name:"Peaceful Sky",  feel:"Peace",    ko:"평화",   rom:"pyeong-hwa"},
    "#FFD6E7":{name:"Grateful Blush",feel:"Grateful", ko:"감사",   rom:"gam-sa"},
    "#FF8A3D":{name:"Silly Spark",   feel:"Silly",    ko:"장난",   rom:"jang-nan"},
    "#0D5B5E":{name:"Deep Steady",   feel:"Steady",   ko:"단단함", rom:"dan-dan-ham"},
    "#FFFFFF":{name:"Snow Soft",     feel:"Clear",    ko:"맑음",   rom:"malg-eum"}
  },
  TEXTURES: [
    {id:"smooth", emoji:"⬜", name:"Smooth"},
    {id:"leopard",emoji:"🐆", name:"Leopard"},
    {id:"cheetah",emoji:"🐾", name:"Cheetah"},
    {id:"waves",  emoji:"🌊", name:"Waves"},
    {id:"dots",   emoji:"⚪", name:"Dots"},
    {id:"stripes",emoji:"📊", name:"Stripes"},
    {id:"glitter",emoji:"💎", name:"Glitter"}
  ],
  FINISHES: [
    {id:"marker", emoji:"🖊️", name:"Bold Marker"},
    {id:"crayon", emoji:"🖍️", name:"Cozy Crayon"},
    {id:"watercolor", emoji:"🎨", name:"Dreamy Watercolor"},
    {id:"glow", emoji:"✨", name:"Glow Magic"},
    {id:"bling", emoji:"💖", name:"Bling Shine"}
  ],
  /* age toggles. here:true is this page. others link to the real Shopify handles. */
  AGES: [
    {id:"little", emoji:"🧸", name:"Toddler", url:"/pages/bacci-kid-heartopedia-toddler-hub"},
    {id:"kids",   emoji:"🖍️", name:"Kids",        url:"/pages/bacci-kid-heartopedia-kid-hub"},
    {id:"tweens", emoji:"🌟", name:"Tweens",      url:"/pages/bacci-kid-heartopedia-tween-hub"},
    {id:"teens",  emoji:"🎧", name:"Teens",       here:true},
    {id:"adults", emoji:"☕", name:"Grown ups",   url:"/pages/bacci-kid-heartopedia-adult-hub"},
    {id:"seniors",emoji:"🌿", name:"Seniors",     url:"/pages/bacci-kid-heartopedia-senior-hub"}
  ],
  /* The Bright Sparks, your hype crew. Each is a Spark (a Phoenix ember). They speak only as an offer, never an assumption. */
  CHEERS: [
    {who:"Pretty Pineapple", line:"There is no wrong way to color. Only your way. I am cheering for it."},
    {who:"Brave Banana",     line:"If a part feels scary to start, you can start with the easy bit. I will be right here."},
    {who:"Kind Kiwi",        line:"Take a slow breath with me if you like. In, and out. No rush at all."},
    {who:"Awesome Apple",    line:"Every color you pick is a little feeling. I love watching you choose."},
    {who:"Cool Cherry",      line:"Brave and scared can feel the same. You are doing beautifully either way."},
    {who:"Pretty Pineapple", line:"Whenever you are ready for the next part, it is waiting. And so am I."}
  ],
  /* the gentle mood meter check in (optional, calm, never a test) */
  MOOD: {
    intro:"Before you color, you can check in with how you feel. Only if you want to.",
    options:[
      {emoji:"🌞", label:"Bright",  reply:"Bright is lovely. Let's pour some of that into the picture."},
      {emoji:"🌤️", label:"Okay",   reply:"Okay is a real and fine place to be. Coloring can keep it company."},
      {emoji:"🌥️", label:"Low",    reply:"Thank you for noticing that. Go gentle. One soft color at a time is plenty."},
      {emoji:"🌧️", label:"Heavy",  reply:"That sounds like a lot to carry. There is no goal here. Just color, or just rest. The door stays open."},
      {emoji:"🤔", label:"Not sure",reply:"Not sure is allowed. Maybe a color will help you find the word. Maybe not. Either way is okay."}
    ]
  },
  /* v14: THE STORYBOOK. The "Brave, up close" section now lives inside a real book
     that flips open. Edit the cover words here. Swap the title any time, one line. */
  BOOK: {
    kicker: "From the Bacci Kid library",
    title: "The Heartopedia",
    subtitle: "Bacci Kid's Book of Big Feelings",
    entry: "Entry 002 · Brave",
    byline: "by Dr. Jamie J. Karia, DSW, LCSW",
    /* v28: the rail crew. Each chapter icon gets a Bacci character that pops to the side on hover. Swap any URL. */
    railChars: {
      story:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Fun_Reading_Time_only_2.png?v=1767476500",
      toyou:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Design_2_character.png?v=1781310055",
      feels:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/32.png?v=1771541414",
      when:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Wonderful_effort_at_school_today_2.png?v=1781309172",
      world:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/1_93b9a92f-22c2-447e-b8e2-f0566c64f907.png?v=1771630654",
      know:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Broccoli.png?v=1772508767",
      turn:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Design_6_character.png?v=1781310108",
      mantra:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/29.png?v=1771541414"
    },
    endNote: "The End 💛 A new story lands next Tuesday.",
    open: "Open the book",
    chapters: [
      {id:"story",   emoji:"📖", label:"Bacci's story"},
      {id:"toyou",   emoji:"💌", label:"From Bacci, to you"},
      {id:"feels",   emoji:"💗", label:"What it feels like"},
      {id:"when",    emoji:"🕰️", label:"When you might feel it"},
      {id:"world",   emoji:"🌍", label:"Feelings around the world"},
      {id:"know",    emoji:"💡", label:"Did you know"},
      {id:"turn",    emoji:"✏️", label:"Your turn"},
      {id:"mantra",  emoji:"✨", label:"The Bacci Kid Mantra"}
    ],
    /* READ ALOUD. English works right away (it reads the page on screen).
       For Korean, paste your reviewed Korean text per chapter below.
       The Korean button appears by itself on any page that has text here. */
    /* DRAFT Korean (machine-assisted). Native-speaker review required before launch. */
    korean: {
      story:"바치가 처음 시간을 뛰어넘었을 때, 세상은 커튼 사이로 비치는 빛처럼 갈라졌어요. 한 번 눈을 깜빡이니 작아졌고, 다시 깜빡이니 키가 컸어요. 한 번도 본 적 없는 옥상에 내려섰어요. 그곳에는 그의 이름을 아는 사람이 하나도 없었어요. 그때 울음소리가 들렸어요. 그는 돌아섰어요. 작은 달빛 웅덩이 속에, 구부러진 꼬리를 가진 새끼 고양이가 떨며 앉아 있었어요. 바치는 그 고양이를 알았어요. 바로 어린 시절의 자기 자신이었어요. '다들 나를 비웃었어, 내가 다르니까' 하고 작은 아이가 속삭였어요. 십 대의 바치는 도망치고 싶었지만, 빛 속으로 무릎을 꿇고 두려움이 그대로 있게 두었어요. 그리고 말했어요. '사람들이 비웃은 그것이 바로 너를 날게 해 줄 거야.' 바로 그곳에서 바치는 깨달았어요. 용감함은 두려움이 없는 게 아니에요. 누군가 우는 소리를 들었을 때 돌아서는 거예요. 그 누군가가 바로 나일 때에도요. 시간을 건너, 작은 고양이는 자신이 강한 누군가로 자라리라 믿기 시작했어요. 그리고 자라서 바로 너가 되었어요.",
      toyou:"바치는 너무 벅찬 날들에 도움이 되었기에 이 이야기를 간직했어요. 언젠가 너에게도 도움이 될지 몰라요. 어느 쪽이든, 이제 이건 너의 것이에요. 원할 때면 언제든 더 있어요. 매주 화요일 새로운 이야기도요. 문은 열려 있어요. 언제든 다시 와요.",
      feels:"가슴속의 한결같은 따뜻함. 배 속이 간질거리고 손이 찌릿해도 '나는 할 수 있어' 하는 조용한 마음. 용감함은 두려움이 없는 게 아니에요. 두려움이 아직 방 안에 있는데도 다정하고 진실한 일을 하는 거예요.",
      when:"첫날. 손을 드는 일. 먼저 미안하다고 말하는 일. 친구를 위해 나서는 일. 잘 안 된 뒤에도 어려운 일을 한 번 더 해 보는 일.",
      world:"한국어로 용감함은 '용감'이에요. 세계 어디에서나 용기는 두려움이 없다는 뜻이 거의 아니에요. 그래도 움직이는 마음을 뜻해요.",
      know:"재미있는 사실: 용감할 때와 무서울 때, 심장은 똑같이 빠르게 뛰어요. 우리 몸은 그 둘을 늘 구별하지는 못해요. 그래서 두 가지를 동시에 느끼면서도 나아갈 수 있어요.",
      turn:"이번 주에 네가 한 용감한 일 하나를 말해 봐요. 아주 작은 것도 좋아요. 그 일을 하기 직전에 네 몸은 어떤 느낌이었나요?",
      mantra:"나는 두려우면서도 동시에 용감할 수 있어요. 나는 다음 작은 한 걸음을 내디뎌요."
    }
  },
  /* v28: the warm finish. Bacci speaks when the sticker is earned. */
  DONE: { msg:"You did it, superstar! Your Brave sticker is yours, a gift from Bacci, Princess Love, Prince GQ, and UniKym, from our hearts to yours. Your certificate is waiting below. Save this masterpiece, or start a brand new one anytime." },
  /* v29: the one line that tells everyone what this place is. */
  TAGLINE: "A coloring page, a storybook, and a museum of feelings, all in one.",
  /* v30: the mindful break. Bacci offers a tiny breathing pause after a while. */
  BREAK: { enabled:true, minutes:14,
    img:"https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Mindfulness_breathing_only_1.png?v=1772494924",
    msg:"You have been creating for a while 💛 Want a tiny breathing break with me?" },
  /* v30: the prize reveal. Paste the video URL and the whole celebration lights up.
     posterUrl shows before play. secretUrl is the Vault of Hearts page (optional). */
  PRIZE: { videoUrl:"", posterUrl:"", secretUrl:"",
    invite:"You won a Bacci Kid prize! 🎁 Tap to open!" },
  MASCOT: { hello:"Hi, I'm Bacci! Pick a color you love, then tap inside the picture to fill it. Have fun!" },
  DISCLAIMER: "The Bacci Kid Heartopedia is a playful, creative tool to help grow feelings vocabulary, calm, and courage. It is made by a licensed clinician but it is not therapy, diagnosis, or medical advice. Stickers, badges, and Bacci Kid Gold Coins are earned, just for fun, have no cash value, and cannot be redeemed for money or merchandise. All Bacci Kid artwork and characters remain the property of Bacci Kid: coloring a page does not transfer any ownership, and your colored copy is yours to enjoy, save, and print for personal, non commercial use only. Nothing you color or type is saved off this device or sent anywhere. Email signups are for adults (18 plus), for the child in your life. © 2026 Bacci Kid. All rights reserved.",
  SIGNUP: {
    headline:"Get next Tuesday's feeling, free",
    sub:"A grown up signs up, and we send a new free coloring feeling every Tuesday. No ads. Nothing ever leaves your child's device.",
    placeholder:"Grown up's email", button:"Send my free Tuesday feeling",
    consent:"I am 18 or older and signing up for the child in my life.",
    thanks:"Thank you. Look out for a new feeling to color every Tuesday.",
    action:"/contact"
  },
  CTA: "A new feeling to color, every Tuesday. Always free, always yours.",
  ownership: "Bacci Kid characters and artwork © Dr. Jamie J. Karia. Some backgrounds are AI assisted. All Bacci Kid characters are her original creations. Coloring pages are licensed for personal, non commercial use only. Coloring a page does not transfer any rights in the underlying artwork or characters; colored versions may be saved and printed for personal enjoyment and may not be sold, published commercially, or used to create products."
};
/* =====================  END CONFIG  ===================== */


/* ===== SHARED MOTION LEVEL  .  window.BKMotion  .  one dial, read by every page =====
   Sets data-bk-motion on <html> as early as possible. resolve order:
   1) the visitor's explicit saved choice (calm | standard | immersive),
   2) a configured non-immersive default, 3) auto: device reduced-motion -> calm, else standard.
   immersive is never auto; it is opt in only. Other components read BKMotion.get()
   and/or the html[data-bk-motion] attribute. */
(function(){
  var C=(typeof BK_HX_CONFIG!=='undefined')?BK_HX_CONFIG:null;
  var M=(C&&C.MOTION)||{};
  var KEY=M.storageKey||'bk_motion_level';
  var OK={calm:1,standard:1,immersive:1};
  function reduced(){ try{ return !!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches); }catch(e){ return false; } }
  function stored(){ try{ var v=localStorage.getItem(KEY); return OK[v]?v:null; }catch(e){ return null; } }
  function resolve(){
    var s=stored(); if(s) return s;
    var d=M.default; if(d&&OK[d]&&d!=='immersive') return d;
    return reduced()?'calm':'standard';
  }
  function apply(l){ try{ document.documentElement.setAttribute('data-bk-motion',l); }catch(e){} }
  function fire(l){ try{ window.dispatchEvent(new CustomEvent('bk-motion-change',{detail:{level:l}})); }catch(e){} }
  function set(l){ if(!OK[l]) return; try{ localStorage.setItem(KEY,l); }catch(e){} apply(l); fire(l); }
  function get(){ return resolve(); }
  apply(resolve());
  /* if the OS setting flips and the visitor has made no explicit choice, follow it */
  try{ var mq=window.matchMedia('(prefers-reduced-motion: reduce)'); if(mq&&mq.addEventListener){ mq.addEventListener('change',function(){ if(!stored()){ apply(resolve()); fire(resolve()); } }); } }catch(e){}
  window.BKMotion={ get:get, set:set, levels:['calm','standard','immersive'] };
})();


/* ---- next engine block ---- */


(function(){
  var C=BK_HX_CONFIG, root=document.getElementById('bk-hx');
  var palIndex=0, color="#E23744", texture="smooth", finish="marker", soundOn=false, actx=null;
  var ops=[], filledCount=0, ready=false, earned=false, factIdx=0;
  function $(id){return document.getElementById(id);}

  /* SEO */
  try{ if(C.SEO){ document.title=C.SEO.title; var m=document.querySelector('meta[name=description]')||document.createElement('meta'); m.name='description'; m.content=C.SEO.description; document.head.appendChild(m);} }catch(e){}

  /* text content */
  $('bk-word').textContent=C.ENTRY.word;
  $('bk-subtitle').textContent="Entry "+C.ENTRY.number+" . "+C.ENTRY.tier+" . tap inside the lines to color"; (function(){var tg=$('bk-tagline'); if(tg){ if(C.TAGLINE&&C.TAGLINE.trim()){ tg.textContent=C.TAGLINE; } else { tg.style.display='none'; } }})();
  $('bk-hook').textContent=C.ENTRY.hook;
  $('bk-tip-text').textContent=C.MASCOT.hello;
  (function(){
    function splitPara(text,per){ var s=(text||'').match(/[^.!?]+[.!?]+["')\]]?\s*/g)||[text]; var out=[],cur=[];
      for(var i=0;i<s.length;i++){ cur.push(s[i].trim()); if(cur.length>=per){ out.push(cur.join(' ')); cur=[]; } }
      if(cur.length) out.push(cur.join(' ')); return out; }
    function renderStory(el,text,per,wm){ if(!el)return; el.innerHTML='';
      splitPara(text,per).forEach(function(t){ var p=document.createElement('p'); p.textContent=t; el.appendChild(p); });
      if(wm&&C.emblemUrl){ var im=document.createElement('img'); im.className='bk-wm'; im.alt=''; im.src=C.emblemUrl; el.appendChild(im); } }
    renderStory($('bk-story'),C.ENTRY.story,4,true);
    if(C.ENTRY.closing) renderStory($('bk-closing'),C.ENTRY.closing,4,false);
  })();
  if(C.MOOD&&C.MOOD.intro)$('bk-mood-intro').textContent=C.MOOD.intro;
  $('bk-feelslike').textContent=C.ENTRY.feelsLike;
  $('bk-when').textContent=C.ENTRY.whenYouFeelIt;
  $('bk-world').textContent=C.ENTRY.worldNote;
  (function(){ var b=$('bk-world-say'); if(!b)return; var ko=C.ENTRY.worldKo, en=C.ENTRY.worldEn||C.ENTRY.feeling;
    if(!ko){ b.style.display='none'; return; } b.innerHTML='🔊 Hear '+ko+(C.ENTRY.worldRom?' ('+C.ENTRY.worldRom+')':'');
    b.onclick=function(){ sayKoEn(ko,en); }; })();
  $('bk-prompt').textContent=C.ENTRY.prompt;
  $('bk-bacci').textContent=C.ENTRY.bacciLine;
  $('bk-mantra').textContent=C.MANTRA;
  $('bk-cta').textContent=C.CTA;
  $('bk-su-h').textContent=C.SIGNUP.headline; $('bk-su-sub').textContent=C.SIGNUP.sub;
  $('bk-su-email').placeholder=C.SIGNUP.placeholder; $('bk-su-btn').textContent=C.SIGNUP.button;
  $('bk-su-consent-t').textContent=C.SIGNUP.consent;
  $('bk-ring').innerHTML="Color <b>"+C.BADGE.earnAfter+"</b> parts to earn the <b>"+C.BADGE.name+"</b> sticker";
  if(C.BADGE.image&&C.BADGE.image.trim()){ $('bk-sticker').innerHTML='<img class="bk-lion" src="'+C.BADGE.image+'" alt="'+(C.BADGE.name||'Brave')+' lion sticker">'; } else { $('bk-sticker').textContent=C.BADGE.emoji; } $('bk-emsg').textContent=C.BADGE.earnMsg;
  $('bk-disc-text').textContent=C.DISCLAIMER; $('bk-own').textContent=C.ownership;
  (function(){ var u=(C.crestUrl&&C.crestUrl.trim())?C.crestUrl:C.emblemUrl; if(u&&u.trim()){ var cr=$('bk-crest'); if(cr){ cr.src=u; cr.style.display='block'; } } })();
  function setFact(){ $('bk-fact').textContent=C.FUNFACTS[factIdx%C.FUNFACTS.length]; } setFact();
  $('bk-fact-more').onclick=function(){factIdx++;setFact();};

  /* age toggles link pages */
  (function(){ var w=$('bk-ages'); C.AGES.forEach(function(a){ var b=document.createElement('button'); b.type='button'; b.className='bk-age'; b.innerHTML=a.emoji+" "+a.name; b.setAttribute('aria-pressed',a.here?'true':'false');
    b.onclick=function(){ if(a.here) return; if(a.url) location.href=a.url; }; w.appendChild(b); }); })();

  /* ---- v3: the gentle mood meter check in ---- */
  (function(){ if(!C.MOOD||!C.MOOD.options){ var m=$('bk-mood'); if(m)m.style.display='none'; return; }
    var row=$('bk-moodrow'), reply=$('bk-moodreply');
    C.MOOD.options.forEach(function(o){ var b=document.createElement('button'); b.type='button'; b.className='bk-moodbtn'; b.setAttribute('aria-pressed','false');
      b.innerHTML='<span class="e">'+o.emoji+'</span>'+o.label;
      b.onclick=function(){ row.querySelectorAll('.bk-moodbtn').forEach(function(x){x.setAttribute('aria-pressed','false');}); b.setAttribute('aria-pressed','true'); reply.textContent=o.reply; };
      row.appendChild(b); }); })();

  /* feeling label (per color name + emotion + Korean + voice) */
  function showFeel(){ var el=$('bk-feel'); var f=C.FEELINGS[(color||'').toUpperCase()];
    if(!f){ el.innerHTML='<span class="dot" style="background:'+color+'"></span><span class="nm">Your color</span>'; return; }
    el.innerHTML='<span class="dot" style="background:'+color+'"></span><span class="nm">'+f.name+'</span><span class="fe">feels like '+f.feel+'</span><span class="ko">'+f.ko+'</span><span class="rom">'+f.rom+'</span><button class="say" id="bk-feel-say" type="button">🔊 Say it</button>';
    var b=$('bk-feel-say'); if(b) b.onclick=function(){ sayKoEn(f.ko,f.feel); }; }
  function sayKoEn(ko,en){ try{ if(!window.speechSynthesis)return; speechSynthesis.cancel(); var u=new SpeechSynthesisUtterance(ko); u.lang='ko-KR'; u.rate=.85; speechSynthesis.speak(u); setTimeout(function(){ var e=new SpeechSynthesisUtterance(en); e.lang='en-US'; e.rate=.9; speechSynthesis.speak(e); },820); }catch(e){} }

  /* palettes + swatches (above the fold) */
  function buildTabs(){ var w=$('bk-tabs'); w.innerHTML=''; C.PALETTES.forEach(function(p,i){ var b=document.createElement('button'); b.type='button'; b.className='bk-tab'; b.textContent=p.name; b.setAttribute('aria-pressed',i===palIndex?'true':'false'); b.onclick=function(){palIndex=i;buildTabs();buildSwatches();}; w.appendChild(b); }); }
  function buildSwatches(){ var w=$('bk-swatches'); w.innerHTML=''; C.PALETTES[palIndex].colors.forEach(function(hex){ var b=document.createElement('button'); b.type='button'; b.className='bk-sw'; b.style.background=hex; var f=C.FEELINGS[hex.toUpperCase()]; var lbl=f?(f.name+', feels like '+f.feel+' ('+f.ko+')'):hex; b.title=lbl; b.setAttribute('aria-label',lbl); b.setAttribute('aria-pressed',hex===color?'true':'false'); b.onclick=function(){ color=hex; buildSwatches(); showFeel(); }; w.appendChild(b); }); }
  function buildChips(id,arr,get,set){ var w=$(id); w.innerHTML=''; arr.forEach(function(o){ var b=document.createElement('button'); b.type='button'; b.className='bk-chip'; b.innerHTML=o.emoji+" "+o.name; b.setAttribute('aria-pressed',get()===o.id?'true':'false'); b.onclick=function(){set(o.id);buildChips(id,arr,get,set);}; w.appendChild(b); }); }
  buildTabs(); buildSwatches(); showFeel();

  /* ==== v22: the EmoFeast juice pass ==== */
  (function(){
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* icons leap off the page */
    root.querySelectorAll('button img').forEach(function(im){ if(!im.classList.contains('bk-coinspin')) im.classList.add('bk-pop'); });

    /* gentle 3D tilt on the coloring paper, frozen while actually coloring */
    var FX=C.FX||{};
    if(FX.tilt && !reduce){
      var paper=root.querySelector('.bk-paper');
      if(paper){
        paper.classList.add('bk-tilting');
        var down=false;
        document.addEventListener('pointerdown',function(){ down=true; paper.style.transform=''; },{passive:true});
        document.addEventListener('pointerup',function(){ down=false; },{passive:true});
        paper.addEventListener('pointermove',function(e){ if(down)return;
          var r=paper.getBoundingClientRect();
          var rx=((e.clientY-r.top)/r.height-.5)*-6, ry=((e.clientX-r.left)/r.width-.5)*6;
          paper.style.transform='perspective(1100px) rotateX('+rx.toFixed(2)+'deg) rotateY('+ry.toFixed(2)+'deg)';
        },{passive:true});
        paper.addEventListener('pointerleave',function(){ paper.style.transform=''; });
      }
    }

    /* the spinning gold phoenix coin on the bonus game buttons */
    if(FX.coinSpin!==false && C.emblemUrl){
      root.querySelectorAll('.bk-bonus').forEach(function(b){
        var coin=document.createElement('img'); coin.className='bk-coinspin'; coin.src=C.emblemUrl; coin.alt=''; coin.setAttribute('aria-hidden','true');
        b.appendChild(coin);
      });
    }

    /* HYPE CHEERLEADER MODE */
    var H=C.HYPE||{};
    if(H.enabled && H.characters && H.characters.length){
      var btn=document.createElement('button'); btn.type='button'; btn.className='bk-hypebtn'; btn.textContent=H.button||'📣 Hype me!';
      var wrap=document.createElement('div'); wrap.className='bk-cheer'; wrap.setAttribute('aria-live','polite');
      var closeX=document.createElement('button'); closeX.type='button'; closeX.className='bk-cheerx'; closeX.setAttribute('aria-label','Close'); closeX.textContent='✕';
      closeX.style.cssText='position:absolute;top:-12px;right:-12px;left:auto;z-index:130;';
      var bub=document.createElement('div'); bub.className='bub';
      var img=document.createElement('img'); img.alt='';
      bub.appendChild(closeX);              /* X lives INSIDE the bubble, anchored to it, never cleared */
      var txt=document.createElement('div'); txt.className='bk-cheer-txt'; bub.appendChild(txt);
      wrap.appendChild(bub); wrap.appendChild(img);
      var hideRef=null;
      function doClose(e){ if(e){ e.preventDefault(); e.stopPropagation(); } if(hideRef){ hideRef(); } else { wrap.classList.remove('up'); wrap.style.pointerEvents='none'; busyShowing=false; } }
      closeX.addEventListener('click',doClose);
      closeX.addEventListener('touchend',doClose);
      root.appendChild(btn); root.appendChild(wrap);
      var cta=document.createElement('div'); cta.className='bk-hypecta'; cta.textContent='Meet the Hype Cheerleader Crew! Tap me 👇'; root.appendChild(cta); var ctaSwapped=false;
      var ctaShown=false;
      if(!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)){
        setTimeout(function(){ if(!ctaShown){ cta.classList.add('show'); } },6000);
        setTimeout(function(){ cta.classList.remove('show'); if(!ctaSwapped){ cta.textContent='Need an extra boost? Tap me! 👇'; ctaSwapped=true; } },17000);
      }
      var t=null;
      var busyShowing=false;
      function hypeShow(){
        if(busyShowing) return;                 /* never stack, never flicker */
        ctaShown=true; cta.classList.remove('show');
        var ch=H.characters[Math.floor(Math.random()*H.characters.length)];
        if(!ch||!ch.url){ return; }
        var ph=(H.phrases&&H.phrases.length)?H.phrases[Math.floor(Math.random()*H.phrases.length)]:'You are doing amazing!';
        if(ch.lines&&ch.lines.length){ ph=ch.lines[Math.floor(Math.random()*ch.lines.length)]; }
        busyShowing=true;
        /* build the bubble first, then reveal only after the character image has actually loaded */
        txt.innerHTML='';
        var crew=document.createElement('span'); crew.className='crewname'; crew.textContent=(H.crewName||'Hype Cheerleader Crew');
        var who=document.createElement('span'); who.className='who'; who.textContent=ch.name||'';
        var msg=document.createElement('span'); msg.className='msg'; msg.textContent=ph;
        txt.appendChild(crew); txt.appendChild(who); txt.appendChild(msg);
        function hide(){
          clearTimeout(t);
          wrap.onmouseenter=null; wrap.onmouseleave=null;   /* detach so a stray hover cannot re-arm or re-pop */
          wrap.style.pointerEvents='none';
          wrap.classList.remove('up');
          busyShowing=false;
        }
        hideRef=hide;
        function reveal(){
          wrap.classList.remove('up'); void wrap.offsetWidth; wrap.classList.add('up');
          wrap.style.pointerEvents='auto';
          clearTimeout(t); t=setTimeout(hide,16000);                 /* linger 16s for slow readers */
          wrap.onmouseenter=function(){ clearTimeout(t); };           /* pause while hovered */
          wrap.onmouseleave=function(){ clearTimeout(t); t=setTimeout(hide,6000); };
        }
        var pre=new Image();
        pre.onload=function(){ img.src=ch.url; img.alt=ch.name||''; reveal(); };
        pre.onerror=function(){ busyShowing=false; };   /* a broken url simply does nothing, no empty flash */
        pre.src=ch.url;
      }
      btn.addEventListener('click',hypeShow);
      try{ root._hypeShow=hypeShow; }catch(e){}
    }
  })();

  /* ---- v16: THE WHEEL HANDOFF. If the feeling wheel sent a colour
     (?feeling=%23HEX in the link), arrive with that brush already
     loaded and the feeling label showing. Nothing is stored. ---- */
  (function(){
    try{
      var q=new URLSearchParams(location.search), h=q.get('feeling');
      if(!h) return;
      h=h.replace('#','');
      if(!/^[0-9A-Fa-f]{6}$/.test(h)) return;
      color='#'+h.toUpperCase();
      buildSwatches(); showFeel();
    }catch(e){}
  })();
  buildChips('bk-texs',C.TEXTURES,function(){return texture;},function(v){texture=v;});
  buildChips('bk-fins',C.FINISHES,function(){return finish;},function(v){finish=v;});

  /* tip dismiss + chevron */
  $('bk-tip-x').onclick=function(){ var tip=$('bk-tip');
    var rm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(rm){ tip.style.display='none'; return; }
    var bub=document.createElement('div'); bub.className='bk-tipbub'; bub.textContent='Have fun! 💖'; tip.appendChild(bub);
    var hearts=['💗','💖','💕','💞','🩷'];
    for(var i=0;i<22;i++){ var h=document.createElement('span'); h.className='bk-heart'; h.textContent=hearts[i%hearts.length];
      h.style.left=(8+Math.random()*84)+'%'; h.style.top='40%';
      h.style.setProperty('--hx',((Math.random()-.5)*160)+'px'); h.style.setProperty('--hy',(-70-Math.random()*120)+'px'); h.style.setProperty('--hr',((Math.random()-.5)*60)+'deg');
      h.style.animationDelay=(Math.random()*.25)+'s'; tip.appendChild(h); }
    tip.style.pointerEvents='none';
    setTimeout(function(){ tip.style.transition='opacity .4s ease, transform .4s ease'; tip.style.opacity='0'; tip.style.transform='translateY(-6px)'; },1250);
    setTimeout(function(){ tip.style.display='none'; },1700); };
  /* ---- v15: THE STORYBOOK READING DESK (slow cover, page turns, read aloud) ---- */
  (function(){
    var book=$('bk-book'); if(!book) return;
    var B=C.BOOK||{}, cover=$('bk-cover'), wrap=$('bk-bookwrap');
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* the cover */
    $('bk-book-kicker').textContent=B.kicker||'';
    $('bk-book-title').textContent=B.title||'The Heartopedia';
    $('bk-book-sub').textContent=B.subtitle||'';
    (function(){ var by=$('bk-book-by'); if(!by)return; if(B.byline&&B.byline.trim()){ by.textContent=B.byline; } else { by.style.display='none'; } })();
    (function(){ if(!B.endNote||!B.endNote.trim())return; var lc=book.querySelector('.bk-chap[data-ch="mantra"]'); if(lc){ var p=document.createElement('p'); p.className='bk-endnote'; p.textContent=B.endNote; lc.appendChild(p); } })();
    $('bk-book-entry').textContent=B.entry||'';
    $('bk-book-open').textContent=B.open||'Open the book';
    var em=$('bk-cover-emblem'); if(C.emblemUrl){ em.src=C.emblemUrl; } else { em.style.display='none'; }

    /* pages */
    var order=(B.chapters||[]).map(function(ch){return ch.id;});
    var cur=0, turning=false, TURN=1250;
    var rail=$('bk-rail'), pc=$('bk-pagecount');
    var btnPrev=$('bk-prev'), btnNext=$('bk-next');
    var btnEN=$('bk-read-en'), btnKO=$('bk-read-ko');
    var lblEN=btnEN.innerHTML, lblKO=btnKO.innerHTML;
    function chapAt(i){ return book.querySelector('.bk-chap[data-ch="'+order[i]+'"]'); }

    /* ribbon rail = page tabs */
    (B.chapters||[]).forEach(function(ch,i){
      var rc=(B.railChars||{})[ch.id];
      var b=document.createElement('button'); b.type='button'; b.textContent=ch.emoji;
      b.title=ch.label; b.setAttribute('aria-label',ch.label); b.setAttribute('data-go',String(i));
      b.onclick=function(){ goTo(i); };
      if(rc){ b.setAttribute('data-char',rc);
        b.addEventListener('mouseenter',function(){ showRailChar(rc); });
        b.addEventListener('mouseleave',function(){ hideRailChar(); });
        b.addEventListener('focus',function(){ showRailChar(rc); });
        b.addEventListener('blur',function(){ hideRailChar(); });
      }
      rail.appendChild(b); });

    /* v37: ONE fixed layer for the popped rail character, free of every clipping ancestor */
    var railLayer=document.getElementById('bk-raillayer');
    if(!railLayer){ railLayer=document.createElement('img'); railLayer.id='bk-raillayer'; railLayer.alt=''; railLayer.setAttribute('aria-hidden','true'); document.body.appendChild(railLayer); }
    var railHideT=null;
    function showRailChar(url){ clearTimeout(railHideT); railLayer.src=url; railLayer.classList.add('show'); }
    function hideRailChar(){ railHideT=setTimeout(function(){ railLayer.classList.remove('show'); }, 80); }

    function refreshUI(){
      rail.querySelectorAll('button').forEach(function(b){
        b.setAttribute('aria-current', b.getAttribute('data-go')===String(cur)?'true':'false'); });
      pc.textContent='Page '+(cur+1)+' of '+order.length;
      btnPrev.disabled = (cur===0);
      btnNext.disabled = (cur===order.length-1);
      var ko=(B.korean||{})[order[cur]];
      btnKO.style.display=(ko&&ko.trim())?'inline-flex':'none';
      stopSpeech();
      var c=chapAt(cur); if(c) c.scrollTop=0;
    }

    function goTo(i){
      if(turning||i===cur||i<0||i>=order.length) return;
      var dir=(i>cur)?'F':'B';
      var out=chapAt(cur), inn=chapAt(i);
      cur=i;
      if(reduce){ out.classList.remove('cur'); inn.classList.add('cur'); refreshUI(); return; }
      turning=true;
      out.classList.add('out'+dir);
      inn.classList.add('cur','in'+dir);
      setTimeout(function(){
        out.classList.remove('cur','out'+dir);
        inn.classList.remove('in'+dir);
        turning=false;
      },TURN);
      refreshUI();
    }
    btnPrev.onclick=function(){ goTo(cur-1); };
    btnNext.onclick=function(){ goTo(cur+1); };
    wrap.addEventListener('keydown',function(e){
      if(e.key==='ArrowRight'){ goTo(cur+1); }
      if(e.key==='ArrowLeft'){ goTo(cur-1); }
    });

    /* the slow, purposeful open */
    function openBook(){
      if(book.classList.contains('open')) return;
      book.classList.add('open'); cover.setAttribute('aria-expanded','true');
      var show=function(){
        cover.style.display='none'; wrap.hidden=false; wrap.setAttribute('tabindex','-1');
        var first=chapAt(0); if(first) first.classList.add('cur');
        refreshUI();
      };
      if(reduce){ show(); } else { setTimeout(show, 1500); }
    }
    cover.onclick=openBook;
    /* v33: back to the front cover */
    function closeBook(){
      if(!book.classList.contains('open')) return;
      book.classList.remove('open'); cover.setAttribute('aria-expanded','false');
      cover.style.display=''; wrap.hidden=true;
      book.querySelectorAll('.bk-chap').forEach(function(c){ c.classList.remove('cur','inF','outF','inB','outB'); });
      cur=0;
      if(root.classList.contains('bk-focuson')){ root.classList.remove('bk-focuson'); var fb=$('bk-focus'); if(fb){ fb.setAttribute('aria-pressed','false'); fb.textContent='🌙 Focus mode'; } }
      try{ document.fullscreenElement&&document.exitFullscreen&&document.exitFullscreen(); }catch(e){}
      book.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});
    }
    var closeBtn=$('bk-closebook'); if(closeBtn){ closeBtn.onclick=closeBook; }
    if('IntersectionObserver' in window){
      var auto=new IntersectionObserver(function(es){ es.forEach(function(e){
        if(e.isIntersecting&&e.intersectionRatio>=0.9){ auto.disconnect(); setTimeout(openBook, 1400); }
      }); },{threshold:[0,0.9,1]});
      auto.observe(cover);
    }

    /* ---- read aloud, English and Korean ---- */
    var speaking=false, queue=[];
    function resetBtns(){ btnEN.innerHTML=lblEN; btnEN.setAttribute('aria-pressed','false');
      btnKO.innerHTML=lblKO; btnKO.setAttribute('aria-pressed','false'); }
    function stopSpeech(){ try{ if(window.speechSynthesis) speechSynthesis.cancel(); }catch(e){}
      speaking=false; queue=[]; resetBtns(); }
    function chunks(text){
      var s=(text||'').replace(/\s+/g,' ').trim();
      var parts=s.match(/[^.!?\u3002]+[.!?\u3002]+["')\]]?\s*/g)||[s];
      var out=[],buf='';
      parts.forEach(function(p){ if((buf+p).length>180){ if(buf)out.push(buf); buf=p; } else buf+=p; });
      if(buf) out.push(buf); return out;
    }
    function speak(text,lang,btn){
      if(!('speechSynthesis' in window)) return;
      if(speaking){ stopSpeech(); return; }
      stopSpeech();
      speaking=true; btn.innerHTML='⏹ Stop'; btn.setAttribute('aria-pressed','true');
      queue=chunks(text);
      (function next(){
        if(!speaking||!queue.length){ stopSpeech(); return; }
        var u=new SpeechSynthesisUtterance(queue.shift());
        u.lang=lang; u.rate=(lang==='ko-KR')?0.85:0.93;
        u.onend=next; u.onerror=function(){ stopSpeech(); };
        speechSynthesis.speak(u);
      })();
    }
    function pageText(){
      var el=chapAt(cur); if(!el) return '';
      var clone=el.cloneNode(true);
      clone.querySelectorAll('button,svg,img').forEach(function(n){ n.parentNode.removeChild(n); });
      return clone.textContent.replace(/\s+/g,' ').trim();
    }
    btnEN.onclick=function(){ speak(pageText(),'en-US',btnEN); };
    btnKO.onclick=function(){ var t=(B.korean||{})[order[cur]]||''; if(t.trim()) speak(t,'ko-KR',btnKO); };
    window.addEventListener('pagehide',stopSpeech);
  })();

  /* ---- the flood fill engine ---- */
  var canvas=$('bk-canvas'), ctx=canvas.getContext('2d',{willReadFrequently:true}), img=new Image();
  function progress(){ $('bk-progress').textContent=filledCount+" of "+C.BADGE.earnAfter+" parts colored"+(earned?"  .  sticker earned 🎉":""); } progress();
  function drawBase(){ ctx.fillStyle="#fff"; ctx.fillRect(0,0,canvas.width,canvas.height); ctx.drawImage(img,0,0,canvas.width,canvas.height); }
  img.crossOrigin="anonymous";
  img.onload=function(){ var w=Math.min(1200,img.naturalWidth||1200); canvas.width=w; canvas.height=Math.round(w*(img.naturalHeight/img.naturalWidth||1)); drawBase();
    try{ ctx.getImageData(0,0,1,1); ready=true; $('bk-loading').style.display='none'; }
    catch(e){ $('bk-loading').innerHTML="This image is not readable for coloring on this preview. On your live store it reads fine. Everything else here is the real design."; } };
  img.onerror=function(){ $('bk-loading').textContent="Could not load the line art. Check CONFIG.lineArtUrl."; };
  img.src=C.lineArtUrl;

  /* preload the Phoenix emblem so it is ready for the certificate (download and print) */
  var emblemImg=null, emblemReady=false;
  if(C.emblemUrl){ emblemImg=new Image(); emblemImg.crossOrigin="anonymous";
    emblemImg.onload=function(){ emblemReady=true; }; emblemImg.onerror=function(){ emblemReady=false; }; emblemImg.src=C.emblemUrl; }

  /* ---- v3: colored preview toggle, Bacci's original vision, with a gentle fade ---- */
  (function(){ var bar=$('bk-previewbar'), btn=$('bk-preview'), cimg=$('bk-colored');
    if(!C.coloredUrl||!C.coloredUrl.trim()){ if(bar)bar.style.display='none'; return; }
    cimg.onerror=function(){ if(bar)bar.style.display='none'; cimg.classList.remove('show'); };
    cimg.src=C.coloredUrl; var on=false;
    btn.onclick=function(){ on=!on; cimg.classList.toggle('show',on); btn.setAttribute('aria-pressed',on?'true':'false');
      btn.firstChild.nodeValue=on?'🖍️ Back to my coloring ':'✨ See Bacci\u0027s colors ';
      var pip=btn.querySelector('.pip'); if(pip)pip.textContent=on?'(your art is safe underneath)':'(tap to fade in and out)'; };
  })();

  /* ---- v13: intro clip waits until the coloring box is on screen, then plays, then melts into coloring ---- */
  (function(){ var ov=$('bk-intro'), vid=$('bk-introvid'), sound=$('bk-introsound'), skip=$('bk-introskip'), cap=$('bk-introcap');
    if(!ov)return;
    if(!C.videoUrl||!C.videoUrl.trim()){ ov.style.display='none'; return; }
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(cap&&C.videoCTA) cap.textContent='✨ '+C.videoCTA;
    if(C.coloredUrl) vid.setAttribute('poster',C.coloredUrl);
    var hidden=false, started=false;
    function done(){ if(hidden)return; hidden=true; try{ vid.pause(); }catch(e){} ov.classList.add('gone'); setTimeout(function(){ ov.style.display='none'; },650); }
    if(reduce){ ov.style.display='none'; return; }   // reduced motion: straight to coloring
    vid.muted=true; vid.playsInline=true; vid.preload='auto'; vid.src=C.videoUrl;
    function tryplay(){ try{ var p=vid.play(); if(p&&p.catch) p.catch(function(){}); }catch(e){} }
    if(sound) sound.onclick=function(e){ e.stopPropagation(); vid.muted=!vid.muted; sound.textContent=vid.muted?'🔊 Sound':'🔇 Mute'; if(vid.paused) tryplay(); };
    vid.addEventListener('ended', done);
    vid.addEventListener('error', function(){ ov.style.display='none'; });
    if(skip) skip.onclick=function(e){ e.stopPropagation(); done(); };
    /* tap anywhere on the overlay (except the buttons) reveals the coloring page */
    ov.addEventListener('click', function(e){ if(e.target===sound||e.target===skip) return; done(); });
    /* once it is really playing, auto-dismiss a beat after its natural length, in case 'ended' never fires */
    vid.addEventListener('playing', function(){ var ms=((isFinite(vid.duration)&&vid.duration>0)?vid.duration*1000:6000)+1200; clearTimeout(ov._max); ov._max=setTimeout(done, ms); });
    /* start ONLY when the coloring box is on screen, after a short beat so the opening is not missed */
    function begin(){ if(started)return;
      if(window.__bkCinematicActive){ if(!begin._waiting){ begin._waiting=true; window.addEventListener('bk-cinematic-done',function(){ begin._waiting=false; begin(); },{once:true}); } return; }
      started=true;
      setTimeout(function(){ tryplay();
        /* safety: if autoplay was blocked and it still has not started, get out of the way so coloring always works */
        setTimeout(function(){ if(!hidden && vid.paused && (vid.currentTime||0)===0) done(); }, 4200);
      }, C.videoStartDelayMs||450); }
    var target=root.querySelector('.bk-paper')||ov;
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(ents){ ents.forEach(function(e){ if(e.isIntersecting && e.intersectionRatio>=0.55){ begin(); io.disconnect(); } }); }, {threshold:[0,0.55,1]});
      io.observe(target);
    } else { begin(); }
  })();

  /* ---- v11: strong parallax on scroll + back to top ---- */
  (function(){
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var orbs=root.querySelector('.bk-orbs'), stars=root.querySelector('.bk-stars');
    var os=orbs?orbs.querySelectorAll('i'):[], rates=[0.10,0.18,0.13,0.22,0.16,0.11,0.20,0.14], ticking=false;
    /* back to top button, on the body so nothing can clip it */
    var top=document.createElement('button'); top.className='bk-totop'; top.type='button'; top.setAttribute('aria-label','Back to the top'); top.innerHTML='↑';
    document.body.appendChild(top);
    var anchor=root.querySelector('.bk-paper')||root;
    top.onclick=function(){ var y=(anchor.getBoundingClientRect().top+(window.pageYOffset||0))-70; window.scrollTo({top:Math.max(0,y),behavior:reduce?'auto':'smooth'}); };
    function upd(){ var y=window.pageYOffset||document.documentElement.scrollTop||0;
      if(!reduce){ for(var i=0;i<os.length;i++){ os[i].style.transform='translate3d(0,'+(y*rates[i%rates.length])+'px,0)'; }
        if(stars) stars.style.transform='translate3d(0,'+(y*0.32)+'px,0)'; }
      top.classList.toggle('show', y>620);
      ticking=false; }
    window.addEventListener('scroll',function(){ if(!ticking){ requestAnimationFrame(upd); ticking=true; } },{passive:true});
    upd();
  })();

  function hexToRgb(hex){ hex=(hex||'').toString().replace('#','').trim(); if(hex.length===3){ hex=hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2]; } var n=parseInt(hex,16); if(isNaN(n)) return [128,128,128]; return [(n>>16)&255,(n>>8)&255,n&255]; }
  function mix(rgb,to,amt){ return [Math.round(rgb[0]+(to[0]-rgb[0])*amt),Math.round(rgb[1]+(to[1]-rgb[1])*amt),Math.round(rgb[2]+(to[2]-rgb[2])*amt)]; }
  function shade(rgb,amt){ return [Math.max(0,Math.min(255,rgb[0]+amt)),Math.max(0,Math.min(255,rgb[1]+amt)),Math.max(0,Math.min(255,rgb[2]+amt))]; }
  function baseColor(rgb,fin){ if(fin==='watercolor')return mix(rgb,[255,255,255],.42); if(fin==='glow')return mix(rgb,[255,255,255],.16); return rgb; }
  /* texture color at a pixel */
  function hash2(a,b){ var n=(a*374761393 + b*668265263)|0; n=Math.imul(n^(n>>>13),1274126177); return (n^(n>>>16))>>>0; }
  function texColor(rgb,tex,x,y){ if(tex==='smooth')return rgb;
    if(tex==='dots'){ return ((x%9<3)&&(y%9<3))?shade(rgb,-44):rgb; }
    if(tex==='stripes'){ return (((x+y)%10)<3)?shade(rgb,-40):rgb; }
    if(tex==='waves'){ var s=Math.sin(y/5)*0.5+0.5; return shade(rgb,Math.round((s-0.5)*44)); }
    if(tex==='glitter'){ return (Math.random()<0.06)?[255,255,255]:(Math.random()<0.06?[255,213,74]:rgb); }
    if(tex==='leopard'){ var S=36, cx=Math.floor(x/S), cy=Math.floor(y/S), best=1e9, bd2=0, bri=0;
      for(var oy=-1;oy<=1;oy++)for(var ox=-1;ox<=1;ox++){ var h=hash2(cx+ox,cy+oy); var jx=(h&255)/255, jy=((h>>>8)&255)/255;
        var ccx=(cx+ox)*S+jx*S, ccy=(cy+oy)*S+jy*S; var dx=x-ccx, dy=y-ccy, d2=dx*dx+dy*dy; if(d2<best){ best=d2; bri=0.30+0.16*(((h>>>16)&255)/255); } }
      var rad=S*bri, r2=rad*rad; if(best<r2){ var d=Math.sqrt(best); return (d>rad*0.52)?shade(rgb,-82):shade(rgb,-26); } return rgb; }
    if(tex==='cheetah'){ var S2=24, c2x=Math.floor(x/S2), c2y=Math.floor(y/S2), h2=hash2(c2x,c2y);
      var jx2=(h2&255)/255, jy2=((h2>>>8)&255)/255, ccx2=c2x*S2+jx2*S2, ccy2=c2y*S2+jy2*S2;
      var rd=S2*(0.18+0.12*(((h2>>>16)&255)/255)), dx2=x-ccx2, dy2=y-ccy2; return (dx2*dx2+dy2*dy2<rd*rd)?shade(rgb,-92):rgb; }
    return rgb; }

  function floodFill(sx,sy){
    var w=canvas.width,h=canvas.height, data=ctx.getImageData(0,0,w,h), d=data.data;
    var si=(sy*w+sx)*4, tr=d[si],tg=d[si+1],tb=d[si+2];
    if(tr<60&&tg<60&&tb<60) return false;            // do not fill the dark outline
    var base=baseColor(hexToRgb(color),finish), fr=base[0],fg=base[1],fb=base[2];
    if(Math.abs(d[si]-fr)<10&&Math.abs(d[si+1]-fg)<10&&Math.abs(d[si+2]-fb)<10) return false;
    var tol=66, seen=new Uint8Array(w*h);
    function ok(i){ if(seen[i>>2])return false; return Math.abs(d[i]-tr)<=tol&&Math.abs(d[i+1]-tg)<=tol&&Math.abs(d[i+2]-tb)<=tol; }
    var stack=[[sx,sy]], minX=sx,maxX=sx,minY=sy,maxY=sy, guard=w*h*4;
    while(stack.length){ if(--guard<0)break; var p=stack.pop(),x=p[0],y=p[1],i=(y*w+x)*4;
      while(y>=0&&ok(i)){y--;i-=w*4;} y++;i+=w*4; var l=false,r=false;
      while(y<h&&ok(i)){ seen[i>>2]=1; var c=texColor(base,texture,x,y); d[i]=c[0];d[i+1]=c[1];d[i+2]=c[2];d[i+3]=255;
        if(x<minX)minX=x; if(x>maxX)maxX=x; if(y<minY)minY=y; if(y>maxY)maxY=y;
        if(x>0){ if(ok(i-4)){ if(!l){stack.push([x-1,y]);l=true;} } else l=false; }
        if(x<w-1){ if(ok(i+4)){ if(!r){stack.push([x+1,y]);r=true;} } else r=false; }
        y++;i+=w*4; } }
    ctx.putImageData(data,0,0);
    if(finish==='bling'){ var n=Math.max(3,Math.round((maxX-minX)*(maxY-minY)/9000)); ctx.fillStyle="#FFFFFF"; for(var k=0;k<n;k++){ var rx=minX+Math.random()*(maxX-minX),ry=minY+Math.random()*(maxY-minY); ctx.globalAlpha=.85; ctx.beginPath(); ctx.arc(rx,ry,1.6,0,6.3); ctx.fill(); } ctx.globalAlpha=1; }
    return true;
  }
  function paint(cx,cy){ if(!ready)return; var rect=canvas.getBoundingClientRect();
    var x=Math.round((cx-rect.left)*(canvas.width/rect.width)), y=Math.round((cy-rect.top)*(canvas.height/rect.height));
    if(x<0||y<0||x>=canvas.width||y>=canvas.height)return;
    var did=floodFill(x,y); if(did){ ops.push({x:x,y:y,color:color,texture:texture,finish:finish}); filledCount++; progress(); checkBadge(); $('bk-floatback').classList.add('show'); playSound(); cheerMaybe(); } }
  canvas.addEventListener('click',function(e){ paint(e.clientX,e.clientY); });
  canvas.addEventListener('touchend',function(e){ if(e.changedTouches&&e.changedTouches[0]){ e.preventDefault(); paint(e.changedTouches[0].clientX,e.changedTouches[0].clientY); } },{passive:false});

  function rebuild(upTo){ var cur={c:color,t:texture,f:finish};
    drawBase(); var keep=ops.slice(0,upTo); ops=[]; filledCount=0;
    keep.forEach(function(o){ color=o.color;texture=o.texture;finish=o.finish; var r=floodFill(o.x,o.y); if(r){ops.push(o);filledCount++;} });
    color=cur.c; texture=cur.t; finish=cur.f; buildSwatches(); showFeel(); progress(); }
  $('bk-undo').onclick=function(){ if(!ops.length)return; rebuild(ops.length-1); if(!ops.length)$('bk-floatback').classList.remove('show'); };
  $('bk-floatback').onclick=$('bk-undo').onclick;
  $('bk-clear').onclick=function(){ ops=[];filledCount=0;earned=false;root.classList.remove('bk-earned');drawBase();progress();$('bk-floatback').classList.remove('show'); };
  $('bk-replay').onclick=function(){ if(!ops.length)return; var saved=ops.slice(), cur={c:color,t:texture,f:finish}; drawBase(); ops=[];filledCount=0; var i=0,reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (function step(){ if(i>=saved.length){ color=cur.c;texture=cur.t;finish=cur.f;buildSwatches();showFeel(); return; } var o=saved[i++]; color=o.color;texture=o.texture;finish=o.finish; floodFill(o.x,o.y); ops.push(o);filledCount++;progress(); if(reduce)step(); else setTimeout(step,260); })(); };

  /* badge */
  function checkBadge(){ if(!earned&&filledCount>=C.BADGE.earnAfter){ earned=true; root.classList.add('bk-earned'); saveSticker(); burst(); celebrate(); } }
  function saveSticker(){ try{ var a=JSON.parse(localStorage.getItem('bk_brave_stk')||'[]'); if(a.indexOf(C.BADGE.emoji)<0){a.push(C.BADGE.emoji);localStorage.setItem('bk_brave_stk',JSON.stringify(a));} }catch(e){} }
  /* v3: the congratulations moment, confetti + spinning coin + Phoenix zoom, reduced motion safe */
  function celebrate(){ var ov=$('bk-congrats'); if(!ov)return;
    var phx=$('bk-congrats-phx'); if(C.emblemUrl&&C.emblemUrl.trim()){ phx.src=C.emblemUrl; phx.style.display='block'; } else { phx.style.display='none'; }
    $('bk-congrats-h').textContent='You earned the '+C.BADGE.name+' sticker '+C.BADGE.emoji;
    $('bk-congrats-p').textContent=C.BADGE.earnMsg;
    ov.classList.add('show');
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!reduce){ var card=ov.querySelector('.card'); var cols=['#FFC542','#FF6FBF','#00C6C6','#A66BFF','#56E0B0','#FFD6E7']; for(var i=0;i<46;i++){ (function(i){ var c=document.createElement('div'); c.className='conf'; c.textContent=['✨','🌟','💛','🐾','🔥'][i%5]; c.style.left=(Math.random()*100)+'%'; c.style.color=cols[i%cols.length]; var dur=2.6+Math.random()*1.8, del=Math.random()*.6; c.style.animation='bkConfFall '+dur+'s linear '+del+'s forwards'; card.appendChild(c); setTimeout(function(){c.remove();},(dur+del)*1000+200); })(i); } }
    clearTimeout(ov._t); ov._t=setTimeout(function(){ ov.classList.remove('show'); }, reduce?3200:4200);
    ov.onclick=function(){ ov.classList.remove('show'); };
  }
  function burst(){ if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return; var b=document.querySelector('#bk-hx .bk-badge'); if(!b)return; b.style.position='relative';
    for(var i=0;i<16;i++){ (function(i){ var s=document.createElement('div'); s.textContent=['✨','🌟','💛','🦁'][i%4]; s.style.cssText='position:absolute;left:50%;top:40%;font-size:18px;pointer-events:none;transition:transform 1s ease,opacity 1s ease;'; b.appendChild(s); var a=Math.random()*6.28,d=60+Math.random()*70; requestAnimationFrame(function(){ s.style.transform='translate('+Math.cos(a)*d+'px,'+Math.sin(a)*d+'px)'; s.style.opacity='0'; }); setTimeout(function(){s.remove();},1050); })(i); } }

  /* sound (off by default) */
  function playSound(){ if(!soundOn)return; try{ actx=actx||new(window.AudioContext||window.webkitAudioContext)(); var o=actx.createOscillator(),g=actx.createGain(); o.type='sine'; o.frequency.value=520+Math.random()*180; o.connect(g); g.connect(actx.destination); var n=actx.currentTime; g.gain.setValueAtTime(.0001,n); g.gain.exponentialRampToValueAtTime(.06,n+.02); g.gain.exponentialRampToValueAtTime(.0001,n+.3); o.start(n); o.stop(n+.32); }catch(e){} }
  $('bk-sound').onclick=function(){ soundOn=!soundOn; this.setAttribute('aria-pressed',soundOn?'true':'false'); $('bk-sound-t').textContent=soundOn?'Sound on':'Sound off';
    var IC=(C.ICONS&&C.ICONS.soundOn&&C.ICONS.soundOn.trim());
    var old=this.querySelector('.bk-ico'); if(old)old.remove();
    if(soundOn&&IC){ if(this.firstChild&&this.firstChild.nodeType===3)this.firstChild.nodeValue=this.firstChild.nodeValue.replace(/^[^A-Za-z0-9]+/,' '); var im=document.createElement('img'); im.className='bk-ico bk-pop xl'; im.src=C.ICONS.soundOn; im.alt=''; this.insertBefore(im,this.firstChild); }
    else { if(this.firstChild&&this.firstChild.nodeType===3)this.firstChild.nodeValue=soundOn?'🔊 ':'🔇 '; else this.insertBefore(document.createTextNode(soundOn?'🔊 ':'🔇 '),this.firstChild); } };

  /* v20: the Bacci icon set. Swap leading emojis for your characters. */
  (function(){ var IC=C.ICONS||{};
    function swap(id,url,cls){ if(!url||!url.trim())return; var b=$(id); if(!b)return;
      if(b.firstChild&&b.firstChild.nodeType===3) b.firstChild.nodeValue=b.firstChild.nodeValue.replace(/^[^A-Za-z0-9]+/,' ');
      var im=document.createElement('img'); im.className=(cls||'bk-ico')+' bk-pop'; im.src=url; im.alt=''; im.setAttribute('aria-hidden','true');
      b.insertBefore(im,b.firstChild); }
    swap('bk-lesson-open',IC.lesson);
    swap('bk-museum',IC.museum);
    swap('bk-clicknow',IC.adventure,'bk-ico lg');
    swap('bk-read-en','https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Sensory_Sound_only.png?v=1781224664','bk-ico');
    swap('bk-read-ko','https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Sensory_Sound_only.png?v=1781224664','bk-ico');
    swap('bk-focus','https://cdn.shopify.com/s/files/1/0500/7307/5871/files/27.png?v=1771541414','bk-ico');
    swap('bk-closebook','https://cdn.shopify.com/s/files/1/0500/7307/5871/files/11.png?v=1771114553','bk-ico');
    swap('bk-hub',IC.kpotLogo,'bk-kpotlogo');
    swap('bk-su-btn',IC.notify);
    if(IC.museum&&IC.museum.trim()){ var mi=$('bk-mu-ico'); mi.src=IC.museum; mi.hidden=false; }
    if(IC.checkin&&IC.checkin.trim()){ var ca=$('bk-checkart'); ca.src=IC.checkin; ca.hidden=false; }
    if(C.MUSEUM_NOTE&&C.MUSEUM_NOTE.trim()){ $('bk-mu-note-t').textContent=C.MUSEUM_NOTE; $('bk-mu-note').hidden=false; } })();

  /* cheers */
  var cheerN=0; function cheerMaybe(){ cheerN++; if(cheerN%4===0) showCheer(); }
  /* (v31) milestone cheers now flow through the Hype Crew, one system, one voice */
  function showCheer(){ if(root._hypeShow) root._hypeShow(); }

  /* artist credit (used on certificate) */
  function creditLine(){ var n=($('bk-namein').value||'').trim(), g=($('bk-forin').value||'').trim(); var s=n?('Lovingly colored by '+n):''; if(g)s+=(s?'  .  ':'')+'A gift for '+g; return s; }

  /* export: save art */
  $('bk-save').onclick=function(){ if(!ready)return; try{ var a=document.createElement('a'); a.download='Bacci_Kid_Brave_art.png'; a.href=canvas.toDataURL('image/png'); a.click(); }catch(e){ alert('Save needs the live store image.'); } };

  /* certificate one pager (single clean page) */
  function wrap(x,text,cx,cy,maxW,lh){ var words=(text||'').split(' '),line='',yy=cy; for(var i=0;i<words.length;i++){ var test=line+words[i]+' '; if(x.measureText(test).width>maxW&&line){ x.fillText(line.trim(),cx,yy); line=words[i]+' '; yy+=lh; } else line=test; } x.fillText(line.trim(),cx,yy); return yy+lh; }
  function buildCertificate(cb){ if(!ready){cb(null);return;} var W=1000,H=1400,cv=document.createElement('canvas'); cv.width=W;cv.height=H; var x=cv.getContext('2d');
    x.fillStyle='#FFFDF7'; x.fillRect(0,0,W,H);
    x.strokeStyle='#B9851E'; x.lineWidth=10; x.strokeRect(16,16,W-32,H-32);
    x.strokeStyle='#14A8A6'; x.lineWidth=2; x.strokeRect(30,30,W-60,H-60);
    x.textAlign='center';
    /* the Phoenix emblem seal, top center, with room from the border */
    var top=92;
    if(emblemReady&&emblemImg){ var es=118; x.drawImage(emblemImg,(W-es)/2,top,es,es); top+=es+34; }
    else { top+=22; }
    /* entry number beneath the emblem */
    x.fillStyle='#B9851E'; x.font='bold 22px Georgia'; x.fillText('ENTRY '+C.ENTRY.number,W/2,top); top+=44;
    x.fillStyle='#9a6a2a'; x.font='600 15px Georgia'; x.fillText('THE BACCI KID HEARTOPEDIA',W/2,top); top+=54;
    x.fillStyle='#14A8A6'; x.font='bold 52px Georgia'; x.fillText(C.ENTRY.word,W/2,top); top+=42;
    x.fillStyle='#9a6a2a'; x.font='600 16px Georgia'; x.fillText('.  A CERTIFICATE OF COLORING  .',W/2,top); top+=40;
    /* the colored art, fit inside a safe box so it never overflows (any image shape) */
    var boxW=560, boxH=540, sc=Math.min(boxW/canvas.width, boxH/canvas.height), dw=canvas.width*sc, dh=canvas.height*sc, ax=(W-dw)/2, ay=top+10;
    x.drawImage(canvas,ax,ay,dw,dh);
    var yy=ay+dh+44;
    x.fillStyle='#14A8A6'; x.font='italic 25px Georgia'; yy=wrap(x,C.ENTRY.hook,W/2,yy,W-200,34);
    x.fillStyle='#B9851E'; x.font='bold 19px Georgia'; x.fillText('THE BACCI KID MANTRA',W/2,yy+12);
    x.fillStyle='#14A8A6'; x.font='italic 25px Georgia'; yy=wrap(x,C.MANTRA,W/2,yy+46,W-220,32);
    var who=creditLine()||'a brave artist'; var today=new Date().toLocaleDateString('en-US',{year:'numeric',month:'long',day:'numeric'});
    x.fillStyle='#9a6a2a'; x.font='italic 19px Georgia'; x.fillText(who+'  .  '+today,W/2,yy+22);
    x.fillStyle='#B9851E'; x.font='bold 22px Georgia'; x.fillText('Meow . Meow . Meow',W/2,H-92);
    x.fillStyle='#14A8A6'; x.font='17px Georgia'; x.fillText('Dr. Jamie J. Karia, DSW, LCSW . baccikid.com',W/2,H-64);
    x.fillStyle='#888'; x.font='13px Georgia'; x.fillText('© 2026 Bacci Kid. All rights reserved.',W/2,H-40);
    cb(cv); }
  $('bk-onepager').onclick=function(){ buildCertificate(function(cv){ if(!cv){alert('Color a little first.');return;} try{ var a=document.createElement('a'); a.download='Bacci_Kid_Brave_certificate.png'; a.href=cv.toDataURL('image/png'); a.click(); }catch(e){} }); };
  $('bk-print').onclick=function(){ buildCertificate(function(cv){ if(!cv)return; try{ var url=cv.toDataURL('image/png'); var w=window.open('','_blank'); if(!w){window.print();return;}
    w.document.write('<!doctype html><html><head><title>Bacci Kid Certificate</title><meta charset="utf-8"><style>@page{margin:0}html,body{margin:0;background:#fff}img{display:block;width:100%;max-width:740px;margin:0 auto}</style></head><body><img src="'+url+'" onload="setTimeout(function(){window.print();},120)"></body></html>'); w.document.close(); }catch(e){window.print();} }); };

  /* museum */
  /* v19: ONE museum for the whole Heartopedia on this device. Older
     Brave-only saves are folded in automatically, nothing is lost. */
  function loadMuseum(){ try{
    var arr=JSON.parse(localStorage.getItem('bk_museum')||'[]');
    var old=localStorage.getItem('bk_brave_museum');
    if(old){ try{ JSON.parse(old).forEach(function(p){ p.feel=p.feel||'Brave'; arr.push(p); }); }catch(e){}
      localStorage.removeItem('bk_brave_museum');
      arr.sort(function(a,b){return (a.when||0)-(b.when||0);}); while(arr.length>12)arr.shift();
      localStorage.setItem('bk_museum',JSON.stringify(arr)); }
    return arr; }catch(e){return [];} }
  $('bk-museum-add').onclick=function(){ if(!ready||!ops.length){alert('Color a little first, then add it.');return;} try{ var cv=document.createElement('canvas');cv.width=300;cv.height=Math.round(300*(canvas.height/canvas.width)); cv.getContext('2d').drawImage(canvas,0,0,cv.width,cv.height); var arr=loadMuseum(); arr.push({thumb:cv.toDataURL('image/jpeg',.7),name:($('bk-namein').value||'').trim(),feel:(C.ENTRY&&C.ENTRY.word)||'',when:Date.now()}); while(arr.length>12)arr.shift(); localStorage.setItem('bk_museum',JSON.stringify(arr)); renderMuseum(); openModal('bk-museum-modal'); }catch(e){alert('Saving needs the live store image.');} };
  function renderRoom(arr){
    var room=$('bk-room'), line=$('bk-roomline'), RM=C.MUSEUM_ROOM||{};
    if(!room||!RM.backgroundUrl||!RM.backgroundUrl.trim()||!(RM.frames&&RM.frames.length)){ if(room)room.hidden=true; if(line)line.hidden=true; return; }
    room.hidden=false; line.hidden=false;
    $('bk-room-bg').src=RM.backgroundUrl;
    room.querySelectorAll('.slot').forEach(function(n){n.remove();});
    var latest=arr.slice(-RM.frames.length).reverse(), filled=0;
    RM.frames.forEach(function(f,i){
      var sl=document.createElement('div'); sl.className='slot';
      sl.style.left=f.left+'%'; sl.style.top=f.top+'%'; sl.style.width=f.width+'%'; sl.style.height=f.height+'%';
      var p=latest[i];
      if(p){ filled++;
        var im=document.createElement('img'); im.src=p.thumb; im.alt=(p.name?p.name+"'s ":'')+'art in a golden frame'; sl.appendChild(im);
        var lbl=(p.name||'')+(p.feel?((p.name?' · ':'')+p.feel):'');
        if(lbl){ var pl=document.createElement('div'); pl.className='plq'; pl.textContent=lbl; sl.appendChild(pl); }
      } else { var q=document.createElement('div'); q.className='q'; q.textContent='?'; sl.appendChild(q); }
      room.appendChild(sl); });
    var total=RM.frames.length, cnt=$('bk-room-count');
    var earned=false; try{ earned=localStorage.getItem('bk_museum_sticker')==='1'; }catch(e){}
    if(filled>=total&&!earned){ try{ localStorage.setItem('bk_museum_sticker','1'); }catch(e){} earned=true; }
    cnt.textContent=(filled>=total)?'Every frame is full. Magnificent! ✨':('Fill the frames: '+filled+' of '+total+'. Fill all '+total+' to earn '+(RM.stickerName||'the Museum Sticker')+'.');
    var stk=$('bk-room-sticker'); stk.hidden=!earned; if(earned)$('bk-room-sticker-name').textContent=RM.stickerName||'The Museum Sticker';
    var door=$('bk-room-door');
    if(RM.portalUrl&&RM.portalUrl.trim()){ door.hidden=false; door.href=safe(RM.portalUrl); door.textContent=RM.portalLabel||'🏛️ Explore the Museum Portals'; }
    else door.hidden=true;
  }
  function renderMuseum(){ var wall=$('bk-museum-wall'); var arr=loadMuseum(); renderRoom(arr);
    var nm=($('bk-namein').value||'').trim();
    if(!nm){ for(var i=arr.length-1;i>=0;i--){ if(arr[i].name){ nm=arr[i].name; break; } } }
    var nh=$('bk-mu-name'); if(nm){ nh.textContent='The '+nm+' Collection ✨'; nh.hidden=false; } else { nh.hidden=true; }
    wall.innerHTML=''; if(!arr.length){ wall.innerHTML='<div style="grid-column:1/-1;font-family:var(--script);font-style:italic;color:#6B5B96;">No art here yet. Color a piece and add it.</div>'; return; } arr.slice().reverse().forEach(function(p){ var f=document.createElement('div'); f.style.cssText='background:#fff;border:5px solid #E6C47A;border-radius:8px;padding:5px;box-shadow:0 6px 14px rgba(166,107,255,.2);'; f.innerHTML='<img src="'+p.thumb+'" alt="Saved coloring" style="width:100%;display:block;border-radius:3px;">'+(p.name?'<div style="font-family:var(--script);font-style:italic;text-align:center;color:#A66BFF;font-size:12px;margin-top:4px;">'+p.name+'</div>':''); wall.appendChild(f); }); }

  /* color lesson grid */
  (function(){ var g=$('bk-lesson-grid'); Object.keys(C.FEELINGS).forEach(function(hex){ var f=C.FEELINGS[hex]; var c=document.createElement('div'); c.style.cssText='border:2px solid rgba(166,107,255,.2);border-radius:14px;padding:12px 8px;text-align:center;cursor:pointer;background:#fff;'; c.innerHTML='<div style="width:34px;height:34px;border-radius:50%;margin:0 auto 6px;border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.18);background:'+hex+'"></div><div style="font-family:var(--head);font-weight:700;">'+f.feel+'</div><div style="font-size:12px;color:#A66BFF;">'+f.ko+' . '+f.rom+'</div>'; c.onclick=function(){sayKoEn(f.ko,f.feel);}; g.appendChild(c); }); })();

  /* modals */
  function openModal(id){ $(id).classList.add('open'); } function closeModal(id){ $(id).classList.remove('open'); }
  $('bk-disc').onclick=function(){ if(C.LINKS.disclaimerUrl){location.href=C.LINKS.disclaimerUrl;return;} openModal('bk-disc-modal'); };
  (function(){ var fl=$('bk-disc-full'), u=C.LINKS.disclaimerFullUrl; if(fl){ if(u&&u.trim()){ fl.href=u; fl.hidden=false; } else { fl.hidden=true; } } })();
  $('bk-disc-close').onclick=function(){closeModal('bk-disc-modal');};
  $('bk-museum').onclick=function(){renderMuseum();openModal('bk-museum-modal');};
  $('bk-museum-close').onclick=function(){closeModal('bk-museum-modal');};
  $('bk-lesson-open').onclick=function(){openModal('bk-lesson-modal');};
  $('bk-lesson-close').onclick=function(){closeModal('bk-lesson-modal');};
  root.querySelectorAll('.bk-modal').forEach(function(m){ m.addEventListener('click',function(e){ if(e.target===m)m.classList.remove('open'); }); });

  /* links */
  function safe(u){ return (u&&u.trim())?u:'/pages/coming-soon'; }
  $('bk-freelink').href=safe(C.LINKS.freePack);
  $('bk-clicknow').onclick=function(){ location.href=safe(C.LINKS.mainHub); };
  $('bk-mainhub').onclick=function(){ location.href=safe(C.LINKS.mainHub); };
  $('bk-hub').onclick=function(){ location.href=safe(C.LINKS.kpotHub); };
  /* v18: the glowing game buttons, built from CONFIG (one per link) */
  (function(){ var row=$('bk-bonusrow'); if(!row)return;
    var list=C.LINKS.bonusGames;
    if(typeof list==='string') list=[{label:'Bonus Family Games', url:list}];
    if(!list||!list.length){ row.hidden=true; return; }
    var icon=(C.bonusIcon&&C.bonusIcon.trim())?C.bonusIcon:((C.emblemUrl&&C.emblemUrl.trim())?C.emblemUrl:'');
    list.forEach(function(g){ if(!g||!g.url)return;
      var b=document.createElement('button'); b.type='button'; b.className='bk-bonus'+(g.tint?' '+g.tint:'');
      var ic=(g.icon&&g.icon.trim())?g.icon:icon;
      if(ic){ var im=document.createElement('img'); im.className='bk-pop'; im.src=ic; im.alt=''; im.setAttribute('aria-hidden','true'); b.appendChild(im); }
      else { var em=document.createElement('span'); em.className='em'; em.textContent='🔥'; b.appendChild(em); }
      b.appendChild(document.createTextNode(' '+(g.label||'Bonus Games')));
      b.style.margin='6px';
      b.onclick=function(){ location.href=safe(g.url); };
      row.appendChild(b); }); })();

  /* v18: the Spin a Feeling doorway */
  (function(){ var w=$('bk-trailerwrap'), b=$('bk-trailer'), u=C.LINKS&&C.LINKS.trailer;
    if(!w||!b||!u||!u.trim()){ if(w)w.hidden=true; return; } w.hidden=false;
    b.onclick=function(){ var url=u.trim();
      if(/youtube\.com|youtu\.be|vimeo\.com/i.test(url)){ window.open(url,'_blank','noopener'); return; }
      var m=document.createElement('div'); m.className='bk-prizemodal on';
      var v=document.createElement('video'); v.src=url; v.controls=true; v.playsInline=true; v.autoplay=true;
      var x=document.createElement('button'); x.className='pclose'; x.type='button'; x.textContent='✕ Close';
      m.appendChild(v); m.appendChild(x); root.appendChild(m);
      x.onclick=function(){ m.remove(); }; v.addEventListener('ended',function(){ m.remove(); });
    };
  })();
  (function(){ var d=$('bk-wheel-door'); if(d){ if(C.LINKS.wheel&&C.LINKS.wheel.trim()){ d.href=safe(C.LINKS.wheel); } else { d.parentNode.style.display='none'; } } })();

  /* v18: the Tuesday shelf, lazy thumbs, never slows the page */
  (function(){ var wrap=$('bk-vol'), row=$('bk-volrow'); if(!wrap||!row)return;
    var g=C.GALLERY||[]; if(!g.length){ return; }
    wrap.hidden=false;
    g.forEach(function(e){ if(!e)return;
      var here=!!e.here, el=document.createElement(here?'div':'a'); el.className='bk-volcard';
      if(!here){ el.href=safe(e.url||'#'); }
      var th=document.createElement('div'); th.className='th';
      if(e.thumb&&e.thumb.trim()){ var im=document.createElement('img'); im.src=e.thumb; im.alt=(e.name||'')+' coloring page'; im.loading='lazy'; th.appendChild(im); }
      else if(here&&C.BADGE.image&&C.BADGE.image.trim()){ th.classList.add('lionth'); var li=document.createElement('img'); li.className='bk-lion'; li.src=C.BADGE.image; li.alt=(e.name||'')+' sticker character'; li.style.cssText='position:absolute;inset:0;width:100%;height:100%;object-fit:contain;padding:6%;'; th.style.position='relative'; th.appendChild(li); }
      else { th.textContent=e.emoji||'🎨'; }
      el.appendChild(th);
      var nm=document.createElement('div'); nm.className='nm'; nm.textContent=e.name||''; el.appendChild(nm);
      var en=document.createElement('div'); en.className='en'; en.textContent='Entry '+(e.entry||''); el.appendChild(en);
      if(here){ var hb=document.createElement('span'); hb.className='here'; hb.textContent='You are here'; el.appendChild(hb); }
      row.appendChild(el); });
    var t=document.createElement('div'); t.className='bk-volcard tease';
    t.innerHTML='<div class="th lockth"><span class="bk-mystery" aria-hidden="true"><i>?</i></span><span class="bk-lockbub">A new feeling lands Tuesday ⏳</span></div><div class="nm">Next Tuesday</div><div class="en">A new feeling</div>';if(C.LINKS.countdown&&C.LINKS.countdown.trim()){ t.querySelector('.bk-lockbub').textContent='Tap for the countdown ⏳'; t.style.cursor='pointer'; t.setAttribute('role','link'); t.setAttribute('tabindex','0'); t.onclick=function(){ location.href=safe(C.LINKS.countdown); }; }
    row.appendChild(t); })();

  /* v18: see it framed */
  (function(){ var btn=$('bk-framed'); if(!btn)return;
    var fm=$('bk-frame-modal'), box=$('bk-frame-art-box'), art=$('bk-frame-art'), fr=$('bk-frame-img');
    var frames=(C.PREVIEW_FRAMES&&C.PREVIEW_FRAMES.length)?C.PREVIEW_FRAMES:(C.PREVIEW_FRAME&&C.PREVIEW_FRAME.url?[C.PREVIEW_FRAME]:[]);
    var fi=Math.floor(Math.random()*Math.max(1,frames.length));
    btn.onclick=function(){
      if(frames.length){ var f=frames[fi%frames.length]; fi++;
        var inset=Math.max(0,Math.min(40,+f.inset||17)); box.style.inset=inset+'%';
        fr.src=f.url; fr.style.display='block';
      } else { fr.style.display='none'; box.style.inset='17%'; }
      var src='';
      try{ if(ready) src=canvas.toDataURL('image/png'); }catch(e){}
      if(!src) src=(C.coloredUrl&&C.coloredUrl.trim())?C.coloredUrl:C.lineArtUrl;
      art.src=src;
      openModal('bk-frame-modal');
    };
    $('bk-frame-close').onclick=function(){ closeModal('bk-frame-modal'); }; })();
  (function(){ if(C.qrImage&&C.qrImage.trim()) $('bk-qr').innerHTML='<img alt="QR to the Heartopedia" src="'+C.qrImage+'">'; })();

  /* signup */
  $('bk-su-btn').onclick=function(){ var email=($('bk-su-email').value||'').trim(), ok=$('bk-su-consent').checked;
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ alert('Please enter a valid email.'); return; }
    if(!ok){ alert('Please confirm you are a grown up (18 or older).'); return; }
    if(C.SIGNUP.action){ try{ fetch(C.SIGNUP.action,{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},mode:'no-cors',body:'form_type=contact&utf8=%E2%9C%93&contact%5Bemail%5D='+encodeURIComponent(email)+'&contact%5Btags%5D=heartopedia-tuesday'}); }catch(e){} }
    var o=$('bk-su-ok'); o.textContent=C.SIGNUP.thanks; o.style.display='block'; $('bk-su-email').value=''; $('bk-su-consent').checked=false; };

  /* (v32) the cheer never auto-fires on a timer anymore; it only appears on a real Hype tap or a coloring milestone */



  /* ==== v30: THE MINDFUL BREAK ==== */
  (function(){ var B=C.BREAK||{}; if(!B.enabled)return;
    var shown=false;
    setTimeout(function(){ if(shown)return; shown=true;
      var card=document.createElement('div'); card.className='bk-breakcard';
      card.innerHTML='<img alt="Mindful Bacci"><div><p></p><div class="row"><button class="b1" type="button">🧘 Breathe with Bacci</button><button class="b2" type="button">Keep creating</button></div></div>';
      card.querySelector('img').src=B.img||''; card.querySelector('p').textContent=B.msg||'Want a tiny breathing break?';
      root.appendChild(card); requestAnimationFrame(function(){card.classList.add('up');});
      function off(){ card.classList.remove('up'); setTimeout(function(){card.remove();},800); }
      card.querySelector('.b2').onclick=off;
      card.querySelector('.b1').onclick=function(){ off();
        var v=document.createElement('div'); v.className='bk-breathveil on';
        v.innerHTML='<div class="bk-breath">Breathe</div><div class="bk-breathword">In… and out… three times 💛</div>';
        root.appendChild(v);
        var rm=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(function(){ v.querySelector('.bk-breathword').textContent='Beautiful. Back to creating 💛';
          setTimeout(function(){ v.remove(); }, 1600); }, rm?1200:24000);
        v.addEventListener('click',function(){ v.remove(); }); };
      setTimeout(function(){ if(card.parentNode) off(); }, 30000);
    }, Math.max(1,(+B.minutes||14))*60000);
  })();

  /* ==== v30: THE PRIZE CELEBRATION (dormant until CONFIG.PRIZE.videoUrl is set) ==== */
  (function(){ var P=C.PRIZE||{}; if(!(P.videoUrl&&P.videoUrl.trim()))return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function rain(n){ if(reduce)return; var cols=['#FFC542','#FF8FC6','#A66BFF','#7DFCF4','#FFE08A','#FF6FAE'];
      for(var i=0;i<n;i++){ var c=document.createElement('span'); c.className='bk-confettirain';
        c.style.left=(Math.random()*100)+'vw'; c.style.background=cols[i%cols.length];
        c.style.width=(8+Math.random()*10)+'px'; c.style.height=(12+Math.random()*14)+'px';
        c.style.animationDuration=(3.4+Math.random()*2.6)+'s'; c.style.animationDelay=(Math.random()*1.4)+'s';
        document.body.appendChild(c); (function(el){setTimeout(function(){el.remove();},7500);})(c); } }
    function showCat(){ var b=document.createElement('button'); b.type='button'; b.className='bk-prizecat on';
      b.innerHTML='<img src="https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Congratulations_You_won_this_Prize_only_1.png?v=1772482245" alt="Prize Bacci"><span></span>';
      b.querySelector('span').textContent=P.invite||'You won a prize! Tap to open!';
      b.onclick=function(){ b.remove(); openVideo(); };
      root.appendChild(b); rain(80); }
    function openVideo(){ var m=document.createElement('div'); m.className='bk-prizemodal on';
      var v=document.createElement('video'); v.src=P.videoUrl; v.controls=true; v.playsInline=true; v.autoplay=true;
      if(P.posterUrl&&P.posterUrl.trim()) v.poster=P.posterUrl;
      var x=document.createElement('button'); x.className='pclose'; x.type='button'; x.textContent='✕ Close';
      m.appendChild(v); m.appendChild(x); root.appendChild(m);
      function finish(){ m.remove(); royalOpen(); }
      x.onclick=finish; v.addEventListener('ended',finish); }
    function royalOpen(){ var bk=$('bk-book'); if(!bk)return;
      bk.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});
      var sweep=document.createElement('div'); sweep.className='bk-goldsweep'; root.appendChild(sweep);
      setTimeout(function(){sweep.remove();},4200);
      bk.classList.add('bk-royal');
      setTimeout(function(){ bk.classList.add('open'); },600);
      if(P.secretUrl&&P.secretUrl.trim()){ var g=document.createElement('button'); g.type='button'; g.className='bk-secretgo'; g.textContent='Enter the Vault of Hearts ✨'; g.style.display='block';
        g.onclick=function(){ location.href=safe(P.secretUrl); };
        root.appendChild(g); setTimeout(function(){ g.remove(); },20000); } }
    var fired=false;
    var ob2=new MutationObserver(function(){ if(!fired&&root.classList.contains('bk-earned')){ fired=true; setTimeout(showCat,1200); ob2.disconnect(); } });
    ob2.observe(root,{attributes:true,attributeFilter:['class']});
  })();

  /* ==== v29: FOCUS MODE, the calm reading theater ==== */
  (function(){ var btn=$('bk-focus'), bk=$('bk-book'); if(!btn||!bk)return;
    var veil=document.createElement('div'); veil.className='bk-focusveil'; root.appendChild(veil);
    var exitB=document.createElement('button'); exitB.type='button'; exitB.className='bk-focusexit'; exitB.textContent='✕ Exit focus'; root.appendChild(exitB);
    function setOn(on){ root.classList.toggle('bk-focuson',on); btn.setAttribute('aria-pressed',on?'true':'false');
      btn.textContent=on?'✕ Exit focus':'🌙 Focus mode';
      if(on){ if(!bk.classList.contains('open')) bk.classList.add('open');
        try{ document.documentElement.requestFullscreen&&document.documentElement.requestFullscreen(); }catch(e){}
      } else { try{ document.fullscreenElement&&document.exitFullscreen&&document.exitFullscreen(); }catch(e){} } }
    btn.onclick=function(){ setOn(!root.classList.contains('bk-focuson')); };
    exitB.onclick=function(){ setOn(false); };
    veil.addEventListener('click',function(){ setOn(false); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&root.classList.contains('bk-focuson')) setOn(false); });
    document.addEventListener('fullscreenchange',function(){ if(!document.fullscreenElement&&root.classList.contains('bk-focuson')){ /* user pressed Esc in fullscreen, stay in theater until they exit */ } });
  })();

  /* ==== v28: the page-turn magic, the warm finish, the sticker cheer, the tuck, the sparkle trail ==== */
  (function(){
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nextBtn=$('bk-next');
    /* proximity glow on Next page */
    if(nextBtn&&!reduce){
      var last=0;
      document.addEventListener('mousemove',function(e){
        var now=Date.now(); if(now-last<80)return; last=now;
        var r=nextBtn.getBoundingClientRect();
        if(r.width===0)return;
        var cx=Math.max(r.left,Math.min(e.clientX,r.right)), cy=Math.max(r.top,Math.min(e.clientY,r.bottom));
        var d=Math.hypot(e.clientX-cx,e.clientY-cy);
        nextBtn.classList.toggle('bk-near', d<140);
      },{passive:true});
    }
    /* soft chime, two gentle sine notes, original and license free */
    function chime(){ if(reduce)return; try{ var AC=window.AudioContext||window.webkitAudioContext; if(!AC)return; var ac=chime.ac||(chime.ac=new AC());
      [523.25,783.99].forEach(function(f,i){ var o=ac.createOscillator(),g=ac.createGain(); o.type='sine'; o.frequency.value=f;
        g.gain.setValueAtTime(0.0001,ac.currentTime); g.gain.exponentialRampToValueAtTime(0.05,ac.currentTime+0.04+i*0.09);
        g.gain.exponentialRampToValueAtTime(0.0001,ac.currentTime+0.9+i*0.09);
        o.connect(g); g.connect(ac.destination); o.start(ac.currentTime+i*0.09); o.stop(ac.currentTime+1.1+i*0.09); }); }catch(e){} }
    /* the burst: translucent orbs + the pink heart */
    function pageBurst(x,y){ if(reduce)return;
      var colors=['rgba(255,143,198,.55)','rgba(125,252,244,.5)','rgba(196,165,255,.55)','rgba(255,224,138,.55)','rgba(255,214,231,.6)'];
      for(var i=0;i<14;i++){ var o=document.createElement('span'); o.className='bk-orb';
        var sz=14+Math.random()*42; o.style.width=o.style.height=sz+'px';
        o.style.left=(x-sz/2)+'px'; o.style.top=(y-sz/2)+'px';
        o.style.setProperty('--orbc',colors[i%colors.length]);
        o.style.setProperty('--ox',((Math.random()-.5)*260)+'px'); o.style.setProperty('--oy',(-60-Math.random()*200)+'px');
        o.style.animationDelay=(Math.random()*.15)+'s';
        document.body.appendChild(o); (function(el){setTimeout(function(){el.remove();},1900);})(o); }
      var h=document.createElement('span'); h.className='bk-heartpop'; h.textContent='💖';
      h.style.left=(x-27)+'px'; h.style.top=(y-27)+'px'; document.body.appendChild(h);
      setTimeout(function(){h.remove();},1300);
      var ph=['💗','💖','💕','💞','🩷'];
      for(var hi=0;hi<11;hi++){ (function(hi){ var s=document.createElement('span'); s.textContent=ph[hi%ph.length];
        s.style.cssText='position:fixed;left:'+x+'px;top:'+y+'px;font-size:'+(15+Math.random()*13)+'px;pointer-events:none;z-index:9999;will-change:transform,opacity;transition:transform 1.15s cubic-bezier(.2,.8,.4,1),opacity 1.15s ease;';
        document.body.appendChild(s);
        var ang=-Math.PI/2+(Math.random()-.5)*1.7, dist=70+Math.random()*120;
        requestAnimationFrame(function(){ s.style.transform='translate('+(Math.cos(ang)*dist).toFixed(1)+'px,'+(Math.sin(ang)*dist-40).toFixed(1)+'px) scale(.7) rotate('+((Math.random()-.5)*60).toFixed(0)+'deg)'; s.style.opacity='0'; });
        setTimeout(function(){ s.remove(); },1250); })(hi); }
      chime(); }
    if(nextBtn){ nextBtn.addEventListener('click',function(e){ var r=nextBtn.getBoundingClientRect(); pageBurst(r.left+r.width/2, r.top); }); }

    /* the warm finish: Bacci thanks the artist when the sticker is earned */
    var doneShown=false;
    function showDone(){ if(doneShown||!(C.DONE&&C.DONE.msg))return; doneShown=true;
      var d=document.createElement('div'); d.className='bk-donecard';
      d.innerHTML='<img src="https://cdn.shopify.com/s/files/1/0500/7307/5871/files/bacci-superhero-cat-boy-transparent-4x.png?v=1781137994" alt="Superhero Bacci"><p></p><button class="x" aria-label="Close">✕</button>';
      d.querySelector('p').textContent=C.DONE.msg;
      d.querySelector('.x').onclick=function(){ d.classList.remove('up'); setTimeout(function(){d.remove();},700); };
      root.appendChild(d); requestAnimationFrame(function(){ d.classList.add('up'); });
      if(!reduce){ var r=root.getBoundingClientRect(); pageBurst(window.innerWidth/2, window.innerHeight-160); }
      setTimeout(function(){ if(d.parentNode){ d.classList.remove('up'); setTimeout(function(){d.remove();},700);} },12000); }
    var ob=new MutationObserver(function(){ if(root.classList.contains('bk-earned')){ showDone(); ob.disconnect(); } });
    ob.observe(root,{attributes:true,attributeFilter:['class']});

    /* the sticker cheer: hover the lion, get a Congratulations and hearts */
    (function(){ var st=$('bk-sticker'); if(!st)return; st.style.position='relative'; st.style.overflow='visible';
      var busy=false;
      st.addEventListener('mouseenter',function(){ if(busy||reduce)return; busy=true;
        var b=document.createElement('div'); b.className='bk-tipbub'; b.style.left='50%'; b.style.transform='translateX(-50%)'; b.textContent='Congratulations! 🎉'; st.appendChild(b);
        var hearts=['💗','💖','💕'];
        for(var i=0;i<8;i++){ var h=document.createElement('span'); h.className='bk-heart'; h.textContent=hearts[i%3];
          h.style.left=(10+Math.random()*80)+'%'; h.style.top='30%';
          h.style.setProperty('--hx',((Math.random()-.5)*120)+'px'); h.style.setProperty('--hy',(-50-Math.random()*90)+'px'); h.style.setProperty('--hr',((Math.random()-.5)*50)+'deg');
          st.appendChild(h); }
        setTimeout(function(){ st.querySelectorAll('.bk-tipbub,.bk-heart').forEach(function(n){n.remove();}); busy=false; },1500); }); })();

    /* the tuck: collapse the storybook and come right back */
    (function(){ var bk=$('bk-book'); if(!bk)return;
      var t=document.createElement('button'); t.type='button'; t.className='bk-tuck'; t.textContent='Tuck the book away 📖';
      bk.parentNode.insertBefore(t,bk.nextSibling);
      t.onclick=function(){ var on=bk.classList.toggle('bk-tucked'); t.textContent=on?'Open the storybook 📖':'Tuck the book away 📖'; if(!on){ bk.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'}); } }; })();

    /* the sparkle trail, story section only */
    (function(){ if(reduce)return; var bk=$('bk-book'); if(!bk)return; bk.style.position='relative';
      var lastS=0; var pal=['#FFD6E7','#C4A5FF','#7DFCF4','#FFE08A','#FFC0DC'];
      bk.addEventListener('mousemove',function(e){ var now=Date.now(); if(now-lastS<55)return; lastS=now;
        var r=bk.getBoundingClientRect(); var sp=document.createElement('span'); sp.className='bk-spark';
        sp.style.left=(e.clientX-r.left+(Math.random()-.5)*10)+'px'; sp.style.top=(e.clientY-r.top+(Math.random()-.5)*10)+'px';
        sp.style.setProperty('--spc',pal[~~(Math.random()*pal.length)]);
        bk.appendChild(sp); setTimeout(function(){sp.remove();},950); },{passive:true}); })();
  })();
})();

  

/* ---- next engine block ---- */


/* ===== THE CINEMATIC INTRO  .  full screen brand film, once per visitor, instant skip ===== */
(function(){
  var C=(typeof BK_HX_CONFIG!=='undefined')?BK_HX_CONFIG:null; if(!C) return;
  var V=C.CINEMATIC; if(!V||!V.enabled||!V.url||!(''+V.url).trim()) return;
  var level=(window.BKMotion&&BKMotion.get)?BKMotion.get():((window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)?'calm':'standard');
  var reduce=(level==='calm'), immersive=(level==='immersive');
  var key=V.storageKey||'bk_cinematic_seen';
  if(V.oncePerVisitor!==false){ try{ if(localStorage.getItem(key)==='1') return; }catch(e){} }
  if(reduce&&V.reducedMotionSkip===true){ try{ localStorage.setItem(key,'1'); }catch(e){} return; }
  function go(){
    if(document.getElementById('bk-cinematic')) return;
    try{ localStorage.setItem(key,'1'); }catch(e){}
    var level=(window.BKMotion&&BKMotion.get)?BKMotion.get():'standard';
    var reduce=(level==='calm'), immersive=(level==='immersive');
    var emerge=(V.emerge!==false) && !reduce;
    var cover=(V.fit==='cover');
    /* the film: cover fills and crops (hides the portal); contain keeps the whole film inside the royal frame */
    var videoCss=cover
      ? 'position:absolute;inset:0;z-index:2;width:100%;height:100%;object-fit:cover;background:#000;'
      : 'position:relative;z-index:2;max-width:96vw;max-height:92vh;width:auto;height:auto;object-fit:contain;background:#000;border-radius:8px;'+
        'box-shadow:0 0 0 1px rgba(255,232,140,.35),0 0 60px rgba(166,107,255,.55),0 0 120px rgba(0,198,198,.3);';
    if(emerge) videoCss+='opacity:0;transform:scale(.94);transition:opacity .8s ease,transform .9s cubic-bezier(.2,.7,.2,1);';
    var st=document.createElement('style');
    st.textContent='#bk-cinematic{position:fixed;inset:0;z-index:2147483600;display:flex;align-items:center;justify-content:center;overflow:hidden;opacity:0;transition:opacity .6s ease;'+
        'background:radial-gradient(ellipse 62% 72% at 50% 44%,#3a1a6e 0%,#1a0b3e 40%,#0a0518 74%,#04020c 100%);}'+
      '#bk-cinematic.on{opacity:1;}'+
      '#bk-cinematic .bk-cine-aura{position:absolute;inset:-25%;z-index:0;pointer-events:none;filter:blur(72px);opacity:.5;'+
        'background:conic-gradient(from 0deg at 50% 50%,rgba(166,107,255,.3),rgba(0,198,198,.2),rgba(255,197,66,.16),rgba(255,111,191,.26),rgba(166,107,255,.3));animation:bkCineAura 26s linear infinite;}'+
      '#bk-cinematic .bk-cine-glow{position:absolute;z-index:0;width:74vmin;height:74vmin;border-radius:50%;pointer-events:none;filter:blur(38px);'+
        'background:radial-gradient(closest-side,rgba(166,107,255,.5),rgba(0,198,198,.22),transparent 72%);animation:bkCinePulse 5.5s ease-in-out infinite;}'+
      '#bk-cinematic .bk-cine-mote{position:absolute;z-index:1;border-radius:50%;background:#fff;pointer-events:none;'+
        'box-shadow:0 0 6px 1px rgba(255,255,255,.85);animation:bkCineFloat linear infinite;}'+
      '#bk-cinematic .bk-cine-col{position:absolute;top:0;bottom:0;z-index:1;width:clamp(54px,9vw,140px);pointer-events:none;}'+
      '#bk-cinematic .bk-cine-col.l{left:0;background:linear-gradient(90deg,transparent,rgba(201,151,31,.18) 24%,rgba(255,236,170,.42) 50%,rgba(201,151,31,.18) 76%,transparent);}'+
      '#bk-cinematic .bk-cine-col.r{right:0;background:linear-gradient(270deg,transparent,rgba(201,151,31,.18) 24%,rgba(255,236,170,.42) 50%,rgba(201,151,31,.18) 76%,transparent);}'+
      '#bk-cinematic .bk-cine-col::before{content:"";position:absolute;inset:0;background:repeating-linear-gradient(90deg,rgba(255,255,255,.10) 0 2px,transparent 2px 9px);}'+
      '#bk-cinematic video{'+videoCss+'}'+
      '#bk-cinematic.bk-play video{opacity:1;transform:none;}'+
      '#bk-cinematic .bk-cine-skip{position:fixed;top:18px;right:20px;z-index:5;font-family:Fredoka,system-ui,sans-serif;font-weight:700;font-size:16px;color:#3a2e5c;background:linear-gradient(135deg,#FFE08A,#FFC542);border:3px solid #fff;border-radius:999px;padding:11px 22px;cursor:pointer;box-shadow:0 8px 26px rgba(0,0,0,.5);transition:transform .15s ease;}'+
      '#bk-cinematic .bk-cine-skip:hover{transform:translateY(-2px);}'+
      '#bk-cinematic .bk-cine-sound{position:fixed;bottom:22px;right:22px;z-index:5;font-family:Fredoka,system-ui,sans-serif;font-weight:700;font-size:14px;color:#fff;background:rgba(255,255,255,.16);border:2px solid rgba(255,255,255,.55);border-radius:999px;padding:9px 18px;cursor:pointer;}'+
      '@keyframes bkCineAura{to{transform:rotate(360deg);}}'+
      '@keyframes bkCinePulse{0%,100%{opacity:.55;transform:scale(1);}50%{opacity:.95;transform:scale(1.08);}}'+
      '@keyframes bkCineFloat{0%{transform:translateY(24px);opacity:0;}12%{opacity:.9;}88%{opacity:.7;}100%{transform:translateY(-110vh);opacity:0;}}'+
      '#bk-cinematic.bk-calm .bk-cine-aura,#bk-cinematic.bk-calm .bk-cine-glow,#bk-cinematic.bk-calm .bk-cine-mote{animation:none!important;}'+
      '#bk-cinematic.bk-calm video{transition:none!important;opacity:1!important;transform:none!important;}'+
      '#bk-cinematic.bk-immersive .bk-cine-col{transition:transform .22s ease;}'+
      '@media(prefers-reduced-motion:reduce){#bk-cinematic .bk-cine-aura,#bk-cinematic .bk-cine-glow,#bk-cinematic .bk-cine-mote{animation:none!important;}#bk-cinematic video{transition:none!important;opacity:1!important;transform:none!important;}}';
    document.head.appendChild(st);
    var ov=document.createElement('div'); ov.id='bk-cinematic';
    if(reduce) ov.classList.add('bk-calm'); if(immersive) ov.classList.add('bk-immersive');
    /* the royal surround: cosmic aura, pulsing glow, drifting motes, grand gold pillars */
    if(V.portal){
      var aura=document.createElement('span'); aura.className='bk-cine-aura'; ov.appendChild(aura);
      var glow=document.createElement('span'); glow.className='bk-cine-glow'; ov.appendChild(glow);
      if(!reduce) for(var i=0;i<16;i++){ var mt=document.createElement('span'); mt.className='bk-cine-mote';
        var sz=(Math.random()*3+1.5).toFixed(1);
        mt.style.width=sz+'px'; mt.style.height=sz+'px';
        mt.style.left=(Math.random()*100).toFixed(1)+'%';
        mt.style.top=(Math.random()*100).toFixed(1)+'%';
        mt.style.animationDuration=(Math.random()*10+10).toFixed(1)+'s';
        mt.style.animationDelay=(-Math.random()*16).toFixed(1)+'s';
        ov.appendChild(mt);
      }
      if(V.columns){ var cl=document.createElement('span'); cl.className='bk-cine-col l'; var cr=document.createElement('span'); cr.className='bk-cine-col r'; ov.appendChild(cl); ov.appendChild(cr); }
    }
    var vid=document.createElement('video'); vid.src=V.url; vid.muted=true; vid.setAttribute('muted',''); vid.playsInline=true; vid.setAttribute('playsinline',''); vid.autoplay=true; vid.preload='auto';
    if(V.poster&&(''+V.poster).trim()) vid.poster=V.poster;
    var skip=document.createElement('button'); skip.type='button'; skip.className='bk-cine-skip'; skip.textContent=V.skipLabel||'Skip ›';
    var snd=document.createElement('button'); snd.type='button'; snd.className='bk-cine-sound'; snd.textContent=V.soundLabel||'🔊 Sound';
    ov.appendChild(vid); ov.appendChild(skip); ov.appendChild(snd);
    document.body.appendChild(ov);
    window.__bkCinematicActive=true;
    var pe=document.documentElement.style.overflow, pb=document.body.style.overflow;
    document.documentElement.style.overflow='hidden'; document.body.style.overflow='hidden';
    requestAnimationFrame(function(){ ov.classList.add('on'); });
    function tryplay(){ try{ var p=vid.play(); if(p&&p.catch) p.catch(function(){}); }catch(e){} }
    var closed=false;
    /* the calm settle, then the film emerges and begins */
    var settle=(typeof V.settleMs==='number')?Math.max(0,V.settleMs):700;
    var started=false;
    function start(){ if(started||closed) return; started=true; ov.classList.add('bk-play'); tryplay(); }
    setTimeout(start, settle);
    if(immersive){ ov.addEventListener('pointermove',function(e){ var cx=(e.clientX/(window.innerWidth||1)-0.5); if(cl) cl.style.transform='translateX('+(cx*12).toFixed(1)+'px)'; if(cr) cr.style.transform='translateX('+(cx*12).toFixed(1)+'px)'; }); }
    function close(){ if(closed) return; closed=true;
      try{ vid.pause(); }catch(e){}
      ov.classList.remove('on');
      document.documentElement.style.overflow=pe; document.body.style.overflow=pb;
      window.__bkCinematicActive=false;
      try{ window.dispatchEvent(new Event('bk-cinematic-done')); }catch(e){}
      setTimeout(function(){ if(ov.parentNode) ov.parentNode.removeChild(ov); if(st.parentNode) st.parentNode.removeChild(st); }, 600);
    }
    skip.addEventListener('click',function(e){ e.stopPropagation(); close(); });
    snd.addEventListener('click',function(e){ e.stopPropagation(); vid.muted=!vid.muted; snd.textContent=vid.muted?(V.soundLabel||'🔊 Sound'):'🔇 Mute'; if(!started) start(); else if(vid.paused) tryplay(); });
    if(V.tapToSkip===true) ov.addEventListener('click',function(e){ if(e.target===skip||e.target===snd) return; close(); });
    vid.addEventListener('ended', close);
    vid.addEventListener('error', close);
    document.addEventListener('keydown',function onk(e){ if(e.key==='Escape'){ document.removeEventListener('keydown',onk); close(); } });
  }
  window.BKCinematic={ play:function(){ go(); } };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',go,{once:true}); else go();
})();


/* ---- next engine block ---- */


/* theme adapter: hide Shopify page title above the experience */
(function(){ var root=document.getElementById('bk-hx'); if(!root)return;
  function init(){ try{ document.documentElement.style.overflowX='clip'; document.body.style.overflowX='clip';
    var main=root.closest('main')||document.body; var c=main.querySelectorAll('.main-page-title,.page-title,h1');
    for(var i=0;i<c.length;i++){ var el=c[i]; if(root.contains(el))continue; var pos=el.compareDocumentPosition(root); if(pos&Node.DOCUMENT_POSITION_FOLLOWING){ if(el.closest('.page-width,.template-page,.shopify-section'))el.style.display='none'; break; } } }catch(e){} }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();


/* ---- next engine block ---- */


/* =====================================================================
   v43 BILINGUAL LAYER  v2  .  English / Korean whole-page toggle
   ADDITIVE: the English engine above is untouched. This rides on top.
   .................................................................
   KOREAN IS DRAFT. Machine-assisted, MUST be reviewed by a native
   Korean speaker before launch (locked Bacci Kid rule). To edit, change
   only the text in KO_BYID / KO_TEXT below. No engine edits needed.
   ===================================================================== */
(function(){
  var root=document.getElementById('bk-hx'); if(!root) return;
  var lang='en', busy=false;
  function trim(s){ return (s||'').replace(/\s+/g,' ').trim(); }

  /* ---- 1. LONG / PAGE-SPECIFIC COPY, swapped by element id ---- */
  var KO_BYID={
    "bk-word":"용감함",
    "bk-subtitle":"엔트리 002 · 청소년 · 선을 따라 안쪽을 탭하면 색칠돼요",
    "bk-tagline":"색칠 페이지, 이야기책, 그리고 감정의 미술관이 하나로.",
    "bk-hook":"용감함은 두려움이 없는 게 아니에요. 누군가 우는 소리를 들었을 때 돌아서는 거예요. 그 누군가가 바로 나일 때에도요.",
    "bk-story":"바치가 처음 시간을 뛰어넘었을 때, 세상은 커튼 사이로 비치는 빛처럼 갈라졌어요. 한 번 눈을 깜빡이니 작아졌고, 다시 깜빡이니 키가 컸어요. 한 번도 본 적 없는 옥상에 내려섰어요. 도시는 저 아래로 멀리까지 빛났어요. 그곳에는 그의 이름을 아는 사람이 하나도 없었어요. 새로 생긴 마음이 가슴에 비해 너무 큰 것 같았어요. 쿵쿵 뛰었어요. 그의 눈은 초록색에서 겁먹은 회색으로 깜빡였어요. 무서울 때면 늘 그러듯이요. 그때 울음소리가 들렸어요. 그는 돌아섰어요. 작은 달빛 웅덩이 속에, 구부러진 꼬리를 가진 새끼 고양이가 떨며 앉아 있었어요. 바치는 그 고양이를 알았어요. 바로 어린 시절의 자기 자신이었어요. '다들 나를 비웃었어, 내가 다르니까' 하고 작은 아이가 속삭였어요. 십 대의 바치는 도망치고 싶었지만, 빛 속으로 무릎을 꿇고 두려움이 그대로 있게 두었어요. 그리고 자기가 아는 가장 진실한 말을 했어요. '사람들이 비웃은 그것이 바로 너를 날게 해 줄 거야.' 새끼 고양이가 눈을 깜빡였어요. 구부러진 꼬리가 아주 조금 들렸어요. 바로 그곳에서 바치는 거의 아무도 소리 내어 말하지 않는 비밀을 깨달았어요. 용감함은 두려움이 없는 게 아니에요. 누군가 우는 소리를 들었을 때 돌아서는 거예요. 그 누군가가 바로 나일 때에도요. 그의 눈은 다시 초록색으로 따뜻해졌어요. 시간을 건너, 구부러진 꼬리를 가진 작은 고양이는 자신이 강한 누군가로 자라리라 믿기 시작했어요. 그 믿음은 옳았어요. 그는 자라서 바로 너가 되었어요.",
    "bk-closing":"바치는 너무 벅찬 날들에 도움이 되었기에 이 이야기를 간직했어요. 언젠가 너에게도 도움이 될지 몰라요. 어쩌면 아닐 수도 있고요. 어느 쪽이든, 이제 이건 너의 것이에요. 원할 때면 언제든 더 있어요. 색칠할 감정도 더, 만날 바치의 친구들도 더, 매주 화요일 새로운 이야기도요. 문은 열려 있어요. 언제든 다시 와요.",
    "bk-feelslike":"가슴속의 한결같은 따뜻함. 배 속이 간질거리고 손이 찌릿해도 '나는 할 수 있어' 하는 조용한 마음. 용감함은 두려움이 없는 게 아니에요. 두려움이 아직 방 안에 있는데도 다정하고 진실한 일을 하는 거예요.",
    "bk-when":"첫날. 손을 드는 일. 먼저 미안하다고 말하는 일. 친구를 위해 나서는 일. 잘 안 된 뒤에도 어려운 일을 한 번 더 해 보는 일.",
    "bk-world":"한국어로 용감함은 '용감'이에요. 세계 어디에서나 용기는 두려움이 없다는 뜻이 거의 아니에요. 그래도 움직이는 마음을 뜻해요.",
    "bk-prompt":"이번 주에 네가 한 용감한 일 하나를 말해 봐요. 아주 작은 것도 좋아요. 그 일을 하기 직전에 네 몸은 어떤 느낌이었나요?",
    "bk-bacci":"바치가 말해요: 용감함은 근육이에요. 작은 시도 하나하나가 그걸 더 크게 만들어요. 나는 너의 용감함을 봤어요. 너는 이미 가지고 있어요.",
    "bk-mantra":"나는 두려우면서도 동시에 용감할 수 있어요. 나는 다음 작은 한 걸음을 내디뎌요.",
    "bk-mood-intro":"색칠하기 전에, 지금 기분이 어떤지 확인해 볼 수 있어요. 원할 때만요.",
    "bk-tip-text":"안녕, 나는 바치야! 마음에 드는 색을 고르고, 그림 안쪽을 탭해서 색칠해 봐. 즐겁게!",
    "bk-cta":"매주 화요일, 색칠할 새로운 감정이 찾아와요. 언제나 무료, 언제나 너의 것.",
    "bk-su-h":"다음 화요일의 감정을 무료로 받기",
    "bk-su-sub":"어른이 신청하면 매주 화요일 새로운 무료 색칠 감정을 보내드려요. 광고 없음. 아이의 기기 밖으로 아무것도 나가지 않아요.",
    "bk-su-consent-t":"저는 18세 이상이며, 제 아이를 위해 신청합니다.",
    "bk-own":"Bacci Kid 캐릭터와 작품 © Dr. Jamie J. Karia. 일부 배경은 AI의 도움을 받았어요. 모든 Bacci Kid 캐릭터는 그녀의 원작이에요. 색칠 페이지는 개인적, 비상업적 용도로만 사용이 허락돼요. 페이지를 색칠해도 원작 그림이나 캐릭터에 대한 어떤 권리도 넘어가지 않아요. 색칠한 버전은 개인적인 즐거움을 위해 저장하고 인쇄할 수 있지만, 판매하거나 상업적으로 게시하거나 제품을 만드는 데 사용할 수 없어요.",
    "bk-disc-text":"바치 키드 하트오피디아는 감정 어휘와 평온함, 용기를 키우도록 돕는 창의적인 놀이 도구예요. 면허를 가진 임상가가 만들었지만 치료나 진단, 의학적 조언이 아니에요. 스티커와 배지, 바치 키드 골드 코인은 재미로 얻는 것이며 현금 가치가 없고 돈이나 상품으로 교환할 수 없어요. 모든 바치 키드 작품과 캐릭터는 Bacci Kid의 자산이에요. 페이지를 색칠해도 소유권은 넘어가지 않으며, 색칠한 사본은 개인적, 비상업적 용도로만 즐기고 저장하고 인쇄할 수 있어요. 색칠하거나 입력한 내용은 기기 밖으로 저장되거나 전송되지 않아요. 이메일 가입은 아이를 위한 성인(18세 이상)을 위한 것이에요. © 2026 Bacci Kid. 모든 권리 보유."
  };

  /* ---- 2. SHORT LABELS, swept by exact text (emoji prefixes handled) ---- */
  var KO_TEXT={
    "The Bacci Kid Heartopedia":"바치 키드 하트오피디아","🐾 The Bacci Kid Heartopedia":"🐾 바치 키드 하트오피디아",
    /* age toggles */
    "Toddler":"유아","Kids":"어린이","Tweens":"청소년 초기","Teens":"청소년","Grown ups":"어른","Seniors":"어르신",
    /* header switches */
    "Sound off":"소리 끔","Sound on":"소리 켬","Museum":"미술관","Color lesson":"색깔 수업",
    /* drawer */
    "Paint set":"물감 세트","Color theme":"색 테마","Texture":"질감","Finish":"마무리",
    "Undo":"되돌리기","Start over":"처음부터","Replay":"다시 보기","Back":"뒤로",
    "Save art":"그림 저장","Add to museum":"미술관에 추가","Certificate":"수료증",
    "See it framed":"액자에 넣어 보기","Print":"인쇄","Got it":"알겠어요",
    "Artist name (for the picture)":"작가 이름 (그림에)","A gift for (optional)":"선물 받는 사람 (선택)",
    /* paint readout */
    "Your color":"네가 고른 색","Say it":"말해 줘",
    "Calm Tide":"평온의 물결","Brave Ember":"용감의 불씨","Sunbeam Joy":"햇살 기쁨","Kindness Bloom":"친절의 꽃",
    "Hope Mist":"희망의 안개","Wonder Violet":"호기심 보라","Cozy Glow":"아늑한 빛","Peaceful Sky":"평화로운 하늘",
    "Grateful Blush":"감사의 발그레","Silly Spark":"장난 스파크","Deep Steady":"깊은 단단함","Snow Soft":"눈처럼 부드러움",
    /* palettes */
    "Feelings":"감정","Soft and Peaceful":"부드럽고 평화롭게","Bold and Brave":"당당하고 용감하게","Tokyo Neon":"도쿄 네온",
    "Candy Pop":"캔디 팝","Ocean Dream":"바다의 꿈","Golden Hour":"황금빛 노을","Bacci Signature":"바치 시그니처",
    "K-Pop Idol":"케이팝 아이돌","Fandom Lights":"팬덤 라이트","Seoul Neon Nights":"서울 네온 나이트",
    "Holographic Candy":"홀로그램 캔디","Full Spectrum":"풀 스펙트럼",
    /* textures */
    "Smooth":"매끈","Leopard":"표범","Cheetah":"치타","Waves":"물결","Dots":"점박이","Stripes":"줄무늬","Glitter":"글리터",
    /* finishes */
    "Bold Marker":"볼드 마커","Cozy Crayon":"코지 크레용","Dreamy Watercolor":"드리미 수채화","Glow Magic":"글로우 매직","Bling Shine":"블링 샤인",
    /* mood meter */
    "Bright":"밝음","Okay":"괜찮음","Low":"가라앉음","Heavy":"무거움","Not sure":"잘 모르겠어요",
    "Bright is lovely. Let's pour some of that into the picture.":"밝은 기분 좋아요. 그 기분을 그림에 담아 봐요.",
    "Okay is a real and fine place to be. Coloring can keep it company.":"괜찮은 것도 진짜 좋은 상태예요. 색칠이 함께해 줄 거예요.",
    "Thank you for noticing that. Go gentle. One soft color at a time is plenty.":"알아차려 줘서 고마워요. 천천히 해요. 부드러운 색 하나씩이면 충분해요.",
    "That sounds like a lot to carry. There is no goal here. Just color, or just rest. The door stays open.":"많이 무거운 마음 같아요. 여기엔 목표가 없어요. 색칠해도 되고, 그냥 쉬어도 돼요. 문은 늘 열려 있어요.",
    "Not sure is allowed. Maybe a color will help you find the word. Maybe not. Either way is okay.":"잘 모르겠는 것도 괜찮아요. 색이 그 말을 찾아 줄지도 몰라요. 아닐 수도 있고요. 어느 쪽이든 괜찮아요.",
    /* preview / book bar */
    "See Bacci's colors":"바치의 색 보기","(press and hold to peek)":"(길게 눌러 살짝 보기)",
    "(your art is safe underneath)":"(네 그림은 아래에 안전하게 있어요)","(tap to fade in and out)":"(눌러서 살짝 비춰 봐요)",
    "Listen in English":"영어로 듣기","Listen in Korean":"한국어로 듣기","한국어로 듣기 (Korean)":"한국어로 듣기",
    "Hear it in Korean":"한국어로 듣기","Another fun fact":"또 다른 재미있는 사실",
    "Focus mode":"집중 모드","Exit focus":"집중 모드 끄기","Back to cover":"표지로 돌아가기",
    "Previous page":"이전 쪽","Next page":"다음 쪽","Open the book":"책 펼치기","Stop":"멈춤",
    /* chapter headers */
    "Bacci's story":"바치의 이야기","From Bacci, to you":"바치가 너에게","What it feels like":"어떤 느낌인가요",
    "When you might feel it":"언제 느낄 수 있나요","Feelings around the world":"세계의 감정","Did you know":"알고 있나요",
    "Your turn":"너의 차례","The Bacci Kid Mantra":"바치 키드 만트라",
    /* tuesday shelf + gallery */
    "The Tuesday shelf":"화요일 선반","You are here":"지금 여기예요","Next Tuesday":"다음 화요일","A new feeling":"새로운 감정",
    "A new feeling lands Tuesday ⏳":"새로운 감정이 화요일에 도착해요 ⏳","Tap for the countdown ⏳":"눌러서 카운트다운 보기 ⏳",
    "Brave":"용감함",
    /* signup + cta */
    "Notify me":"알림 받기","Send my free Tuesday feeling":"무료 화요일 감정 보내기","Grown up's email":"보호자 이메일",
    "I am 18 or older and signing up for the child in my life.":"저는 18세 이상이며, 제 아이를 위해 신청합니다.",
    /* scan + hub */
    "Explore the whole Heartopedia and grab your":"하트오피디아 전체를 둘러보고",
    "free coloring pack":"무료 색칠 꾸러미",
    "A new word for your heart, every Tuesday.":"매주 화요일, 너의 마음을 위한 새로운 단어.",
    ". A new word for your heart, every Tuesday.":". 매주 화요일, 너의 마음을 위한 새로운 단어.",
    "SCAN":"스캔","FOR MORE":"더 보기","Open the hub now":"지금 허브 열기",
    /* wheel + bonus games */
    "Spin a Feeling":"감정 돌리기","A new dozen colours every day 👑":"매일 새로운 색 열두 가지 👑","Let’s get creative ✨":"창의력을 발휘해 봐요 ✨",
    "The Playful Pounce · Vol 1":"장난스러운 점프 · 1권","The Lucky Leap · Vol 2":"행운의 도약 · 2권",
    /* nav + footer */
    "Main color hub":"메인 색칠 허브","Disclaimer":"안내 사항","Back to KPOT hub":"KPOT 허브로",
    "Meow . Meow . Meow":"야옹 · 야옹 · 야옹","© 2026 Bacci Kid. All rights reserved.":"© 2026 Bacci Kid. 모든 권리 보유.",
    "A gentle note":"안내","Close":"닫기",
    "Stickers are earned, just for fun, and have no cash value. Art © 2026 Bacci Kid.":"스티커는 재미로 얻는 것이며 현금 가치가 없어요. 그림 © 2026 Bacci Kid.",
    /* loading / intro / mascot greeting */
    "Loading your picture...":"그림을 불러오는 중이에요...","Bringing Bacci to life":"바치를 살아나게 하는 중",
    "Sound":"소리","Mute":"음소거","Skip ›":"건너뛰기 ›",
    "Hi, I'm Bacci! Pick a color you love, then tap inside the picture to fill it. Have fun!":"안녕, 나는 바치야! 마음에 드는 색을 고르고, 그림 안쪽을 탭해서 색칠해 봐. 즐겁게!",
    /* hype */
    "Hype me!":"응원해 줘!","Meet the Hype Cheerleader Crew! Tap me 👇":"응원단을 만나 봐요! 나를 눌러요 👇",
    "Need an extra boost? Tap me! 👇":"힘이 더 필요해요? 나를 눌러요! 👇","Have fun! 💖":"즐겁게 색칠해요! 💖",
    "Look at you go! 🌟":"잘한다! 🌟","Your colors are glowing! ✨":"네 색이 빛나고 있어! ✨",
    "So brave, so bright! 💜":"정말 용감하고, 정말 빛나! 💜","That is YOUR masterpiece! 🎨":"그건 바로 너의 걸작이야! 🎨",
    "The Bright Sparks see you shining! 📣":"브라이트 스파크가 네가 빛나는 걸 보고 있어! 📣",
    "One color at a time, superstar! 🌈":"한 번에 한 색씩, 슈퍼스타! 🌈","Bacci is cheering for you! 🐾":"바치가 너를 응원하고 있어! 🐾",
    "Wow, that choice! Chef kiss! 💋":"와, 그 선택! 최고야! 💋","Keep going, the museum is waiting! 🖼️":"계속해, 미술관이 기다리고 있어! 🖼️",
    "You make Tuesdays magical! 🎉":"네 덕분에 화요일이 마법 같아! 🎉",
    /* hype crew: header + names */
    "Hype Cheerleader Crew":"응원단","Your Hype Crew":"너의 응원단",
    "Pretty Pineapple":"예쁜 파인애플","Awesome Apple":"멋진 사과","Kind Kiwi":"친절한 키위","Cool Cherry":"쿨한 체리",
    "Wonderful Watermelon":"근사한 수박","Optimistic Orange":"긍정 오렌지","Famous Grape":"유명한 포도","Lovely Lemon":"사랑스러운 레몬",
    "Brave Banana":"용감한 바나나","Classic Carrot":"클래식 당근","Calm Corn":"차분한 옥수수","Genius Broccoli":"천재 브로콜리",
    "Beautiful Beet":"아름다운 비트","Sparkling Spinach":"반짝이는 시금치","Accepted Artichoke":"환영받는 아티초크",
    "Laughing Bacci":"웃는 바치","Excited Bacci":"신난 바치","Grateful Bacci":"감사하는 바치","MVP Bacci":"MVP 바치",
    /* hype crew: every one-liner */
    "You are one of a kind, just like me! 🍍":"너는 세상에 하나뿐이야, 나처럼! 🍍",
    "Sweet work, superstar! ✨":"달콤한 솜씨야, 슈퍼스타! ✨",
    "Stand tall and shine! 🍍💛":"당당하게 서서 빛나! 🍍💛",
    "You are awesome to the core! 🍎":"너는 속까지 멋져! 🍎",
    "One brave color at a time! ❤️":"한 번에 용감한 색 하나씩! ❤️",
    "Crunch! That was brilliant! 🍎✨":"아삭! 정말 훌륭했어! 🍎✨",
    "Kindness looks beautiful on you! 🥝":"친절함이 너에게 정말 잘 어울려! 🥝",
    "Your heart is doing great things 💚":"너의 마음이 멋진 일을 하고 있어 💚",
    "Small and mighty, just like me! 🥝":"작지만 강해, 나처럼! 🥝",
    "Stay cool, you are doing amazing! 🍒":"여유롭게, 정말 잘하고 있어! 🍒",
    "Coolest artist on the block! 😎":"동네에서 제일 멋진 예술가! 😎",
    "Twice as sweet, that is you! 🍒🍒":"두 배로 달콤한 게 바로 너야! 🍒🍒",
    "You are wonderful, through and through! 🍉":"너는 처음부터 끝까지 멋져! 🍉",
    "So refreshing to watch you create! 💚":"네가 만드는 걸 보면 정말 상쾌해! 💚",
    "Big heart, big art! 🍉":"큰 마음, 큰 작품! 🍉",
    "The bright side looks good on you! 🍊":"밝은 면이 너에게 잘 어울려! 🍊",
    "Keep that sunny spirit going! ☀️":"그 햇살 같은 마음 계속 이어 가! ☀️",
    "You light up the page! 🍊":"네가 페이지를 환하게 밝혀! 🍊",
    "You are a star in the making! 🍇":"너는 떠오르는 별이야! 🍇",
    "A bunch of talent, that is you! 💜":"재능이 한 송이 가득, 바로 너야! 💜",
    "Famously fabulous work! 🍇✨":"소문날 만큼 멋진 솜씨야! 🍇✨",
    "When life gives you colors, shine! 🍋":"삶이 색을 주면, 빛나! 🍋",
    "Zesty and bright, just like you! 💛":"상큼하고 밝아, 너처럼! 💛",
    "Lovely choice, artist! 🍋":"사랑스러운 선택이야, 예술가님! 🍋",
    "Look how brave you are! 🍌":"네가 얼마나 용감한지 봐! 🍌",
    "You can do hard things, I just saw it! 💪":"너는 어려운 일도 해낼 수 있어, 방금 봤어! 💪",
    "Top banana, that is you! 🍌":"최고가 바로 너야! 🍌",
    "A classic masterpiece in the making! 🥕":"고전 명작이 만들어지는 중! 🥕",
    "You see so clearly, keep going! 👀":"너는 정말 또렷이 봐, 계속해! 👀",
    "Rooting for you, always! 🥕":"언제나 너를 응원해! 🥕",
    "Nice and calm, you have got this 🌽":"차분하게, 넌 할 수 있어 🌽",
    "One gentle step at a time 💛":"한 번에 부드러운 한 걸음씩 💛",
    "So peaceful to watch you work 🌽":"네가 작업하는 걸 보면 참 평화로워 🌽",
    "Now THAT is a genius color choice! 🥦":"방금 그건 천재적인 색 선택이야! 🥦",
    "Your brain and heart make magic 💚":"너의 머리와 마음이 마법을 만들어 💚",
    "Brilliant, simply brilliant! 🥦✨":"훌륭해, 그냥 훌륭해! 🥦✨",
    "You cannot be beat! 💜":"아무도 너를 이길 수 없어! 💜",
    "Beautiful inside and out! ✨":"안도 밖도 아름다워! ✨",
    "Your colors make my heart happy 💗":"너의 색이 내 마음을 행복하게 해 💗",
    "You are absolutely sparkling today! ✨":"오늘 너 정말 반짝반짝해! ✨",
    "Strong and shining, that is you! 💚":"강하고 빛나는 게 바로 너야! 💚",
    "I am cheering so hard right now! 📣":"지금 정말 열심히 응원하고 있어! 📣",
    "You belong here, exactly as you are 💚":"너는 있는 그대로 이곳에 어울려 💚",
    "Layer by layer, you shine 💛":"한 겹 한 겹, 너는 빛나 💛",
    "So glad you came to color today!":"오늘 색칠하러 와 줘서 정말 기뻐!",
    "Your joy is contagious! 😄":"너의 기쁨이 전염돼! 😄",
    "That made my whiskers wiggle! 😹":"그것 때문에 내 수염이 씰룩였어! 😹",
    "Keep that smile going! 😄💛":"그 미소 계속 이어 가! 😄💛",
    "WOW! Look at you go! ✨":"와! 정말 잘한다! ✨",
    "I literally cannot sit still, this is SO good! 🎉":"가만히 앉아 있을 수가 없어, 정말 너무 멋져! 🎉",
    "Best part of my whole day, seeing this! ⭐":"이걸 보는 게 오늘 하루 최고의 순간이야! ⭐",
    "I am so grateful for YOU 💜":"나는 네가 정말 고마워 💜",
    "Thank you for being here today 🙏💛":"오늘 여기 와 줘서 고마워 🙏💛",
    "You make this world warmer 💜":"너는 이 세상을 더 따뜻하게 만들어 💜",
    "You are the real MVP! ⭐":"네가 진짜 MVP야! ⭐",
    "Champions take their time, just like you 🏆":"챔피언은 천천히 해, 너처럼 🏆",
    "Proud of you. Truly. ⭐💛":"네가 자랑스러워. 진심으로. ⭐💛",
    /* museum + breaks + prize */
    "Every frame is full. Magnificent! ✨":"모든 액자가 가득 찼어요. 멋져요! ✨","The Museum Sticker":"미술관 스티커",
    "🏛️ Explore the Museum Portals":"🏛️ 미술관 포털 둘러보기","Explore the Museum Portals":"미술관 포털 둘러보기",
    "Breathe with Bacci":"바치와 함께 숨쉬기","Keep creating":"계속 만들기","Want a tiny breathing break?":"잠깐 숨 고르는 시간을 가질까요?",
    "Breathe":"숨쉬기","In… and out… three times 💛":"들이쉬고… 내쉬고… 세 번 💛","Beautiful. Back to creating 💛":"멋져요. 다시 만들러 가요 💛",
    "You won a prize! Tap to open!":"상을 받았어요! 눌러서 열어 봐요!","Enter the Vault of Hearts ✨":"마음의 금고로 들어가기 ✨","Congratulations! 🎉":"축하해요! 🎉",
    "Open the storybook 📖":"이야기책 펼치기 📖","Tuck the book away 📖":"책 덮기 📖"
  };

  /* feeling word map for templated lines */
  var FEELWORD={ "Brave":"용감","Calm":"평온","Joy":"기쁨","Kind":"친절","Hope":"희망","Curious":"호기심","Cozy":"아늑함","Peace":"평화","Grateful":"감사","Silly":"장난","Steady":"단단함","Clear":"맑음","Loved":"사랑받음","Happy":"행복" };
  var STICKERWORD={ "Brave":"용감함","Loved":"사랑받음","Cozy":"아늑함","Happy":"행복","Calm":"평온" };

  /* ---- 3. TEMPLATED STRINGS (live numbers / names) ---- */
  var KO_RE=[
    {re:/^(\d+) of (\d+) parts colored$/, ko:function(m){return m[2]+"칸 중 "+m[1]+"칸 색칠됨";}},
    {re:/^(\d+) of (\d+) parts colored\s*\.\s*sticker earned 🎉$/, ko:function(m){return m[2]+"칸 중 "+m[1]+"칸 색칠됨 · 스티커 획득 🎉";}},
    {re:/^Color (\d+) parts to earn the (.+) sticker$/, ko:function(m){return (STICKERWORD[m[2]]||m[2])+" 스티커를 받으려면 "+m[1]+"칸을 색칠하세요";}},
    {re:/^You earned the (.+) sticker.*$/, ko:function(m){return (STICKERWORD[m[1]]||m[1])+" 스티커를 얻었어요!";}},
    {re:/^Page (\d+) of (\d+)$/, ko:function(m){return m[1]+" / "+m[2]+" 쪽";}},
    {re:/^Entry (.+)$/, ko:function(m){return "엔트리 "+m[1];}},
    {re:/^feels like (.+)$/, ko:function(m){return "이런 느낌이에요: "+(FEELWORD[m[1]]||m[1]);}},
    {re:/^Fill the frames: (\d+) of (\d+)\. Fill all (\d+) to earn (.+)$/, ko:function(m){return "액자를 채워요: "+m[2]+"개 중 "+m[1]+"개. 모두 채우면 "+m[4]+"을(를) 받아요";}},
    {re:/^The (.+) Collection ✨$/, ko:function(m){return m[1]+" 컬렉션 ✨";}}
  ];

  /* ---- 4. ALERT / SYSTEM POPUPS (native dialogs) ---- */
  var KO_ALERT={
    "Save needs the live store image.":"저장하려면 실제 스토어 이미지가 필요해요.",
    "Saving needs the live store image.":"저장하려면 실제 스토어 이미지가 필요해요.",
    "Color a little first.":"먼저 조금 색칠해 주세요.",
    "Color a little first, then add it.":"먼저 조금 색칠한 뒤에 추가해 주세요.",
    "Please enter a valid email.":"올바른 이메일 주소를 입력해 주세요.",
    "Please confirm you are a grown up (18 or older).":"18세 이상 보호자임을 확인해 주세요."
  };
  var _alert=window.alert;
  window.alert=function(msg){ try{ if(lang==='ko'&&KO_ALERT[msg]) msg=KO_ALERT[msg]; }catch(e){} return _alert.call(window,msg); };

  /* ---- engine ---- */
  function translateNode(n){
    var raw=n.nodeValue; var key=trim(raw); if(!key) return;
    var ko=null;
    if(KO_TEXT[key]!=null){ ko=KO_TEXT[key]; }
    else { var lead=(key.match(/^[^A-Za-z가-힣]+/)||[''])[0]; var trail=(key.match(/[^A-Za-z가-힣]+$/)||[''])[0];
           var mid=key.slice(lead.length), midT=key.slice(0,key.length-trail.length), both=key.slice(lead.length,key.length-trail.length);
           if(lead&&KO_TEXT[mid]!=null) ko=lead+KO_TEXT[mid];
           else if(trail&&KO_TEXT[midT]!=null) ko=KO_TEXT[midT]+trail;
           else if((lead||trail)&&both&&KO_TEXT[both]!=null) ko=lead+KO_TEXT[both]+trail; }
    if(ko==null){ for(var i=0;i<KO_RE.length;i++){ var mm=key.match(KO_RE[i].re); if(mm){ ko=KO_RE[i].ko(mm); break; } } }
    if(ko!=null && raw.indexOf(ko)===-1){ if(n.__en==null) n.__en=raw; n.nodeValue=raw.replace(key,ko); }
  }
  function walkText(fn){
    var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:function(n){
      var p=n.parentNode; if(!p) return NodeFilter.FILTER_REJECT;
      var tag=p.nodeName; if(tag==='SCRIPT'||tag==='STYLE'||tag==='INPUT'||tag==='TEXTAREA') return NodeFilter.FILTER_REJECT;
      if(p.closest && p.closest('[data-bk-i18n-skip]')) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    }});
    var n; while((n=w.nextNode())) fn(n);
  }
  function toKO(){
    for(var id in KO_BYID){ var el=document.getElementById(id); if(el){ if(el.__en==null) el.__en=el.textContent; if(el.textContent!==KO_BYID[id]) el.textContent=KO_BYID[id]; } }
    walkText(translateNode);
    root.querySelectorAll('input[placeholder]').forEach(function(inp){ var k=trim(inp.getAttribute('placeholder')); if(KO_TEXT[k]){ if(inp.__ph==null) inp.__ph=inp.getAttribute('placeholder'); if(inp.getAttribute('placeholder')!==KO_TEXT[k]) inp.setAttribute('placeholder',KO_TEXT[k]); } });
  }
  function toEN(){
    for(var id in KO_BYID){ var el=document.getElementById(id); if(el&&el.__en!=null&&el.textContent!==el.__en) el.textContent=el.__en; }
    walkText(function(n){ if(n.__en!=null && n.nodeValue!==n.__en) n.nodeValue=n.__en; });
    root.querySelectorAll('input[placeholder]').forEach(function(inp){ if(inp.__ph!=null) inp.setAttribute('placeholder',inp.__ph); });
  }
  function apply(){ if(busy) return; busy=true; try{ if(lang==='ko') toKO(); else toEN(); } finally { setTimeout(function(){ busy=false; },0); } }

  var pend=null;
  new MutationObserver(function(){ if(lang!=='ko'||busy) return; clearTimeout(pend); pend=setTimeout(apply,50); })
    .observe(root,{childList:true,subtree:true,characterData:true});

  /* ---- the toggle + translator speech bubble ---- */
  function addToggle(){
    var bar=root.querySelector('.bk-switches'); if(!bar||document.getElementById('bk-langtoggle')) return;
    var st=document.createElement('style');
    st.textContent='#bk-langtoggle{position:relative;overflow:visible;}'+
      '#bk-hx .bk-langtip{position:absolute;left:50%;bottom:calc(100% + 14px);transform:translateX(-50%) scale(.6);transform-origin:bottom center;'+
      'display:flex;align-items:center;gap:10px;white-space:nowrap;padding:10px 16px 10px 12px;border-radius:18px 18px 18px 4px;'+
      'background:linear-gradient(135deg,#FFF0FB,#EAE4FF 55%,#E0FBFF);border:2px solid var(--violet);'+
      'box-shadow:0 14px 30px rgba(166,107,255,.4),0 0 0 4px rgba(255,255,255,.6);opacity:0;pointer-events:none;'+
      'transition:opacity .22s ease,transform .28s cubic-bezier(.2,1.4,.4,1);z-index:60;}'+
      '#bk-hx .bk-langtip::after{content:"";position:absolute;left:50%;top:100%;transform:translateX(-50%);border:9px solid transparent;border-top-color:var(--violet);}'+
      '#bk-hx .bk-langtip img{width:46px;height:46px;object-fit:contain;flex:0 0 auto;filter:drop-shadow(0 4px 8px rgba(166,107,255,.4));}'+
      '#bk-hx .bk-langtip .tx{font-family:var(--head);font-weight:700;line-height:1.05;font-size:calc(14px*var(--fs));'+
      'background:linear-gradient(90deg,#FF6FBF,#A66BFF,#14C9C0);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;}'+
      '#bk-hx .bk-langtip .tx b{display:block;font-size:calc(17px*var(--fs));}'+
      '#bk-langtoggle:hover .bk-langtip,#bk-langtoggle:focus-visible .bk-langtip{opacity:1;transform:translateX(-50%) scale(1);}'+
      '@media (prefers-reduced-motion: reduce){#bk-hx .bk-langtip{transition:opacity .2s ease;transform:translateX(-50%) scale(1);}}';
    root.appendChild(st);
    var b=document.createElement('button'); b.type='button'; b.className='bk-switch'; b.id='bk-langtoggle';
    b.setAttribute('aria-pressed','false'); b.setAttribute('data-bk-i18n-skip','1'); b.setAttribute('aria-label','Translator, English and Korean');
    b.innerHTML='🌏 <span class="lbl">한국어</span>'+
      '<span class="bk-langtip" aria-hidden="true">'+
      '<img src="https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Fun_Reading_Time_only_2.png?v=1767476500" alt="">'+
      '<span class="tx">Translator<b>번역기</b></span></span>';
    b.addEventListener('click',function(){ lang=(lang==='ko')?'en':'ko'; b.setAttribute('aria-pressed',lang==='ko'?'true':'false');
      b.querySelector('.lbl').textContent=(lang==='ko')?'English':'한국어'; document.documentElement.lang=(lang==='ko')?'ko':'en'; apply(); });
    bar.appendChild(b);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',addToggle,{once:true}); else addToggle();
})();


/* ---- next engine block ---- */


/* ===== THE IN-EXPERIENCE MOTION TOGGLE  .  sits beside the language switch =====
   Cycles Calm -> Standard -> Immersive, saves the choice via BKMotion, and the
   choice then drives every page that reads the shared motion level. Immersive
   carries a transparent "Step Inside, AR coming" note. No fake VR button. */
(function(){
  var C=(typeof BK_HX_CONFIG!=='undefined')?BK_HX_CONFIG:null; if(!C) return;
  var M=C.MOTION; if(!M||M.enabled===false||M.showToggle===false) return;
  if(!window.BKMotion) return;
  var ORDER=['calm','standard','immersive'];
  function labelFor(l){ return l==='calm'?(M.calmLabel||'🍃 Calm'):l==='immersive'?(M.immersiveLabel||'🌀 Immersive'):(M.standardLabel||'✨ Standard'); }
  function render(b){ var l=BKMotion.get(); var note=(l==='immersive'&&M.immersiveNote)?(' · '+M.immersiveNote):'';
    b.innerHTML='<span class="lbl">'+(M.label?M.label+': ':'')+labelFor(l)+note+'</span>';
    b.setAttribute('aria-label',(M.label||'Motion')+', currently '+labelFor(l).replace(/^[^A-Za-z]+/,'')+'. Tap to change.'); }
  function init(){
    var root=document.getElementById('bk-hx'); if(!root) return;
    var bar=root.querySelector('.bk-switches'); if(!bar||document.getElementById('bk-motiontoggle')) return;
    var b=document.createElement('button'); b.type='button'; b.className='bk-switch'; b.id='bk-motiontoggle'; b.setAttribute('data-bk-i18n-skip','1');
    render(b);
    b.addEventListener('click',function(){ var cur=BKMotion.get(); var nx=ORDER[(ORDER.indexOf(cur)+1)%ORDER.length]; BKMotion.set(nx); render(b); });
    window.addEventListener('bk-motion-change',function(){ render(b); });
    bar.appendChild(b);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();


/* ---- next engine block ---- */


/* ===== WATCH THE INTRO  .  a catchy replay button beside the switches =====
   Summons the full cinematic on purpose, any time, even after it has been seen.
   It calls window.BKCinematic.play(). You can also wire your own big hero button
   anywhere with onclick="BKCinematic.play()". */
(function(){
  var C=(typeof BK_HX_CONFIG!=='undefined')?BK_HX_CONFIG:null; if(!C) return;
  var V=C.CINEMATIC; if(!V||V.enabled===false||V.replayButton===false) return;
  function init(){
    var root=document.getElementById('bk-hx'); if(!root) return;
    var bar=root.querySelector('.bk-switches'); if(!bar||document.getElementById('bk-introreplay')) return;
    var b=document.createElement('button'); b.type='button'; b.className='bk-switch'; b.id='bk-introreplay'; b.setAttribute('data-bk-i18n-skip','1');
    b.innerHTML='<span class="lbl">'+(V.replayLabel||'✨ Watch the intro')+'</span>';
    b.addEventListener('click',function(){ if(window.BKCinematic&&BKCinematic.play) BKCinematic.play(); });
    bar.appendChild(b);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
/* ===== BACCI BRAVE HEARTOPEDIA v44 SUPREME SIMULATION LAYER =====
   Adds the BraveVerse story camera, portal rotation, sensory imagination bubbles,
   badge and coin moments, stronger safety rails, lazy media, JSON-LD, and a safer
   museum bridge. Built as progressive enhancement. If this layer fails, the v43.4
   coloring and story engine still works. */
(function(){
  var C=(typeof BK_HX_CONFIG!=='undefined')?BK_HX_CONFIG:null;
  var root=document.getElementById('bk-hx');
  if(!C||!root||root.__bkV44) return;
  root.__bkV44=true;
  root.classList.add('bk-v44-supreme');

  var cdnFiles='https://cdn.shopify.com/s/files/1/0500/7307/5871/files/';
  var cdnVideos='https://cdn.shopify.com/videos/c/o/v/';
  var REG={
    links:{ museum:'/pages/bacci-kid-museum-portals', artWall:'/pages/my-art-gallery', mainHub:C.LINKS&&C.LINKS.mainHub?C.LINKS.mainHub:'/pages/bacci-kid-heartopedia-main-hub', kpot:C.LINKS&&C.LINKS.kpotHub?C.LINKS.kpotHub:'/pages/kpot-main-hub', disclaimer:'/pages/disclaimer' },
    portals:[
      {name:'Celestial Palace Star-Stair Portal', mood:'grand brave arrival', img:cdnFiles+'ChatGPT_Image_Jun_15_2026_02_34_39_AM_7.png?v=1781505343', vid:cdnVideos+'cfd18f6a77bf4e9f8c48a36321160af0.mp4', guide:'Brave Banana'},
      {name:'Starblossom Treasures Bazaar', mood:'curious world sweep', img:cdnFiles+'ChatGPT_Image_Jun_15_2026_02_34_39_AM_8.png?v=1781505344', vid:cdnVideos+'26f9c54d805e44efa361920d6014df0d.mp4', guide:'Kind Kiwi'},
      {name:'Zodiac Spiral Vortex', mood:'deep courage vortex', img:cdnFiles+'ChatGPT_Image_Jun_15_2026_02_34_39_AM_4.png?v=1781505343', vid:cdnVideos+'b51b47ab759147beb483bc0c647e3fd1.mp4', guide:'Genius Broccoli'},
      {name:'Neon Bubble Tea Metropolis', mood:'KPOT city crossover', img:cdnFiles+'ChatGPT_Image_May_3_2026_02_44_08_PM_7_46683636-8807-40eb-816e-40d25de0edbe.png?v=1781499953', vid:cdnVideos+'a6286f96e2ae42e6a2cdf60b2f84bdae.mp4', guide:'Awesome Apple'},
      {name:'Twin Column Dawn Portal', mood:'soft calm courage', img:cdnFiles+'ChatGPT_Image_Jun_15_2026_12_26_09_AM.png?v=1781497585', vid:cdnVideos+'37a1cf54dae64f79bb491ac33c424f47.mp4', guide:'Calm Corn'},
      {name:'Crystal Archway Bridge Portal', mood:'hero landing bridge', img:cdnFiles+'ChatGPT_Image_Jun_15_2026_02_34_39_AM_5.png?v=1781505344', vid:cdnVideos+'9e45941972464fee8b1177b644087dbf.mp4', guide:'Classic Carrot'},
      {name:'Golden Mandala Portal', mood:'golden heart ceremony', img:cdnFiles+'ChatGPT_Image_Jun_15_2026_02_27_17_AM_9.png?v=1781504947', vid:cdnVideos+'9f7988fecdd94aaa92a13f684ad0e50d.mp4', guide:'Pretty Pineapple'},
      {name:'Waterfall Vortex Burst', mood:'pulled forward into courage', img:cdnFiles+'ChatGPT_Image_Jun_14_2026_01_00_13_AM_10_d26e6403-3ef7-4674-8e4d-3c81a2ca7f5a.png?v=1781499368', vid:cdnVideos+'db605b82157b43389457ad05cc5b0288.mp4', guide:'Wonderful Watermelon'}
    ],
    rooms:[
      {name:'Bacci Kid Museum Homepage Gallery', img:cdnFiles+'ChatGPT_Image_Jun_7_2026_02_16_06_AM_10.png?v=1780813120', kind:'launch room'},
      {name:'7D Portal Gallery', img:cdnFiles+'ChatGPT_Image_Jun_6_2026_11_11_41_PM_7_f34cbb53-1a59-485d-b0b0-d8461da16422.png?v=1780879587', kind:'portal spine'},
      {name:'Oceanic Lumina Hall', img:cdnFiles+'ChatGPT_Image_Jun_6_2026_11_17_09_PM_2.png?v=1780802324', vid:cdnVideos+'6a36e41c7878401b9615770312802fa9.mp4', kind:'living room'},
      {name:'Global Mosaic Worlds Gallery', img:cdnFiles+'ChatGPT_Image_Jun_6_2026_11_17_11_PM_9.png?v=1780802324', kind:'heritage room'},
      {name:'Royal Wonder Museum', img:cdnFiles+'ChatGPT_Image_Jun_6_2026_11_27_45_PM.png?v=1780802895', kind:'royal room'},
      {name:'Emerald Fairy Garden Hall', img:cdnFiles+'ChatGPT_Image_Jun_7_2026_01_12_00_AM_6.png?v=1780809264', vid:cdnVideos+'c359ce19349c4a81bcc6920e9b1437f3.mp4', kind:'garden room'},
      {name:'Neon Cosmos Arcade Palace', img:cdnFiles+'ChatGPT_Image_Jun_7_2026_02_16_04_AM_5.png?v=1780813119', vid:cdnVideos+'cb2e8b02c41b4ba09849da633a6ebf30.mp4', kind:'arcade room'},
      {name:'Stardust Street Food Pavilion', img:cdnFiles+'ChatGPT_Image_Jun_7_2026_02_16_03_AM_4.png?v=1780813120', vid:cdnVideos+'20946851f582403fb7021c2adfd26cd3.mp4', kind:'KPOT food room'},
      {name:'11D-12D Infinity Nexus', img:cdnFiles+'ChatGPT_Image_Jun_6_2026_11_11_41_PM_5_74a8be62-18bb-4326-aba3-007b1eb411fc.png?v=1780879587', vid:cdnVideos+'3da5a00a065c4d88a3aeee1819c1378e.mp4', kind:'infinity room'}
    ],
    idents:{ calm:[cdnVideos+'9bce3af6526e47cca0739ec9d893ac13.mp4'], action:[cdnVideos+'fb67b477c8e342dc8ccfdb97414a448f.mp4', cdnVideos+'fd60efedbc9245f5b9d9a87d32068428.mp4', cdnVideos+'cc7f5649fd1c4d58b6dde7eac213c4a1.mp4'] },
    invitations:[
      cdnFiles+'BacciKid_Heartopedia_v3_TitleCard_RadiantPastelGold_WebsiteAsset_ColorPNG.png?v=1781043344',
      cdnFiles+'BacciKid_Heartopedia_v3_EnvelopeBack_PhoenixWaxSeal_PearlPastelGold_ColorPNG.png?v=1781043344',
      cdnFiles+'BacciKid_Heartopedia_v3_EnvelopeFront_TitleSeal_PearlPastelGold_ColorPNG.png?v=1781043344',
      cdnFiles+'BacciKid_Heartopedia_v3_RadiantHero_InvitationInsideEnvelope_PastelGold_ColorPNG.png?v=1781043344',
      cdnFiles+'BacciKid_Heartopedia_v3_DivineInvitation_YouAreInvited_RareMagicalHonor_ColorPNG.png?v=1781043344'
    ],
    coins:[
      {name:'$1 Million Bacci Kid Gold Coin', url:cdnFiles+'1_Million_Bacci_Coin_coin.png?v=1772752134'},
      {name:'$1 Billion Bacci Kid Gold Coin', url:cdnFiles+'1_Billion_Bacci_Coin_coin.png?v=1772752419'},
      {name:'$1 Trillion Bacci J aime Gems Coin', url:cdnFiles+'1_Trillion_Bacci_J_aime_Gems_Coin_coin.png?v=1772752285'},
      {name:'$1 Zillion Bacci J aime Coin', url:cdnFiles+'1_Zillion_Bacci_J_aime_Coin_coin-01.png?v=1772751098'}
    ],
    ribbons:[
      {name:'Brave Sticker', url:C.BADGE&&C.BADGE.image?C.BADGE.image:''},
      {name:'Fun Reading Time', url:cdnFiles+'Fun_Reading_Time_only_2.png?v=1767476500'},
      {name:'Congratulations Prize', url:cdnFiles+'Congratulations_You_won_this_Prize_only_1.png?v=1772482245'},
      {name:'Mindful Breathing', url:cdnFiles+'Mindfulness_breathing_only_1.png?v=1772494924'}
    ],
    sensory:[
      {name:'Brave Banana', img:cdnFiles+'banana_1.png?v=1772481971', cue:'Imagine a warm banana-sunshine glow. Let it remind your body that brave can be tiny and real.', action:'Name one small next step.'},
      {name:'Kind Kiwi', img:cdnFiles+'kiwi.png?v=1772507636', cue:'Imagine a fresh green kindness sparkle. It is an imagination cue only, gentle and safe.', action:'Send one kind thought to yourself.'},
      {name:'Famous Grape', img:cdnFiles+'grape.png?v=1772514249', cue:'Imagine a soft grape-purple shimmer bubble. Notice what your body wants to tell you.', action:'Choose one feeling word.'},
      {name:'Calm Corn', img:cdnFiles+'corn_1.png?v=1772509376', cue:'Imagine a cozy golden calm. Breathe once before the next click.', action:'Breathe in. Breathe out.'},
      {name:'Lovely Lemon', img:cdnFiles+'lemon.png?v=1772514182', cue:'Imagine a bright lemon-heart sparkle. Let your courage have a little light.', action:'Say, I can try.'}
    ],
    pageScenes:{
      story:{portal:0, guide:'Brave Banana', line:'The story camera is open. Bacci is meeting the smaller part of himself with courage.'},
      toyou:{portal:4, guide:'Kind Kiwi', line:'This page is the gentle handoff. The story becomes yours without pressure.'},
      feels:{portal:7, guide:'Famous Grape', line:'A feeling can be a body signal. Notice it, color it, and let it pass through.'},
      when:{portal:3, guide:'Awesome Apple', line:'Bravery often appears in ordinary moments: a first day, a raised hand, a truthful apology.'},
      world:{portal:1, guide:'Wonderful Watermelon', line:'Courage belongs to every culture. In Korean, brave is yong-gam.'},
      know:{portal:2, guide:'Genius Broccoli', line:'Your body can feel scared and brave at the same time. That is not a mistake.'},
      turn:{portal:5, guide:'Classic Carrot', line:'Your turn is a tiny quest. One brave thing this week is enough.'},
      mantra:{portal:6, guide:'Pretty Pineapple', line:'The mantra is the crown. Feel afraid and still take the next small step.'}
    }
  };
  window.BK_SUPREME_REGISTRY=REG;

  function qs(s,c){ return (c||document).querySelector(s); }
  function qsa(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }
  function make(tag, cls, html){ var e=document.createElement(tag); if(cls)e.className=cls; if(html!=null)e.innerHTML=html; return e; }
  function key(name){ return 'bk_v44_'+name; }
  function getStore(name, fallback){ try{ var v=localStorage.getItem(key(name)); return v==null?fallback:JSON.parse(v); }catch(e){ return fallback; } }
  function setStore(name, val){ try{ localStorage.setItem(key(name), JSON.stringify(val)); }catch(e){} }
  function modIndex(name, len){ var n=getStore(name,0)||0; var out=n%len; setStore(name,n+1); return out; }
  function reduced(){ try{ return document.documentElement.getAttribute('data-bk-motion')==='calm'||(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches); }catch(e){ return false; } }
  function currentMotion(){ try{ return window.BKMotion&&BKMotion.get?BKMotion.get():(reduced()?'calm':'standard'); }catch(e){ return 'standard'; } }
  function imgTag(url, alt, cls){ return '<img class="'+(cls||'')+'" src="'+url+'" alt="'+(alt||'')+'" loading="lazy" decoding="async">'; }
  function preloadOne(url, type){ if(!url) return; try{ var l=document.createElement('link'); l.rel='preload'; l.as=type||'image'; l.href=url; document.head.appendChild(l); }catch(e){} }

  function setupHead(){
    try{
      if(!document.querySelector('link[rel="preconnect"][href="https://cdn.shopify.com"]')){ var pc=document.createElement('link'); pc.rel='preconnect'; pc.href='https://cdn.shopify.com'; pc.crossOrigin='anonymous'; document.head.appendChild(pc); }
      var desc='A cinematic Bacci Kid Brave Heartopedia experience with coloring, storytelling, emotional vocabulary, museum portals, device-only progress, and playful no-cash-value rewards.';
      var meta=document.querySelector('meta[name="description"]'); if(meta&&!meta.content) meta.content=desc;
      var ld=document.createElement('script'); ld.type='application/ld+json'; ld.setAttribute('data-bk-v44','1');
      ld.textContent=JSON.stringify({ '@context':'https://schema.org', '@type':'CreativeWork', name:'Brave - The Bacci Kid Heartopedia', creator:{'@type':'Person', name:'Dr. Jamie J. Karia, DSW, LCSW'}, publisher:{'@type':'Organization', name:'Bacci Kid'}, educationalUse:'emotional vocabulary and creative reflection', audience:{'@type':'Audience', audienceType:'teens and families'}, isAccessibleForFree:true, inLanguage:['en','ko'], url:location.href });
      if(!document.querySelector('script[data-bk-v44="1"]')) document.head.appendChild(ld);
    }catch(e){}
  }

  function lazyVideo(v){
    if(!v||!v.getAttribute('data-src')) return;
    function load(){ if(v.__loaded) return; v.__loaded=true; v.src=v.getAttribute('data-src'); v.load(); if(v.hasAttribute('data-autoplay')&&!reduced()){ var p=v.play(); if(p&&p.catch) p.catch(function(){}); } }
    if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(es){ es.forEach(function(en){ if(en.isIntersecting){ load(); io.disconnect(); } }); },{rootMargin:'260px 0px'}); io.observe(v); }
    else load();
  }

  function findCharacter(name){
    var arr=(C.HYPE&&C.HYPE.characters)||[];
    for(var i=0;i<arr.length;i++){ if((arr[i].name||'').toLowerCase()===(name||'').toLowerCase()) return arr[i]; }
    return arr[0]||{name:'Bacci', url:(C.crestUrl||C.emblemUrl||''), lines:['You are doing beautifully.']};
  }

  function setScene(panel, sceneKey, forcePortal){
    var scene=REG.pageScenes[sceneKey]||REG.pageScenes.story;
    var p=REG.portals[(forcePortal!=null?forcePortal:scene.portal)%REG.portals.length];
    var ch=findCharacter(scene.guide||p.guide);
    var poster=qs('.bk-sim-poster',panel), video=qs('.bk-sim-video',panel), title=qs('.bk-sim-title',panel), mood=qs('.bk-sim-mood',panel), av=qs('.bk-sim-avatar',panel), who=qs('.bk-sim-who',panel), line=qs('.bk-sim-line',panel);
    poster.src=p.img; poster.alt=p.name;
    video.pause(); video.removeAttribute('src'); video.removeAttribute('data-src'); video.load();
    if(p.vid){ video.setAttribute('data-src',p.vid); video.setAttribute('poster',p.img); video.setAttribute('data-autoplay','1'); video.__loaded=false; lazyVideo(video); }
    title.textContent=p.name; mood.textContent=p.mood;
    av.src=ch.url; av.alt=ch.name||scene.guide||'Bacci Kid guide'; who.textContent=ch.name||scene.guide||'Bacci Kid guide'; line.textContent=scene.line;
    panel.setAttribute('data-scene',sceneKey||'story');
    sparkleBurst(panel, 14);
  }

  function sparkleBurst(scope, count){
    if(reduced()) return;
    var box=qs('.bk-sim-shell',scope)||scope;
    for(var i=0;i<count;i++){
      var s=make('i','bk-v44-spark','');
      s.style.left=(8+Math.random()*84)+'%'; s.style.top=(10+Math.random()*78)+'%';
      s.style.setProperty('--vx', ((Math.random()-.5)*120)+'px');
      s.style.setProperty('--vy', ((Math.random()-.5)*120)+'px');
      s.style.animationDelay=(Math.random()*.2)+'s';
      box.appendChild(s); setTimeout((function(x){return function(){ if(x&&x.parentNode)x.parentNode.removeChild(x); };})(s),1500);
    }
  }

  function buildSimulation(){
    if(document.getElementById('bk-supreme')) return;
    var panel=make('section','bk-supreme',
      '<div class="bk-supreme-head">'+
        '<div class="bk-supreme-kicker">New v44 . BraveVerse story simulation</div>'+
        '<h2>Step into Bacci Kid Brave</h2>'+
        '<p class="bk-supreme-copy">A cinematic, device-safe story camera that connects the coloring page, the book, the museum portals, the Hype Cheerleader Crew, imagination-based sensory bubbles, badges, and Bacci Kid Gold Coins into one clear emotional-learning journey.</p>'+
        '<div class="bk-supreme-toolbar" role="group" aria-label="BraveVerse controls">'+
          '<button type="button" data-mode="story">📖 Story Cam</button>'+
          '<button type="button" data-mode="portal">🌀 Next Portal</button>'+
          '<button type="button" data-mode="sense">🌸 Scent Bubble</button>'+
          '<button type="button" data-mode="museum">🏛 Museum Room</button>'+
          '<button type="button" data-mode="coin">🪙 Gold Coin</button>'+
          '<button type="button" data-mode="safety">🛡 Safety</button>'+
        '</div>'+
      '</div>'+
      '<div class="bk-sim-grid">'+
        '<div class="bk-sim-shell" aria-live="polite">'+
          '<img class="bk-sim-poster" alt="" loading="lazy" decoding="async">'+
          '<video class="bk-sim-video" muted loop playsinline preload="none"></video>'+
          '<div class="bk-holo-veil" aria-hidden="true"><i></i><i></i><i></i></div>'+
          '<div class="bk-sim-badge"><span class="bk-sim-title"></span><small class="bk-sim-mood"></small></div>'+
          '<div class="bk-sim-guide">'+
            '<img class="bk-sim-avatar" alt="" loading="lazy" decoding="async">'+
            '<div class="bk-sim-bubble"><b class="bk-sim-who"></b><span class="bk-sim-line"></span></div>'+
          '</div>'+
        '</div>'+
        '<div class="bk-sim-console">'+
          '<h3>Brave Quest</h3>'+
          '<p>Choose one tiny brave action. The page will celebrate the skill, not perfection.</p>'+
          '<div class="bk-quest-list" role="group" aria-label="Brave quest choices">'+
            '<button type="button" data-quest="name">Name the feeling</button>'+
            '<button type="button" data-quest="breathe">Take one slow breath</button>'+
            '<button type="button" data-quest="ask">Ask for help</button>'+
            '<button type="button" data-quest="try">Try one tiny step</button>'+
          '</div>'+
          '<div class="bk-sensory-strip" aria-live="polite"></div>'+
          '<div class="bk-coin-case" aria-live="polite"></div>'+
          '<p class="bk-safe-mini">Rewards are playful, earned just for fun, have no cash value, and cannot be redeemed for money or merchandise. Progress stays on this device.</p>'+
        '</div>'+
      '</div>');
    var book=qs('.bk-book');
    if(book&&book.parentNode) book.parentNode.insertBefore(panel, book.nextSibling); else root.appendChild(panel);
    var modeButtons=qsa('[data-mode]',panel);
    modeButtons.forEach(function(b){ b.addEventListener('click',function(){ handleMode(panel,b.getAttribute('data-mode')); }); });
    qsa('[data-quest]',panel).forEach(function(b){ b.addEventListener('click',function(){ earnRibbon(panel,b.textContent); }); });
    setScene(panel,'story');
    buildSensory(panel,0);
    buildCoinCase(panel,false);
    attachBookWatcher(panel);
    attachTilt(panel);
  }

  function handleMode(panel, mode){
    if(mode==='story'){ updateFromCurrentPage(panel); return; }
    if(mode==='portal'){ var i=modIndex('portal_index',REG.portals.length); setScene(panel,'story',i); return; }
    if(mode==='sense'){ var i2=modIndex('sense_index',REG.sensory.length); buildSensory(panel,i2); sparkleBurst(panel,18); return; }
    if(mode==='museum'){ openMuseumPreview(panel); return; }
    if(mode==='coin'){ buildCoinCase(panel,true); return; }
    if(mode==='safety'){ openSafetyModal(); return; }
  }

  function buildSensory(panel, idx){
    var s=REG.sensory[idx%REG.sensory.length]; var strip=qs('.bk-sensory-strip',panel); if(!strip) return;
    strip.innerHTML='<div class="bk-sense-card">'+imgTag(s.img,s.name,'')+'<div><b>'+s.name+' imagination bubble</b><p>'+s.cue+'</p><small>'+s.action+'</small></div></div>';
  }

  function buildCoinCase(panel, celebrate){
    var box=qs('.bk-coin-case',panel); if(!box) return;
    var idx=modIndex('coin_index',REG.coins.length); var coin=REG.coins[idx];
    box.innerHTML='<div class="bk-coin-prize"><img src="'+coin.url+'" alt="'+coin.name+'" loading="lazy" decoding="async"><div><b>'+coin.name+'</b><span>Earned for showing up and practicing courage. No cash value.</span></div></div>';
    if(celebrate){ sparkleBurst(panel,30); try{ if(root._hypeShow) root._hypeShow(); }catch(e){} }
  }

  function earnRibbon(panel, label){
    var count=getStore('quest_count',0)+1; setStore('quest_count',count);
    var rib=REG.ribbons[count%REG.ribbons.length];
    var strip=qs('.bk-sensory-strip',panel); if(strip){ strip.innerHTML='<div class="bk-ribbon-card">'+imgTag(rib.url,rib.name,'')+'<div><b>'+rib.name+' earned</b><p>'+label+' was counted as a brave practice moment.</p><small>Saved on this device only.</small></div></div>'; }
    if(count>=4) buildCoinCase(panel,true); else sparkleBurst(panel,18);
  }

  function openMuseumPreview(panel){
    var idx=modIndex('room_index',REG.rooms.length), r=REG.rooms[idx];
    var poster=qs('.bk-sim-poster',panel), video=qs('.bk-sim-video',panel), title=qs('.bk-sim-title',panel), mood=qs('.bk-sim-mood',panel), who=qs('.bk-sim-who',panel), line=qs('.bk-sim-line',panel), av=qs('.bk-sim-avatar',panel);
    poster.src=r.img; poster.alt=r.name; title.textContent=r.name; mood.textContent=r.kind||'museum room';
    video.pause(); video.removeAttribute('src'); video.removeAttribute('data-src'); video.load();
    if(r.vid){ video.setAttribute('data-src',r.vid); video.setAttribute('poster',r.img); video.setAttribute('data-autoplay','1'); video.__loaded=false; lazyVideo(video); }
    var ch=findCharacter('MVP Bacci'); av.src=ch.url; av.alt=ch.name; who.textContent='Museum Passport'; line.textContent='This room is ready for rotating jewel-framed art, short clips, and a child\'s saved art on this device.';
    sparkleBurst(panel,20);
  }

  function attachBookWatcher(panel){
    function currentChap(){ var c=qs('.bk-chap.cur'); return c?c.getAttribute('data-ch'):'story'; }
    function update(){ setTimeout(function(){ setScene(panel,currentChap()); },80); }
    ['bk-next','bk-prev','bk-cover','bk-closebook'].forEach(function(id){ var b=document.getElementById(id); if(b)b.addEventListener('click',update); });
    qsa('#bk-rail button').forEach(function(b){ b.addEventListener('click',update); });
    var pages=document.getElementById('bk-pages');
    if(pages&&'MutationObserver' in window){ new MutationObserver(function(){ updateFromCurrentPage(panel); }).observe(pages,{subtree:true,attributes:true,attributeFilter:['class']}); }
  }
  function updateFromCurrentPage(panel){ var c=qs('.bk-chap.cur'); setScene(panel,c?c.getAttribute('data-ch'):'story'); }

  function attachTilt(panel){
    if(reduced()) return;
    var shell=qs('.bk-sim-shell',panel); if(!shell) return;
    shell.addEventListener('pointermove',function(e){ var r=shell.getBoundingClientRect(); var rx=((e.clientY-r.top)/r.height-.5)*-7; var ry=((e.clientX-r.left)/r.width-.5)*7; shell.style.setProperty('--rx',rx.toFixed(2)+'deg'); shell.style.setProperty('--ry',ry.toFixed(2)+'deg'); });
    shell.addEventListener('pointerleave',function(){ shell.style.setProperty('--rx','0deg'); shell.style.setProperty('--ry','0deg'); });
  }

  function openSafetyModal(){
    var m=document.getElementById('bk-v44-safety-modal');
    if(!m){
      m=make('div','bk-modal bk-v44-modal','<div class="box" role="dialog" aria-modal="true" aria-label="Bacci Kid safety and privacy note">'+
        '<h3>Safety and privacy note</h3>'+
        '<p>The Bacci Kid Heartopedia is a playful creative emotional-learning experience. It is not therapy, diagnosis, medical care, crisis care, legal advice, or a substitute for a professional relationship.</p>'+
        '<p>For children, a parent or guardian should supervise. Email signups and purchases are for adults only. No emergency or safety concern should be handled inside this page. Use local emergency services or appropriate professional support when needed.</p>'+
        '<p>Art, nicknames, badges, coins, and progress are designed to stay on this device through browser storage unless a grown-up intentionally saves, prints, or uses Shopify checkout. Stickers, badges, and Bacci Kid Gold Coins are earned just for fun, have no cash value, and cannot be redeemed for money or merchandise.</p>'+
        '<p>All Bacci Kid characters, artwork, videos, logos, story worlds, and code concepts remain protected Bacci Kid intellectual property. Personal coloring use does not transfer commercial rights.</p>'+
        '<div class="bk-v44-close-row"><button class="bk-btn" type="button" id="bk-v44-safety-close">Close</button><a class="bk-btn ghost" href="'+REG.links.disclaimer+'">Full disclaimer</a></div>'+
      '</div>');
      root.appendChild(m); var close=qs('#bk-v44-safety-close',m); if(close) close.addEventListener('click',function(){ m.classList.remove('open'); });
      m.addEventListener('click',function(e){ if(e.target===m)m.classList.remove('open'); });
    }
    m.classList.add('open');
  }

  function enhanceMuseumConfig(){
    try{
      C.MUSEUM_ROOM=C.MUSEUM_ROOM||{};
      if(!C.MUSEUM_ROOM.backgroundUrl) C.MUSEUM_ROOM.backgroundUrl=REG.rooms[0].img;
      if(!C.MUSEUM_ROOM.portalUrl) C.MUSEUM_ROOM.portalUrl=REG.links.museum;
      var door=document.getElementById('bk-room-door'); if(door){ door.href=REG.links.museum; door.textContent=C.MUSEUM_ROOM.portalLabel||'Explore the Museum Portals'; door.hidden=false; }
    }catch(e){}
  }

  function cinematicBridge(url){
    var level=currentMotion(); var pool=level==='immersive'?REG.idents.action:REG.idents.calm; var vurl=pool[modIndex('ident_index',pool.length)];
    if(!vurl){ location.href=url; return; }
    var veil=make('div','bk-v44-transition','<video muted playsinline preload="auto"></video><button type="button">Skip</button><span>Opening the next Bacci Kid doorway</span>');
    document.body.appendChild(veil); var v=qs('video',veil), b=qs('button',veil), done=false;
    function go(){ if(done)return; done=true; try{v.pause();}catch(e){} veil.classList.add('out'); setTimeout(function(){ location.href=url; },260); }
    b.addEventListener('click',go); v.addEventListener('ended',go); v.addEventListener('error',go); v.src=vurl; setTimeout(function(){ veil.classList.add('on'); try{ var p=v.play(); if(p&&p.catch)p.catch(function(){ setTimeout(go,650); }); }catch(e){ go(); } },20); setTimeout(go,6200);
  }

  function wireDoors(){
    qsa('a[href="/pages/bacci-kid-museum-portals"],a[href="'+REG.links.museum+'"]').forEach(function(a){ if(a.__bkBridge)return; a.__bkBridge=true; a.addEventListener('click',function(e){ if(e.metaKey||e.ctrlKey||e.shiftKey) return; e.preventDefault(); cinematicBridge(a.href); }); });
    var b=document.getElementById('bk-museum'); if(b&&!b.__bkBridge){ b.__bkBridge=true; b.addEventListener('dblclick',function(){ cinematicBridge(REG.links.museum); }); }
  }

  function polishMedia(){
    qsa('img',root).forEach(function(img){ if(!img.hasAttribute('loading')&&!img.classList.contains('bk-crest')) img.setAttribute('loading','lazy'); if(!img.hasAttribute('decoding')) img.setAttribute('decoding','async'); });
    preloadOne(C.crestUrl||C.emblemUrl,'image'); preloadOne(C.lineArtUrl,'image');
  }

  function addGlobalKeys(){
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'){ qsa('.bk-v44-modal.open,.bk-modal.open',root).forEach(function(m){ m.classList.remove('open'); }); } if((e.key||'').toLowerCase()==='h'&&e.altKey){ try{ if(root._hypeShow) root._hypeShow(); }catch(x){} } });
  }

  function init(){ setupHead(); enhanceMuseumConfig(); buildSimulation(); polishMedia(); wireDoors(); addGlobalKeys(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();

/* ---- next engine block ---- */
/* ===== BACCI KID v45 FAN CONVERSION POLISH  .  additive patch ===== */
(function(){
  var root=document.getElementById('bk-hx');
  if(!root||root.__bkV45FanLoop) return;
  root.__bkV45FanLoop=true;
  root.classList.add('bk-v45-fanloop');

  function qs(s,c){return (c||document).querySelector(s);}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function by(id){return document.getElementById(id);}
  function reduce(){
    try{
      return document.documentElement.getAttribute('data-bk-motion')==='calm'||(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }catch(e){return false;}
  }
  function data(){
    try{return JSON.parse(localStorage.getItem('bk_v45_passport')||'{}')||{};}
    catch(e){return {};}
  }
  function save(o){
    try{localStorage.setItem('bk_v45_passport',JSON.stringify(o));}
    catch(e){}
  }
  function mark(k){
    var o=data();
    if(!o[k]){
      o[k]=Date.now();
      save(o);
      sparkle(k);
    }
    refresh();
  }
  function make(tag,cls,html){
    var e=document.createElement(tag);
    if(cls)e.className=cls;
    if(html!=null)e.innerHTML=html;
    return e;
  }
  function scrollToEl(el){
    if(!el)return;
    el.scrollIntoView({behavior:reduce()?'auto':'smooth',block:'center'});
    pulse(el);
  }
  function pulse(el){
    if(!el)return;
    el.classList.add('bk-v45-pulse');
    setTimeout(function(){el.classList.remove('bk-v45-pulse');},1800);
  }
  function sparkle(k){
    if(reduce()) return;
    var wrap=qs('.bk-v45-passport',root)||root;
    for(var i=0;i<18;i++){
      var s=make('i','bk-v45-pop','');
      s.style.left=(8+Math.random()*84)+'%';
      s.style.top=(15+Math.random()*68)+'%';
      s.style.setProperty('--sx',((Math.random()-.5)*190)+'px');
      s.style.setProperty('--sy',(-40-Math.random()*140)+'px');
      s.style.animationDelay=(Math.random()*.22)+'s';
      wrap.appendChild(s);
      setTimeout((function(x){
        return function(){
          if(x&&x.parentNode)x.parentNode.removeChild(x);
        };
      })(s),1500);
    }
  }

  var header=qs('.bk-top',root);
  var passport=qs('.bk-v45-passport',root);
  if(header&&!passport){
    passport=make('section','bk-v45-passport',
      '<div class="bk-v45-glow" aria-hidden="true"></div>'+
      '<div class="bk-v45-copy">'+
        '<span class="bk-v45-kicker">Bacci Kid fan quest</span>'+
        '<h2>Color. Read. Unlock. Come back Tuesday.</h2>'+
        '<p>Four tiny steps turn this page into a living Bacci Kid memory: one color, one brave story moment, one museum doorway, one reason to return.</p>'+
      '</div>'+
      '<div class="bk-v45-steps" aria-label="Bacci Kid fan quest progress">'+
        '<button type="button" data-step="color"><b>1</b><span>Color Bacci</span></button>'+
        '<button type="button" data-step="story"><b>2</b><span>Open the Story</span></button>'+
        '<button type="button" data-step="museum"><b>3</b><span>Enter Museum</span></button>'+
        '<button type="button" data-step="fan"><b>4</b><span>Join Tuesday Magic</span></button>'+
      '</div>'+
      '<div class="bk-v45-actions">'+
        '<button type="button" data-bk45="color">✨ Start with one color</button>'+
        '<button type="button" data-bk45="story">📖 Open Bacci\'s story</button>'+
        '<button type="button" data-bk45="museum">🏛 See the museum</button>'+
      '</div>');
    header.parentNode.insertBefore(passport,header.nextSibling);
  }

  function refresh(){
    var o=data();
    if(root.classList.contains('bk-earned')) o.fan=o.fan||Date.now();
    ['color','story','museum','fan'].forEach(function(k){
      var el=qs('[data-step="'+k+'"]',passport);
      if(el) el.classList.toggle('done',!!o[k]);
    });
    var done=Object.keys(o).filter(function(k){return o[k];}).length;
    if(passport) passport.setAttribute('data-complete',String(Math.min(done,4)));
  }

  if(passport){
    passport.addEventListener('click',function(e){
      var b=e.target.closest('button');
      if(!b)return;
      var step=b.getAttribute('data-step')||b.getAttribute('data-bk45');

      if(step==='color'){
        mark('color');
        scrollToEl(qs('.bk-paper',root));
      }

      if(step==='story'){
        mark('story');
        var c=by('bk-cover');
        if(c)c.click();
        setTimeout(function(){scrollToEl(by('bk-book'));},180);
      }

      if(step==='museum'){
        mark('museum');
        var m=by('bk-museum');
        if(m)m.click();
      }

      if(step==='fan'){
        mark('fan');
        scrollToEl(qs('.bk-signup',root));
      }
    });
  }

  root.addEventListener('click',function(e){
    var t=e.target;

    if(t&&t.id==='bk-canvas') mark('color');

    var b=t.closest&&t.closest('button,a');
    if(!b)return;

    var id=b.id||'';
    if(id==='bk-cover'||id==='bk-next'||id==='bk-read-en'||id==='bk-read-ko'||id==='bk-focus') mark('story');
    if(id==='bk-museum'||id==='bk-museum-add'||id==='bk-room-door') mark('museum');
    if(id==='bk-su-btn'||id==='bk-clicknow'||b.classList.contains('bk-hypebtn')) mark('fan');
  },true);

  if('MutationObserver' in window){
    new MutationObserver(function(){
      if(root.classList.contains('bk-earned')) mark('fan');
    }).observe(root,{attributes:true,attributeFilter:['class']});
  }

  if(!reduce()){
    var ticking=false, px=0, py=0;
    root.addEventListener('pointermove',function(e){
      px=e.clientX;
      py=e.clientY;
      if(ticking)return;
      ticking=true;
      requestAnimationFrame(function(){
        var r=root.getBoundingClientRect();
        root.style.setProperty('--bk45-x',(px-r.left)+'px');
        root.style.setProperty('--bk45-y',(py-r.top)+'px');
        ticking=false;
      });
    },{passive:true});
  }

  setTimeout(function(){
    var o=data();
    if(o.color||qs('.bk-v45-nudge',root)) return;

    var n=make('div','bk-v45-nudge',
      '<b>Start here</b>'+
      '<span>Pick one color and tap Bacci. The story world wakes up after your first brave click.</span>'+
      '<button type="button">Take me there</button>');

    root.appendChild(n);
    setTimeout(function(){n.classList.add('show');},30);

    n.querySelector('button').onclick=function(){
      mark('color');
      scrollToEl(qs('.bk-paper',root));
      n.classList.remove('show');
      setTimeout(function(){n.remove();},400);
    };

    setTimeout(function(){
      if(n.parentNode){
        n.classList.remove('show');
        setTimeout(function(){
          if(n.parentNode)n.remove();
        },500);
      }
    },18000);
  },9000);

  refresh();
})();

/* ---- next engine block ---- */
/* ===== BACCI KID v46 MOBILE CLARITY + MOOD CHECK COLLAPSE + BRAVE BANANA STORY GUIDE ===== */
(function(){
  var root=document.getElementById('bk-hx');
  if(!root||root.__bkV46MobileMoodGuide) return;
  root.__bkV46MobileMoodGuide=true;
  root.classList.add('bk-v46-mobile-clarity');

  var BANANA_URL='https://cdn.shopify.com/s/files/1/0500/7307/5871/files/banana_1.png?v=1772481971';
  var STORE='bk_v46_brave_mood_check';

  function qs(s,c){return (c||document).querySelector(s);}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function by(id){return document.getElementById(id);}
  function make(tag,cls,html){var e=document.createElement(tag); if(cls)e.className=cls; if(html!=null)e.innerHTML=html; return e;}
  function isMobile(){return window.matchMedia&&window.matchMedia('(max-width: 990px)').matches;}
  function reduce(){try{return document.documentElement.getAttribute('data-bk-motion')==='calm'||(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);}catch(e){return false;}}
  function safeScroll(el,block){if(!el)return; try{el.scrollIntoView({behavior:reduce()?'auto':'smooth',block:block||'center'});}catch(e){el.scrollIntoView();}}
  function pulse(el){if(!el)return; el.classList.add('bk-v46-pulse'); setTimeout(function(){el.classList.remove('bk-v46-pulse');},1700);}
  function burst(anchor,count){
    if(reduce()||!anchor) return;
    anchor.classList.add('bk-v46-burst-host');
    var icons=['💗','💖','💕','✨','🐾'];
    for(var i=0;i<(count||16);i++){
      var h=make('span','bk-v46-heart',icons[i%icons.length]);
      h.style.left=(10+Math.random()*80)+'%';
      h.style.top=(40+Math.random()*18)+'%';
      h.style.setProperty('--dx',((Math.random()-.5)*190)+'px');
      h.style.setProperty('--dy',(-60-Math.random()*145)+'px');
      h.style.setProperty('--rr',((Math.random()-.5)*80)+'deg');
      h.style.animationDelay=(Math.random()*.22)+'s';
      anchor.appendChild(h);
      setTimeout((function(x){
        return function(){
          if(x&&x.parentNode)x.parentNode.removeChild(x);
        };
      })(h),1450);
    }
  }
  function saveMood(obj){try{sessionStorage.setItem(STORE,JSON.stringify(obj));}catch(e){}}
  function getMood(){try{return JSON.parse(sessionStorage.getItem(STORE)||'null');}catch(e){return null;}}
  function clearMood(){try{sessionStorage.removeItem(STORE);}catch(e){}}

  function enhanceMood(){
    var mood=by('bk-mood'), row=by('bk-moodrow'), reply=by('bk-moodreply');
    if(!mood||!row||mood.__bkV46) return;
    mood.__bkV46=true;
    mood.classList.add('bk-mood-v46');
    mood.setAttribute('aria-expanded','true');

    var actions=make('div','bk-mood-v46-actions','<button type="button" class="bk-mood-v46-got">Got it 💖</button><button type="button" class="bk-mood-v46-skip">Skip for now</button>');
    var summary=make('button','bk-mood-v46-summary','<span>💗 Mood check complete</span><small>Ready to color with Bacci.</small><b>Change</b>');
    summary.type='button';
    mood.appendChild(actions);
    mood.appendChild(summary);

    var got=qs('.bk-mood-v46-got',actions), skip=qs('.bk-mood-v46-skip',actions);
    var selected='', selectedReply='';

    function setSummary(label,msg){
      summary.innerHTML='<span>💗 '+label+'</span><small>'+msg+'</small><b>Change</b>';
    }

    function collapse(label,msg){
      label=label||selected||'Ready';
      msg=msg||selectedReply||'Ready to color with Bacci.';
      setSummary(label,msg);
      mood.classList.add('bk-mood-v46-done');
      mood.setAttribute('aria-expanded','false');
      saveMood({label:label,msg:msg});
      burst(mood,20);
      if(isMobile()) setTimeout(function(){
        safeScroll(qs('.bk-paper',root),'start');
        pulse(qs('.bk-paper',root));
      },320);
    }

    function reopen(){
      mood.classList.remove('bk-mood-v46-done');
      mood.setAttribute('aria-expanded','true');
      clearMood();
      if(isMobile()) setTimeout(function(){
        safeScroll(mood,'center');
      },50);
    }

    row.addEventListener('click',function(e){
      var btn=e.target.closest&&e.target.closest('.bk-moodbtn');
      if(!btn||!row.contains(btn)) return;
      setTimeout(function(){
        selected=(btn.textContent||'').replace(/\s+/g,' ').trim();
        selectedReply=(reply&&reply.textContent?reply.textContent:'Ready to color with Bacci.');
        got.textContent='Got it 💖';
        mood.classList.add('bk-mood-v46-ready');
        burst(btn,8);
      },0);
    });

    got.addEventListener('click',function(){
      collapse(selected||'Mood noticed',selectedReply||'Thank you for checking in. Now the page can breathe.');
    });

    skip.addEventListener('click',function(){
      collapse('Skipped for now','No pressure. You can still color, read, and explore.');
    });

    summary.addEventListener('click',reopen);

    var remembered=getMood();
    if(remembered&&remembered.label){
      setSummary(remembered.label,remembered.msg||'Ready to color with Bacci.');
      mood.classList.add('bk-mood-v46-done');
      mood.setAttribute('aria-expanded','false');
    }
  }

  function buildBrushStrip(){
    var sw=by('bk-swatches'), preview=by('bk-previewbar');
    if(!sw||!preview||by('bk-v46-brush-strip')) return;

    var strip=make('div','bk-v46-brush-strip','<span>Quick colors</span><div class="bk-v46-brush-colors"></div>');
    strip.id='bk-v46-brush-strip';
    preview.parentNode.insertBefore(strip,preview.nextSibling);

    var holder=qs('.bk-v46-brush-colors',strip);

    function rebuild(){
      holder.innerHTML='';
      qsa('.bk-sw',sw).slice(0,14).forEach(function(orig){
        var b=make('button','','');
        b.type='button';
        b.style.background=orig.style.background||orig.style.backgroundColor;
        b.setAttribute('aria-label',orig.getAttribute('aria-label')||'Quick color');
        b.addEventListener('click',function(){
          orig.click();
          qsa('button',holder).forEach(function(x){x.removeAttribute('aria-current');});
          b.setAttribute('aria-current','true');
          pulse(qs('.bk-paper',root));
        });
        holder.appendChild(b);
      });
    }

    rebuild();

    if('MutationObserver' in window){
      new MutationObserver(rebuild).observe(sw,{childList:true,subtree:true,attributes:true,attributeFilter:['style','aria-pressed']});
    }
  }

  function mobileDock(){
    if(by('bk-v46-dock')) return;

    var dock=make('nav','bk-v46-dock','<button type="button" data-go="color">🎨 Color</button><button type="button" data-go="tools">🖌 Tools</button><button type="button" data-go="story">📖 Story</button><button type="button" data-go="museum">🏛 Museum</button>');
    dock.id='bk-v46-dock';
    dock.setAttribute('aria-label','Bacci Kid quick navigation');
    root.appendChild(dock);

    dock.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('button[data-go]');
      if(!b)return;

      var go=b.getAttribute('data-go');

      if(go==='color'){
        safeScroll(qs('.bk-paper',root),'start');
        pulse(qs('.bk-paper',root));
      }

      if(go==='tools'){
        safeScroll(qs('.bk-drawer',root),'start');
        pulse(qs('.bk-drawer',root));
      }

      if(go==='story'){
        var cover=by('bk-cover');
        var book=by('bk-book');
        if(cover&&book&&!book.classList.contains('open')) cover.click();
        setTimeout(function(){
          safeScroll(by('bk-book'),'start');
          pulse(by('bk-book'));
        },260);
      }

      if(go==='museum'){
        var m=by('bk-museum');
        if(m)m.click();
      }
    });
  }

  function bananaGuide(){
    var book=by('bk-book');
    if(!book||by('bk-v46-banana-guide')) return;

    var guide=make('aside','bk-v46-guide','<button type="button" class="bk-v46-guide-hide" aria-label="Hide Brave Banana guide">×</button><img src="'+BANANA_URL+'" alt="Brave Banana"><div><b>Brave Banana Guide</b><p></p><button type="button" class="bk-v46-guide-spark">Guide me ✨</button></div>');
    guide.id='bk-v46-banana-guide';
    book.appendChild(guide);

    var lines={
      cover:'I will stay close when you open the story. Brave starts with one page.',
      story:'This is the brave part. Bacci turns toward the smaller self who needs kindness.',
      toyou:'This page gives the story to you. Take only what feels helpful.',
      feels:'Notice the body feeling. Brave can flutter and still be real.',
      when:'Brave often hides inside ordinary moments. A hand raised. A truth spoken. One more try.',
      world:'In Korean, brave is yong-gam. Courage belongs to every culture.',
      know:'Scared and brave can happen together. Your body is not wrong.',
      turn:'Tiny quest time. Name one brave thing, even a small one.',
      mantra:'This is the power line. Feel afraid and take the next small step.'
    };

    function current(){
      var c=qs('.bk-chap.cur',book);
      return c?c.getAttribute('data-ch'):'cover';
    }

    function update(){
      var open=book.classList.contains('open')&&!book.classList.contains('bk-tucked');
      guide.classList.toggle('show',open);
      var ch=current();
      qs('p',guide).textContent=lines[ch]||lines.cover;
    }

    qs('.bk-v46-guide-hide',guide).addEventListener('click',function(){
      guide.classList.toggle('min');
    });

    qs('.bk-v46-guide-spark',guide).addEventListener('click',function(){
      burst(guide,16);
      pulse(qs('.bk-chap.cur',book)||book);
    });

    qsa('#bk-next,#bk-prev,#bk-cover,#bk-closebook,#bk-rail button',root).forEach(function(b){
      b.addEventListener('click',function(){
        setTimeout(update,360);
        setTimeout(update,1600);
      });
    });

    if('MutationObserver' in window){
      new MutationObserver(update).observe(book,{subtree:true,attributes:true,attributeFilter:['class']});
    }

    update();
  }

  function init(){
    enhanceMood();
    buildBrushStrip();
    mobileDock();
    bananaGuide();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

/* ---- next engine block ---- */
/* ===== BACCI KID v47 TRUST + SOURCES + WORDGLOW + INNER TEEN PATCH ===== */
(function(){
  var root=document.getElementById('bk-hx');
  if(!root||root.__bkV47TrustWordGlow) return;
  root.__bkV47TrustWordGlow=true;
  root.classList.add('bk-v47-trust-wordglow');

  function qs(s,c){return (c||document).querySelector(s);}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function by(id){return document.getElementById(id);}
  function make(tag,cls,html){
    var e=document.createElement(tag);
    if(cls)e.className=cls;
    if(html!=null)e.innerHTML=html;
    return e;
  }

  var STRONG_DISCLAIMER =
    "The Bacci Kid Heartopedia is a playful creative coloring, story, and emotional-vocabulary experience. It may support reflection, feelings language, calm practice, and creative self-expression, but it is not therapy, diagnosis, medical care, crisis care, legal advice, educational testing, or a substitute for professional services. No outcome is promised. If a child, teen, adult, or family has a safety concern, health concern, mental-health concern, emergency, or crisis, use appropriate local emergency services or qualified professional support. Children should use this experience with parent or guardian supervision. Email signups and purchases are for adults only. Personalization, nicknames, mood choices, coloring progress, badges, coins, and museum saves are intended to stay on this device unless a grown-up intentionally saves, prints, submits a form, or checks out through Shopify. Stickers, badges, and Bacci Kid Gold Coins are playful earned rewards only, have no cash value, cannot be redeemed for money or merchandise, and are not gambling, raffles, sweepstakes, or currency. Bacci Kid characters, artwork, videos, stories, frames, worlds, logos, and designs remain the protected property of Bacci Kid and/or Dr. Jamie J. Karia. Coloring or customizing a page does not transfer copyright, trademark, commercial, merchandising, licensing, AI-training, redistribution, resale, or publishing rights. Partner locations or organizations may share or host Bacci Kid materials, but they are not responsible for clinical care, emergency response, diagnosis, treatment, child supervision, or the user's personal interpretation of the experience. Korean and bilingual content is provided for educational language practice and should be reviewed by a qualified Korean speaker before final publication. © 2026 Bacci Kid. All rights reserved.";

  var OWNERSHIP =
    "Bacci Kid artwork, characters, story worlds, names, logos, videos, badges, coins, frames, and designs remain protected Bacci Kid intellectual property. You may enjoy, save, and print your colored copy for personal, non-commercial use only. You may not sell, redistribute, use commercially, upload as a product, mint, license, claim ownership of, or train AI systems with Bacci Kid artwork, characters, frames, story worlds, videos, or designs. Coloring is a personal-use creative license, not a transfer of rights.";

  var INNER_TEEN_COPY =
    "Hi, I am Bacci. Pick a color you love, then tap inside the picture to fill it. This Brave page is made for teens, but you do not have to be a teen to join. If you are a grown-up, caregiver, educator, grandparent, or curious visitor, you can color with the inner teen, inner child, present self, or future self that still lives inside you. Some people connect to that creatively, spiritually, or reflectively. Take only what feels meaningful. This is creative reflection, not therapy, diagnosis, crisis care, or a promise of any result.";

  var VOCAB = [
    {en:'Brave', ko:'용감', rom:'yong-gam', spark:'doing the next true thing while fear is nearby'},
    {en:'Calm', ko:'평온', rom:'pyeong-on', spark:'a softer place for the body to land'},
    {en:'Curious', ko:'호기심', rom:'ho-gi-sim', spark:'wanting to understand instead of instantly judging'},
    {en:'Hope', ko:'희망', rom:'hui-mang', spark:'a small light that says tomorrow can still open'},
    {en:'Kind', ko:'친절', rom:'chin-jeol', spark:'choosing care with yourself or someone else'},
    {en:'Grateful', ko:'감사', rom:'gam-sa', spark:'noticing something that mattered'},
    {en:'Peace', ko:'평화', rom:'pyeong-hwa', spark:'a quiet moment inside or around you'},
    {en:'Sad', ko:'슬픔', rom:'seul-peum', spark:'a feeling that may need care, comfort, or time'},
    {en:'Angry', ko:'화남', rom:'hwa-nam', spark:'a signal that something may feel unfair, hurt, or crossed'},
    {en:'Anxious', ko:'불안', rom:'bul-an', spark:'a body alarm asking for attention and steadiness'},
    {en:'Proud', ko:'자랑스러움', rom:'ja-rang-seu-reo-um', spark:'honoring effort, growth, or courage'},
    {en:'Loved', ko:'사랑받는', rom:'sa-rang-bat-neun', spark:'remembering you are worthy of care'},
    {en:'Steady', ko:'단단함', rom:'dan-dan-ham', spark:'grounded enough to take one small step'},
    {en:'Focus Flow', ko:'몰입', rom:'mol-ip', spark:'when attention settles into one meaningful thing'}
  ];

  var SOURCES = [
    {
      title:'CASEL SEL Framework',
      note:'Educational background for social and emotional learning language.',
      url:'https://casel.org/fundamentals-of-sel/what-is-the-casel-framework/'
    },
    {
      title:'FTC COPPA Rule',
      note:'Children online privacy rule background.',
      url:'https://www.ftc.gov/legal-library/browse/rules/childrens-online-privacy-protection-rule-coppa'
    },
    {
      title:'FTC COPPA FAQs',
      note:'Parent notice, consent, and children privacy guidance.',
      url:'https://www.ftc.gov/business-guidance/resources/complying-coppa-frequently-asked-questions'
    },
    {
      title:'FTC Advertising Substantiation Policy Statement',
      note:'Background on supporting objective advertising claims.',
      url:'https://www.ftc.gov/legal-library/browse/ftc-policy-statement-regarding-advertising-substantiation'
    },
    {
      title:'FTC Health Products Compliance Guidance',
      note:'Background on truthful and substantiated wellness-related claims.',
      url:'https://www.ftc.gov/business-guidance/resources/health-products-compliance-guidance'
    },
    {
      title:'FTC Endorsement Guides FAQ',
      note:'Background for influencers, reviews, testimonials, and disclosures.',
      url:'https://www.ftc.gov/business-guidance/resources/ftcs-endorsement-guides-what-people-are-asking'
    },
    {
      title:'American Academy of Pediatrics, The Power of Play',
      note:'Background on play, development, and social-emotional skills.',
      url:'https://publications.aap.org/pediatrics/article/142/3/e20182058/38649/The-Power-of-Play-A-Pediatric-Role-in-Enhancing'
    },
    {
      title:'PubMed, Mindfulness Coloring Research',
      note:'Background on coloring and mindfulness research. Not a promise of results.',
      url:'https://pubmed.ncbi.nlm.nih.gov/30908136/'
    }
  ];

  function strengthenIntro(){
    var tip=by('bk-tip'), p=by('bk-tip-text');
    if(!tip||!p||p.__bkV47) return;
    p.__bkV47=true;
    tip.classList.add('bk-v47-inner-teen');
    p.textContent=INNER_TEEN_COPY;
  }

  function strengthenDisclaimer(){
    var d=by('bk-disc-text');
    if(d) d.textContent=STRONG_DISCLAIMER;

    var own=by('bk-own');
    if(own) own.textContent=OWNERSHIP;
  }

  function speakPair(en,ko){
    try{
      if(!window.speechSynthesis) return;
      speechSynthesis.cancel();
      var u1=new SpeechSynthesisUtterance(ko);
      u1.lang='ko-KR';
      u1.rate=.84;
      speechSynthesis.speak(u1);
      setTimeout(function(){
        var u2=new SpeechSynthesisUtterance(en);
        u2.lang='en-US';
        u2.rate=.9;
        speechSynthesis.speak(u2);
      },850);
    }catch(e){}
  }

  function buildWordLab(){
    if(by('bk-v47-wordlab')) return;

    var lab=make('section','bk-v47-wordlab',
      '<div class="bk-v47-wordlab-head">'+
        '<span>WordGlow Lab · English + 한국어</span>'+
        '<h3>Build your feeling vocabulary</h3>'+
        '<p>Tap a card to hear the Korean and English feeling word. English speakers can learn Korean. Korean speakers can practice English. Everyone gets a bigger emotional vocabulary.</p>'+
      '</div>'+
      '<div class="bk-v47-wordgrid" id="bk-v47-wordgrid"></div>'+
      '<p class="bk-v47-footnote">Language note: this is educational vocabulary practice, not a clinical assessment. Korean child-facing and clinical-adjacent copy should be reviewed by a qualified Korean speaker before final publication.</p>'
    );

    var insertAfter=by('bk-mood')||qs('.bk-stage',root)||qs('.bk-top',root);
    if(insertAfter&&insertAfter.parentNode) insertAfter.parentNode.insertBefore(lab,insertAfter.nextSibling);
    else root.appendChild(lab);

    var grid=by('bk-v47-wordgrid');
    VOCAB.forEach(function(v){
      var card=make('article','bk-v47-wordcard',
        '<b>'+v.en+'</b>'+
        '<div class="ko">'+v.ko+'</div>'+
        '<small>'+v.rom+' · '+v.spark+'</small>'+
        '<button type="button">🔊 Say both</button>'
      );
      card.querySelector('button').addEventListener('click',function(){ speakPair(v.en,v.ko); });
      grid.appendChild(card);
    });
  }

  function buildTrustModal(){
    if(by('bk-v47-trust-modal')) return;

    var m=make('div','bk-modal bk-v47-modal','');
    m.id='bk-v47-trust-modal';
    m.setAttribute('role','dialog');
    m.setAttribute('aria-modal','true');
    m.setAttribute('aria-label','Bacci Kid trust, safety, references, and use note');

    var sourceHtml=SOURCES.map(function(s){
      return '<a href="'+s.url+'" target="_blank" rel="noopener noreferrer"><strong>'+s.title+'</strong><br><span>'+s.note+'</span></a>';
    }).join('');

    m.innerHTML =
      '<div class="box">'+
        '<h3>Trust, Sources, and Safety Notes</h3>'+
        '<p><strong>Bacci Kid is a creative emotional-vocabulary experience.</strong> It is built to support playful reflection, coloring, story, language learning, and feelings vocabulary. It is not therapy, diagnosis, medical care, crisis care, legal advice, or a substitute for professional services.</p>'+

        '<h4>How this page protects privacy</h4>'+
        '<ul>'+
          '<li>Coloring progress, mood choices, nickname-style personalization, museum saves, badges, and coins are designed to stay on this device unless a grown-up intentionally saves, prints, submits, or checks out.</li>'+
          '<li>Email signup and purchases are for adults only.</li>'+
          '<li>No public chat, public leaderboard, raffle, sweepstakes, coin conversion, or child-to-child messaging should be added without legal review.</li>'+
        '</ul>'+

        '<h4>Rewards and purchases</h4>'+
        '<ul>'+
          '<li>Bacci Kid stickers, badges, and Gold Coins are playful earned rewards only.</li>'+
          '<li>They have no cash value and cannot be redeemed for money, products, discounts, prizes, or merchandise.</li>'+
          '<li>Real purchases, if offered, should happen only through parent or adult checkout.</li>'+
        '</ul>'+

        '<h4>Artwork and use rights</h4>'+
        '<p>Bacci Kid characters, artwork, story worlds, frames, badges, videos, names, logos, and designs remain protected Bacci Kid intellectual property. Coloring or customizing a page gives a personal-use creative copy only and does not transfer commercial rights.</p>'+

        '<h4>Partners and locations</h4>'+
        '<p>If this experience appears through a restaurant, school, clinic, camp, museum, nonprofit, or other partner, that does not make the partner responsible for clinical care, emergency response, child supervision, diagnosis, treatment, or the user\'s personal interpretation of the activity.</p>'+

        '<h4>References and educational background</h4>'+
        '<p>These sources are included for transparency and educational background. They are not a promise that any individual user will experience a specific result.</p>'+
        '<div class="bk-v47-sources">'+sourceHtml+'</div>'+

        '<div class="bk-v47-close-row">'+
          '<button class="bk-btn" type="button" id="bk-v47-trust-close">Close</button>'+
          '<a class="bk-btn ghost" href="/pages/disclaimer">Full disclaimer</a>'+
          '<a class="bk-btn ghost" href="/policies/privacy-policy">Privacy policy</a>'+
          '<a class="bk-btn ghost" href="/policies/terms-of-service">Terms</a>'+
        '</div>'+
      '</div>';

    root.appendChild(m);

    by('bk-v47-trust-close').addEventListener('click',function(){ m.classList.remove('open'); });
    m.addEventListener('click',function(e){ if(e.target===m) m.classList.remove('open'); });
  }

  function openTrust(){
    buildTrustModal();
    by('bk-v47-trust-modal').classList.add('open');
  }

  function addSwitchButtons(){
    var bar=qs('.bk-switches',root);
    if(!bar) return;

    if(!by('bk-v47-trust-btn')){
      var trust=make('button','bk-switch','🛡️ <span>Trust & Sources</span>');
      trust.id='bk-v47-trust-btn';
      trust.type='button';
      trust.addEventListener('click',openTrust);
      bar.appendChild(trust);
    }

    if(!by('bk-v47-word-btn')){
      var word=make('button','bk-switch','🌏 <span>WordGlow Lab</span>');
      word.id='bk-v47-word-btn';
      word.type='button';
      word.addEventListener('click',function(){
        buildWordLab();
        var lab=by('bk-v47-wordlab');
        if(lab) lab.scrollIntoView({behavior:'smooth',block:'center'});
      });
      bar.appendChild(word);
    }
  }

  function addTrustBar(){
    if(by('bk-v47-trustbar')) return;

    var bar=make('section','bk-v47-trustbar',
      '<b>Parent, partner, and creator protection note</b>'+
      '<p>This experience is playful emotional vocabulary, coloring, story, and language practice. It is not therapy, diagnosis, medical advice, crisis care, or a promise of results. Rewards are just for fun and have no cash value. Personalization is designed to stay on this device.</p>'+
      '<div class="bk-v47-trust-actions">'+
        '<button type="button" id="bk-v47-trustbar-open">🛡️ Trust & Sources</button>'+
        '<a href="/pages/disclaimer">Full disclaimer</a>'+
        '<a href="/policies/privacy-policy">Privacy policy</a>'+
      '</div>'
    );

    var nav=qs('.bk-navrow',root), foot=qs('.bk-foot',root);
    if(nav&&nav.parentNode) nav.parentNode.insertBefore(bar,nav);
    else if(foot&&foot.parentNode) foot.parentNode.insertBefore(bar,foot);
    else root.appendChild(bar);

    by('bk-v47-trustbar-open').addEventListener('click',openTrust);
  }

  function enhanceDisclaimerButton(){
    var b=by('bk-disc');
    if(!b||b.__bkV47) return;
    b.__bkV47=true;
    b.innerHTML='🛡️ Disclaimer + Sources';
  }

  function init(){
    strengthenIntro();
    strengthenDisclaimer();
    addSwitchButtons();
    addTrustBar();
    buildWordLab();
    enhanceDisclaimerButton();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

/* ---- next engine block ---- */
/* ===== BACCI KID v48 WORDGLOW PRO + QA SENTINEL ===== */
(function(){
  var root=document.getElementById('bk-hx');
  if(!root||root.__bkV48WordGlowQASentinel) return;
  root.__bkV48WordGlowQASentinel=true;
  root.classList.add('bk-v48-wordglow-sentinel');

  function qs(s,c){return (c||document).querySelector(s);}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function by(id){return document.getElementById(id);}
  function make(tag,cls,html){
    var e=document.createElement(tag);
    if(cls)e.className=cls;
    if(html!=null)e.innerHTML=html;
    return e;
  }
  function config(){
    try{return typeof BK_HX_CONFIG!=='undefined'?BK_HX_CONFIG:null;}
    catch(e){return null;}
  }
  function reduced(){
    try{
      return document.documentElement.getAttribute('data-bk-motion')==='calm'||(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }catch(e){return false;}
  }

  var WORDS = [
    {cat:'feelings', en:'Brave', ko:'용감', rom:'yong-gam', spark:'I can feel afraid and still take one small true step.'},
    {cat:'feelings', en:'Calm', ko:'평온', rom:'pyeong-on', spark:'My body can land in one softer moment.'},
    {cat:'feelings', en:'Curious', ko:'호기심', rom:'ho-gi-sim', spark:'I can wonder before I judge.'},
    {cat:'feelings', en:'Hope', ko:'희망', rom:'hui-mang', spark:'A tiny light can still count.'},
    {cat:'feelings', en:'Proud', ko:'자랑스러움', rom:'ja-rang-seu-reo-um', spark:'I can honor effort, not only results.'},
    {cat:'feelings', en:'Grateful', ko:'감사', rom:'gam-sa', spark:'I can notice what helped me today.'},
    {cat:'feelings', en:'Anxious', ko:'불안', rom:'bul-an', spark:'My body alarm is asking for steadiness.'},
    {cat:'feelings', en:'Sad', ko:'슬픔', rom:'seul-peum', spark:'A heavy feeling can need care and time.'},
    {cat:'feelings', en:'Angry', ko:'화남', rom:'hwa-nam', spark:'Anger can be a signal that something matters.'},
    {cat:'teen', en:'Quiet Brave', ko:'조용한 용기', rom:'jo-yong-han yong-gi', spark:'Not all courage is loud.'},
    {cat:'teen', en:'Genius Flow', ko:'몰입', rom:'mol-ip', spark:'My attention can settle into one meaningful thing.'},
    {cat:'teen', en:'Social Battery Low', ko:'사회 에너지 낮음', rom:'sa-hoe e-neo-ji na-jeum', spark:'I can need space and still care.'},
    {cat:'teen', en:'Brain Fog', ko:'머리가 흐릿함', rom:'meo-ri-ga heu-rit-ham', spark:'I can go slower without giving up.'},
    {cat:'teen', en:'Reset Needed', ko:'리셋이 필요함', rom:'ri-set-i pil-yo-ham', spark:'A reset is not a failure.'},
    {cat:'teen', en:'Soft but Strong', ko:'부드럽지만 강함', rom:'bu-deu-reop-ji-man gang-ham', spark:'Gentle can still be powerful.'},
    {cat:'phrases', en:'I feel brave.', ko:'나는 용기를 느껴요.', rom:'na-neun yong-gi-reul neu-kkyeo-yo', spark:'Use this when courage is present, even a little.'},
    {cat:'phrases', en:'I need a break.', ko:'나는 잠깐 쉬어야 해요.', rom:'na-neun jam-kkan swi-eo-ya hae-yo', spark:'A break can be a wise next step.'},
    {cat:'phrases', en:'I can try again.', ko:'나는 다시 해볼 수 있어요.', rom:'na-neun da-si hae-bol su i-sseo-yo', spark:'Trying again can be quiet courage.'},
    {cat:'phrases', en:'I want help.', ko:'도움이 필요해요.', rom:'do-um-i pil-yo-hae-yo', spark:'Asking for help can be brave.'},
    {cat:'phrases', en:'I am proud of myself.', ko:'나는 내가 자랑스러워요.', rom:'na-neun nae-ga ja-rang-seu-reo-wo-yo', spark:'Self-pride can be kind and steady.'},
    {cat:'phrases', en:'I can pause first.', ko:'먼저 멈출 수 있어요.', rom:'meon-jeo meom-chul su i-sseo-yo', spark:'A pause can protect your next choice.'},
    {cat:'phrases', en:'I can name this feeling.', ko:'이 감정의 이름을 말할 수 있어요.', rom:'i gam-jeong-ui i-reum-eul mal-hal su i-sseo-yo', spark:'Naming a feeling gives it a handle.'}
  ];

  function speak(en,ko){
    try{
      if(!window.speechSynthesis) return;
      speechSynthesis.cancel();
      var k=new SpeechSynthesisUtterance(ko);
      k.lang='ko-KR';
      k.rate=.84;
      speechSynthesis.speak(k);
      setTimeout(function(){
        var e=new SpeechSynthesisUtterance(en);
        e.lang='en-US';
        e.rate=.9;
        speechSynthesis.speak(e);
      },850);
    }catch(x){}
  }

  function countWord(){
    var n=0;
    try{n=+(localStorage.getItem('bk_v48_wordglow_count')||0);}catch(e){}
    n++;
    try{localStorage.setItem('bk_v48_wordglow_count',String(n));}catch(e){}
    refreshStamp();
    if(n===3){
      try{ if(root._hypeShow) root._hypeShow(); }catch(e){}
    }
  }

  function refreshStamp(){
    var st=by('bk-v48-stamp-count');
    if(!st) return;
    var n=0;
    try{n=+(localStorage.getItem('bk_v48_wordglow_count')||0);}catch(e){}
    st.textContent=Math.min(n,3)+' of 3 WordGlow sparks practiced';
    var badge=by('bk-v48-stamp-badge');
    if(badge){
      badge.textContent=n>=3?'WordGlow stamp earned 🌏✨':'Practice 3 words to earn the WordGlow stamp';
    }
  }

  function drawCards(cat){
    var grid=by('bk-v48-wordgrid');
    if(!grid) return;
    grid.innerHTML='';
    WORDS.filter(function(w){return cat==='all'||w.cat===cat;}).forEach(function(w){
      var card=make('article','bk-v48-wordcard',
        '<b>'+w.en+'</b>'+
        '<div class="ko">'+w.ko+'</div>'+
        '<small>'+w.rom+' · '+w.spark+'</small>'+
        '<div class="row"><button type="button">🔊 Say both</button><button type="button" class="alt">Use as today\'s word</button></div>'
      );
      qsa('button',card)[0].addEventListener('click',function(){
        speak(w.en,w.ko);
        countWord();
      });
      qsa('button',card)[1].addEventListener('click',function(){
        try{localStorage.setItem('bk_v48_today_word',JSON.stringify(w));}catch(e){}
        countWord();
        var bubble=qs('.bk-sim-line',root)||by('bk-moodreply')||by('bk-tip-text');
        if(bubble) bubble.textContent='Today\'s WordGlow word is '+w.en+' · '+w.ko+'. '+w.spark;
      });
      grid.appendChild(card);
    });
  }

  function buildQuiz(){
    var q=by('bk-v48-quiz');
    if(!q) return;
    var pool=WORDS.slice(0);
    var answer=pool[Math.floor(Math.random()*pool.length)];
    var choices=[answer.en];
    while(choices.length<4){
      var c=pool[Math.floor(Math.random()*pool.length)].en;
      if(choices.indexOf(c)<0) choices.push(c);
    }
    choices.sort(function(){return Math.random()-.5;});
    q.innerHTML='<p>Mini WordGlow Quest: What does <strong>'+answer.ko+'</strong> mean?</p><div class="choices"></div><p class="bk-v48-quiz-reply" aria-live="polite"></p>';
    var row=qs('.choices',q);
    choices.forEach(function(c){
      var b=make('button','',c);
      b.type='button';
      b.addEventListener('click',function(){
        var reply=qs('.bk-v48-quiz-reply',q);
        if(c===answer.en){
          reply.textContent='Correct. '+answer.en+' means '+answer.ko+'.';
          countWord();
          speak(answer.en,answer.ko);
        }else{
          reply.textContent='Close try. The answer is '+answer.en+'.';
        }
      });
      row.appendChild(b);
    });
  }

  function buildWordGlowPro(){
    if(by('bk-v48-wordpro')) return;

    var pro=make('section','bk-v48-wordpro',
      '<div class="bk-v48-wordpro-head">'+
        '<span class="bk-v48-kicker">WordGlow Pro · English + 한국어</span>'+
        '<h3>Build your feeling vocabulary</h3>'+
        '<p>Tap a card to hear Korean and English together. English speakers can learn Korean. Korean speakers can practice English. Everyone gets more precise feeling language.</p>'+
      '</div>'+
      '<div class="bk-v48-tabs" role="group" aria-label="WordGlow categories">'+
        '<button type="button" data-cat="all" aria-pressed="true">All</button>'+
        '<button type="button" data-cat="feelings" aria-pressed="false">Feelings</button>'+
        '<button type="button" data-cat="teen" aria-pressed="false">Teen states</button>'+
        '<button type="button" data-cat="phrases" aria-pressed="false">Useful phrases</button>'+
      '</div>'+
      '<div class="bk-v48-wordgrid" id="bk-v48-wordgrid"></div>'+
      '<div class="bk-v48-quiz" id="bk-v48-quiz"></div>'+
      '<div class="bk-v48-stamp"><div><b id="bk-v48-stamp-badge">Practice 3 words to earn the WordGlow stamp</b><br><span id="bk-v48-stamp-count">0 of 3 WordGlow sparks practiced</span></div><button type="button" id="bk-v48-new-quiz">New mini quest</button></div>'+
      '<p class="bk-v48-note">Language note: Korean copy here is educational vocabulary practice and should be reviewed by a qualified Korean speaker before final launch, especially for child-facing, clinical-adjacent, or partnership use.</p>'
    );

    var place=by('bk-v47-wordlab')||by('bk-mood')||qs('.bk-stage',root)||qs('.bk-top',root);
    if(place&&place.parentNode) place.parentNode.insertBefore(pro,place.nextSibling);
    else root.appendChild(pro);

    qsa('.bk-v48-tabs button',pro).forEach(function(b){
      b.addEventListener('click',function(){
        qsa('.bk-v48-tabs button',pro).forEach(function(x){x.setAttribute('aria-pressed','false');});
        b.setAttribute('aria-pressed','true');
        drawCards(b.getAttribute('data-cat')||'all');
      });
    });

    by('bk-v48-new-quiz').addEventListener('click',buildQuiz);
    drawCards('all');
    buildQuiz();
    refreshStamp();

    var worldBtn=by('bk-world-say');
    if(worldBtn&&!worldBtn.__bkV48){
      worldBtn.__bkV48=true;
      var more=make('button','bk-btn ghost','🌏 Open WordGlow Pro');
      more.type='button';
      more.style.marginTop='9px';
      more.addEventListener('click',function(){
        pro.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'center'});
      });
      worldBtn.parentNode.appendChild(more);
    }
  }

  function linkIsReasonable(u){
    if(!u) return false;
    if(u==='#') return false;
    if(/^\/pages\/[a-z0-9-]+$/i.test(u)) return true;
    if(/^\/policies\/[a-z0-9-]+$/i.test(u)) return true;
    if(/^https:\/\/cdn\.shopify\.com\//i.test(u)) return true;
    if(/^https:\/\/baccikid\.com\//i.test(u)) return true;
    if(/^https:\/\/baccikid\.b-cdn\.net\//i.test(u)) return true;
    if(/^https?:\/\//i.test(u)) return true;
    return false;
  }

  function addResult(list,status,label,detail){
    list.push({status:status,label:label,detail:detail||''});
  }

  function checkId(list,id,label){
    var el=by(id);
    addResult(list,el?'pass':'fail',label||('#'+id),el?'Found #'+id:'Missing #'+id);
    return el;
  }

  function checkButton(list,id,label){
    var el=checkId(list,id,label);
    if(!el) return;
    var ok=(el.tagName==='BUTTON'||el.getAttribute('role')==='button'||el.onclick||el.href);
    addResult(list,ok?'pass':'warn',(label||id)+' action','Element exists. Manual click test still recommended.');
  }

  function checkHref(list,id,label){
    var el=by(id);
    if(!el){
      addResult(list,'fail',label||id,'Missing element');
      return;
    }
    var href=el.getAttribute('href')||'';
    addResult(list,linkIsReasonable(href)?'pass':'warn',label||id,'href = '+href);
  }

  function checkConfigLinks(list){
    var C=config();
    if(!C){ addResult(list,'fail','BK_HX_CONFIG','Config not available'); return; }

    addResult(list,'pass','BK_HX_CONFIG','Config detected');
    var links=C.LINKS||{};
    ['mainHub','kpotHub','wheel','freePack','disclaimerFullUrl'].forEach(function(k){
      addResult(list,linkIsReasonable(links[k])?'pass':'warn','CONFIG.LINKS.'+k,links[k]||'Empty');
    });

    if(!links.trailer) addResult(list,'pass','Trailer link','Empty is okay. Trailer button stays hidden.');
    if(!links.countdown) addResult(list,'pass','Countdown link','Empty is okay. Next Tuesday card is quiet.');

    if(Array.isArray(links.bonusGames)&&links.bonusGames.length){
      links.bonusGames.forEach(function(g,i){
        addResult(list,linkIsReasonable(g.url)?'pass':'warn','Bonus game '+(i+1),g.label+' -> '+g.url);
      });
    }else{
      addResult(list,'warn','Bonus games','No bonus games configured.');
    }

    var room=C.MUSEUM_ROOM||{};
    addResult(list,room.backgroundUrl?'pass':'warn','Museum room background',room.backgroundUrl||'Empty. v44 should fill this.');
    addResult(list,room.portalUrl?'pass':'warn','Museum room portal',room.portalUrl||'Empty. v44 should fill this.');
    addResult(list,Array.isArray(room.frames)&&room.frames.length===4?'pass':'warn','Museum frame coordinates',(room.frames||[]).length+' frame slots found.');

    if(C.PRIZE&&C.PRIZE.videoUrl){
      addResult(list,linkIsReasonable(C.PRIZE.videoUrl)?'pass':'warn','Prize video',C.PRIZE.videoUrl);
    }else{
      addResult(list,'pass','Prize video','Empty is okay. Prize reveal remains dormant.');
    }
  }

  function checkRegistry(list){
    var R=window.BK_SUPREME_REGISTRY;
    if(!R){
      addResult(list,'warn','BK_SUPREME_REGISTRY','Not found. v44 simulation layer may not be installed.');
      return;
    }
    addResult(list,'pass','BK_SUPREME_REGISTRY','Registry detected');
    ['portals','rooms','sensory','coins','ribbons'].forEach(function(k){
      var arr=R[k];
      addResult(list,Array.isArray(arr)&&arr.length?'pass':'warn','Registry '+k,Array.isArray(arr)?arr.length+' items':'Missing');
    });
    if(R.links){
      ['museum','mainHub','kpot'].forEach(function(k){
        if(R.links[k]) addResult(list,linkIsReasonable(R.links[k])?'pass':'warn','Registry link '+k,R.links[k]);
      });
    }
  }

  function checkKnownOpenItems(list){
    addResult(list,'warn','Known asset open item','Portal 1 image 5 rings-walk still was listed as missing in the v19 library.');
    addResult(list,'warn','Known asset open item','Portal 2 image 2 Rainbow Crystal Vortex video was listed as missing.');
    addResult(list,'warn','Known asset open item','Portal 2 image 6 full clip list still needed confirmation.');
    addResult(list,'warn','Known asset open item','Winner diamond-phoenix ident URL was still pending.');
    addResult(list,'warn','Known asset open item','Prism clip assignment needed confirmation.');
  }

  function checkCriticalMedia(list){
    var C=config();
    if(!C) return;
    [
      ['Line art',C.lineArtUrl],
      ['Colored art',C.coloredUrl],
      ['Phoenix emblem',C.emblemUrl],
      ['Crest',C.crestUrl],
      ['Canvas intro video',C.videoUrl],
      ['Cinematic intro video',C.CINEMATIC&&C.CINEMATIC.url]
    ].forEach(function(x){
      addResult(list,linkIsReasonable(x[1])?'pass':'warn',x[0],x[1]||'Empty');
    });
  }

  function runQA(){
    var list=[];
    checkId(list,'bk-hx','Root #bk-hx');
    checkId(list,'bk-canvas','Coloring canvas');
    checkId(list,'bk-book','Storybook');
    checkId(list,'bk-mood','Mood check');
    checkId(list,'bk-swatches','Paint swatches');
    checkId(list,'bk-tabs','Palette tabs');

    [
      ['bk-sound','Sound toggle'],
      ['bk-museum','Museum button'],
      ['bk-lesson-open','Color lesson button'],
      ['bk-tip-x','Intro Got it button'],
      ['bk-preview','See Bacci colors'],
      ['bk-undo','Undo'],
      ['bk-clear','Start over'],
      ['bk-replay','Replay'],
      ['bk-save','Save art'],
      ['bk-museum-add','Add to museum'],
      ['bk-onepager','Certificate'],
      ['bk-framed','See it framed'],
      ['bk-print','Print'],
      ['bk-cover','Open book cover'],
      ['bk-read-en','Listen English'],
      ['bk-read-ko','Listen Korean'],
      ['bk-focus','Focus mode'],
      ['bk-closebook','Back to cover'],
      ['bk-prev','Previous page'],
      ['bk-next','Next page'],
      ['bk-world-say','Hear Korean'],
      ['bk-fact-more','Another fact'],
      ['bk-su-btn','Signup button'],
      ['bk-clicknow','Open hub now'],
      ['bk-mainhub','Main hub'],
      ['bk-disc','Disclaimer'],
      ['bk-hub','KPOT hub'],
      ['bk-disc-close','Disclaimer close'],
      ['bk-museum-close','Museum close'],
      ['bk-lesson-close','Lesson close'],
      ['bk-frame-close','Frame close']
    ].forEach(function(x){checkButton(list,x[0],x[1]);});

    checkHref(list,'bk-freelink','Free pack link');
    checkHref(list,'bk-wheel-door','Spin a Feeling doorway');
    checkHref(list,'bk-disc-full','Full disclaimer link');
    checkHref(list,'bk-room-door','Museum portal door');

    var anchors=qsa('a',root);
    anchors.forEach(function(a,i){
      var href=a.getAttribute('href')||'';
      if(!linkIsReasonable(href)){
        addResult(list,'warn','Anchor '+(i+1),'Suspicious href: '+href+' text: '+(a.textContent||'').trim().slice(0,60));
      }
    });

    checkConfigLinks(list);
    checkRegistry(list);
    checkCriticalMedia(list);
    checkKnownOpenItems(list);

    renderQA(list);
  }

  function renderQA(list){
    var panel=by('bk-v48-qa-panel');
    if(!panel) return;
    var pass=list.filter(function(x){return x.status==='pass';}).length;
    var warn=list.filter(function(x){return x.status==='warn';}).length;
    var fail=list.filter(function(x){return x.status==='fail';}).length;

    var html=
      '<div class="bk-v48-qa-head"><h3>Bacci Kid QA Sentinel</h3><div><button type="button" id="bk-v48-rerun">Run again</button> <button type="button" id="bk-v48-closeqa">Close</button></div></div>'+
      '<div class="bk-v48-qa-summary"><div>Pass: '+pass+'</div><div>Warnings: '+warn+'</div><div>Fails: '+fail+'</div></div>'+
      '<p style="font-weight:800;color:#6b5b96;">This checks DOM IDs, configured paths, obvious placeholders, registry arrays, and critical media URL formats. It cannot prove every Shopify destination exists unless you click the links or test the live page in Shopify.</p>'+
      '<div class="bk-v48-qa-list">'+list.map(function(r){
        return '<div class="bk-v48-qa-item '+r.status+'"><span class="tag">'+r.status.toUpperCase()+'</span><div><strong>'+r.label+'</strong><br><code>'+String(r.detail).replace(/[<>&]/g,function(c){return {"<":"&lt;",">":"&gt;","&":"&amp;"}[c];})+'</code></div></div>';
      }).join('')+'</div>';
    panel.innerHTML=html;

    by('bk-v48-rerun').addEventListener('click',runQA);
    by('bk-v48-closeqa').addEventListener('click',function(){panel.classList.remove('open');});
    panel.classList.add('open');
  }

  function buildQA(){
    if(by('bk-v48-qa-btn')) return;

    var btn=make('button','bk-v48-qa-btn','🧪 QA');
    btn.id='bk-v48-qa-btn';
    btn.type='button';
    btn.addEventListener('click',runQA);
    root.appendChild(btn);

    var panel=make('div','bk-v48-qa-panel','');
    panel.id='bk-v48-qa-panel';
    root.appendChild(panel);

    var show=(location.search.indexOf('bkqa=1')>-1);
    if(show) btn.classList.add('show');

    document.addEventListener('keydown',function(e){
      if(e.altKey&&e.shiftKey&&(e.key||'').toLowerCase()==='q'){
        btn.classList.toggle('show');
        if(btn.classList.contains('show')) runQA();
      }
      if(e.key==='Escape'&&panel.classList.contains('open')){
        panel.classList.remove('open');
      }
    });
  }

  function addSwitchShortcuts(){
    var bar=qs('.bk-switches',root);
    if(!bar) return;

    if(!by('bk-v48-word-btn')){
      var word=make('button','bk-switch','🌏 <span>WordGlow Pro</span>');
      word.id='bk-v48-word-btn';
      word.type='button';
      word.addEventListener('click',function(){
        buildWordGlowPro();
        var el=by('bk-v48-wordpro');
        if(el) el.scrollIntoView({behavior:reduced()?'auto':'smooth',block:'center'});
      });
      bar.appendChild(word);
    }
  }

  function init(){
    buildWordGlowPro();
    addSwitchShortcuts();
    buildQA();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

/* ---- next engine block ---- */
/* ===== BACCI KID v49 LIVING LUXURY BOOK + BRAVEVERSE RECAP + PARENT KEEPSAKE CTA ===== */
(function(){
  var root=document.getElementById('bk-hx');
  if(!root||root.__bkV49LivingLuxuryBook) return;
  root.__bkV49LivingLuxuryBook=true;
  root.classList.add('bk-v49-living-book');

  function qs(s,c){return (c||document).querySelector(s);}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function by(id){return document.getElementById(id);}
  function make(tag,cls,html){
    var e=document.createElement(tag);
    if(cls)e.className=cls;
    if(html!=null)e.innerHTML=html;
    return e;
  }
  function C(){
    try{return typeof BK_HX_CONFIG!=='undefined'?BK_HX_CONFIG:null;}
    catch(e){return null;}
  }
  function reduce(){
    try{
      return document.documentElement.getAttribute('data-bk-motion')==='calm'||(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }catch(e){return false;}
  }
  function getLS(k,fallback){
    try{
      var v=localStorage.getItem(k);
      return v==null?fallback:JSON.parse(v);
    }catch(e){return fallback;}
  }
  function setLS(k,v){
    try{localStorage.setItem(k,JSON.stringify(v));}
    catch(e){}
  }
  function counter(k,len){
    var n=getLS(k,0)||0;
    setLS(k,n+1);
    return n%len;
  }
  function safeScroll(el,block){
    if(!el)return;
    try{el.scrollIntoView({behavior:reduce()?'auto':'smooth',block:block||'center'});}
    catch(e){el.scrollIntoView();}
  }
  function sanitizeName(raw){
    raw=(raw||'').toString().replace(/<[^>]*>/g,'').replace(/https?:\/\/\S+/gi,'').replace(/[^\w\s'-]/g,'').replace(/\s+/g,' ').trim();
    var banned=/\b(fuck|shit|bitch|asshole|cunt|dick|pussy|nigger|nigga|fag|slut|whore|kill|suicide|rape)\b/i;
    if(!raw||banned.test(raw)) return 'Brave Artist';
    return raw.slice(0,16);
  }
  function currentMotion(){
    try{return window.BKMotion&&BKMotion.get?BKMotion.get():'standard';}
    catch(e){return 'standard';}
  }

  var FILE='https://cdn.shopify.com/s/files/1/0500/7307/5871/files/';
  var VID='https://cdn.shopify.com/videos/c/o/v/';

  var REELS=[
    {
      name:'Divine Invitation',
      caption:'The invitation opens. The story chooses a brave heart.',
      url:VID+'fe63499e3afd40829c3a16084ac7c7c0.mp4',
      poster:FILE+'BacciKid_Heartopedia_v3_DivineInvitation_YouAreInvited_RareMagicalHonor_ColorPNG.png?v=1781043344'
    },
    {
      name:'Heartopedia Arrival',
      caption:'Pearl light, Phoenix seal, and one glowing doorway.',
      url:VID+'95a6d03fa1bd41dda447f148c16e988a.mp4',
      poster:FILE+'BacciKid_Heartopedia_v3_RadiantHero_InvitationInsideEnvelope_PastelGold_ColorPNG.png?v=1781043344'
    },
    {
      name:'Celestial Palace Portal',
      caption:'Bacci runs toward the page as the portal wakes.',
      url:VID+'cfd18f6a77bf4e9f8c48a36321160af0.mp4',
      poster:FILE+'ChatGPT_Image_Jun_15_2026_02_34_39_AM_7.png?v=1781505343'
    },
    {
      name:'Starblossom Sweep',
      caption:'The world moves, the camera breathes, and the chapter begins.',
      url:VID+'26f9c54d805e44efa361920d6014df0d.mp4',
      poster:FILE+'ChatGPT_Image_Jun_15_2026_02_34_39_AM_8.png?v=1781505344'
    },
    {
      name:'Twin Column Dawn',
      caption:'A softer portal for readers who need calm before courage.',
      url:VID+'37a1cf54dae64f79bb491ac33c424f47.mp4',
      poster:FILE+'ChatGPT_Image_Jun_15_2026_12_26_09_AM.png?v=1781497585'
    },
    {
      name:'Golden Mandala Bloom',
      caption:'The book seals the feeling in gold before the next step.',
      url:VID+'9f7988fecdd94aaa92a13f684ad0e50d.mp4',
      poster:FILE+'ChatGPT_Image_Jun_15_2026_02_27_17_AM_9.png?v=1781504947'
    }
  ];

  var IDENTS={
    calm:VID+'9bce3af6526e47cca0739ec9d893ac13.mp4',
    action:[
      VID+'fb67b477c8e342dc8ccfdb97414a448f.mp4',
      VID+'cc7f5649fd1c4d58b6dde7eac213c4a1.mp4',
      VID+'2637eff3c64540d3aacb8bf85e18ecd0.mp4'
    ]
  };

  var PRODUCT_LINKS={
    deluxe:'/products/deluxe-brave-keepsake-kit',
    certificate:'/products/premium-brave-certificate',
    framed:'/products/brave-framed-art-keepsake',
    recap:'/products/braveverse-recap-page',
    bonus:'/products/ultimate-braveverse-bonus-pack'
  };

  var STORY_SPARKS={
    story:{
      title:'Scene 1 · The rooftop of time',
      text:'The city is loud below him, but the real sound is smaller: a younger self crying in moonlight. Bacci does not become fearless. He turns around anyway.'
    },
    toyou:{
      title:'Scene 2 · The story becomes yours',
      text:'Some stories do not demand anything. They wait beside you like a lantern. Take the sentence that helps. Leave the rest for later.'
    },
    feels:{
      title:'Scene 3 · The body signal',
      text:'Brave can feel like a fast heart, warm chest, buzzing hands, or one quiet breath. The signal is not the enemy. It is information.'
    },
    when:{
      title:'Scene 4 · Ordinary courage',
      text:'The brave moment may be a raised hand, an apology, a boundary, a second try, or choosing not to disappear from your own life.'
    },
    world:{
      title:'Scene 5 · Courage around the world',
      text:'In Korean, 용감 means brave. Different languages, same ancient spark: the heart moves forward while fear is still nearby.'
    },
    know:{
      title:'Scene 6 · The science of the spark',
      text:'Fear and courage can use the same body electricity. The difference is not whether your heart races. The difference is what you choose next.'
    },
    turn:{
      title:'Scene 7 · Your portal route',
      text:'Pick one tiny brave action. Not perfect. Not dramatic. Just true enough to count.'
    },
    mantra:{
      title:'Scene 8 · The seal',
      text:'The mantra closes the circle: I can feel afraid and be brave at the same time. I take the next small step.'
    }
  };

  function pickReel(){
    return REELS[counter('bk_v49_reel_index',REELS.length)];
  }

  function setVideo(video,reel,loop){
    if(!video||!reel) return;
    video.pause();
    video.removeAttribute('src');
    if(reel.poster) video.poster=reel.poster;
    video.src=reel.url;
    video.muted=true;
    video.setAttribute('muted','');
    video.playsInline=true;
    video.setAttribute('playsinline','');
    video.loop=!!loop;
    video.preload='metadata';
    if(!reduce()){
      setTimeout(function(){
        try{
          var p=video.play();
          if(p&&p.catch)p.catch(function(){});
        }catch(e){}
      },120);
    }
  }

  function addBookGate(){
    var book=by('bk-book');
    if(!book||by('bk-v49-bookgate')) return;

    var reel=pickReel();

    var gate=make('section','bk-v49-bookgate',
      '<div class="bk-v49-bookgate-grid">'+
        '<div class="bk-v49-bookgate-copy">'+
          '<span class="bk-v49-kicker">Living Book Premiere</span>'+
          '<h2>The BraveVerse opens here.</h2>'+
          '<p>This is not only a coloring page. It is a living storybook, a feelings mirror, a museum doorway, and a tiny brave practice ritual. Watch the invitation, then open the book when you are ready.</p>'+
          '<div class="bk-v49-actions">'+
            '<button type="button" id="bk-v49-premiere-btn">✨ Play invitation to book</button>'+
            '<button type="button" id="bk-v49-open-book">📖 Open the living book</button>'+
            '<button type="button" id="bk-v49-next-reel">🌀 Rotate reel</button>'+
          '</div>'+
        '</div>'+
        '<div class="bk-v49-holoscreen" aria-live="polite">'+
          '<img class="bk-v49-holo-poster" alt="">'+
          '<video class="bk-v49-holo-video" muted loop playsinline preload="metadata"></video>'+
          '<div class="bk-v49-screen-caption"><b></b><span></span></div>'+
        '</div>'+
      '</div>'
    );

    book.parentNode.insertBefore(gate,book);

    var poster=qs('.bk-v49-holo-poster',gate);
    var video=qs('.bk-v49-holo-video',gate);
    var capB=qs('.bk-v49-screen-caption b',gate);
    var capS=qs('.bk-v49-screen-caption span',gate);

    function load(r){
      poster.src=r.poster||'';
      poster.alt=r.name||'Bacci Kid reel';
      capB.textContent=r.name||'Bacci Kid StoryCast';
      capS.textContent=r.caption||'The story world is waking up.';
      setVideo(video,r,true);
    }

    load(reel);

    by('bk-v49-next-reel').addEventListener('click',function(){
      load(pickReel());
    });

    by('bk-v49-open-book').addEventListener('click',function(){
      openBookAndCollapse();
    });

    by('bk-v49-premiere-btn').addEventListener('click',function(){
      playPremiereSequence(openBookAndCollapse);
    });
  }

  function upgradeBookCover(){
    var cover=by('bk-cover');
    if(!cover||cover.__bkV49) return;
    cover.__bkV49=true;
    cover.classList.add('bk-v49-cover');

    var reel=pickReel();
    var video=make('video','bk-v49-cover-video','');
    video.muted=true;
    video.setAttribute('muted','');
    video.playsInline=true;
    video.setAttribute('playsinline','');
    video.loop=true;
    video.preload='metadata';
    if(reel.poster) video.poster=reel.poster;

    var glass=make('span','bk-v49-cover-glass','');
    var lens=make('span','bk-v49-lens','');
    var gems=make('span','bk-v49-gems','<i></i><i></i><i></i><i></i><i></i>');

    cover.insertBefore(video,cover.firstChild);
    cover.insertBefore(glass,cover.firstChild.nextSibling);
    cover.insertBefore(lens,cover.firstChild.nextSibling);
    cover.insertBefore(gems,cover.firstChild.nextSibling);

    setVideo(video,reel,true);
  }

  function addStorySpark(){
    var deck=qs('#bk-book .bk-deck');
    var pages=by('bk-pages');
    if(!deck||!pages||by('bk-v49-story-spark')) return;

    var spark=make('div','bk-v49-story-spark','<b></b><p></p>');
    spark.id='bk-v49-story-spark';
    deck.insertBefore(spark,pages);

    function current(){
      var cur=qs('.bk-chap.cur',by('bk-book'));
      return cur?cur.getAttribute('data-ch'):'story';
    }

    function update(){
      var s=STORY_SPARKS[current()]||STORY_SPARKS.story;
      qs('b',spark).textContent=s.title;
      qs('p',spark).textContent=s.text;
    }

    qsa('#bk-next,#bk-prev,#bk-cover,#bk-closebook,#bk-rail button',root).forEach(function(b){
      b.addEventListener('click',function(){
        setTimeout(update,120);
        setTimeout(update,1450);
      });
    });

    if('MutationObserver' in window){
      new MutationObserver(update).observe(pages,{subtree:true,attributes:true,attributeFilter:['class']});
    }

    update();
  }

  function openBookAndCollapse(){
    var cover=by('bk-cover');
    var book=by('bk-book');
    if(cover&&book&&!book.classList.contains('open')) cover.click();
    setTimeout(function(){
      root.classList.add('bk-v49-story-mode');
      safeScroll(book,'start');
    },360);
  }

  function addColorReturn(){
    if(by('bk-v49-color-return')) return;
    var book=by('bk-book');
    if(!book) return;

    var ret=make('div','bk-v49-color-return','<span>Coloring Studio is tucked away so the story can breathe.</span><button type="button">🎨 Reopen Coloring Studio</button>');
    ret.id='bk-v49-color-return';
    book.parentNode.insertBefore(ret,book);

    qs('button',ret).addEventListener('click',function(){
      root.classList.remove('bk-v49-story-mode');
      safeScroll(qs('.bk-stage',root),'start');
    });

    function sync(){
      if(book.classList.contains('open')){
        root.classList.add('bk-v49-story-mode');
      }else{
        root.classList.remove('bk-v49-story-mode');
      }
    }

    if('MutationObserver' in window){
      new MutationObserver(sync).observe(book,{attributes:true,attributeFilter:['class']});
    }
  }

  function playPremiereSequence(done){
    var intro=REELS[counter('bk_v49_invite_index',2)];
    var second=REELS[counter('bk_v49_book_index',REELS.length)];
    var ident=currentMotion()==='immersive'
      ? IDENTS.action[counter('bk_v49_ident_index',IDENTS.action.length)]
      : IDENTS.calm;

    var sequence=[
      {url:intro.url, poster:intro.poster, cap:'The invitation arrives.'},
      {url:second.url, poster:second.poster, cap:'The living book wakes.'},
      {url:ident, poster:'', cap:'Bacci Kid seals the doorway.'}
    ];

    var ov=make('div','bk-v49-premiere','<video muted playsinline preload="auto"></video><button type="button" class="sound">🔊 Sound</button><button type="button" class="skip">Skip</button><div class="cap"></div>');
    document.body.appendChild(ov);

    var v=qs('video',ov);
    var cap=qs('.cap',ov);
    var i=0;
    var closed=false;
    var oldHtml=document.documentElement.style.overflow;
    var oldBody=document.body.style.overflow;
    document.documentElement.style.overflow='hidden';
    document.body.style.overflow='hidden';

    function close(){
      if(closed)return;
      closed=true;
      try{v.pause();}catch(e){}
      ov.classList.remove('on');
      document.documentElement.style.overflow=oldHtml;
      document.body.style.overflow=oldBody;
      setTimeout(function(){
        if(ov.parentNode) ov.parentNode.removeChild(ov);
        if(typeof done==='function') done();
      },340);
    }

    function playNext(){
      if(closed)return;
      if(i>=sequence.length){ close(); return; }
      var item=sequence[i++];
      cap.textContent=item.cap||'Opening the BraveVerse.';
      if(item.poster) v.poster=item.poster;
      v.src=item.url;
      try{
        var p=v.play();
        if(p&&p.catch)p.catch(function(){ setTimeout(playNext,1100); });
      }catch(e){
        setTimeout(playNext,600);
      }
    }

    qs('.skip',ov).addEventListener('click',close);
    qs('.sound',ov).addEventListener('click',function(){
      v.muted=!v.muted;
      this.textContent=v.muted?'🔊 Sound':'🔇 Mute';
      try{v.play();}catch(e){}
    });
    v.addEventListener('ended',playNext);
    v.addEventListener('error',playNext);

    setTimeout(function(){
      ov.classList.add('on');
      playNext();
    },30);

    setTimeout(close,26000);
  }

  function getMood(){
    try{
      var m=JSON.parse(sessionStorage.getItem('bk_v46_brave_mood_check')||'null');
      if(m&&m.label) return m.label;
    }catch(e){}
    var pressed=qs('#bk-moodrow .bk-moodbtn[aria-pressed="true"]');
    return pressed?pressed.textContent.replace(/\s+/g,' ').trim():'Mood not selected';
  }

  function getTodayWord(){
    try{
      var w=JSON.parse(localStorage.getItem('bk_v48_today_word')||'null');
      if(w&&w.en) return w.en+' · '+w.ko;
    }catch(e){}
    return 'Brave · 용감';
  }

  function getColorFeeling(){
    var f=qs('#bk-feel .nm');
    var fe=qs('#bk-feel .fe');
    return (f?f.textContent:'Brave Ember')+(fe?' · '+fe.textContent.replace(/^feels like\s*/i,''):'');
  }

  function getProgress(){
    var p=by('bk-progress');
    return p?p.textContent.replace(/\s+/g,' ').trim():'Progress is waiting for your first color.';
  }

  function canvasData(){
    var canvas=by('bk-canvas');
    if(!canvas) return '';
    try{return canvas.toDataURL('image/png');}
    catch(e){return '';}
  }

  function buildRecap(){
    if(by('bk-v49-recap')) return;

    var book=by('bk-book')||qs('.bk-book',root);
    var recap=make('section','bk-v49-recap',
      '<div class="bk-v49-recap-head">'+
        '<span class="bk-v49-kicker">BraveVerse Recap</span>'+
        '<h2>Turn today into a keepsake.</h2>'+
        '<p>Create a local BraveVerse reflection card from this session. It is a playful creative recap, not a diagnosis, not therapy, and not a promise of results.</p>'+
      '</div>'+
      '<div class="bk-v49-recap-grid">'+
        '<div class="bk-v49-recap-card">'+
          '<div class="bk-v49-recap-art"><img id="bk-v49-recap-img" alt="Your Brave coloring preview"></div>'+
          '<div class="bk-v49-recap-title"><b id="bk-v49-recap-name">Brave Artist</b><span id="bk-v49-recap-line">Your BraveVerse card is waiting.</span></div>'+
        '</div>'+
        '<div class="bk-v49-recap-info">'+
          '<div class="bk-v49-recap-row"><b>MoodGlow</b><span id="bk-v49-recap-mood">Mood not selected</span></div>'+
          '<div class="bk-v49-recap-row"><b>WordGlow</b><span id="bk-v49-recap-word">Brave · 용감</span></div>'+
          '<div class="bk-v49-recap-row"><b>Color signal</b><span id="bk-v49-recap-color">Brave Ember</span></div>'+
          '<div class="bk-v49-recap-row"><b>Progress</b><span id="bk-v49-recap-progress">Color Bacci to unlock your recap.</span></div>'+
          '<div class="bk-v49-recap-row"><b>Next tiny brave step</b><span id="bk-v49-recap-step">Say one true thing kindly, or ask for help if you need it.</span></div>'+
          '<div class="bk-v49-recap-actions">'+
            '<button type="button" id="bk-v49-generate-recap">✨ Generate recap</button>'+
            '<button type="button" id="bk-v49-save-recap">⬇ Save recap card</button>'+
            '<button type="button" id="bk-v49-copy-note">📋 Copy parent note</button>'+
          '</div>'+
        '</div>'+
      '</div>'+
      '<div class="bk-v49-shop">'+
        '<h3>Grown-up checkout: premium Brave keepsakes</h3>'+
        '<p>The core experience stays free. Premium keepsakes are optional adult purchases for families who want a polished printable memory, bonus pages, or a deluxe downloadable pack.</p>'+
        '<div class="bk-v49-offers">'+
          '<div class="bk-v49-offer"><strong>Premium Brave Certificate</strong><em>$4.44</em><span>Printable certificate with premium finish and personal-use license note.</span></div>'+
          '<div class="bk-v49-offer"><strong>Framed Art Keepsake</strong><em>$5.55</em><span>A more polished framed-art download than a screenshot.</span></div>'+
          '<div class="bk-v49-offer"><strong>BraveVerse Recap Page</strong><em>$7.77</em><span>A heartfelt creative reflection page for the session.</span></div>'+
          '<div class="bk-v49-offer"><strong>Deluxe Brave Keepsake Kit</strong><em>$11.11</em><span>Best value: certificate, framed art, recap, bonus page, and license note.</span></div>'+
        '</div>'+
        '<div class="bk-v49-shop-actions">'+
          '<a class="best" href="'+PRODUCT_LINKS.deluxe+'">Best value · Deluxe Kit</a>'+
          '<a href="'+PRODUCT_LINKS.certificate+'">Certificate</a>'+
          '<a href="'+PRODUCT_LINKS.framed+'">Framed Art</a>'+
          '<a href="'+PRODUCT_LINKS.recap+'">Recap Page</a>'+
        '</div>'+
        '<p class="bk-v49-shop-note">Adult checkout only. Stickers, badges, and Bacci Kid Gold Coins are earned just for fun, have no cash value, and cannot be redeemed for money or merchandise. Edit these product links after your Shopify products exist.</p>'+
      '</div>'
    );

    if(book&&book.parentNode) book.parentNode.insertBefore(recap,book.nextSibling);
    else root.appendChild(recap);

    by('bk-v49-generate-recap').addEventListener('click',generateRecap);
    by('bk-v49-save-recap').addEventListener('click',downloadRecap);
    by('bk-v49-copy-note').addEventListener('click',copyParentNote);

    generateRecap();
  }

  function generateRecap(){
    var name=sanitizeName((by('bk-namein')&&by('bk-namein').value)||'');
    var mood=getMood();
    var word=getTodayWord();
    var color=getColorFeeling();
    var progress=getProgress();
    var art=canvasData();

    by('bk-v49-recap-name').textContent=name;
    by('bk-v49-recap-line').textContent='Today, '+name+' practiced Brave with Bacci.';
    by('bk-v49-recap-mood').textContent=mood;
    by('bk-v49-recap-word').textContent=word;
    by('bk-v49-recap-color').textContent=color;
    by('bk-v49-recap-progress').textContent=progress;
    by('bk-v49-recap-step').textContent='One tiny brave step: tell the truth kindly, ask for help, or try again softly.';

    var img=by('bk-v49-recap-img');
    if(art){ img.src=art; }
    else if(C()&&C().coloredUrl){ img.src=C().coloredUrl; }
  }

  function wrapText(ctx,text,x,y,maxWidth,lineHeight){
    text=(text||'').toString();
    var words=text.split(/\s+/);
    var line='';
    for(var i=0;i<words.length;i++){
      var test=line+words[i]+' ';
      if(ctx.measureText(test).width>maxWidth&&line){
        ctx.fillText(line.trim(),x,y);
        line=words[i]+' ';
        y+=lineHeight;
      }else{
        line=test;
      }
    }
    ctx.fillText(line.trim(),x,y);
    return y+lineHeight;
  }

  function downloadRecap(){
    generateRecap();

    var W=1080,H=1920;
    var cv=document.createElement('canvas');
    cv.width=W;
    cv.height=H;
    var x=cv.getContext('2d');

    var g=x.createLinearGradient(0,0,W,H);
    g.addColorStop(0,'#fff0fb');
    g.addColorStop(.45,'#f1edff');
    g.addColorStop(1,'#e8ffff');
    x.fillStyle=g;
    x.fillRect(0,0,W,H);

    x.fillStyle='rgba(255,213,116,.34)';
    x.beginPath();
    x.arc(170,180,220,0,Math.PI*2);
    x.fill();

    x.fillStyle='rgba(166,107,255,.20)';
    x.beginPath();
    x.arc(930,230,260,0,Math.PI*2);
    x.fill();

    x.fillStyle='#2b2059';
    x.textAlign='center';
    x.font='900 58px Arial';
    x.fillText('My BraveVerse Recap',W/2,120);

    x.font='700 30px Arial';
    x.fillStyle='#8c4f8c';
    x.fillText('Bacci Kid Heartopedia · Brave',W/2,168);

    var art=by('bk-v49-recap-img');
    if(art&&art.complete&&art.naturalWidth){
      var boxX=130,boxY=245,boxW=820,boxH=820;
      x.fillStyle='#ffffff';
      x.fillRect(boxX,boxY,boxW,boxH);
      x.strokeStyle='#ffd574';
      x.lineWidth=16;
      x.strokeRect(boxX,boxY,boxW,boxH);

      var ratio=Math.min((boxW-60)/art.naturalWidth,(boxH-60)/art.naturalHeight);
      var dw=art.naturalWidth*ratio;
      var dh=art.naturalHeight*ratio;
      x.drawImage(art,boxX+(boxW-dw)/2,boxY+(boxH-dh)/2,dw,dh);
    }

    var name=by('bk-v49-recap-name').textContent||'Brave Artist';
    var mood=by('bk-v49-recap-mood').textContent||'Mood not selected';
    var word=by('bk-v49-recap-word').textContent||'Brave · 용감';
    var color=by('bk-v49-recap-color').textContent||'Brave Ember';
    var progress=by('bk-v49-recap-progress').textContent||'Progress waiting';

    x.textAlign='left';
    x.fillStyle='#ffffff';
    x.fillRect(130,1120,820,500);
    x.strokeStyle='#a66bff';
    x.lineWidth=6;
    x.strokeRect(130,1120,820,500);

    x.fillStyle='#ff4fa0';
    x.font='900 32px Arial';
    x.fillText('Colored by',160,1185);
    x.fillStyle='#2b2059';
    x.font='900 46px Arial';
    x.fillText(name,160,1238);

    x.fillStyle='#8e62ff';
    x.font='900 28px Arial';
    x.fillText('MoodGlow',160,1308);
    x.fillStyle='#2b2059';
    x.font='700 28px Arial';
    x.fillText(mood,355,1308);

    x.fillStyle='#8e62ff';
    x.font='900 28px Arial';
    x.fillText('WordGlow',160,1365);
    x.fillStyle='#2b2059';
    x.font='700 28px Arial';
    x.fillText(word,355,1365);

    x.fillStyle='#8e62ff';
    x.font='900 28px Arial';
    x.fillText('Color signal',160,1422);
    x.fillStyle='#2b2059';
    x.font='700 28px Arial';
    wrapText(x,color,355,1422,520,34);

    x.fillStyle='#8e62ff';
    x.font='900 28px Arial';
    x.fillText('Progress',160,1510);
    x.fillStyle='#2b2059';
    x.font='700 24px Arial';
    wrapText(x,progress,355,1510,520,32);

    x.textAlign='center';
    x.fillStyle='#2b2059';
    x.font='italic 34px Georgia';
    wrapText(x,'I can feel afraid and be brave at the same time. I take the next small step.',W/2,1688,820,44);

    x.fillStyle='#6b5b96';
    x.font='700 20px Arial';
    x.fillText('Creative reflection only. Not therapy, diagnosis, medical care, or a promise of results.',W/2,1810);
    x.fillText('Personal, non-commercial use only. Bacci Kid artwork and characters remain protected Bacci Kid IP.',W/2,1844);

    x.fillStyle='#8e62ff';
    x.font='900 24px Arial';
    x.fillText('© 2026 Bacci Kid · Dr. Jamie J. Karia, DSW, LCSW · baccikid.com',W/2,1890);

    try{
      var a=document.createElement('a');
      a.download='Bacci_Kid_BraveVerse_Recap.png';
      a.href=cv.toDataURL('image/png');
      a.click();
    }catch(e){
      alert('The recap card could not save from this browser. Try the live Shopify page or use the premium keepsake option.');
    }
  }

  function copyParentNote(){
    var note='Bacci Kid BraveVerse Recap: This is a playful creative coloring and feelings-vocabulary reflection, not therapy, diagnosis, medical care, or a promise of results. Premium keepsakes are optional adult purchases. Bacci Kid artwork and characters remain protected Bacci Kid intellectual property.';
    try{
      if(navigator.clipboard&&navigator.clipboard.writeText){
        navigator.clipboard.writeText(note);
        alert('Parent note copied.');
      }else{
        alert(note);
      }
    }catch(e){
      alert(note);
    }
  }

  function wireEarnedRecap(){
    if('MutationObserver' in window){
      new MutationObserver(function(){
        if(root.classList.contains('bk-earned')){
          setTimeout(generateRecap,250);
        }
      }).observe(root,{attributes:true,attributeFilter:['class']});
    }
    ['bk-namein','bk-forin'].forEach(function(id){
      var el=by(id);
      if(el) el.addEventListener('input',function(){ setTimeout(generateRecap,120); });
    });
    root.addEventListener('click',function(e){
      if(e.target&&e.target.id==='bk-canvas') setTimeout(generateRecap,300);
    },true);
  }

  function init(){
    addBookGate();
    upgradeBookCover();
    addStorySpark();
    addColorReturn();
    buildRecap();
    wireEarnedRecap();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

/* ---- next engine block ---- */
/* ===== BACCI KID v50 BRAVEVERSE DIRECTOR'S CUT + JOURNAL + ACCESSIBILITY ===== */
(function(){
  var root=document.getElementById('bk-hx');
  if(!root||root.__bkV50DirectorJournalAccess) return;
  root.__bkV50DirectorJournalAccess=true;
  root.classList.add('bk-v50-director');

  function qs(s,c){return (c||document).querySelector(s);}
  function qsa(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function by(id){return document.getElementById(id);}
  function make(tag,cls,html){
    var e=document.createElement(tag);
    if(cls)e.className=cls;
    if(html!=null)e.innerHTML=html;
    return e;
  }
  function C(){
    try{return typeof BK_HX_CONFIG!=='undefined'?BK_HX_CONFIG:null;}
    catch(e){return null;}
  }
  function reduce(){
    try{
      return document.documentElement.getAttribute('data-bk-motion')==='calm'||(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }catch(e){return false;}
  }
  function scrollToEl(el){
    if(!el)return;
    try{el.scrollIntoView({behavior:reduce()?'auto':'smooth',block:'center'});}
    catch(e){el.scrollIntoView();}
  }
  function safeName(raw){
    raw=(raw||'').toString().replace(/<[^>]*>/g,'').replace(/https?:\/\/\S+/gi,'').replace(/[^\w\s'-]/g,'').replace(/\s+/g,' ').trim();
    var banned=/\b(fuck|shit|bitch|asshole|cunt|dick|pussy|nigger|nigga|fag|slut|whore|kill|suicide|rape)\b/i;
    if(!raw||banned.test(raw)) return 'Brave Artist';
    return raw.slice(0,16);
  }

  var TEEN_STORY =
    "The night Bacci jumped through time, the sky did not open like a door. It split like a secret that had been waiting too long. One second, he was small enough to believe every laugh meant something was wrong with him. The next, he was older, standing on a rooftop above a city that did not know his name. Neon signs blinked below. Wind pushed at his cape. His heart hit his ribs like it wanted out. Then he heard crying. Not loud. Not dramatic. Just the kind of small sound people make when they are trying not to need anyone. Bacci turned. In a circle of moonlight sat a kitten with a crooked tail and eyes gone gray from fear. Bacci knew that tail. He knew those eyes. He knew the feeling of wanting to become invisible before someone else made him feel small. It was him. The younger him. The one the world had laughed at before it understood what it was looking at. The kitten whispered, They said different like it was a bad thing. Teen Bacci wanted to run. Not because he did not care. Because caring hurt. Because sometimes the bravest moment is the one where you realize you are not fighting a monster. You are standing in front of the part of yourself you left behind. So he knelt. He did not pretend his hands were steady. He did not pretend fear had left the rooftop. He let it stand there with him. Then he said the sentence he wished someone had given him sooner. The thing they laughed at is the thing that will make you fly. The kitten looked up. The crooked tail lifted, barely, but enough. Somewhere inside the city, a future shifted. Bacci understood then that brave is not becoming fearless. Brave is refusing to abandon yourself when fear arrives. It is turning toward the crying voice, even when that voice is yours. His eyes warmed back to green. The gold on his chest caught the moon. Across time, a small kitten began to believe he might grow into someone powerful. He was right. He grew into you.";

  var TEEN_CLOSING =
    "Bacci kept this story because some nights still get loud inside him. Maybe you know that feeling. Maybe you do not. Either way, the story is yours now. You do not have to become fearless to enter the next chapter. You only need one true step, one kind sentence, one breath that says, I am still here. When you are ready, BraveVerse has more doors. Some are soft. Some are electric. Some are waiting for the part of you that is tired of hiding.";

  var PROMPTS={
    story:{
      label:'Rooftop Check',
      prompt:'What is one part of you that deserves not to be abandoned?',
      tip:'This prompt can help you practice self-awareness without needing to explain your whole life.'
    },
    toyou:{
      label:'Lantern Sentence',
      prompt:'Write one sentence you wish someone had told you sooner.',
      tip:'A short sentence can become a future reminder when feelings get loud.'
    },
    feels:{
      label:'Body Signal Decoder',
      prompt:'Where does brave show up in your body: chest, stomach, hands, jaw, breath, or somewhere else?',
      tip:'Noticing body signals can help you pause before reacting.'
    },
    when:{
      label:'Tiny Brave Scene',
      prompt:'Pick one real-life brave scene: asking for help, apologizing, trying again, setting a boundary, or showing your work.',
      tip:'Specific tiny actions are easier to practice than huge life goals.'
    },
    world:{
      label:'WordBridge',
      prompt:'Today, brave is 용감, yong-gam. What word in any language makes you feel stronger?',
      tip:'Language gives feelings handles. Handles make feelings easier to carry.'
    },
    know:{
      label:'Rename the Signal',
      prompt:'If your heart races, what else could it mean besides fear?',
      tip:'Reframing can help you see a body signal as information, not proof that something is wrong.'
    },
    turn:{
      label:'Portal Route',
      prompt:'What is your next tiny brave step today?',
      tip:'A tiny step counts because courage grows through repeated practice.'
    },
    mantra:{
      label:'Future Self Note',
      prompt:'Write one line your future self may need to read later.',
      tip:'A saved note can become a kind message across time.'
    }
  };

  var DICTIONARY=[
    {word:'Brave', meaning:'Doing the next true thing while fear is still nearby.'},
    {word:'Self-awareness', meaning:'Noticing what you feel, think, need, or value before you react.'},
    {word:'Boundary', meaning:'A clear line that protects your time, energy, body, or peace.'},
    {word:'Repair', meaning:'A brave attempt to fix harm, reconnect, apologize, or try again.'},
    {word:'Body signal', meaning:'A physical clue such as a racing heart, tight jaw, warm chest, or shaky hands.'},
    {word:'Reframe', meaning:'Looking at a situation in a new, more helpful, more truthful way.'},
    {word:'Inner teen', meaning:'The younger part of you that still remembers wanting to belong, be seen, or feel safe.'},
    {word:'Future self', meaning:'A version of you that may one day thank you for the small kind choice you make now.'}
  ];

  var PATHS=[
    {id:'quiet', name:'Quiet Brave', line:'My courage does not have to be loud to count.'},
    {id:'social', name:'Social Brave', line:'I can speak truthfully and still choose kindness.'},
    {id:'creative', name:'Creative Brave', line:'I can let my work be seen before it feels perfect.'},
    {id:'repair', name:'Repair Brave', line:'I can return, repair, and try again with care.'}
  ];

  function renderParas(el,text){
    if(!el)return;
    el.innerHTML='';
    var parts=(text||'').match(/[^.!?]+[.!?]+["')\]]?\s*/g)||[text];
    var cur=[];
    parts.forEach(function(s,i){
      cur.push(s.trim());
      if(cur.length===3||i===parts.length-1){
        var p=document.createElement('p');
        p.textContent=cur.join(' ');
        el.appendChild(p);
        cur=[];
      }
    });
    var cfg=C();
    if(cfg&&cfg.emblemUrl){
      var im=document.createElement('img');
      im.className='bk-wm';
      im.alt='';
      im.src=cfg.emblemUrl;
      el.appendChild(im);
    }
  }

  function upgradeStoryText(){
    var cfg=C();
    if(!cfg) return;

    cfg.ENTRY.story=TEEN_STORY;
    cfg.ENTRY.closing=TEEN_CLOSING;
    cfg.ENTRY.hook='Brave is not becoming fearless. Brave is refusing to abandon yourself when fear walks in.';
    cfg.ENTRY.feelsLike='A charged body and a steady choice. A fast heart, warm chest, buzzing hands, or one quiet breath that says, I can stay with myself.';
    cfg.ENTRY.whenYouFeelIt='Group chats. First days. Apologies. Auditions. Tryouts. Presentations. Boundaries. Starting again after something did not work.';
    cfg.ENTRY.prompt='Choose your Brave Route. Quiet Brave, Social Brave, Creative Brave, or Repair Brave. What tiny step would that version of you take today?';
    cfg.ENTRY.bacciLine='Bacci says: you do not have to prove you are fearless. You only have to stop leaving yourself behind.';
    cfg.MANTRA='I can feel fear, stay with myself, and take one true next step.';

    var word=by('bk-word');
    if(word) word.textContent='Brave';

    var hook=by('bk-hook');
    if(hook) hook.textContent=cfg.ENTRY.hook;

    renderParas(by('bk-story'),TEEN_STORY);
    renderParas(by('bk-closing'),TEEN_CLOSING);

    var feels=by('bk-feelslike');
    if(feels) feels.textContent=cfg.ENTRY.feelsLike;

    var when=by('bk-when');
    if(when) when.textContent=cfg.ENTRY.whenYouFeelIt;

    var prompt=by('bk-prompt');
    if(prompt) prompt.textContent=cfg.ENTRY.prompt;

    var bacci=by('bk-bacci');
    if(bacci) bacci.textContent=cfg.ENTRY.bacciLine;

    var mantra=by('bk-mantra');
    if(mantra) mantra.textContent=cfg.MANTRA;

    var fact=by('bk-fact');
    if(fact) fact.textContent='Brain Spark: fear and courage can feel similar in the body. The difference is not the heartbeat. The difference is the next choice.';

    var coverTitle=by('bk-book-title');
    if(coverTitle) coverTitle.textContent='BraveVerse';

    var coverSub=by('bk-book-sub');
    if(coverSub) coverSub.textContent='A living storybook for courage, identity, and one tiny true step';

    var entry=by('bk-book-entry');
    if(entry) entry.textContent='Entry 002 · Brave · Teen Director Cut';
  }

  function addWorldChipAndAgeNames(){
    if(!by('bk-v50-world-chip')){
      var chip=make('div','bk-v50-world-chip','⚡ BraveVerse · Teen Heartopedia · suggested ages 13 to 17 · inner teen friendly');
      chip.id='bk-v50-world-chip';
      var sub=by('bk-subtitle');
      if(sub&&sub.parentNode) sub.parentNode.insertBefore(chip,sub.nextSibling);
    }

    var map={
      'Toddler':['Tiny Hearts','2 to 4 with grown-up'],
      'Kids':['Wonder Hearts','5 to 8'],
      'Tweens':['Glow Quest','9 to 12'],
      'Teens':['BraveVerse','13 to 17'],
      'Grown ups':['Inner Compass','18+'],
      'Seniors':['Golden Hearts','60+']
    };

    qsa('.bk-age',root).forEach(function(b){
      if(b.__bkV50Age) return;
      var txt=b.textContent.replace(/\s+/g,' ').trim();
      Object.keys(map).forEach(function(k){
        if(txt.indexOf(k)>-1){
          b.__bkV50Age=true;
          var emoji=txt.replace(k,'').trim();
          b.innerHTML=emoji+' '+k+'<span class="bk-v50-age-sub">'+map[k][0]+' · '+map[k][1]+'</span>';
          b.title=map[k][0]+' · suggested ages '+map[k][1];
        }
      });
    });
  }

  function addAccessibilityControls(){
    var bar=qs('.bk-switches',root);
    if(!bar) return;

    if(!by('bk-v50-text')){
      var text=make('button','bk-switch bk-v50-switch','🔠 <span>Text size</span>');
      text.id='bk-v50-text';
      text.type='button';
      text.addEventListener('click',function(){
        if(root.classList.contains('bk-v50-xl')){
          root.classList.remove('bk-v50-xl','bk-v50-large');
          text.innerHTML='🔠 <span>Text size</span>';
          return;
        }
        if(root.classList.contains('bk-v50-large')){
          root.classList.add('bk-v50-xl');
          text.innerHTML='🔠 <span>XL text</span>';
          return;
        }
        root.classList.add('bk-v50-large');
        text.innerHTML='🔠 <span>Large text</span>';
      });
      bar.appendChild(text);
    }

    if(!by('bk-v50-night')){
      var night=make('button','bk-switch bk-v50-switch','🌙 <span>Warm night</span>');
      night.id='bk-v50-night';
      night.type='button';
      night.setAttribute('aria-pressed','false');
      night.addEventListener('click',function(){
        root.classList.toggle('bk-v50-night');
        night.setAttribute('aria-pressed',root.classList.contains('bk-v50-night')?'true':'false');
      });
      bar.appendChild(night);
    }

    if(!by('bk-v50-comfort-open')){
      var comfort=make('button','bk-switch bk-v50-switch','💧 <span>Comfort break</span>');
      comfort.id='bk-v50-comfort-open';
      comfort.type='button';
      comfort.addEventListener('click',openComfort);
      bar.appendChild(comfort);
    }
  }

  function addComfortPanel(){
    if(by('bk-v50-comfort-panel')) return;

    var panel=make('section','bk-v50-panel',
      '<h3>Comfort check</h3>'+
      '<p>This story can bring up feelings. You are allowed to pause, breathe, drink water, skip a page, or leave and return later. Creative reflection is not therapy or crisis care.</p>'+
      '<div class="bk-v50-comfort-grid">'+
        '<button type="button" data-comfort="breathe">Breathe with Bacci</button>'+
        '<button type="button" data-comfort="water">Hydration reset</button>'+
        '<button type="button" data-comfort="stop">Stop and return later</button>'+
      '</div>'
    );
    panel.id='bk-v50-comfort-panel';

    var book=by('bk-book');
    if(book&&book.parentNode) book.parentNode.insertBefore(panel,book);
    else root.appendChild(panel);

    panel.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('button[data-comfort]');
      if(!b)return;
      var type=b.getAttribute('data-comfort');
      if(type==='breathe') openComfort('Take one slow breath with Bacci. In for four. Out for six. Do that three times if it feels okay.');
      if(type==='water') openComfort('Hydration reset: drink some water, relax your shoulders, then choose whether to keep going.');
      if(type==='stop') openComfort('Stopping is allowed. Close the page, come back later, or talk with a trusted grown-up or qualified professional if something feels too big.');
    });
  }

  function openComfort(message){
    var m=by('bk-v50-comfort-modal');
    if(!m){
      m=make('div','bk-v50-comfort-modal',
        '<div class="bk-v50-comfort-box">'+
          '<h3>Pause with Bacci</h3>'+
          '<p id="bk-v50-comfort-msg"></p>'+
          '<button type="button" id="bk-v50-comfort-close">I am ready</button>'+
        '</div>'
      );
      m.id='bk-v50-comfort-modal';
      document.body.appendChild(m);
      by('bk-v50-comfort-close').addEventListener('click',function(){m.classList.remove('open');});
      m.addEventListener('click',function(e){if(e.target===m)m.classList.remove('open');});
    }
    by('bk-v50-comfort-msg').textContent=message||'Take a breath, drink water if you need it, and remember: you can pause or return later.';
    m.classList.add('open');
  }

  function addDictionary(){
    if(by('bk-v50-dictionary')) return;

    var d=make('section','bk-v50-dictionary',
      '<h3>Bacci WordSpark Dictionary</h3>'+
      '<p>Tap any word for a quick meaning. This keeps the story accessible without slowing down readers who already know the word.</p>'+
      '<div class="bk-v50-dict-grid" id="bk-v50-dict-grid"></div>'+
      '<div class="bk-v50-reading-card">Read it, listen to it, or do both. All three count. The goal is not perfect reading. The goal is connection, vocabulary, and one useful idea.</div>'
    );
    d.id='bk-v50-dictionary';

    var world=by('bk-world');
    var insert=world&&world.closest('.bk-chap')?by('bk-book'):by('bk-book');
    if(insert&&insert.parentNode) insert.parentNode.insertBefore(d,insert.nextSibling);
    else root.appendChild(d);

    var grid=by('bk-v50-dict-grid');
    DICTIONARY.forEach(function(item){
      var card=make('article','bk-v50-dict-card','<b>'+item.word+'</b><span>'+item.meaning+'</span><button type="button">Say it</button>');
      card.querySelector('button').addEventListener('click',function(){
        try{
          if(!window.speechSynthesis)return;
          speechSynthesis.cancel();
          var u=new SpeechSynthesisUtterance(item.word+'. '+item.meaning);
          u.lang='en-US';
          u.rate=.9;
          speechSynthesis.speak(u);
        }catch(e){}
      });
      grid.appendChild(card);
    });
  }

  function currentChapter(){
    var c=qs('.bk-chap.cur',root);
    return c?c.getAttribute('data-ch'):'story';
  }

  function addJournal(){
    if(by('bk-v50-journal')) return;

    var j=make('section','bk-v50-journal',
      '<div class="bk-v50-journal-top">'+
        '<h3>Bacci Brave Journal</h3>'+
        '<p>A private practice space for one sentence, one sketch idea, or one tiny brave step. It saves on this device only until you clear it or download it.</p>'+
      '</div>'+
      '<div class="bk-v50-paths" role="group" aria-label="Choose your Brave Route">'+
        '<button type="button" data-path="quiet">Quiet Brave</button>'+
        '<button type="button" data-path="social">Social Brave</button>'+
        '<button type="button" data-path="creative">Creative Brave</button>'+
        '<button type="button" data-path="repair">Repair Brave</button>'+
      '</div>'+
      '<div class="bk-v50-journal-prompt"><b id="bk-v50-journal-label">Rooftop Check</b><span id="bk-v50-journal-prompt">What is one part of you that deserves not to be abandoned?</span></div>'+
      '<textarea id="bk-v50-journal-text" maxlength="1800" placeholder="Write one sentence, a list, a note to future you, or nothing at all. No pressure."></textarea>'+
      '<div class="bk-v50-journal-actions">'+
        '<button type="button" id="bk-v50-save-journal">Save on this device</button>'+
        '<button type="button" id="bk-v50-download-journal">Download journal</button>'+
        '<button type="button" id="bk-v50-clear-journal">Clear</button>'+
      '</div>'+
      '<p class="bk-v50-journal-note">Journal note: this is creative reflection, not therapy, diagnosis, or crisis care. If something feels too big or unsafe, stop and reach out to a trusted grown-up, local emergency service, or qualified professional.</p>'
    );
    j.id='bk-v50-journal';

    var recap=by('bk-v49-recap');
    var book=by('bk-book');
    if(recap&&recap.parentNode) recap.parentNode.insertBefore(j,recap);
    else if(book&&book.parentNode) book.parentNode.insertBefore(j,book.nextSibling);
    else root.appendChild(j);

    var txt=by('bk-v50-journal-text');
    try{ txt.value=localStorage.getItem('bk_v50_journal')||''; }catch(e){}

    by('bk-v50-save-journal').addEventListener('click',function(){
      try{localStorage.setItem('bk_v50_journal',txt.value||'');}catch(e){}
      openComfort('Saved on this device. Your journal is private to this browser unless you download, print, copy, or share it.');
    });

    by('bk-v50-clear-journal').addEventListener('click',function(){
      txt.value='';
      try{localStorage.removeItem('bk_v50_journal');}catch(e){}
      openComfort('Journal cleared from this browser.');
    });

    by('bk-v50-download-journal').addEventListener('click',function(){
      var name=safeName((by('bk-namein')&&by('bk-namein').value)||'Brave Artist');
      var path=(localStorage.getItem('bk_v50_path_name')||'Brave Route').replace(/"/g,'');
      var body=[
        'Bacci Kid Brave Journal',
        'Creative reflection only. Not therapy, diagnosis, crisis care, or a promise of results.',
        '',
        'Artist: '+name,
        'Route: '+path,
        'Date: '+new Date().toLocaleDateString(),
        '',
        'Prompt: '+(by('bk-v50-journal-prompt').textContent||''),
        '',
        txt.value||''
      ].join('\n');
      var blob=new Blob([body],{type:'text/plain;charset=utf-8'});
      var a=document.createElement('a');
      a.download='Bacci_Kid_Brave_Journal.txt';
      a.href=URL.createObjectURL(blob);
      a.click();
      setTimeout(function(){URL.revokeObjectURL(a.href);},800);
    });

    qsa('.bk-v50-paths button',j).forEach(function(b){
      b.addEventListener('click',function(){
        qsa('.bk-v50-paths button',j).forEach(function(x){x.setAttribute('aria-pressed','false');});
        b.setAttribute('aria-pressed','true');
        var id=b.getAttribute('data-path');
        var p=PATHS.filter(function(x){return x.id===id;})[0]||PATHS[0];
        try{
          localStorage.setItem('bk_v50_path',p.id);
          localStorage.setItem('bk_v50_path_name',p.name);
        }catch(e){}
        var line=by('bk-bacci');
        if(line) line.textContent='Bacci says: '+p.line+' Your next step can be tiny and still count.';
      });
    });

    function updatePrompt(){
      var p=PROMPTS[currentChapter()]||PROMPTS.story;
      by('bk-v50-journal-label').textContent=p.label;
      by('bk-v50-journal-prompt').textContent=p.prompt+' Tip: '+p.tip;
    }

    qsa('#bk-next,#bk-prev,#bk-cover,#bk-closebook,#bk-rail button',root).forEach(function(b){
      b.addEventListener('click',function(){
        setTimeout(updatePrompt,150);
        setTimeout(updatePrompt,1450);
      });
    });

    var pages=by('bk-pages');
    if(pages&&'MutationObserver' in window){
      new MutationObserver(updatePrompt).observe(pages,{subtree:true,attributes:true,attributeFilter:['class']});
    }

    updatePrompt();
  }

  function addPaidBranchCTA(){
    if(by('bk-v50-branch-cta')) return;
    var j=by('bk-v50-journal')||by('bk-book');
    if(!j) return;

    var cta=make('section','bk-v50-panel',
      '<h3>Want more BraveVerse?</h3>'+
      '<p>The free story gives you the core Brave path. A future grown-up checkout can unlock optional BraveVerse Branches: Quiet Brave, Social Brave, Creative Brave, and Repair Brave, with extra printable pages and bonus videos.</p>'+
      '<div class="bk-v50-comfort-grid">'+
        '<button type="button" id="bk-v50-branch-free">Stay with the free story</button>'+
        '<button type="button" id="bk-v50-branch-shop">Grown-up bonus pack preview</button>'+
      '</div>'
    );
    cta.id='bk-v50-branch-cta';
    j.parentNode.insertBefore(cta,j.nextSibling);

    by('bk-v50-branch-free').addEventListener('click',function(){scrollToEl(by('bk-book'));});
    by('bk-v50-branch-shop').addEventListener('click',function(){
      var offer=qs('.bk-v49-shop',root);
      if(offer) scrollToEl(offer);
      else openComfort('Bonus BraveVerse Branches can become a parent-only paid add-on later. Keep the free story generous and the purchase optional.');
    });
  }

  function init(){
    upgradeStoryText();
    addWorldChipAndAgeNames();
    addAccessibilityControls();
    addComfortPanel();
    addDictionary();
    addJournal();
    addPaidBranchCTA();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();

/* =========================================================
BACCI KID BRAVE v55E . THE GLOW PILL RESCUE . ASSET EDITION
Pins the Start Your Glow Journey pill on every device.
========================================================= */
(function(){
  if (window.BacciGlowRescueV55E) return;
  window.BacciGlowRescueV55E = true;
  var LAB_URL = "/pages/worldglow-lab";
  var PHRASE = "start your glow journey";

  function findPill(){
    var els = document.querySelectorAll("a, button, [role='button'], div, span");
    for (var i = 0; i < els.length; i++) {
      var t = (els[i].textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      if (t === PHRASE || (t.indexOf(PHRASE) !== -1 && t.length < 40)) return els[i];
    }
    return null;
  }

  function makePill(){
    var a = document.createElement("a");
    a.href = LAB_URL;
    a.textContent = "\u2728 Start Your Glow Journey";
    document.body.appendChild(a);
    return a;
  }

  function pin(el){
    var phone = window.innerWidth < 768;
    var s = el.style;
    s.setProperty("display", "inline-flex", "important");
    s.setProperty("visibility", "visible", "important");
    s.setProperty("opacity", "1", "important");
    s.setProperty("position", "fixed", "important");
    s.setProperty("z-index", "2147483000", "important");
    s.setProperty("bottom", phone ? "84px" : "24px", "important");
    if (phone) {
      s.setProperty("left", "50%", "important");
      s.setProperty("right", "auto", "important");
      s.setProperty("transform", "translateX(-50%)", "important");
    } else {
      s.setProperty("left", "auto", "important");
      s.setProperty("right", "24px", "important");
      s.setProperty("transform", "none", "important");
    }
    s.setProperty("align-items", "center", "important");
    s.setProperty("gap", "8px", "important");
    s.setProperty("padding", "12px 20px", "important");
    s.setProperty("border-radius", "999px", "important");
    s.setProperty("background", "linear-gradient(135deg, #7b2ff7, #f107a3)", "important");
    s.setProperty("color", "#ffffff", "important");
    s.setProperty("font-weight", "700", "important");
    s.setProperty("font-size", "15px", "important");
    s.setProperty("text-decoration", "none", "important");
    s.setProperty("box-shadow", "0 6px 24px rgba(123, 47, 247, 0.55)", "important");
    s.setProperty("cursor", "pointer", "important");
    s.setProperty("max-width", "90vw", "important");
    s.setProperty("white-space", "nowrap", "important");
    if (el.dataset.bkGlowRescued !== "true") {
      el.dataset.bkGlowRescued = "true";
      el.addEventListener("click", function(e){
        e.preventDefault();
        e.stopPropagation();
        window.location.href = LAB_URL;
      }, true);
    }
  }

  function run(){
    var pill = findPill();
    if (!pill) pill = makePill();
    pin(pill);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
  var born = Date.now();
  var pulse = setInterval(function(){
    run();
    if (Date.now() - born > 10000) clearInterval(pulse);
  }, 500);
  window.addEventListener("resize", run);
})();


/* =========================================================
BACCI KID BRAVE v55T . THE STORY GATE
Date: 2026-07-22 . 10:10 PM
Owner: Dr. Jamie J. Karia, DSW, LCSW . Baccikid@gmail.com
This file REPLACES v55S. If v55S was never pasted, skip it and
paste only this. If v55S was already pasted, this still works:
every piece is guarded and this placement wins.
1. THE STORY GATE PLACEMENT: the Story Pod launcher now stands
   AFTER the coloring experience (right after the color stage),
   as the doorway that introduces the Living Story. When the
   Living Story page URL exists, one small edit adds its button.
2. SEEN AND GONE: after a visitor finishes the pod (Got it or
   Collapse), the launcher retires on that device (localStorage,
   COPPA safe). The Story Pod pill in the button row remains.
3. THE RHINO GROWS UP: Color lesson becomes Sound + Color
   Studio and links to /pages/bacci-kid-sound-color-studio.
4. THE LOCKED STUDIO PILL: a floating Music Studio pill sits
   above the Glow pill on every screen.
5. THE LAB FINALLY BOWS: the on page vocabulary section hides
   by its own landmarks (its WorldGlow Lab pill plus its Say
   Both buttons), stops climbing before Paint Set, and re hides
   itself if the page ever redraws it. Hidden never deleted.
Paste at the BOTTOM of Assets/bacci-brave.js after the last
Meow comment currently in the file.
========================================================= */
(function(){
  if (window.BacciStoryGateV55T) return;
  window.BacciStoryGateV55T = true;
  var STUDIO_URL = "/pages/bacci-kid-sound-color-studio";
  var SEEN_KEY = "bkPodSeenV55S";
  var css = document.createElement("style");
  css.textContent = [
    ".bk-v55s-studio-dock{position:fixed;right:18px;bottom:104px;z-index:2147482500;border:0;",
    "cursor:pointer;border-radius:999px;padding:12px 18px;color:#fff;font-weight:1000;font-size:14px;",
    "background:linear-gradient(90deg,#7b2ff7,#13c6cb);box-shadow:0 10px 26px rgba(123,47,247,.45);}",
    "@media(max-width:767px){.bk-v55s-studio-dock{right:12px;bottom:150px;padding:10px 14px;font-size:13px;}}",
    ".bk-v55t-hidden{display:none !important;}"
  ].join("");
  document.head.appendChild(css);
  function textOf(el){ return (el && el.textContent ? el.textContent : "").replace(/\s+/g, " ").trim().toLowerCase(); }
  function seen(){ try { return localStorage.getItem(SEEN_KEY) === "1"; } catch (e) { return false; } }
  function markSeen(){ try { localStorage.setItem(SEEN_KEY, "1"); } catch (e) {} }
  function launcher(){ return document.querySelector(".bk-v55r-launch"); }
  function enforce(){
    var l = launcher();
    if (l && seen()) l.classList.add("bk-v55r-hidden");
    hideLab();
  }
  function relocate(){
    var l = launcher();
    if (!l || l.dataset.bkV55t === "true") return;
    var stage = document.querySelector(".bk-stage");
    if (!stage || !stage.parentNode) return;
    l.dataset.bkV55t = "true";
    stage.parentNode.insertBefore(l, stage.nextSibling);
  }
  function wireSeen(){
    ["b16got", "b16collapse"].forEach(function(id){
      var b = document.getElementById(id);
      if (b && b.dataset.bkV55s !== "true") {
        b.dataset.bkV55s = "true";
        b.addEventListener("click", function(){
          markSeen();
          setTimeout(enforce, 500);
        }, true);
      }
    });
  }
  function studioPill(){
    var cands = document.querySelectorAll("a, button, [role='button']");
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i], t = textOf(el);
      if (t.indexOf("color lesson") !== -1 && t.length < 30 && el.dataset.bkV55s !== "true") {
        el.dataset.bkV55s = "true";
        var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false), n, done = false;
        while ((n = w.nextNode())) {
          if (!done && n.nodeValue && n.nodeValue.trim().length > 2) {
            n.nodeValue = " Sound + Color Studio";
            done = true;
          } else if (n.nodeValue && n.nodeValue.trim().length > 2) {
            n.nodeValue = "";
          }
        }
        if (el.tagName && el.tagName.toLowerCase() === "a") el.setAttribute("href", STUDIO_URL);
        el.addEventListener("click", function(e){
          e.preventDefault();
          e.stopPropagation();
          window.location.href = STUDIO_URL;
        }, true);
      }
    }
  }
  function studioDock(){
    if (document.querySelector(".bk-v55s-studio-dock")) return;
    var d = document.createElement("button");
    d.type = "button";
    d.className = "bk-v55s-studio-dock";
    d.setAttribute("aria-label", "Open the Bacci Kid Sound and Color Studio");
    d.textContent = "\uD83C\uDFA7 Music Studio";
    document.body.appendChild(d);
    d.addEventListener("click", function(){ window.location.href = STUDIO_URL; });
  }
  var FOREIGN = ["paint set", "fan quest", "mood noticed", "story pod", "hype me", "start your glow",
    "color bacci", "open the story", "enter museum", "got it", "watch bacci"];
  function safeT(t){
    for (var i = 0; i < FOREIGN.length; i++) { if (t.indexOf(FOREIGN[i]) !== -1) return false; }
    return true;
  }
  function hideLab(){
    var seed = null, i, t;
    var els = document.querySelectorAll("span, div, p, h1, h2, h3");
    for (i = 0; i < els.length; i++) {
      t = textOf(els[i]);
      if (t.indexOf("worldglow lab") !== -1 && t.indexOf("english") !== -1 && t.length < 60) { seed = els[i]; break; }
    }
    if (!seed) {
      for (i = 0; i < els.length; i++) {
        t = textOf(els[i]);
        if (t.indexOf("build your feeling vocabulary") !== -1 && t.length < 80) { seed = els[i]; break; }
      }
    }
    if (!seed) return;
    var node = seed, best = seed;
    while (node.parentElement && node.parentElement !== document.body) {
      node = node.parentElement;
      if (!safeT(textOf(node))) break;
      best = node;
    }
    t = textOf(best);
    if (t.indexOf("say both") !== -1 && t.indexOf("vocabulary") !== -1 && safeT(t)) {
      best.classList.add("bk-v55t-hidden");
    }
  }
  document.addEventListener("click", function(){ setTimeout(enforce, 600); }, true);
  function run(){ relocate(); wireSeen(); studioPill(); studioDock(); enforce(); }
  if (document.readyState === "loading") { document.addEventListener("DOMContentLoaded", run, { once: true }); } else { run(); }
  var born = Date.now();
  var pulse = setInterval(function(){ run(); if (Date.now() - born > 25000) clearInterval(pulse); }, 600);
})();
/* Created for Bacci Kid . Dr. Jamie J. Karia, DSW, LCSW
Meow . Meow . Meow 🐱 © 2026 Bacci Kid. All rights reserved. */



/* =========================================================
BACCI KID BRAVE REPAIR PATCH 01
WORLDGLOW LAB NAME + CHEMISTRY ICON + PRO PILL CLEANUP
Version: v56A
Date: 2026-07-23

SEARCH HEADER:
BACCI KID BRAVE REPAIR PATCH 01

WHAT THIS PATCH DOES:
1. Hides every visible WorldGlow Pro / WordGlow Pro shortcut pill.
2. Keeps the underlying Pro section untouched by default.
3. Corrects "WordGlow Lab" to "WorldGlow Lab".
4. Replaces the Earth icon with a chemistry test tube.
5. Adds large translucent floating bubbles above the test tube.
6. Reapplies the repair if another Brave script redraws the buttons.

SAFE REMOVAL:
Delete this entire titled block only.
========================================================= */
(function(){
  if (window.BacciBraveRepairPatch01WorldGlowV56A) return;
  window.BacciBraveRepairPatch01WorldGlowV56A = true;

  /* =====================================================
     EASY EDIT SETTING 01
     false = hide only the Pro buttons/pills
     true  = also hide the full old Pro content section
     Keep FALSE for the exact repair requested today.
  ===================================================== */
  var HIDE_WORLDGLOW_PRO_SECTION = false;

  /* =====================================================
     PATCH 01A — VISUAL STYLES
     Chemistry test tube + grand translucent bubbles
  ===================================================== */
  var style = document.createElement("style");
  style.id = "bk-repair-01-worldglow-style";
  style.textContent = [
    "#bk-hx .bk-worldglow-lab-icon{",
      "position:relative;",
      "display:inline-grid;",
      "place-items:end center;",
      "width:42px;",
      "height:36px;",
      "flex:0 0 42px;",
      "overflow:visible;",
      "margin-right:2px;",
    "}",
    "#bk-hx .bk-worldglow-lab-icon .bk-worldglow-tube{",
      "position:relative;",
      "z-index:3;",
      "display:block;",
      "font-size:28px;",
      "line-height:1;",
      "transform:rotate(-7deg);",
      "filter:drop-shadow(0 4px 8px rgba(0,198,198,.34));",
    "}",
    "#bk-hx .bk-worldglow-lab-icon i{",
      "position:absolute;",
      "z-index:2;",
      "display:block;",
      "border-radius:50%;",
      "pointer-events:none;",
      "background:radial-gradient(circle at 30% 24%,rgba(255,255,255,.98),rgba(190,255,250,.72) 35%,rgba(103,225,242,.34) 66%,rgba(166,107,255,.14) 100%);",
      "border:1px solid rgba(255,255,255,.88);",
      "box-shadow:0 0 10px rgba(125,252,244,.46),inset 0 0 7px rgba(255,255,255,.72);",
      "animation:bkWorldGlowBubbleRise 3.8s ease-in-out infinite;",
      "opacity:0;",
    "}",
    "#bk-hx .bk-worldglow-lab-icon .b1{width:13px;height:13px;left:21px;bottom:21px;animation-delay:0s;}",
    "#bk-hx .bk-worldglow-lab-icon .b2{width:9px;height:9px;left:11px;bottom:24px;animation-delay:.8s;}",
    "#bk-hx .bk-worldglow-lab-icon .b3{width:17px;height:17px;left:28px;bottom:27px;animation-delay:1.55s;}",
    "#bk-hx .bk-worldglow-lab-icon .b4{width:7px;height:7px;left:18px;bottom:31px;animation-delay:2.25s;}",
    "@keyframes bkWorldGlowBubbleRise{",
      "0%{transform:translate3d(0,8px,0) scale(.45);opacity:0;}",
      "18%{opacity:.92;}",
      "62%{opacity:.76;}",
      "100%{transform:translate3d(var(--bubble-x,7px),-34px,0) scale(1.28);opacity:0;}",
    "}",
    "#bk-hx .bk-worldglow-lab-icon .b1{--bubble-x:8px;}",
    "#bk-hx .bk-worldglow-lab-icon .b2{--bubble-x:-8px;}",
    "#bk-hx .bk-worldglow-lab-icon .b3{--bubble-x:11px;}",
    "#bk-hx .bk-worldglow-lab-icon .b4{--bubble-x:-3px;}",
    "#bk-hx .bk-worldglow-pro-pill-hidden{display:none!important;visibility:hidden!important;}",
    "@media(max-width:520px){",
      "#bk-hx .bk-worldglow-lab-icon{width:38px;height:34px;flex-basis:38px;}",
      "#bk-hx .bk-worldglow-lab-icon .bk-worldglow-tube{font-size:25px;}",
    "}",
    "@media(prefers-reduced-motion:reduce){",
      "#bk-hx .bk-worldglow-lab-icon i{animation:none!important;opacity:.66;}",
      "#bk-hx .bk-worldglow-lab-icon .b1{transform:translate(5px,-8px);}",
      "#bk-hx .bk-worldglow-lab-icon .b2{transform:translate(-4px,-4px);}",
      "#bk-hx .bk-worldglow-lab-icon .b3{transform:translate(8px,-12px);}",
      "#bk-hx .bk-worldglow-lab-icon .b4{transform:translate(0,-16px);}",
    "}"
  ].join("");
  document.head.appendChild(style);

  function cleanText(el){
    return (el && el.textContent ? el.textContent : "")
      .replace(/\s+/g, " ")
      .trim();
  }

  /* =====================================================
     PATCH 01B — HIDE WORLDGLOW PRO PILLS
     Covers the top-row pill and "Open WordGlow Pro" shortcut.
  ===================================================== */
  function hideWorldGlowProPills(){
    var direct = [
      document.getElementById("bk-v48-word-btn")
    ];

    direct.forEach(function(el){
      if (!el) return;
      el.classList.add("bk-worldglow-pro-pill-hidden");
      el.hidden = true;
      el.setAttribute("aria-hidden","true");
      el.setAttribute("tabindex","-1");
      el.style.setProperty("display","none","important");
    });

    var controls = document.querySelectorAll(
      "#bk-hx button, #bk-hx a, #bk-hx [role='button']"
    );

    controls.forEach(function(el){
      var text = cleanText(el).toLowerCase();
      var isPro =
        text === "wordglow pro" ||
        text === "worldglow pro" ||
        text === "open wordglow pro" ||
        text === "open worldglow pro";

      if (!isPro) return;

      el.classList.add("bk-worldglow-pro-pill-hidden");
      el.hidden = true;
      el.setAttribute("aria-hidden","true");
      el.setAttribute("tabindex","-1");
      el.style.setProperty("display","none","important");
    });

    if (HIDE_WORLDGLOW_PRO_SECTION) {
      var section = document.getElementById("bk-v48-wordpro");
      if (section) {
        section.hidden = true;
        section.setAttribute("aria-hidden","true");
        section.style.setProperty("display","none","important");
      }
    }
  }

  /* =====================================================
     PATCH 01C — CORRECT LAB NAME
     WordGlow Lab becomes WorldGlow Lab everywhere relevant.
  ===================================================== */
  function correctWorldGlowLabName(){
    var labButton = document.getElementById("bk-v47-word-btn");

    if (labButton) {
      var label = labButton.querySelector(".bk-worldglow-lab-label");
      var hasIcon = labButton.querySelector(".bk-worldglow-lab-icon");

      if (!label || !hasIcon || cleanText(label) !== "WorldGlow Lab") {
        labButton.innerHTML =
          '<span class="bk-worldglow-lab-icon" aria-hidden="true">' +
            '<span class="bk-worldglow-tube">🧪</span>' +
            '<i class="b1"></i>' +
            '<i class="b2"></i>' +
            '<i class="b3"></i>' +
            '<i class="b4"></i>' +
          '</span>' +
          '<span class="bk-worldglow-lab-label">WorldGlow Lab</span>';

        labButton.setAttribute(
          "aria-label",
          "Open WorldGlow Lab, English and Korean feeling vocabulary"
        );
        labButton.setAttribute("title","Open WorldGlow Lab");
      }
    }

    var labKicker = document.querySelector(
      "#bk-v47-wordlab .bk-v47-wordlab-head > span"
    );

    if (labKicker) {
      var kickerText = cleanText(labKicker);
      if (
        kickerText.indexOf("WordGlow Lab") !== -1 ||
        kickerText.indexOf("WorldGlow Lab") !== -1
      ) {
        labKicker.textContent = "WorldGlow Lab · English + 한국어";
      }
    }

    var exactLabels = document.querySelectorAll(
      "#bk-v47-wordlab span, #bk-v47-wordlab h1, #bk-v47-wordlab h2, #bk-v47-wordlab h3"
    );

    exactLabels.forEach(function(el){
      var text = cleanText(el);
      if (text === "WordGlow Lab") {
        el.textContent = "WorldGlow Lab";
      }
      if (text === "WordGlow Lab · English + 한국어") {
        el.textContent = "WorldGlow Lab · English + 한국어";
      }
    });
  }

  /* =====================================================
     PATCH 01D — APPLY + REDRAW PROTECTION
     Reapplies after Brave dynamically creates or redraws pills.
  ===================================================== */
  var queued = false;

  function applyRepair(){
    hideWorldGlowProPills();
    correctWorldGlowLabName();
  }

  function scheduleRepair(){
    if (queued) return;
    queued = true;
    requestAnimationFrame(function(){
      queued = false;
      applyRepair();
    });
  }

  function startRepair(){
    applyRepair();

    if ("MutationObserver" in window) {
      var observer = new MutationObserver(scheduleRepair);
      observer.observe(document.documentElement,{
        childList:true,
        subtree:true,
        characterData:true
      });
    }

    setTimeout(applyRepair,500);
    setTimeout(applyRepair,1500);
    setTimeout(applyRepair,3500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded",startRepair,{once:true});
  } else {
    startRepair();
  }
})();

/* END BACCI KID BRAVE REPAIR PATCH 01
WORLDGLOW LAB NAME + CHEMISTRY ICON + PRO PILL CLEANUP
========================================================= */



/* =========================================================
BACCI KID BRAVE REPAIR PATCH 02
SEPARATED TOP + END PAGE NAVIGATION RAIL
Version: v56B
Date: 2026-07-23

SEARCH HEADER:
BACCI KID BRAVE REPAIR PATCH 02

WHAT THIS PATCH DOES:
1. Hides the older single .bk-totop button that is trapped
   underneath the Start Your Glow Journey pill.
2. Creates one separate vertical navigation rail.
3. TOP takes the visitor to the absolute top of the page.
4. END takes the visitor to the absolute end of the website.
5. Keeps clear spacing above the Music Studio and Glow pills.
6. Supports desktop, tablet, phone, keyboard, and reduced motion.

SAFE REMOVAL:
Delete this entire titled block only.
========================================================= */
(function(){
  if (window.BacciBraveRepairPatch02ScrollRailV56B) return;
  window.BacciBraveRepairPatch02ScrollRailV56B = true;

  /* =====================================================
     EASY EDIT SETTINGS 02
     Change only these values if you later want to move
     the two-arrow rail higher or farther from the edge.
  ===================================================== */
  var DESKTOP_RIGHT_PX = 18;
  var DESKTOP_BOTTOM_PX = 188;
  var MOBILE_RIGHT_PX = 12;
  var MOBILE_BOTTOM_PX = 218;

  /* =====================================================
     PATCH 02A — STYLES
     A separate vertical rail that never touches the pills.
  ===================================================== */
  var style = document.createElement("style");
  style.id = "bk-repair-02-scroll-rail-style";
  style.textContent = [
    ".bk-totop{display:none!important;visibility:hidden!important;pointer-events:none!important;}",

    ".bk-page-nav-rail-v56b{",
      "position:fixed;",
      "right:"+DESKTOP_RIGHT_PX+"px;",
      "bottom:"+DESKTOP_BOTTOM_PX+"px;",
      "z-index:2147482900;",
      "display:grid;",
      "gap:12px;",
      "padding:7px;",
      "border-radius:999px;",
      "background:linear-gradient(145deg,rgba(255,255,255,.93),rgba(246,239,255,.9) 58%,rgba(230,255,255,.92));",
      "border:2px solid rgba(255,255,255,.9);",
      "box-shadow:0 16px 42px rgba(73,43,135,.26),0 0 28px rgba(125,252,244,.18);",
      "backdrop-filter:blur(14px) saturate(1.1);",
      "-webkit-backdrop-filter:blur(14px) saturate(1.1);",
      "isolation:isolate;",
    "}",

    ".bk-page-nav-rail-v56b::before{",
      "content:'';",
      "position:absolute;",
      "inset:5px;",
      "z-index:-1;",
      "border-radius:999px;",
      "border:1px solid rgba(166,107,255,.18);",
      "pointer-events:none;",
    "}",

    ".bk-page-nav-btn-v56b{",
      "width:54px;",
      "height:54px;",
      "display:grid;",
      "grid-template-rows:1fr auto;",
      "place-items:center;",
      "gap:0;",
      "padding:6px 4px 5px;",
      "border:3px solid #fff;",
      "border-radius:50%;",
      "cursor:pointer;",
      "font-family:Fredoka,'Baloo 2',system-ui,sans-serif;",
      "font-weight:900;",
      "color:#fff;",
      "box-shadow:0 8px 20px rgba(90,55,160,.3);",
      "transition:transform .18s ease,filter .18s ease,opacity .18s ease,box-shadow .18s ease;",
    "}",

    ".bk-page-nav-btn-v56b[data-direction='up']{",
      "background:linear-gradient(135deg,#00c6c6,#7b61ff 58%,#a66bff);",
    "}",

    ".bk-page-nav-btn-v56b[data-direction='down']{",
      "background:linear-gradient(135deg,#a66bff,#ff6fbf 58%,#ff9b63);",
    "}",

    ".bk-page-nav-btn-v56b .arrow{",
      "display:block;",
      "font-size:25px;",
      "line-height:.82;",
      "text-shadow:0 2px 5px rgba(35,20,75,.35);",
    "}",

    ".bk-page-nav-btn-v56b .label{",
      "display:block;",
      "font-size:8.5px;",
      "line-height:1;",
      "letter-spacing:.75px;",
      "text-transform:uppercase;",
    "}",

    ".bk-page-nav-btn-v56b:hover,",
    ".bk-page-nav-btn-v56b:focus-visible{",
      "transform:translateY(-2px) scale(1.07);",
      "filter:saturate(1.08) brightness(1.04);",
      "box-shadow:0 12px 28px rgba(90,55,160,.4),0 0 22px rgba(125,252,244,.28);",
      "outline:3px solid rgba(255,255,255,.72);",
      "outline-offset:2px;",
    "}",

    ".bk-page-nav-btn-v56b:active{",
      "transform:translateY(2px) scale(.98);",
    "}",

    ".bk-page-nav-btn-v56b.is-disabled{",
      "opacity:.42;",
      "filter:grayscale(.15);",
      "cursor:default;",
      "box-shadow:none;",
    "}",

    ".bk-page-nav-btn-v56b.is-disabled:hover{",
      "transform:none;",
      "filter:grayscale(.15);",
    "}",

    "@media(max-width:767px){",
      ".bk-page-nav-rail-v56b{",
        "right:"+MOBILE_RIGHT_PX+"px;",
        "bottom:calc("+MOBILE_BOTTOM_PX+"px + env(safe-area-inset-bottom));",
        "gap:9px;",
        "padding:6px;",
      "}",
      ".bk-page-nav-btn-v56b{",
        "width:48px;",
        "height:48px;",
        "padding:5px 3px 4px;",
      "}",
      ".bk-page-nav-btn-v56b .arrow{font-size:22px;}",
      ".bk-page-nav-btn-v56b .label{font-size:7.5px;}",
    "}",

    "@media(prefers-reduced-motion:reduce){",
      ".bk-page-nav-btn-v56b{transition:none!important;}",
      ".bk-page-nav-btn-v56b:hover,",
      ".bk-page-nav-btn-v56b:focus-visible{transform:none!important;}",
    "}",

    "@media print{",
      ".bk-page-nav-rail-v56b{display:none!important;}",
    "}"
  ].join("");
  document.head.appendChild(style);

  /* =====================================================
     PATCH 02B — BUILD THE TOP + END BUTTONS
  ===================================================== */
  function buildRail(){
    var existing = document.getElementById("bk-page-nav-rail-v56b");
    if (existing) return existing;

    var rail = document.createElement("nav");
    rail.id = "bk-page-nav-rail-v56b";
    rail.className = "bk-page-nav-rail-v56b";
    rail.setAttribute("aria-label","Page navigation");

    var up = document.createElement("button");
    up.type = "button";
    up.className = "bk-page-nav-btn-v56b";
    up.dataset.direction = "up";
    up.setAttribute("aria-label","Go to the top of the page");
    up.setAttribute("title","Go to the top of the page");
    up.innerHTML =
      '<span class="arrow" aria-hidden="true">↑</span>' +
      '<span class="label">Top</span>';

    var down = document.createElement("button");
    down.type = "button";
    down.className = "bk-page-nav-btn-v56b";
    down.dataset.direction = "down";
    down.setAttribute("aria-label","Go to the end of the website");
    down.setAttribute("title","Go to the end of the website");
    down.innerHTML =
      '<span class="arrow" aria-hidden="true">↓</span>' +
      '<span class="label">End</span>';

    rail.appendChild(up);
    rail.appendChild(down);
    document.body.appendChild(rail);

    return rail;
  }

  /* =====================================================
     PATCH 02C — SCROLL ACTIONS
     Calculates the page height at click time so dynamically
     loaded Brave content is included.
  ===================================================== */
  function reducedMotion(){
    try{
      return (
        document.documentElement.getAttribute("data-bk-motion") === "calm" ||
        (
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches
        )
      );
    }catch(e){
      return false;
    }
  }

  function pageScroller(){
    return document.scrollingElement || document.documentElement;
  }

  function goTop(){
    window.scrollTo({
      top:0,
      left:0,
      behavior:reducedMotion() ? "auto" : "smooth"
    });
  }

  function goEnd(){
    var scroller = pageScroller();
    var bottom = Math.max(
      scroller.scrollHeight,
      document.documentElement.scrollHeight,
      document.body ? document.body.scrollHeight : 0
    );

    window.scrollTo({
      top:bottom,
      left:0,
      behavior:reducedMotion() ? "auto" : "smooth"
    });
  }

  /* =====================================================
     PATCH 02D — BUTTON STATE
     Makes it clear when the visitor is already at the top
     or already at the end.
  ===================================================== */
  function updateState(){
    var rail = document.getElementById("bk-page-nav-rail-v56b");
    if (!rail) return;

    var up = rail.querySelector("[data-direction='up']");
    var down = rail.querySelector("[data-direction='down']");
    var scroller = pageScroller();

    var y = window.pageYOffset || scroller.scrollTop || 0;
    var max = Math.max(0,scroller.scrollHeight - window.innerHeight);
    var atTop = y <= 8;
    var atEnd = y >= max - 8;

    if (up) {
      up.classList.toggle("is-disabled",atTop);
      up.setAttribute("aria-disabled",atTop ? "true" : "false");
    }

    if (down) {
      down.classList.toggle("is-disabled",atEnd);
      down.setAttribute("aria-disabled",atEnd ? "true" : "false");
    }
  }

  /* =====================================================
     PATCH 02E — INITIALIZE + REDRAW PROTECTION
  ===================================================== */
  function start(){
    var rail = buildRail();
    var up = rail.querySelector("[data-direction='up']");
    var down = rail.querySelector("[data-direction='down']");

    up.addEventListener("click",function(){
      if (this.getAttribute("aria-disabled") === "true") return;
      goTop();
    });

    down.addEventListener("click",function(){
      if (this.getAttribute("aria-disabled") === "true") return;
      goEnd();
    });

    var ticking = false;
    window.addEventListener("scroll",function(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        updateState();
        ticking = false;
      });
    },{passive:true});

    window.addEventListener("resize",updateState);
    window.addEventListener("load",updateState);
    updateState();

    if ("MutationObserver" in window) {
      var observer = new MutationObserver(function(){
        updateState();
      });
      observer.observe(document.documentElement,{
        childList:true,
        subtree:true
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded",start,{once:true});
  } else {
    start();
  }
})();

/* END BACCI KID BRAVE REPAIR PATCH 02
SEPARATED TOP + END PAGE NAVIGATION RAIL
========================================================= */




/* =========================================================
BACCI KID BRAVE REPAIR PATCH 03
HYPE INVITATION ALIGNMENT + RESPONSIVE TWO-LINE POINTER
Version: v56C
Date: 2026-07-23

SEARCH HEADER:
BACCI KID BRAVE REPAIR PATCH 03

WHAT THIS PATCH DOES:
1. Keeps the Hype me button on the left side.
2. Moves the Hype invitation bubble to the same left side.
3. Places the invitation directly above the Hype me button.
4. Changes the invitation into a compact two-line message.
5. Points the invitation tail downward toward Hype me.
6. Protects spacing on desktop, iPad, and phone.
7. Re-formats the later "Need an extra boost?" message too.

SAFE REMOVAL:
Delete this entire titled block only.
========================================================= */
(function(){
  if (window.BacciBraveRepairPatch03HypeInviteV56C) return;
  window.BacciBraveRepairPatch03HypeInviteV56C = true;

  /* =====================================================
     EASY EDIT SETTINGS 03
     These values control only the Hype invitation system.
  ===================================================== */
  var DESKTOP_LEFT_PX = 16;
  var DESKTOP_BUTTON_BOTTOM_PX = 18;
  var DESKTOP_INVITE_BOTTOM_PX = 84;

  var IPAD_LEFT_PX = 14;
  var IPAD_BUTTON_BOTTOM_PX = 18;
  var IPAD_INVITE_BOTTOM_PX = 82;

  var PHONE_LEFT_PX = 10;
  var PHONE_BUTTON_BOTTOM_PX = 208;
  var PHONE_INVITE_BOTTOM_PX = 270;

  /* =====================================================
     PATCH 03A — RESPONSIVE HYPE POSITIONING
  ===================================================== */
  var style = document.createElement("style");
  style.id = "bk-repair-03-hype-invite-style";
  style.textContent = [
    /* DESKTOP */
    "#bk-hx .bk-hypebtn{",
      "left:"+DESKTOP_LEFT_PX+"px!important;",
      "right:auto!important;",
      "bottom:"+DESKTOP_BUTTON_BOTTOM_PX+"px!important;",
      "z-index:2147482850!important;",
      "max-width:min(210px,calc(100vw - 32px));",
      "white-space:nowrap;",
    "}",

    "#bk-hx .bk-hypecta{",
      "left:"+DESKTOP_LEFT_PX+"px!important;",
      "right:auto!important;",
      "bottom:"+DESKTOP_INVITE_BOTTOM_PX+"px!important;",
      "z-index:2147482849!important;",
      "width:max-content;",
      "max-width:min(258px,calc(100vw - 32px));",
      "display:grid!important;",
      "gap:2px;",
      "padding:10px 15px 11px!important;",
      "border-radius:17px 17px 17px 6px!important;",
      "text-align:left;",
      "white-space:normal!important;",
      "line-height:1.16;",
      "overflow:visible;",
      "background:linear-gradient(135deg,rgba(255,255,255,.97),rgba(255,241,249,.97) 54%,rgba(235,255,255,.97))!important;",
      "border:2px solid var(--pink)!important;",
      "box-shadow:0 10px 25px rgba(255,111,191,.3),0 0 0 3px rgba(255,255,255,.46)!important;",
    "}",

    "#bk-hx .bk-hypecta::after{",
      "content:'';",
      "position:absolute;",
      "left:30px;",
      "top:100%;",
      "width:0;",
      "height:0;",
      "border-left:10px solid transparent;",
      "border-right:10px solid transparent;",
      "border-top:12px solid var(--pink);",
      "filter:drop-shadow(0 3px 1px rgba(255,111,191,.18));",
      "pointer-events:none;",
    "}",

    "#bk-hx .bk-hypecta::before{",
      "content:'';",
      "position:absolute;",
      "left:32px;",
      "top:calc(100% - 1px);",
      "z-index:2;",
      "width:0;",
      "height:0;",
      "border-left:8px solid transparent;",
      "border-right:8px solid transparent;",
      "border-top:10px solid #fff5fb;",
      "pointer-events:none;",
    "}",

    "#bk-hx .bk-hypecta .bk-hypecta-main{",
      "display:block;",
      "font-family:var(--head);",
      "font-weight:800;",
      "font-size:calc(12.5px*var(--fs));",
      "color:var(--rose);",
      "letter-spacing:.1px;",
    "}",

    "#bk-hx .bk-hypecta .bk-hypecta-action{",
      "display:block;",
      "font-family:var(--head);",
      "font-weight:900;",
      "font-size:calc(12px*var(--fs));",
      "color:#087c79;",
    "}",

    /* IPAD / TABLET */
    "@media(min-width:768px) and (max-width:1100px){",
      "#bk-hx .bk-hypebtn{",
        "left:"+IPAD_LEFT_PX+"px!important;",
        "right:auto!important;",
        "bottom:"+IPAD_BUTTON_BOTTOM_PX+"px!important;",
      "}",
      "#bk-hx .bk-hypecta{",
        "left:"+IPAD_LEFT_PX+"px!important;",
        "right:auto!important;",
        "bottom:"+IPAD_INVITE_BOTTOM_PX+"px!important;",
        "max-width:230px;",
      "}",
    "}",

    /* PHONE */
    "@media(max-width:767px){",
      "#bk-hx .bk-hypebtn{",
        "left:"+PHONE_LEFT_PX+"px!important;",
        "right:auto!important;",
        "bottom:calc("+PHONE_BUTTON_BOTTOM_PX+"px + env(safe-area-inset-bottom))!important;",
        "padding:11px 17px!important;",
        "font-size:calc(13px*var(--fs))!important;",
        "max-width:calc(100vw - 20px);",
      "}",
      "#bk-hx .bk-hypecta{",
        "left:"+PHONE_LEFT_PX+"px!important;",
        "right:auto!important;",
        "bottom:calc("+PHONE_INVITE_BOTTOM_PX+"px + env(safe-area-inset-bottom))!important;",
        "max-width:min(205px,calc(100vw - 20px));",
        "padding:9px 13px 10px!important;",
        "text-align:left;",
      "}",
      "#bk-hx .bk-hypecta .bk-hypecta-main{",
        "font-size:calc(11.5px*var(--fs));",
      "}",
      "#bk-hx .bk-hypecta .bk-hypecta-action{",
        "font-size:calc(11px*var(--fs));",
      "}",
      "#bk-hx .bk-hypecta::after{left:25px;}",
      "#bk-hx .bk-hypecta::before{left:27px;}",
    "}",

    /* VERY NARROW PHONES */
    "@media(max-width:390px){",
      "#bk-hx .bk-hypecta{",
        "max-width:178px;",
      "}",
      "#bk-hx .bk-hypecta .bk-hypecta-main{",
        "font-size:11px;",
      "}",
      "#bk-hx .bk-hypecta .bk-hypecta-action{",
        "font-size:10.5px;",
      "}",
    "}",

    "@media(prefers-reduced-motion:reduce){",
      "#bk-hx .bk-hypecta.show{animation:none!important;}",
    "}",

    "@media print{",
      "#bk-hx .bk-hypebtn,",
      "#bk-hx .bk-hypecta{display:none!important;}",
    "}"
  ].join("");
  document.head.appendChild(style);

  /* =====================================================
     PATCH 03B — TWO-LINE WORDING
     Formats both the first invitation and its later reminder.
  ===================================================== */
  function textOf(el){
    return (el && el.textContent ? el.textContent : "")
      .replace(/\s+/g," ")
      .trim()
      .toLowerCase();
  }

  function formatInvite(){
    var invite = document.querySelector("#bk-hx .bk-hypecta");
    if (!invite) return;

    var text = textOf(invite);
    var mode = text.indexOf("need an extra boost") !== -1
      ? "boost"
      : "meet";

    if (
      invite.dataset.bkRepair03Mode === mode &&
      invite.querySelector(".bk-hypecta-main")
    ) return;

    invite.dataset.bkRepair03Mode = mode;

    if (mode === "boost") {
      invite.innerHTML =
        '<span class="bk-hypecta-main">Need an extra boost?</span>' +
        '<span class="bk-hypecta-action">Tap Hype me! ↓</span>';
    } else {
      invite.innerHTML =
        '<span class="bk-hypecta-main">Meet the Hype Cheerleader Crew!</span>' +
        '<span class="bk-hypecta-action">Tap Hype me! ↓</span>';
    }

    invite.setAttribute(
      "aria-label",
      mode === "boost"
        ? "Need an extra boost? Tap the Hype me button below."
        : "Meet the Hype Cheerleader Crew. Tap the Hype me button below."
    );
  }

  /* =====================================================
     PATCH 03C — REDRAW PROTECTION
     The original script changes this message after 17 seconds.
     This observer re-applies the two-line layout afterward.
  ===================================================== */
  var queued = false;

  function scheduleFormat(){
    if (queued) return;
    queued = true;
    requestAnimationFrame(function(){
      queued = false;
      formatInvite();
    });
  }

  function start(){
    formatInvite();

    if ("MutationObserver" in window) {
      var observer = new MutationObserver(scheduleFormat);
      observer.observe(document.documentElement,{
        childList:true,
        subtree:true,
        characterData:true
      });
    }

    setTimeout(formatInvite,500);
    setTimeout(formatInvite,1500);
    setTimeout(formatInvite,6500);
    setTimeout(formatInvite,17500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded",start,{once:true});
  } else {
    start();
  }
})();

/* END BACCI KID BRAVE REPAIR PATCH 03
HYPE INVITATION ALIGNMENT + RESPONSIVE TWO-LINE POINTER
========================================================= */



/* =========================================================
BACCI KID BRAVE REPAIR PATCH 04 — FINAL
PRIMARY MUSIC STUDIO + NEW COMPACT GLOW JOURNEY
Version: v56G
Date: 2026-07-23

SEARCH HEADER:
BACCI KID BRAVE REPAIR PATCH 04 — FINAL

IMPORTANT INSTALLATION:
1. Keep Patches 01, 02, and 03.
2. Delete Patch 04 Replacement v56E.
3. Delete Patch 04F v56F.
4. Paste this one final Patch 04 at the absolute bottom.

WHAT THIS FINAL PATCH DOES:
1. Keeps Music Studio as the primary floating action.
2. Displays a small visible music-note detail inside Music Studio.
3. Uses "Music Studio" on desktop and iPad.
4. Uses "Music" on phones.
5. Permanently hides the old rescued Start Your Glow Journey control.
6. Removes the leftover empty purple vertical decoration.
7. Creates one brand-new secondary button: "✨ Glow Journey".
8. Keeps the original WorldGlow Lab destination.
9. Adds no continuous floating animation.
10. Protects desktop, iPad, phone, and reduced-motion layouts.

SAFE REMOVAL:
Delete this entire titled block only.
========================================================= */
(function(){
  if (window.BacciBraveRepairPatch04FinalV56G) return;
  window.BacciBraveRepairPatch04FinalV56G = true;

  var WORLDGLOW_URL = "/pages/worldglow-lab";

  /* =====================================================
     EASY EDIT SETTINGS 04 — FINAL
  ===================================================== */
  var MUSIC_DESKTOP_WIDTH = 156;
  var MUSIC_DESKTOP_HEIGHT = 46;

  var MUSIC_IPAD_WIDTH = 142;
  var MUSIC_IPAD_HEIGHT = 44;

  var MUSIC_PHONE_WIDTH = 108;
  var MUSIC_PHONE_HEIGHT = 42;

  var GLOW_DESKTOP_WIDTH = 158;
  var GLOW_DESKTOP_HEIGHT = 40;

  var GLOW_IPAD_WIDTH = 150;
  var GLOW_IPAD_HEIGHT = 38;

  var GLOW_PHONE_WIDTH = 142;
  var GLOW_PHONE_HEIGHT = 38;

  /* =====================================================
     PATCH 04 FINAL A — REMOVE OLD GLOW SYSTEMS
  ===================================================== */
  var style = document.createElement("style");
  style.id = "bk-repair-04-final-style";
  style.textContent = [
    /* Hide every prior rescued / patched Glow control. */
    "[data-bk-glow-rescued='true'],",
    ".bk-glow-secondary-v56d,",
    ".bk-glow-secondary-v56e,",
    ".bk-glow-orphan-decoration-v56f{",
      "display:none!important;",
      "visibility:hidden!important;",
      "opacity:0!important;",
      "pointer-events:none!important;",
    "}",

    /* PRIMARY MUSIC STUDIO */
    ".bk-v55s-studio-dock.bk-music-final-v56g{",
      "position:fixed!important;",
      "left:auto!important;",
      "right:18px!important;",
      "bottom:78px!important;",
      "z-index:2147482800!important;",
      "display:inline-flex!important;",
      "align-items:center!important;",
      "justify-content:center!important;",
      "gap:7px!important;",
      "width:"+MUSIC_DESKTOP_WIDTH+"px!important;",
      "min-width:"+MUSIC_DESKTOP_WIDTH+"px!important;",
      "max-width:"+MUSIC_DESKTOP_WIDTH+"px!important;",
      "height:"+MUSIC_DESKTOP_HEIGHT+"px!important;",
      "min-height:"+MUSIC_DESKTOP_HEIGHT+"px!important;",
      "padding:0 14px!important;",
      "margin:0!important;",
      "border:2px solid rgba(255,255,255,.96)!important;",
      "border-radius:999px!important;",
      "overflow:hidden!important;",
      "color:#fff!important;",
      "font-family:Fredoka,'Baloo 2',system-ui,sans-serif!important;",
      "font-size:14px!important;",
      "font-weight:900!important;",
      "line-height:1!important;",
      "letter-spacing:.08px!important;",
      "white-space:nowrap!important;",
      "text-shadow:0 1px 3px rgba(24,12,78,.38)!important;",
      "background:linear-gradient(105deg,#6f2cff 0%,#745cf5 46%,#00bfc5 100%)!important;",
      "box-shadow:0 5px 0 #5133bc,0 13px 28px rgba(84,52,190,.32),0 0 20px rgba(0,191,197,.22)!important;",
      "filter:none!important;",
      "animation:none!important;",
      "transform:none!important;",
      "transition:transform .16s ease,box-shadow .16s ease,filter .16s ease!important;",
    "}",

    ".bk-v55s-studio-dock.bk-music-final-v56g::before,",
    ".bk-v55s-studio-dock.bk-music-final-v56g::after{",
      "content:none!important;",
      "display:none!important;",
    "}",

    ".bk-v55s-studio-dock.bk-music-final-v56g:hover,",
    ".bk-v55s-studio-dock.bk-music-final-v56g:focus-visible{",
      "transform:translateY(-2px) scale(1.025)!important;",
      "filter:saturate(1.06) brightness(1.03)!important;",
      "box-shadow:0 7px 0 #5133bc,0 17px 34px rgba(84,52,190,.38),0 0 25px rgba(0,191,197,.28)!important;",
      "outline:3px solid rgba(255,255,255,.7)!important;",
      "outline-offset:2px!important;",
    "}",

    ".bk-v55s-studio-dock.bk-music-final-v56g:active{",
      "transform:translateY(2px) scale(.985)!important;",
      "box-shadow:0 2px 0 #5133bc,0 8px 19px rgba(84,52,190,.3)!important;",
    "}",

    ".bk-music-final-v56g .bk-music-icon-final-v56g{",
      "font-size:17px;",
      "line-height:1;",
    "}",

    ".bk-music-final-v56g .bk-music-note-final-v56g{",
      "display:inline-block;",
      "font-size:13px;",
      "line-height:1;",
      "color:#d9ffff;",
      "opacity:.9;",
      "transform:rotate(-8deg);",
      "transition:transform .18s ease;",
    "}",

    ".bk-music-final-v56g:hover .bk-music-note-final-v56g,",
    ".bk-music-final-v56g:focus-visible .bk-music-note-final-v56g{",
      "transform:translateY(-3px) rotate(8deg) scale(1.16);",
    "}",

    ".bk-music-final-v56g .bk-music-phone-final-v56g{display:none;}",

    /* BRAND-NEW SECONDARY GLOW JOURNEY */
    "#bk-glow-journey-final-v56g{",
      "position:fixed!important;",
      "left:auto!important;",
      "right:18px!important;",
      "bottom:24px!important;",
      "z-index:2147482700!important;",
      "display:inline-flex!important;",
      "align-items:center!important;",
      "justify-content:center!important;",
      "gap:7px!important;",
      "width:"+GLOW_DESKTOP_WIDTH+"px!important;",
      "min-width:"+GLOW_DESKTOP_WIDTH+"px!important;",
      "max-width:"+GLOW_DESKTOP_WIDTH+"px!important;",
      "height:"+GLOW_DESKTOP_HEIGHT+"px!important;",
      "min-height:"+GLOW_DESKTOP_HEIGHT+"px!important;",
      "padding:0 12px!important;",
      "margin:0!important;",
      "border:2px solid rgba(166,107,255,.4)!important;",
      "border-radius:999px!important;",
      "overflow:hidden!important;",
      "color:#49356f!important;",
      "font-family:Fredoka,'Baloo 2',system-ui,sans-serif!important;",
      "font-size:12.5px!important;",
      "font-weight:850!important;",
      "line-height:1!important;",
      "letter-spacing:0!important;",
      "white-space:nowrap!important;",
      "text-decoration:none!important;",
      "text-shadow:none!important;",
      "background:rgba(255,255,255,.95)!important;",
      "box-shadow:0 7px 18px rgba(87,57,145,.16)!important;",
      "filter:none!important;",
      "animation:none!important;",
      "transform:none!important;",
      "transition:transform .16s ease,box-shadow .16s ease,background .16s ease!important;",
    "}",

    "#bk-glow-journey-final-v56g::before,",
    "#bk-glow-journey-final-v56g::after{",
      "content:none!important;",
      "display:none!important;",
    "}",

    "#bk-glow-journey-final-v56g:hover,",
    "#bk-glow-journey-final-v56g:focus-visible{",
      "transform:translateY(-2px)!important;",
      "background:#fff!important;",
      "box-shadow:0 10px 23px rgba(87,57,145,.22),0 0 13px rgba(0,191,197,.12)!important;",
      "outline:3px solid rgba(255,255,255,.72)!important;",
      "outline-offset:2px!important;",
    "}",

    "#bk-glow-journey-final-v56g .bk-glow-star-final-v56g{",
      "font-size:14px;",
      "line-height:1;",
    "}",

    /* IPAD */
    "@media(min-width:768px) and (max-width:1100px){",
      ".bk-v55s-studio-dock.bk-music-final-v56g{",
        "right:14px!important;",
        "bottom:76px!important;",
        "width:"+MUSIC_IPAD_WIDTH+"px!important;",
        "min-width:"+MUSIC_IPAD_WIDTH+"px!important;",
        "max-width:"+MUSIC_IPAD_WIDTH+"px!important;",
        "height:"+MUSIC_IPAD_HEIGHT+"px!important;",
        "min-height:"+MUSIC_IPAD_HEIGHT+"px!important;",
        "font-size:13px!important;",
        "padding:0 11px!important;",
      "}",

      "#bk-glow-journey-final-v56g{",
        "right:14px!important;",
        "bottom:24px!important;",
        "width:"+GLOW_IPAD_WIDTH+"px!important;",
        "min-width:"+GLOW_IPAD_WIDTH+"px!important;",
        "max-width:"+GLOW_IPAD_WIDTH+"px!important;",
        "height:"+GLOW_IPAD_HEIGHT+"px!important;",
        "min-height:"+GLOW_IPAD_HEIGHT+"px!important;",
        "font-size:12px!important;",
      "}",
    "}",

    /* PHONE */
    "@media(max-width:767px){",
      ".bk-v55s-studio-dock.bk-music-final-v56g{",
        "left:auto!important;",
        "right:10px!important;",
        "bottom:calc(138px + env(safe-area-inset-bottom))!important;",
        "width:"+MUSIC_PHONE_WIDTH+"px!important;",
        "min-width:"+MUSIC_PHONE_WIDTH+"px!important;",
        "max-width:"+MUSIC_PHONE_WIDTH+"px!important;",
        "height:"+MUSIC_PHONE_HEIGHT+"px!important;",
        "min-height:"+MUSIC_PHONE_HEIGHT+"px!important;",
        "font-size:12.5px!important;",
        "padding:0 9px!important;",
        "gap:5px!important;",
      "}",

      ".bk-music-final-v56g .bk-music-desktop-final-v56g{display:none!important;}",
      ".bk-music-final-v56g .bk-music-phone-final-v56g{display:inline!important;}",

      "#bk-glow-journey-final-v56g{",
        "left:50%!important;",
        "right:auto!important;",
        "bottom:calc(82px + env(safe-area-inset-bottom))!important;",
        "width:"+GLOW_PHONE_WIDTH+"px!important;",
        "min-width:"+GLOW_PHONE_WIDTH+"px!important;",
        "max-width:"+GLOW_PHONE_WIDTH+"px!important;",
        "height:"+GLOW_PHONE_HEIGHT+"px!important;",
        "min-height:"+GLOW_PHONE_HEIGHT+"px!important;",
        "font-size:11.5px!important;",
        "padding:0 10px!important;",
        "transform:translateX(-50%)!important;",
      "}",

      "#bk-glow-journey-final-v56g:hover,",
      "#bk-glow-journey-final-v56g:focus-visible{",
        "transform:translateX(-50%) translateY(-2px)!important;",
      "}",
    "}",

    "@media(max-width:390px){",
      ".bk-v55s-studio-dock.bk-music-final-v56g{",
        "width:100px!important;",
        "min-width:100px!important;",
        "max-width:100px!important;",
      "}",

      "#bk-glow-journey-final-v56g{",
        "width:134px!important;",
        "min-width:134px!important;",
        "max-width:134px!important;",
        "font-size:11px!important;",
      "}",
    "}",

    "@media(prefers-reduced-motion:reduce){",
      ".bk-v55s-studio-dock.bk-music-final-v56g,",
      "#bk-glow-journey-final-v56g,",
      ".bk-music-note-final-v56g{transition:none!important;}",

      ".bk-v55s-studio-dock.bk-music-final-v56g:hover,",
      ".bk-v55s-studio-dock.bk-music-final-v56g:focus-visible{transform:none!important;}",

      "#bk-glow-journey-final-v56g:hover,",
      "#bk-glow-journey-final-v56g:focus-visible{transform:none!important;}",
    "}",

    "@media print{",
      ".bk-v55s-studio-dock.bk-music-final-v56g,",
      "#bk-glow-journey-final-v56g{display:none!important;}",
    "}"
  ].join("");
  document.head.appendChild(style);

  function cleanText(el){
    return (el && el.textContent ? el.textContent : "")
      .replace(/\s+/g," ")
      .trim()
      .toLowerCase();
  }

  function hideImportant(el){
    if (!el || el.id === "bk-glow-journey-final-v56g") return;

    el.setAttribute("aria-hidden","true");
    el.setAttribute("tabindex","-1");
    el.style.setProperty("display","none","important");
    el.style.setProperty("visibility","hidden","important");
    el.style.setProperty("opacity","0","important");
    el.style.setProperty("pointer-events","none","important");
  }

  /* =====================================================
     PATCH 04 FINAL B — HIDE OLD RESCUED GLOW + PURPLE SHELL
  ===================================================== */
  function removeOldGlow(){
    document.querySelectorAll(
      "[data-bk-glow-rescued='true'],"+
      ".bk-glow-secondary-v56d,"+
      ".bk-glow-secondary-v56e,"+
      ".bk-glow-orphan-decoration-v56f"
    ).forEach(hideImportant);

    var all = document.querySelectorAll(
      "a,button,[role='button'],div,span"
    );

    all.forEach(function(el){
      if (el.id === "bk-glow-journey-final-v56g") return;

      var text = cleanText(el);
      if (text.indexOf("start your glow journey") === -1) return;

      var cs;
      var rect;

      try{
        cs = window.getComputedStyle(el);
        rect = el.getBoundingClientRect();
      }catch(e){
        return;
      }

      var isFloating =
        cs.position === "fixed" ||
        cs.position === "absolute";

      var isControlSized =
        rect.width > 40 &&
        rect.width < 520 &&
        rect.height > 20 &&
        rect.height < 190;

      if (isFloating && isControlSized) {
        hideImportant(el);
      }
    });

    /*
      Remove the empty purple vertical capsule left beside the old
      Glow control. It has no meaningful text, is fixed at bottom-right,
      and uses the old rescue gradient colors.
    */
    document.querySelectorAll("body > *, #bk-hx > *").forEach(function(el){
      if (
        el.id === "bk-glow-journey-final-v56g" ||
        el.classList.contains("bk-v55s-studio-dock") ||
        el.classList.contains("bk-page-nav-rail-v56b") ||
        el.classList.contains("bk-hypebtn") ||
        el.classList.contains("bk-hypecta")
      ) return;

      if (cleanText(el).length > 2) return;

      var cs;
      var rect;

      try{
        cs = window.getComputedStyle(el);
        rect = el.getBoundingClientRect();
      }catch(e){
        return;
      }

      var visual = [
        cs.background,
        cs.backgroundColor,
        cs.backgroundImage,
        cs.borderColor,
        cs.boxShadow
      ].join(" ").toLowerCase();

      var purple =
        visual.indexOf("123, 47, 247") !== -1 ||
        visual.indexOf("241, 7, 163") !== -1 ||
        visual.indexOf("166, 107, 255") !== -1 ||
        visual.indexOf("123,47,247") !== -1 ||
        visual.indexOf("241,7,163") !== -1 ||
        visual.indexOf("#7b2ff7") !== -1 ||
        visual.indexOf("#f107a3") !== -1 ||
        visual.indexOf("#a66bff") !== -1;

      var bottomRight =
        rect.right > window.innerWidth - 190 &&
        rect.bottom > window.innerHeight - 190;

      var capsule =
        rect.width > 8 &&
        rect.width < 110 &&
        rect.height > 20 &&
        rect.height < 170;

      if (
        cs.position === "fixed" &&
        purple &&
        bottomRight &&
        capsule
      ) {
        hideImportant(el);
      }
    });
  }

  /* =====================================================
     PATCH 04 FINAL C — FORMAT PRIMARY MUSIC STUDIO
  ===================================================== */
  function formatMusic(){
    var music = document.querySelector(".bk-v55s-studio-dock");
    if (!music) return;

    music.classList.remove(
      "bk-music-primary-v56d",
      "bk-music-primary-v56e"
    );
    music.classList.add("bk-music-final-v56g");

    music.setAttribute(
      "aria-label",
      "Open the Bacci Kid Sound and Color Music Studio"
    );
    

    if (!music.querySelector(".bk-music-icon-final-v56g")) {
      music.innerHTML =
        '<span class="bk-music-icon-final-v56g" aria-hidden="true">🎧</span>' +
        '<span class="bk-music-desktop-final-v56g">Music Studio</span>' +
        '<span class="bk-music-phone-final-v56g">Music</span>' +
        '<span class="bk-music-note-final-v56g" aria-hidden="true">♫</span>';
    }
  }

  /* =====================================================
     PATCH 04 FINAL D — CREATE A BRAND-NEW GLOW BUTTON
  ===================================================== */
  function buildNewGlow(){
    var glow = document.getElementById(
      "bk-glow-journey-final-v56g"
    );

    if (!glow) {
      glow = document.createElement("a");
      glow.id = "bk-glow-journey-final-v56g";
      glow.href = WORLDGLOW_URL;
      glow.setAttribute(
        "aria-label",
        "Open Glow Journey in WorldGlow Lab"
      );
      glow.setAttribute("title","Open Glow Journey");
      glow.innerHTML =
        '<span class="bk-glow-star-final-v56g" aria-hidden="true">✨</span>' +
        '<span>Glow Journey</span>';

      document.body.appendChild(glow);
    }

    glow.href = WORLDGLOW_URL;
  }

  /* =====================================================
     PATCH 04 FINAL E — APPLY + REDRAW PROTECTION
  ===================================================== */
  var queued = false;

  function apply(){
    removeOldGlow();
    formatMusic();
    buildNewGlow();
    removeOldGlow();
  }

  function schedule(){
    if (queued) return;
    queued = true;

    requestAnimationFrame(function(){
      queued = false;
      apply();
    });
  }

  function start(){
    apply();

    if ("MutationObserver" in window) {
      var observer = new MutationObserver(schedule);

      observer.observe(document.documentElement,{
        childList:true,
        subtree:true,
        attributes:true,
        attributeFilter:[
          "class",
          "style",
          "data-bk-glow-rescued"
        ]
      });
    }

    window.addEventListener("resize",schedule);

    setTimeout(apply,300);
    setTimeout(apply,800);
    setTimeout(apply,1500);
    setTimeout(apply,3500);
    setTimeout(apply,6500);
    setTimeout(apply,10500);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {once:true}
    );
  } else {
    start();
  }
})();

/* END BACCI KID BRAVE REPAIR PATCH 04 — FINAL
PRIMARY MUSIC STUDIO + NEW COMPACT GLOW JOURNEY
========================================================= */



/* =========================================================
BACCI KID BRAVE REPAIR PATCH 05
MUSIC STUDIO MICRO-NOTES + SOFT INTERACTION CHIME
Version: v56H
Date: 2026-07-23

SEARCH HEADER:
BACCI KID BRAVE REPAIR PATCH 05

INSTALLATION:
Keep Patches 01, 02, 03, and Final Patch 04 v56G.
Paste this small Patch 05 underneath Final Patch 04.

WHAT THIS PATCH DOES:
1. Keeps the permanent Music Studio button clean:
   🎧 Music Studio on desktop/iPad and 🎧 Music on phones.
2. Removes the permanent small music-note glyph from the button.
3. Releases only two translucent notes:
   - desktop: hover or keyboard focus
   - mobile/tablet touch: tap
   - Sound On: one brief visual note response
4. Plays a short, soft, original Web Audio chime:
   - when Music Studio is deliberately opened
   - when the main Brave Sound control is switched ON
5. Never autoplays.
6. Never loops.
7. Uses very low volume.
8. Disables decorative movement in Calm/reduced-motion mode.
9. Delays Music Studio navigation only about 240ms so the
   interaction chime can begin without feeling slow.

SAFE REMOVAL:
Delete this entire titled block only.
========================================================= */
(function(){
  if (window.BacciBraveRepairPatch05MusicMagicV56H) return;
  window.BacciBraveRepairPatch05MusicMagicV56H = true;

  var STUDIO_URL = "/pages/bacci-kid-sound-color-studio";
  var NAVIGATION_DELAY_MS = 240;

  /* =====================================================
     EASY EDIT SETTINGS 05
  ===================================================== */
  var ENABLE_MICRO_NOTES = true;
  var ENABLE_SOFT_CHIME = true;
  var CHIME_VOLUME = 0.022; /* intentionally very soft */

  /* =====================================================
     PATCH 05A — REMOVE PERMANENT NOTE + STYLE MICRO-NOTES
  ===================================================== */
  var style = document.createElement("style");
  style.id = "bk-repair-05-music-magic-style";
  style.textContent = [
    /* Final Patch 04 created a permanent note. Hide it now. */
    ".bk-music-note-final-v56g{display:none!important;}",

    ".bk-music-micro-note-v56h{",
      "position:fixed;",
      "z-index:2147483005;",
      "display:block;",
      "pointer-events:none;",
      "font-family:Georgia,'Times New Roman',serif;",
      "font-weight:900;",
      "line-height:1;",
      "color:rgba(121,91,255,.88);",
      "text-shadow:",
        "0 0 7px rgba(255,255,255,.98),",
        "0 0 14px rgba(0,198,198,.48),",
        "0 5px 12px rgba(77,43,151,.22);",
      "will-change:transform,opacity;",
      "animation:bkMusicMicroNoteV56H .86s cubic-bezier(.18,.78,.28,1) forwards;",
    "}",

    ".bk-music-micro-note-v56h.note-two{",
      "color:rgba(0,177,190,.82);",
    "}",

    "@keyframes bkMusicMicroNoteV56H{",
      "0%{",
        "transform:translate3d(0,5px,0) scale(.45) rotate(-10deg);",
        "opacity:0;",
      "}",
      "18%{opacity:.9;}",
      "72%{opacity:.68;}",
      "100%{",
        "transform:translate3d(var(--note-x),var(--note-y),0) scale(1.08) rotate(var(--note-r));",
        "opacity:0;",
      "}",
    "}",

    "@media(prefers-reduced-motion:reduce){",
      ".bk-music-micro-note-v56h{display:none!important;animation:none!important;}",
    "}",

    "@media print{",
      ".bk-music-micro-note-v56h{display:none!important;}",
    "}"
  ].join("");
  document.head.appendChild(style);

  function reducedMotion(){
    try{
      return (
        document.documentElement.getAttribute("data-bk-motion") === "calm" ||
        (
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches
        )
      );
    }catch(e){
      return false;
    }
  }

  function isTouchLayout(){
    try{
      return (
        window.matchMedia &&
        (
          window.matchMedia("(hover:none)").matches ||
          window.matchMedia("(pointer:coarse)").matches ||
          window.matchMedia("(max-width:767px)").matches
        )
      );
    }catch(e){
      return window.innerWidth < 768;
    }
  }

  function findMusicStudio(){
    return document.querySelector(
      ".bk-v55s-studio-dock.bk-music-final-v56g, .bk-v55s-studio-dock"
    );
  }

  function findSoundButton(){
    return document.getElementById("bk-sound");
  }

  /* =====================================================
     PATCH 05B — TWO-NOTE VISUAL MICRO-ANIMATION
  ===================================================== */
  var lastNoteBurst = 0;

  function releaseNotes(anchor, count){
    if (
      !ENABLE_MICRO_NOTES ||
      reducedMotion() ||
      !anchor
    ) return;

    var now = Date.now();
    if (now - lastNoteBurst < 520) return;
    lastNoteBurst = now;

    var rect = anchor.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var total = Math.max(1,Math.min(count || 2,2));
    var symbols = ["♪","♫"];

    for (var i=0; i<total; i++) {
      var note = document.createElement("span");
      note.className =
        "bk-music-micro-note-v56h" +
        (i === 1 ? " note-two" : "");
      note.textContent = symbols[i];
      note.setAttribute("aria-hidden","true");

      /*
        Notes rise mostly upward and slightly inward so they do not
        collide with the Top/End rail at the far right.
      */
      var startX =
        rect.left +
        rect.width * (i === 0 ? .34 : .58);

      var startY =
        rect.top +
        rect.height * .28 +
        i * 3;

      note.style.left = startX + "px";
      note.style.top = startY + "px";
      note.style.fontSize = (i === 0 ? 17 : 20) + "px";
      note.style.setProperty(
        "--note-x",
        (i === 0 ? "-15px" : "-4px")
      );
      note.style.setProperty(
        "--note-y",
        (i === 0 ? "-34px" : "-49px")
      );
      note.style.setProperty(
        "--note-r",
        (i === 0 ? "-8deg" : "10deg")
      );
      note.style.animationDelay = (i * .08) + "s";

      document.body.appendChild(note);

      setTimeout((function(el){
        return function(){
          if (el && el.parentNode) el.parentNode.removeChild(el);
        };
      })(note),1100);
    }
  }

  /* =====================================================
     PATCH 05C — SHORT ORIGINAL SOFT CHIME
     Web Audio only starts after a deliberate user action.
  ===================================================== */
  var audioContext = null;
  var lastChime = 0;

  function softChime(){
    if (!ENABLE_SOFT_CHIME) return;

    var nowMs = Date.now();
    if (nowMs - lastChime < 420) return;
    lastChime = nowMs;

    try{
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;

      audioContext = audioContext || new AC();

      if (audioContext.state === "suspended") {
        audioContext.resume().catch(function(){});
      }

      var start = audioContext.currentTime + .01;
      var master = audioContext.createGain();
      master.gain.setValueAtTime(.0001,start);
      master.gain.exponentialRampToValueAtTime(
        Math.max(.006,CHIME_VOLUME),
        start + .035
      );
      master.gain.exponentialRampToValueAtTime(
        .0001,
        start + .62
      );
      master.connect(audioContext.destination);

      /*
        Three soft bell-like notes:
        E5, A5, C#6. Short, uplifting, and original.
      */
      var notes = [
        {frequency:659.25, delay:0,    level:1},
        {frequency:880.00, delay:.075, level:.74},
        {frequency:1108.73,delay:.15,  level:.48}
      ];

      notes.forEach(function(n){
        var osc = audioContext.createOscillator();
        var gain = audioContext.createGain();

        osc.type = "sine";
        osc.frequency.setValueAtTime(
          n.frequency,
          start + n.delay
        );

        gain.gain.setValueAtTime(
          .0001,
          start + n.delay
        );
        gain.gain.exponentialRampToValueAtTime(
          Math.max(.003,CHIME_VOLUME * n.level),
          start + n.delay + .025
        );
        gain.gain.exponentialRampToValueAtTime(
          .0001,
          start + n.delay + .43
        );

        osc.connect(gain);
        gain.connect(master);

        osc.start(start + n.delay);
        osc.stop(start + n.delay + .47);
      });
    }catch(e){}
  }

  /* =====================================================
     PATCH 05D — MUSIC STUDIO INTERACTIONS
  ===================================================== */
  function wireMusicStudio(){
    var music = findMusicStudio();
    if (!music || music.dataset.bkMusicMagicV56H === "true") return;

    music.dataset.bkMusicMagicV56H = "true";

    /* Desktop hover/focus visual notes. */
    music.addEventListener("mouseenter",function(){
      if (!isTouchLayout()) releaseNotes(music,2);
    });

    music.addEventListener("focus",function(){
      if (!isTouchLayout()) releaseNotes(music,2);
    });

    /*
      Capture phase runs before the original navigation handler.
      This lets the soft chime begin, then opens Music Studio.
    */
    music.addEventListener("click",function(e){
      e.preventDefault();
      e.stopImmediatePropagation();

      releaseNotes(music,2);
      softChime();

      setTimeout(function(){
        window.location.href = STUDIO_URL;
      },NAVIGATION_DELAY_MS);
    },true);

    /*
      Touch feedback starts immediately on pointer-down, while the
      actual navigation still occurs on click.
    */
    music.addEventListener("pointerdown",function(e){
      if (
        e.pointerType === "touch" ||
        e.pointerType === "pen" ||
        isTouchLayout()
      ) {
        releaseNotes(music,2);
      }
    },{passive:true});
  }

  /* =====================================================
     PATCH 05E — SOUND ON RESPONSE
     Existing Brave code changes aria-pressed before this later
     listener runs. Chime only when Sound has just become ON.
  ===================================================== */
  function wireSoundToggle(){
    var sound = findSoundButton();
    if (!sound || sound.dataset.bkSoundMagicV56H === "true") return;

    sound.dataset.bkSoundMagicV56H = "true";

    sound.addEventListener("click",function(){
      setTimeout(function(){
        var on =
          sound.getAttribute("aria-pressed") === "true";

        if (!on) return;

        releaseNotes(sound,1);
        softChime();
      },0);
    });
  }

  /* =====================================================
     PATCH 05F — APPLY + REDRAW PROTECTION
  ===================================================== */
  var queued = false;

  function apply(){
    wireMusicStudio();
    wireSoundToggle();
  }

  function schedule(){
    if (queued) return;
    queued = true;

    requestAnimationFrame(function(){
      queued = false;
      apply();
    });
  }

  function start(){
    apply();

    if ("MutationObserver" in window) {
      var observer = new MutationObserver(schedule);

      observer.observe(document.documentElement,{
        childList:true,
        subtree:true
      });
    }

    setTimeout(apply,400);
    setTimeout(apply,1200);
    setTimeout(apply,3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {once:true}
    );
  } else {
    start();
  }
})();

/* END BACCI KID BRAVE REPAIR PATCH 05
MUSIC STUDIO MICRO-NOTES + SOFT INTERACTION CHIME
========================================================= */



/* =========================================================
BACCI KID BRAVE REPAIR PATCH 06
COLORING EXPERIENCE PRIORITY LOCK + INLINE WORLDGLOW HIDE
Version: v56I
Date: 2026-07-23

SEARCH HEADER:
BACCI KID BRAVE REPAIR PATCH 06

INSTALLATION:
Keep Patches 01 through 05.
Paste this Patch 06 underneath Patch 05 at the absolute bottom
of Assets/bacci-brave.js.

WHY THIS PATCH EXISTS:
The v49 Living Book code adds the class bk-v49-story-mode when
the storybook opens. The existing CSS then collapses the entire
.bk-stage, which contains the coloring canvas and Paint Set.
That is why the core coloring experience disappears after a
visitor scrolls down to the book and then returns upward.

WHAT THIS PATCH DOES:
1. Permanently prevents the core .bk-stage from collapsing.
2. Keeps the canvas, Paint Set, palette tabs, swatches, textures,
   finishes, undo, save, print, preview, and museum tools intact.
3. Removes bk-v49-story-mode whenever an older script re-adds it.
4. Hides the obsolete "Coloring Studio is tucked away" control.
5. Hides ONLY the inline vocabulary card section:
   #bk-v47-wordlab / .bk-v47-wordlab.
6. Does not delete that vocabulary section or its data.
7. Redirects the top WorldGlow Lab pill to /pages/worldglow-lab,
   so the pill stays useful after the inline section is hidden.
8. Protects the coloring stage from the older broad
   bk-v55t-hidden class.
9. Runs a non-destructive integrity audit for the essential
   coloring controls and exposes the result in:
   window.BacciBraveColorPriorityAuditV56I
10. Does not clear canvas art, history, localStorage, journal
    entries, badges, museum saves, or any previous repair.

SAFE REMOVAL:
Delete this entire titled block only.
========================================================= */
(function(){
  if (window.BacciBraveRepairPatch06ColorPriorityV56I) return;
  window.BacciBraveRepairPatch06ColorPriorityV56I = true;

  var WORLDGLOW_URL = "/pages/worldglow-lab";

  /* =====================================================
     PATCH 06A — CSS PRIORITY LOCK
     Later CSS wins over the older v49 collapse rule.
  ===================================================== */
  var style = document.createElement("style");
  style.id = "bk-repair-06-color-priority-style";
  style.textContent = [
    "#bk-hx .bk-stage,",
    "#bk-hx.bk-v49-story-mode .bk-stage{",
      "max-height:none!important;",
      "height:auto!important;",
      "min-height:0!important;",
      "opacity:1!important;",
      "visibility:visible!important;",
      "overflow:visible!important;",
      "margin-top:16px!important;",
      "transform:none!important;",
      "pointer-events:auto!important;",
      "transition:none!important;",
    "}",

    "@media(min-width:1000px){",
      "#bk-hx .bk-stage,",
      "#bk-hx.bk-v49-story-mode .bk-stage{",
        "display:grid!important;",
        "grid-template-columns:minmax(0,1fr) 360px!important;",
        "gap:22px!important;",
        "align-items:start!important;",
      "}",
    "}",

    "@media(max-width:999px){",
      "#bk-hx .bk-stage,",
      "#bk-hx.bk-v49-story-mode .bk-stage{",
        "display:block!important;",
        "margin-top:10px!important;",
      "}",
    "}",

    "#bk-hx .bk-v49-color-return,",
    "#bk-hx.bk-v49-story-mode .bk-v49-color-return{",
      "display:none!important;",
      "visibility:hidden!important;",
      "pointer-events:none!important;",
    "}",

    "#bk-hx #bk-v47-wordlab,",
    "#bk-hx .bk-v47-wordlab{",
      "display:none!important;",
      "visibility:hidden!important;",
      "opacity:0!important;",
      "height:0!important;",
      "max-height:0!important;",
      "min-height:0!important;",
      "margin:0!important;",
      "padding:0!important;",
      "border:0!important;",
      "overflow:hidden!important;",
      "pointer-events:none!important;",
    "}",

    "#bk-hx .bk-stage.bk-v55t-hidden{",
      "visibility:visible!important;",
      "opacity:1!important;",
    "}",

    "@media(min-width:1000px){",
      "#bk-hx .bk-stage.bk-v55t-hidden{display:grid!important;}",
    "}",

    "@media(max-width:999px){",
      "#bk-hx .bk-stage.bk-v55t-hidden{display:block!important;}",
    "}"
  ].join("");
  document.head.appendChild(style);

  function by(id){
    return document.getElementById(id);
  }

  function getRoot(){
    return by("bk-hx");
  }

  /* =====================================================
     PATCH 06B — PROTECT ESSENTIAL COLORING NODES
  ===================================================== */
  function revealNode(el){
    if (!el) return;

    if (el.classList.contains("bk-v55t-hidden")) {
      el.classList.remove("bk-v55t-hidden");
    }

    if (el.hasAttribute("hidden")) {
      el.removeAttribute("hidden");
    }

    if (el.getAttribute("aria-hidden") === "true") {
      el.setAttribute("aria-hidden","false");
    }
  }

  function protectColoringNodes(){
    var r = getRoot();
    if (!r) return;

    var stage = r.querySelector(".bk-stage");

    [
      stage,
      stage && stage.firstElementChild,
      r.querySelector(".bk-paper"),
      r.querySelector(".bk-canvas-wrap"),
      r.querySelector(".bk-previewbar"),
      r.querySelector(".bk-drawer"),
      by("bk-canvas"),
      by("bk-tabs"),
      by("bk-swatches"),
      by("bk-texs"),
      by("bk-fins")
    ].forEach(revealNode);

    r.setAttribute("data-bk-color-priority","locked");
  }

  /* =====================================================
     PATCH 06C — DISABLE THE OLD AUTO-COLLAPSE STATE
  ===================================================== */
  function removeStoryCollapseState(){
    var r = getRoot();
    if (!r) return;

    if (r.classList.contains("bk-v49-story-mode")) {
      r.classList.remove("bk-v49-story-mode");
    }
  }

  /* =====================================================
     PATCH 06D — HIDE ONLY THE INLINE WORLDGLOW CARD SECTION
  ===================================================== */
  function hideInlineWorldGlow(){
    var lab = by("bk-v47-wordlab") ||
      document.querySelector("#bk-hx .bk-v47-wordlab");

    if (!lab) return;

    if (!lab.hidden) {
      lab.hidden = true;
    }

    lab.setAttribute("aria-hidden","true");
    lab.setAttribute("data-bk-inline-worldglow","hidden");
    lab.style.setProperty("display","none","important");
  }

  /* =====================================================
     PATCH 06E — KEEP THE TOP WORLDGLOW PILL FUNCTIONAL
  ===================================================== */
  function wireWorldGlowPill(){
    var button = by("bk-v47-word-btn");
    if (!button || button.dataset.bkWorldGlowRouteV56I === "true") {
      return;
    }

    button.dataset.bkWorldGlowRouteV56I = "true";
    button.setAttribute("aria-label","Open WorldGlow Lab");

    button.addEventListener("click",function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      window.location.href = WORLDGLOW_URL;
    },true);
  }

  /* =====================================================
     PATCH 06F — NON-DESTRUCTIVE COLORING INTEGRITY AUDIT
  ===================================================== */
  function runAudit(){
    var r = getRoot();

    var required = [
      ["root","bk-hx"],
      ["coloring stage",".bk-stage"],
      ["canvas","bk-canvas"],
      ["Paint Set",".bk-drawer"],
      ["palette tabs","bk-tabs"],
      ["color swatches","bk-swatches"],
      ["textures","bk-texs"],
      ["finishes","bk-fins"],
      ["undo","bk-undo"],
      ["start over","bk-clear"],
      ["save art","bk-save"],
      ["preview","bk-preview"],
      ["print","bk-print"],
      ["museum save","bk-museum-add"]
    ];

    var checks = required.map(function(item){
      var el = item[1].charAt(0) === "."
        ? (r && r.querySelector(item[1]))
        : by(item[1]);

      return {
        name:item[0],
        selector:item[1],
        present:!!el
      };
    });

    var stage = r && r.querySelector(".bk-stage");
    var lab = by("bk-v47-wordlab");
    var missing = checks.filter(function(check){
      return !check.present;
    });

    var audit = {
      timestamp:new Date().toISOString(),
      pass:missing.length === 0,
      missing:missing,
      checks:checks,
      coloringStagePresent:!!stage,
      storyCollapseClassActive:!!(
        r && r.classList.contains("bk-v49-story-mode")
      ),
      inlineWorldGlowHidden:!!(
        !lab ||
        lab.hidden ||
        window.getComputedStyle(lab).display === "none"
      ),
      note:
        "This audit does not alter art, canvas operations, localStorage, " +
        "journal text, badges, museum saves, or purchase links."
    };

    window.BacciBraveColorPriorityAuditV56I = audit;

    try{
      if (audit.pass) {
        console.info(
          "[Bacci Brave Patch 06] Coloring integrity audit passed.",
          audit
        );
      } else {
        console.warn(
          "[Bacci Brave Patch 06] Missing coloring controls:",
          audit
        );
      }
    }catch(e){}

    return audit;
  }

  /* =====================================================
     PATCH 06G — APPLY + PROTECT AGAINST OLDER REDRAWS
  ===================================================== */
  var queued = false;

  function enforce(){
    removeStoryCollapseState();
    protectColoringNodes();
    hideInlineWorldGlow();
    wireWorldGlowPill();
  }

  function schedule(){
    if (queued) return;
    queued = true;

    requestAnimationFrame(function(){
      queued = false;
      enforce();
    });
  }

  function start(){
    enforce();

    var r = getRoot();

    if (r && "MutationObserver" in window) {
      var observer = new MutationObserver(schedule);

      observer.observe(r,{
        childList:true,
        subtree:true,
        attributes:true,
        attributeFilter:["class","hidden","aria-hidden"]
      });
    }

    window.addEventListener("pageshow",schedule);
    window.addEventListener("resize",schedule);

    setTimeout(enforce,250);
    setTimeout(enforce,700);
    setTimeout(enforce,1500);
    setTimeout(enforce,3500);
    setTimeout(runAudit,1800);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {once:true}
    );
  } else {
    start();
  }
})();

/* END BACCI KID BRAVE REPAIR PATCH 06
COLORING EXPERIENCE PRIORITY LOCK + INLINE WORLDGLOW HIDE
========================================================= */




/* =========================================================
BACCI KID BRAVE REPAIR PATCH 07
COMPACT MOOD PILL + RESPONSIVE MOOD SHEET + BACCI HUG
Version: v56J
Date: 2026-07-23

SEARCH HEADER:
BACCI KID BRAVE REPAIR PATCH 07

INSTALLATION:
Keep Patches 01 through 06.
Paste this Patch 07 underneath Patch 06 at the absolute bottom
of Assets/bacci-brave.js.

WHY THIS PATCH EXISTS:
The coloring experience is the primary purpose of the page.
The completed full-width mood summary currently forms a visual
barrier immediately above the coloring canvas. This patch moves
the optional mood check into the utility-control row while
preserving the existing mood engine and session storage.

WHAT THIS PATCH DOES:
1. Adds a compact Mood pill before the Sound control.
2. Before selection: "💗 Mood check".
3. After selection on desktop: "💗 Mood: Bright · Change".
4. On phones: compact labels such as "💗 Bright".
5. Opens a polished anchored popover on desktop.
6. Opens a centered touch sheet on iPad.
7. Opens a bottom sheet on phones.
8. Keeps the coloring canvas stationary when mood opens.
9. Hides the original full-width mood card and summary from view.
10. Proxies choices into the existing mood buttons and v46 logic.
11. Uses the same session key: bk_v46_brave_mood_check.
12. Shows a brief supportive toast after confirmation.
13. Gives every mood a Bacci response:
    - Bright: Bacci Spark
    - Okay: Bacci Spark
    - Low: Bacci Hug
    - Heavy: Bacci Hug
    - Not sure: Bacci Pause
14. Offers Comfort Break for Low, Heavy, and Not sure.
15. Does not diagnose, assess, promise outcomes, or replace care.
16. Does not alter the coloring engine, Paint Set, canvas state,
    storybook, WorldGlow routing, Hype, Music Studio, or prior patches.

DESIGN DECISION:
There is NOT a second separate lightbox after each mood. The Bacci
support moment lives inside the mood sheet. This avoids modal-on-modal
clutter and keeps mobile interaction controlled.

SAFE REMOVAL:
Delete this entire titled block only.
========================================================= */
(function(){
  if (window.BacciBraveRepairPatch07MoodV56J) return;
  window.BacciBraveRepairPatch07MoodV56J = true;

  var STORE_KEY = "bk_v46_brave_mood_check";
  var root = document.getElementById("bk-hx");
  if (!root) return;

  var FALLBACKS = {
    checkin:
      "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Can_you_please_share_your_feelings_03de94c8-25ee-4fb7-8a50-95ed7329eb1b.png?v=1781225458",
    mvp:
      "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Bacci_0267ead1-4c48-4782-9276-7dc98f8c204b.png?v=1760395200",
    excited:
      "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/1_5656d832-41fc-4366-8abe-4aae6ec1bb6a.png?v=1771114552",
    grateful:
      "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/grateful_2_1.png?v=1772506520",
    mindful:
      "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Mindfulness_breathing_only_1.png?v=1772494924"
  };

  var DEFAULT_OPTIONS = [
    {
      emoji:"🌞",
      label:"Bright",
      reply:"Bright is lovely. Let's pour some of that into the picture."
    },
    {
      emoji:"🌤️",
      label:"Okay",
      reply:"Okay is a real and fine place to be. Coloring can keep it company."
    },
    {
      emoji:"🌥️",
      label:"Low",
      reply:"Thank you for noticing that. Go gentle. One soft color at a time is plenty."
    },
    {
      emoji:"🌧️",
      label:"Heavy",
      reply:"That sounds like a lot to carry. There is no goal here. Just color, or just rest. The door stays open."
    },
    {
      emoji:"🤔",
      label:"Not sure",
      reply:"Not sure is allowed. Maybe a color will help you find the word. Maybe not. Either way is okay."
    }
  ];

  var SUPPORT = {
    "Bright":{
      kind:"Bacci Spark",
      title:"Let that brightness join the page.",
      copy:"You can carry this bright moment into one color, one shape, or one playful choice.",
      image:"excited",
      comfort:false
    },
    "Okay":{
      kind:"Bacci Spark",
      title:"Okay is a real place to begin.",
      copy:"Nothing has to become bigger or brighter. You can start exactly where you are.",
      image:"mvp",
      comfort:false
    },
    "Low":{
      kind:"Bacci Hug",
      title:"One soft color is enough.",
      copy:"You noticed your energy feels low. You can color gently, pause, or simply stay here for a moment.",
      image:"grateful",
      comfort:true
    },
    "Heavy":{
      kind:"Bacci Hug",
      title:"There is no goal you have to reach.",
      copy:"That sounds like a lot to carry. You can color, rest, drink water, or open a comfort break. This page can wait.",
      image:"mindful",
      comfort:true
    },
    "Not sure":{
      kind:"Bacci Pause",
      title:"Not sure is allowed.",
      copy:"A color may help you find a word, or it may not. You are still welcome to explore without deciding.",
      image:"checkin",
      comfort:true
    }
  };

  var selectedLabel = "";
  var selectedReply = "";
  var lastFocused = null;
  var bodyOverflow = "";
  var observerQueued = false;

  function by(id){
    return document.getElementById(id);
  }

  function qs(selector, scope){
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope){
    return Array.prototype.slice.call(
      (scope || document).querySelectorAll(selector)
    );
  }

  function options(){
    try{
      if (
        window.BK_HX_CONFIG &&
        BK_HX_CONFIG.MOOD &&
        Array.isArray(BK_HX_CONFIG.MOOD.options) &&
        BK_HX_CONFIG.MOOD.options.length
      ) {
        return BK_HX_CONFIG.MOOD.options;
      }
    }catch(e){}
    return DEFAULT_OPTIONS;
  }

  function configAsset(key){
    try{
      if (key === "checkin") {
        return (
          BK_HX_CONFIG.ICONS &&
          BK_HX_CONFIG.ICONS.checkin
        ) || FALLBACKS.checkin;
      }
      if (key === "mindful") {
        return (
          BK_HX_CONFIG.BREAK &&
          BK_HX_CONFIG.BREAK.img
        ) || FALLBACKS.mindful;
      }
      if (
        BK_HX_CONFIG.HYPE &&
        Array.isArray(BK_HX_CONFIG.HYPE.characters)
      ) {
        var names = {
          excited:"Excited Bacci",
          grateful:"Grateful Bacci",
          mvp:"MVP Bacci"
        };
        var wanted = names[key];
        var found = BK_HX_CONFIG.HYPE.characters.filter(function(item){
          return item && item.name === wanted && item.url;
        })[0];
        if (found) return found.url;
      }
    }catch(e){}
    return FALLBACKS[key] || FALLBACKS.mvp;
  }

  function readStoredMood(){
    try{
      var value = JSON.parse(
        sessionStorage.getItem(STORE_KEY) || "null"
      );
      return value && value.label ? value : null;
    }catch(e){
      return null;
    }
  }

  function writeStoredMood(label, msg){
    try{
      sessionStorage.setItem(
        STORE_KEY,
        JSON.stringify({
          label:label,
          msg:msg
        })
      );
    }catch(e){}
  }

  function normalizedLabel(label){
    label = (label || "").replace(/\s+/g," ").trim();
    if (/skipped/i.test(label)) return "Skipped";
    return label;
  }

  function originalMoodButton(index){
    return qsa("#bk-moodrow .bk-moodbtn")[index] || null;
  }

  function clickOriginalChoice(index){
    var button = originalMoodButton(index);
    if (button) button.click();
  }

  function originalGot(){
    return qs("#bk-mood .bk-mood-v46-got");
  }

  function originalSkip(){
    return qs("#bk-mood .bk-mood-v46-skip");
  }

  function reducedMotion(){
    try{
      return (
        document.documentElement.getAttribute("data-bk-motion") === "calm" ||
        (
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches
        )
      );
    }catch(e){
      return false;
    }
  }

  /* =====================================================
     PATCH 07A — STYLES
  ===================================================== */
  var style = document.createElement("style");
  style.id = "bk-repair-07-mood-style";
  style.textContent = [
    /* Hide the legacy full-width mood UI, but keep it in the DOM. */
    "#bk-hx #bk-mood{",
      "display:none!important;",
      "visibility:hidden!important;",
      "position:absolute!important;",
      "left:-10000px!important;",
      "top:auto!important;",
      "width:1px!important;",
      "height:1px!important;",
      "margin:0!important;",
      "padding:0!important;",
      "overflow:hidden!important;",
      "pointer-events:none!important;",
    "}",

    /* Compact utility pill. */
    "#bk-mood-pill-v56j{",
      "max-width:190px;",
      "display:inline-flex;",
      "align-items:center;",
      "justify-content:center;",
      "gap:5px;",
      "white-space:nowrap;",
    "}",
    "#bk-mood-pill-v56j .bk-mood-pill-mobile-v56j{display:none;}",
    "#bk-mood-pill-v56j .bk-mood-change-v56j{",
      "font-size:.82em;",
      "color:#00807e;",
      "font-weight:800;",
    "}",
    "#bk-mood-pill-v56j[data-has-mood='true']{",
      "background:linear-gradient(135deg,#fff6fc,#fff 58%,#eaffff);",
      "border-color:rgba(255,111,191,.42);",
      "box-shadow:0 5px 14px rgba(255,111,191,.16);",
    "}",
    "#bk-mood-pill-v56j[aria-expanded='true']{",
      "background:linear-gradient(90deg,#ff6fbf,#a66bff)!important;",
      "color:#fff!important;",
      "border-color:transparent!important;",
    "}",
    "#bk-mood-pill-v56j[aria-expanded='true'] .bk-mood-change-v56j{",
      "color:#fff!important;",
    "}",

    /* Overlay and sheet. */
    "#bk-mood-overlay-v56j{",
      "position:fixed;",
      "inset:0;",
      "z-index:2147483300;",
      "display:none;",
      "background:rgba(38,25,70,.18);",
      "backdrop-filter:blur(3px);",
      "-webkit-backdrop-filter:blur(3px);",
    "}",
    "#bk-mood-overlay-v56j.open{display:block;}",

    "#bk-mood-sheet-v56j{",
      "--mood-left:50%;",
      "--mood-top:120px;",
      "position:fixed;",
      "left:var(--mood-left);",
      "top:var(--mood-top);",
      "width:min(580px,calc(100vw - 32px));",
      "max-height:min(78vh,720px);",
      "overflow:auto;",
      "border:2px solid rgba(166,107,255,.38);",
      "border-radius:26px;",
      "padding:20px;",
      "background:",
        "radial-gradient(circle at 12% 8%,rgba(255,214,242,.55),transparent 36%),",
        "radial-gradient(circle at 90% 10%,rgba(207,251,239,.55),transparent 35%),",
        "linear-gradient(150deg,#fff,#fff7fc 58%,#efffff);",
      "box-shadow:0 28px 80px rgba(65,38,120,.34),0 0 0 6px rgba(255,255,255,.42);",
      "transform:translateX(-50%);",
      "color:#3a2e5c;",
      "font-family:Quicksand,system-ui,sans-serif;",
    "}",

    "#bk-mood-sheet-v56j .bk-mood-sheet-head-v56j{",
      "display:flex;",
      "align-items:flex-start;",
      "justify-content:space-between;",
      "gap:14px;",
      "margin-bottom:14px;",
    "}",
    "#bk-mood-sheet-v56j .bk-mood-kicker-v56j{",
      "display:inline-block;",
      "font-family:Fredoka,system-ui,sans-serif;",
      "font-size:12px;",
      "font-weight:800;",
      "letter-spacing:1.3px;",
      "text-transform:uppercase;",
      "color:#ff4fa0;",
    "}",
    "#bk-mood-sheet-v56j h2{",
      "margin:3px 0 4px;",
      "font-family:Fredoka,system-ui,sans-serif;",
      "font-size:clamp(25px,3vw,36px);",
      "line-height:1.05;",
      "background:linear-gradient(90deg,#ff4fa0,#8b68f5,#00aeb8);",
      "-webkit-background-clip:text;",
      "background-clip:text;",
      "color:transparent;",
    "}",
    "#bk-mood-sheet-v56j .bk-mood-intro-v56j{",
      "margin:0;",
      "font-size:15px;",
      "line-height:1.45;",
      "color:#62538a;",
      "font-weight:700;",
    "}",
    "#bk-mood-close-v56j{",
      "flex:0 0 auto;",
      "width:40px;",
      "height:40px;",
      "display:grid;",
      "place-items:center;",
      "border:0;",
      "border-radius:50%;",
      "cursor:pointer;",
      "color:#fff;",
      "font-size:20px;",
      "font-weight:900;",
      "background:linear-gradient(135deg,#8b68f5,#ff5bb4);",
      "box-shadow:0 8px 20px rgba(125,76,210,.3);",
    "}",

    "#bk-mood-options-v56j{",
      "display:grid;",
      "grid-template-columns:repeat(5,minmax(0,1fr));",
      "gap:9px;",
      "margin-top:16px;",
    "}",
    "#bk-mood-options-v56j button{",
      "min-height:92px;",
      "display:grid;",
      "place-items:center;",
      "align-content:center;",
      "gap:3px;",
      "padding:10px 7px;",
      "border:2px solid rgba(166,107,255,.22);",
      "border-radius:18px;",
      "cursor:pointer;",
      "background:rgba(255,255,255,.9);",
      "color:#3a2e5c;",
      "font-family:Fredoka,system-ui,sans-serif;",
      "font-weight:800;",
      "box-shadow:0 7px 18px rgba(88,58,150,.09);",
      "transition:transform .15s ease,box-shadow .15s ease,border-color .15s ease;",
    "}",
    "#bk-mood-options-v56j button:hover,",
    "#bk-mood-options-v56j button:focus-visible{",
      "transform:translateY(-2px);",
      "box-shadow:0 11px 24px rgba(88,58,150,.16);",
      "outline:3px solid rgba(255,255,255,.8);",
    "}",
    "#bk-mood-options-v56j button[aria-pressed='true']{",
      "border-color:transparent;",
      "background:linear-gradient(135deg,#7dfcf4,#8edbe8 45%,#d9c6ff);",
      "box-shadow:0 7px 0 #53aeb6,0 14px 28px rgba(83,174,182,.2);",
      "color:#163b4c;",
    "}",
    "#bk-mood-options-v56j .emoji{",
      "font-size:29px;",
      "line-height:1;",
    "}",
    "#bk-mood-options-v56j .label{",
      "font-size:13px;",
      "line-height:1.1;",
    "}",

    /* Bacci response card. */
    "#bk-mood-support-v56j{",
      "display:none;",
      "grid-template-columns:92px 1fr;",
      "gap:14px;",
      "align-items:center;",
      "margin-top:16px;",
      "padding:14px;",
      "border:2px solid rgba(255,197,66,.52);",
      "border-radius:20px;",
      "background:linear-gradient(135deg,#fffaf0,#fff 58%,#efffff);",
      "box-shadow:0 12px 28px rgba(122,80,180,.11);",
    "}",
    "#bk-mood-support-v56j.show{display:grid;}",
    "#bk-mood-support-v56j.is-hug{",
      "border-color:rgba(255,111,191,.52);",
      "background:linear-gradient(135deg,#fff1f8,#fff 55%,#f0fffb);",
      "box-shadow:0 14px 34px rgba(255,111,191,.16);",
    "}",
    "#bk-mood-support-v56j img{",
      "width:92px;",
      "height:92px;",
      "object-fit:contain;",
      "filter:drop-shadow(0 9px 16px rgba(115,72,175,.2));",
    "}",
    "#bk-mood-support-v56j .kind{",
      "font-family:Fredoka,system-ui,sans-serif;",
      "font-size:11px;",
      "font-weight:900;",
      "letter-spacing:1.2px;",
      "text-transform:uppercase;",
      "color:#ff4fa0;",
    "}",
    "#bk-mood-support-v56j h3{",
      "margin:3px 0 4px;",
      "font-family:Fredoka,system-ui,sans-serif;",
      "font-size:19px;",
      "line-height:1.15;",
      "color:#4e377b;",
    "}",
    "#bk-mood-support-v56j p{",
      "margin:0;",
      "font-size:13.5px;",
      "line-height:1.45;",
      "font-weight:700;",
      "color:#66578b;",
    "}",
    "#bk-mood-comfort-v56j{",
      "display:none;",
      "margin-top:9px;",
      "border:0;",
      "border-radius:999px;",
      "padding:8px 13px;",
      "cursor:pointer;",
      "font-family:Fredoka,system-ui,sans-serif;",
      "font-size:12px;",
      "font-weight:850;",
      "color:#073c3c;",
      "background:linear-gradient(135deg,#8ffcf6,#00c6c6);",
      "box-shadow:0 4px 0 #00807e;",
    "}",
    "#bk-mood-comfort-v56j.show{display:inline-flex;}",

    "#bk-mood-actions-v56j{",
      "display:flex;",
      "justify-content:flex-end;",
      "gap:9px;",
      "flex-wrap:wrap;",
      "margin-top:17px;",
    "}",
    "#bk-mood-actions-v56j button{",
      "border:0;",
      "border-radius:999px;",
      "padding:11px 18px;",
      "cursor:pointer;",
      "font-family:Fredoka,system-ui,sans-serif;",
      "font-size:13px;",
      "font-weight:900;",
    "}",
    "#bk-mood-skip-v56j{",
      "color:#755600;",
      "background:linear-gradient(135deg,#fff8df,#ffe08a);",
      "box-shadow:0 5px 0 #c9971f;",
    "}",
    "#bk-mood-save-v56j{",
      "color:#073c3c;",
      "background:linear-gradient(135deg,#8ffcf6,#00c6c6);",
      "box-shadow:0 5px 0 #00807e;",
    "}",
    "#bk-mood-save-v56j[disabled]{",
      "opacity:.42;",
      "cursor:not-allowed;",
      "box-shadow:none;",
    "}",

    /* Temporary toast. */
    "#bk-mood-toast-v56j{",
      "position:fixed;",
      "left:50%;",
      "top:max(18px,env(safe-area-inset-top));",
      "z-index:2147483500;",
      "max-width:min(440px,calc(100vw - 28px));",
      "padding:11px 17px;",
      "border:2px solid rgba(255,255,255,.9);",
      "border-radius:999px;",
      "background:linear-gradient(135deg,#fff,#fff1f8 55%,#eaffff);",
      "box-shadow:0 14px 38px rgba(90,55,150,.28);",
      "font-family:Fredoka,system-ui,sans-serif;",
      "font-size:13px;",
      "font-weight:850;",
      "color:#59417f;",
      "text-align:center;",
      "pointer-events:none;",
      "opacity:0;",
      "transform:translate(-50%,-12px) scale(.96);",
      "transition:opacity .22s ease,transform .25s ease;",
    "}",
    "#bk-mood-toast-v56j.show{",
      "opacity:1;",
      "transform:translate(-50%,0) scale(1);",
    "}",

    /* iPad / tablet: centered touch sheet. */
    "@media(min-width:768px) and (max-width:1100px){",
      "#bk-mood-sheet-v56j{",
        "left:50%!important;",
        "top:50%!important;",
        "width:min(650px,calc(100vw - 42px));",
        "max-height:min(82vh,760px);",
        "transform:translate(-50%,-50%);",
      "}",
      "#bk-mood-options-v56j{grid-template-columns:repeat(5,minmax(100px,1fr));overflow-x:auto;padding-bottom:5px;}",
    "}",

    /* Phone: horizontal utility ribbon + bottom sheet. */
    "@media(max-width:767px){",
      "#bk-hx .bk-switches{",
        "justify-content:flex-start!important;",
        "flex-wrap:nowrap!important;",
        "overflow-x:auto!important;",
        "overscroll-behavior-x:contain;",
        "scroll-snap-type:x proximity;",
        "-webkit-overflow-scrolling:touch;",
        "padding:4px 3px 9px;",
        "scrollbar-width:thin;",
      "}",
      "#bk-hx .bk-switches .bk-switch{",
        "flex:0 0 auto;",
        "scroll-snap-align:start;",
      "}",
      "#bk-mood-pill-v56j{max-width:132px;}",
      "#bk-mood-pill-v56j .bk-mood-pill-desktop-v56j{display:none;}",
      "#bk-mood-pill-v56j .bk-mood-pill-mobile-v56j{display:inline;}",
      "#bk-mood-pill-v56j .bk-mood-change-v56j{display:none;}",

      "#bk-mood-overlay-v56j{background:rgba(38,25,70,.3);}",
      "#bk-mood-sheet-v56j{",
        "left:0!important;",
        "right:0!important;",
        "top:auto!important;",
        "bottom:0!important;",
        "width:100%!important;",
        "max-height:min(86vh,760px);",
        "border-radius:28px 28px 0 0;",
        "padding:18px 16px calc(22px + env(safe-area-inset-bottom));",
        "transform:none!important;",
      "}",
      "#bk-mood-options-v56j{",
        "grid-template-columns:repeat(5,minmax(88px,1fr));",
        "overflow-x:auto;",
        "padding:2px 2px 9px;",
        "scroll-snap-type:x mandatory;",
      "}",
      "#bk-mood-options-v56j button{",
        "scroll-snap-align:center;",
        "min-height:86px;",
      "}",
      "#bk-mood-support-v56j{",
        "grid-template-columns:72px 1fr;",
        "gap:11px;",
        "padding:12px;",
      "}",
      "#bk-mood-support-v56j img{width:72px;height:72px;}",
      "#bk-mood-actions-v56j{",
        "display:grid;",
        "grid-template-columns:1fr 1fr;",
      "}",
      "#bk-mood-actions-v56j button{width:100%;padding:12px 10px;}",
    "}",

    "@media(max-width:390px){",
      "#bk-mood-sheet-v56j{padding-left:12px;padding-right:12px;}",
      "#bk-mood-support-v56j{grid-template-columns:60px 1fr;}",
      "#bk-mood-support-v56j img{width:60px;height:60px;}",
    "}",

    "@media(prefers-reduced-motion:reduce){",
      "#bk-mood-options-v56j button,",
      "#bk-mood-toast-v56j{transition:none!important;}",
    "}",

    "@media print{",
      "#bk-mood-overlay-v56j,",
      "#bk-mood-toast-v56j{display:none!important;}",
    "}"
  ].join("");
  document.head.appendChild(style);

  /* =====================================================
     PATCH 07B — BUILD THE PILL, SHEET, AND TOAST
  ===================================================== */
  function buildPill(){
    var existing = by("bk-mood-pill-v56j");
    if (existing) return existing;

    var switches = qs("#bk-hx .bk-switches");
    if (!switches) return null;

    var pill = document.createElement("button");
    pill.type = "button";
    pill.id = "bk-mood-pill-v56j";
    pill.className = "bk-switch";
    pill.setAttribute("aria-haspopup","dialog");
    pill.setAttribute("aria-controls","bk-mood-sheet-v56j");
    pill.setAttribute("aria-expanded","false");
    pill.dataset.hasMood = "false";

    switches.insertBefore(pill,switches.firstChild);
    pill.addEventListener("click",openMoodSheet);

    return pill;
  }

  function buildOverlay(){
    var existing = by("bk-mood-overlay-v56j");
    if (existing) return existing;

    var overlay = document.createElement("div");
    overlay.id = "bk-mood-overlay-v56j";

    overlay.innerHTML =
      '<section id="bk-mood-sheet-v56j" role="dialog" aria-modal="true" aria-labelledby="bk-mood-title-v56j">' +
        '<div class="bk-mood-sheet-head-v56j">' +
          '<div>' +
            '<span class="bk-mood-kicker-v56j">A gentle check-in</span>' +
            '<h2 id="bk-mood-title-v56j">How are you arriving today?</h2>' +
            '<p class="bk-mood-intro-v56j">Choose only if you want to. This is not a test, assessment, or diagnosis.</p>' +
          '</div>' +
          '<button id="bk-mood-close-v56j" type="button" aria-label="Close mood check">×</button>' +
        '</div>' +
        '<div id="bk-mood-options-v56j" role="group" aria-label="Choose a mood"></div>' +
        '<div id="bk-mood-support-v56j" aria-live="polite">' +
          '<img id="bk-mood-support-img-v56j" alt="">' +
          '<div>' +
            '<div class="kind" id="bk-mood-support-kind-v56j"></div>' +
            '<h3 id="bk-mood-support-title-v56j"></h3>' +
            '<p id="bk-mood-support-copy-v56j"></p>' +
            '<button id="bk-mood-comfort-v56j" type="button">💧 Open Comfort Break</button>' +
          '</div>' +
        '</div>' +
        '<div id="bk-mood-actions-v56j">' +
          '<button id="bk-mood-skip-v56j" type="button">Skip for now</button>' +
          '<button id="bk-mood-save-v56j" type="button" disabled>Save mood</button>' +
        '</div>' +
      '</section>';

    document.body.appendChild(overlay);

    overlay.addEventListener("click",function(e){
      if (e.target === overlay) closeMoodSheet();
    });

    by("bk-mood-close-v56j").addEventListener(
      "click",
      closeMoodSheet
    );

    by("bk-mood-skip-v56j").addEventListener(
      "click",
      skipMood
    );

    by("bk-mood-save-v56j").addEventListener(
      "click",
      saveMood
    );

    by("bk-mood-comfort-v56j").addEventListener(
      "click",
      openComfortBreak
    );

    buildOptions();
    return overlay;
  }

  function buildToast(){
    var toast = by("bk-mood-toast-v56j");
    if (toast) return toast;

    toast = document.createElement("div");
    toast.id = "bk-mood-toast-v56j";
    toast.setAttribute("role","status");
    toast.setAttribute("aria-live","polite");
    document.body.appendChild(toast);
    return toast;
  }

  function buildOptions(){
    var holder = by("bk-mood-options-v56j");
    if (!holder || holder.children.length) return;

    options().forEach(function(item,index){
      var button = document.createElement("button");
      button.type = "button";
      button.dataset.index = String(index);
      button.dataset.label = item.label;
      button.setAttribute("aria-pressed","false");
      button.innerHTML =
        '<span class="emoji" aria-hidden="true">' +
          item.emoji +
        '</span>' +
        '<span class="label">' +
          item.label +
        '</span>';

      button.addEventListener("click",function(){
        chooseMood(index);
      });

      holder.appendChild(button);
    });
  }

  /* =====================================================
     PATCH 07C — STATE AND PILL LABEL
  ===================================================== */
  function updatePill(){
    var pill = buildPill();
    if (!pill) return;

    var stored = readStoredMood();
    var label = stored ? normalizedLabel(stored.label) : "";

    if (!label) {
      pill.dataset.hasMood = "false";
      pill.innerHTML =
        '<span aria-hidden="true">💗</span>' +
        '<span class="bk-mood-pill-desktop-v56j">Mood check</span>' +
        '<span class="bk-mood-pill-mobile-v56j">Mood</span>';
      pill.setAttribute("aria-label","Open optional mood check");
      return;
    }

    pill.dataset.hasMood = "true";

    if (label === "Skipped") {
      pill.innerHTML =
        '<span aria-hidden="true">💗</span>' +
        '<span class="bk-mood-pill-desktop-v56j">Mood skipped</span>' +
        '<span class="bk-mood-pill-mobile-v56j">Skipped</span>' +
        '<span class="bk-mood-change-v56j">· Change</span>';
      pill.setAttribute(
        "aria-label",
        "Mood check skipped. Open to change."
      );
      return;
    }

    pill.innerHTML =
      '<span aria-hidden="true">💗</span>' +
      '<span class="bk-mood-pill-desktop-v56j">Mood: ' +
        label +
      '</span>' +
      '<span class="bk-mood-pill-mobile-v56j">' +
        label +
      '</span>' +
      '<span class="bk-mood-change-v56j">· Change</span>';

    pill.setAttribute(
      "aria-label",
      "Current mood " + label + ". Open to change."
    );
  }

  function selectButtonFor(label){
    qsa("#bk-mood-options-v56j button").forEach(function(button){
      var pressed = button.dataset.label === label;
      button.setAttribute(
        "aria-pressed",
        pressed ? "true" : "false"
      );
    });
  }

  /* =====================================================
     PATCH 07D — BACCI SUPPORT MOMENT
  ===================================================== */
  function showSupport(label){
    var support = SUPPORT[label];
    var box = by("bk-mood-support-v56j");
    if (!support || !box) return;

    box.classList.add("show");
    box.classList.toggle(
      "is-hug",
      support.kind === "Bacci Hug"
    );

    by("bk-mood-support-kind-v56j").textContent =
      support.kind;
    by("bk-mood-support-title-v56j").textContent =
      support.title;
    by("bk-mood-support-copy-v56j").textContent =
      support.copy;

    var image = by("bk-mood-support-img-v56j");
    image.src = configAsset(support.image);
    image.alt =
      support.kind + " from Bacci Kid";

    by("bk-mood-comfort-v56j").classList.toggle(
      "show",
      !!support.comfort
    );
  }

  function chooseMood(index){
    var item = options()[index];
    if (!item) return;

    selectedLabel = item.label;
    selectedReply = item.reply || "";

    selectButtonFor(selectedLabel);
    showSupport(selectedLabel);

    by("bk-mood-save-v56j").disabled = false;

    /*
      Proxy the choice into the original mood engine. The old card is
      visually hidden, but its event logic remains available.
    */
    clickOriginalChoice(index);
  }

  /* =====================================================
     PATCH 07E — OPEN / CLOSE / POSITION / ACCESSIBILITY
  ===================================================== */
  function positionDesktopSheet(){
    var pill = by("bk-mood-pill-v56j");
    var sheet = by("bk-mood-sheet-v56j");
    if (!pill || !sheet) return;

    if (window.innerWidth <= 1100) {
      sheet.style.removeProperty("--mood-left");
      sheet.style.removeProperty("--mood-top");
      return;
    }

    var rect = pill.getBoundingClientRect();
    var width = Math.min(580,window.innerWidth - 32);
    var half = width / 2;
    var center = rect.left + rect.width / 2;
    center = Math.max(
      half + 16,
      Math.min(window.innerWidth - half - 16,center)
    );

    var top = rect.bottom + 12;
    var estimatedHeight = 570;

    if (top + estimatedHeight > window.innerHeight - 16) {
      top = Math.max(16,rect.top - estimatedHeight - 12);
    }

    sheet.style.setProperty(
      "--mood-left",
      center + "px"
    );
    sheet.style.setProperty(
      "--mood-top",
      top + "px"
    );
  }

  function openMoodSheet(){
    buildOverlay();

    var overlay = by("bk-mood-overlay-v56j");
    var pill = by("bk-mood-pill-v56j");
    if (!overlay || !pill) return;

    lastFocused = document.activeElement;
    selectedLabel = "";
    selectedReply = "";

    var stored = readStoredMood();
    if (
      stored &&
      stored.label &&
      normalizedLabel(stored.label) !== "Skipped"
    ) {
      selectedLabel = normalizedLabel(stored.label);
      selectedReply = stored.msg || "";
      selectButtonFor(selectedLabel);
      showSupport(selectedLabel);
      by("bk-mood-save-v56j").disabled = false;
    } else {
      selectButtonFor("");
      var support = by("bk-mood-support-v56j");
      if (support) support.classList.remove("show","is-hug");
      by("bk-mood-save-v56j").disabled = true;
    }

    positionDesktopSheet();

    bodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    overlay.classList.add("open");
    pill.setAttribute("aria-expanded","true");

    setTimeout(function(){
      var target =
        qs("#bk-mood-options-v56j button[aria-pressed='true']") ||
        qs("#bk-mood-options-v56j button");
      if (target) target.focus();
    },40);
  }

  function closeMoodSheet(){
    var overlay = by("bk-mood-overlay-v56j");
    var pill = by("bk-mood-pill-v56j");

    if (overlay) overlay.classList.remove("open");
    if (pill) pill.setAttribute("aria-expanded","false");

    document.body.style.overflow = bodyOverflow;

    if (
      lastFocused &&
      typeof lastFocused.focus === "function"
    ) {
      lastFocused.focus();
    }
  }

  function focusTrap(e){
    var overlay = by("bk-mood-overlay-v56j");
    if (!overlay || !overlay.classList.contains("open")) return;

    if (e.key === "Escape") {
      e.preventDefault();
      closeMoodSheet();
      return;
    }

    if (e.key !== "Tab") return;

    var focusable = qsa(
      "#bk-mood-sheet-v56j button:not([disabled])"
    );

    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (
      !e.shiftKey &&
      document.activeElement === last
    ) {
      e.preventDefault();
      first.focus();
    }
  }

  document.addEventListener("keydown",focusTrap);

  /* =====================================================
     PATCH 07F — SAVE / SKIP / TOAST
  ===================================================== */
  function showToast(text){
    var toast = buildToast();
    toast.textContent = text;
    toast.classList.add("show");

    clearTimeout(toast._timer);
    toast._timer = setTimeout(function(){
      toast.classList.remove("show");
    },2200);
  }

  function saveMood(){
    if (!selectedLabel) return;

    var got = originalGot();

    /*
      The existing v46 logic stores the selected mood. If it is not
      available yet, use the same session key directly.
    */
    if (got) {
      got.click();
    } else {
      writeStoredMood(
        selectedLabel,
        selectedReply ||
        "Thank you for checking in."
      );
    }

    /*
      Ensure a clean, normalized state even if v46's internal timing
      has not completed yet.
    */
    setTimeout(function(){
      writeStoredMood(
        selectedLabel,
        selectedReply ||
        "Thank you for checking in."
      );
      updatePill();
    },20);

    closeMoodSheet();
    showToast("Thank you for checking in 💗");
  }

  function skipMood(){
    var skip = originalSkip();

    if (skip) {
      skip.click();
    } else {
      writeStoredMood(
        "Skipped for now",
        "No pressure. You can still color, read, and explore."
      );
    }

    setTimeout(function(){
      writeStoredMood(
        "Skipped for now",
        "No pressure. You can still color, read, and explore."
      );
      updatePill();
    },20);

    closeMoodSheet();
    showToast("Mood check skipped. No pressure 💗");
  }

  function openComfortBreak(){
    closeMoodSheet();

    var comfortButton = by("bk-v50-comfort-open");
    if (comfortButton) {
      comfortButton.click();
      return;
    }

    var panel = by("bk-v50-comfort-panel");
    if (panel) {
      panel.scrollIntoView({
        behavior:reducedMotion() ? "auto" : "smooth",
        block:"center"
      });
      return;
    }

    showToast(
      "Pause, breathe, drink water, or return later. The page can wait 💗"
    );
  }

  /* =====================================================
     PATCH 07G — INITIALIZE + REDRAW PROTECTION
  ===================================================== */
  function enforce(){
    buildPill();
    buildOverlay();
    buildToast();
    updatePill();
  }

  function scheduleEnforce(){
    if (observerQueued) return;
    observerQueued = true;

    requestAnimationFrame(function(){
      observerQueued = false;
      enforce();
    });
  }

  function start(){
    enforce();

    if ("MutationObserver" in window) {
      var observer = new MutationObserver(scheduleEnforce);
      observer.observe(root,{
        childList:true,
        subtree:true
      });
    }

    window.addEventListener("resize",function(){
      var overlay = by("bk-mood-overlay-v56j");
      if (overlay && overlay.classList.contains("open")) {
        positionDesktopSheet();
      }
    });

    window.addEventListener("pageshow",function(){
      updatePill();
    });

    setTimeout(enforce,300);
    setTimeout(enforce,900);
    setTimeout(enforce,1800);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {once:true}
    );
  } else {
    start();
  }
})();

/* END BACCI KID BRAVE REPAIR PATCH 07
COMPACT MOOD PILL + RESPONSIVE MOOD SHEET + BACCI HUG
========================================================= */




/* =========================================================
BACCI KID BRAVE REPAIR PATCH 08
MOOD DISCOVERY + FIRST-CLICK FIX + SOUND + BACCI PAUSE
Version: v56K
Date: 2026-07-23

SEARCH HEADER:
BACCI KID BRAVE REPAIR PATCH 08

INSTALLATION:
Keep Patches 01 through 07.
Paste this Patch 08 underneath Patch 07 at the absolute bottom
of Assets/bacci-brave.js.

WHAT THIS PATCH DOES:
1. Makes the Mood pill open reliably on the first interaction.
2. Adds a one-time four-second cue:
   "💗 Optional mood check"
3. The cue appears once per device and never becomes a permanent
   section or blocks the coloring experience.
4. Keeps the existing branded response structure:
   Bright   -> Bacci Spark
   Okay     -> Bacci Spark
   Low      -> Bacci Hug
   Heavy    -> Bacci Hug
   Not sure -> Bacci Pause
5. Replaces response artwork with Bacci mood-specific assets.
6. Adds very soft, original Web Audio micro-chimes only when the
   main Brave Sound control is ON.
7. Adds a clearer Music Studio click chime when Sound is ON.
8. Fixes the broken "[object PointerEvent]" Comfort Break result.
9. Renames that action:
   "Take a 30-second Bacci Pause"
10. Opens a dedicated Bacci Pause experience with:
    - no autoplay
    - no breath holding
    - eyes-open permission
    - three gentle ten-second phases
    - optional soft phase tones only when Sound is ON
11. Does not add the full sticker sheet to the mood picker.
12. Does not add adult burnout language to this teen experience.
13. Does not alter coloring, Paint Set, storybook, WorldGlow,
    Hype, Music Studio navigation, or saved mood storage.

SAFE REMOVAL:
Delete this entire titled block only.
========================================================= */
(function(){
  if (window.BacciBraveRepairPatch08MoodPolishV56K) return;
  window.BacciBraveRepairPatch08MoodPolishV56K = true;

  var CUE_KEY = "bk_v56k_optional_mood_cue_seen";
  var PAUSE_IMAGE =
    "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Bacci-meditation.png?v=1760395201";

  var MOOD_IMAGES = {
    "Bright":
      "https://baccikid.b-cdn.net/Bacci%20Moods%20and%20Feelings%20Images/1.%20Original%20(happy).png",
    "Okay":
      PAUSE_IMAGE,
    "Low":
      "https://baccikid.b-cdn.net/Bacci%20Moods%20and%20Feelings%20Images/3.%20Original%20(sad).png",
    "Heavy":
      "https://baccikid.b-cdn.net/Bacci%20Moods%20and%20Feelings%20Images/6.%20Original%20(tired%20burnout%20overwhelmed%20ruminating).png",
    "Not sure":
      "https://baccikid.b-cdn.net/Bacci%20Moods%20and%20Feelings%20Images/Observe%20dont%20absorb%20no%20text.png"
  };

  var MOOD_ALT = {
    "Bright":"Happy Bacci character",
    "Okay":"Bacci sitting calmly in meditation",
    "Low":"Bacci showing a low or sad feeling",
    "Heavy":"Bacci showing tired or overwhelmed energy",
    "Not sure":"Bacci observing through a magnifying glass"
  };

  var root = document.getElementById("bk-hx");
  if (!root) return;

  var audioContext = null;
  var lastSoundAt = 0;
  var openingFallbackTimer = null;
  var pauseTimer = null;
  var pauseElapsed = 0;

  function by(id){
    return document.getElementById(id);
  }

  function qs(selector, scope){
    return (scope || document).querySelector(selector);
  }

  function soundIsOn(){
    var sound = by("bk-sound");
    return !!(
      sound &&
      sound.getAttribute("aria-pressed") === "true"
    );
  }

  /* =====================================================
     PATCH 08A — STYLES
  ===================================================== */
  var style = document.createElement("style");
  style.id = "bk-repair-08-mood-polish-style";
  style.textContent = [
    "#bk-mood-pill-v56j{touch-action:manipulation;-webkit-tap-highlight-color:transparent;}",
    "#bk-mood-pill-v56j.bk-mood-discovery-pulse-v56k{animation:bkMoodDiscoveryPulseV56K 1.15s ease-in-out 2;}",
    "@keyframes bkMoodDiscoveryPulseV56K{0%,100%{transform:translateY(0) scale(1);box-shadow:0 5px 14px rgba(255,111,191,.16);}50%{transform:translateY(-2px) scale(1.045);box-shadow:0 10px 25px rgba(255,111,191,.3),0 0 18px rgba(0,198,198,.2);}}",
    "#bk-mood-cue-v56k{position:fixed;z-index:2147483450;display:none;max-width:min(210px,calc(100vw - 24px));padding:9px 13px;border:2px solid rgba(255,111,191,.55);border-radius:15px;background:linear-gradient(135deg,#fff,#fff1f8 56%,#eaffff);box-shadow:0 14px 34px rgba(82,48,142,.25);font-family:Fredoka,system-ui,sans-serif;font-size:12.5px;font-weight:850;line-height:1.2;color:#5b3f7f;text-align:center;pointer-events:none;opacity:0;transform:translateY(-7px) scale(.96);transition:opacity .2s ease,transform .22s ease;}",
    "#bk-mood-cue-v56k.show{display:block;opacity:1;transform:translateY(0) scale(1);}",
    "#bk-mood-cue-v56k::after{content:'';position:absolute;left:28px;top:100%;border-left:8px solid transparent;border-right:8px solid transparent;border-top:9px solid rgba(255,111,191,.7);}",
    "#bk-mood-support-img-v56j{object-fit:contain!important;object-position:center!important;}",
    "#bk-mood-comfort-v56j{white-space:nowrap;}",
    "#bk-pause-overlay-v56k{position:fixed;inset:0;z-index:2147483600;display:none;align-items:center;justify-content:center;padding:20px;background:rgba(28,17,58,.42);backdrop-filter:blur(7px);-webkit-backdrop-filter:blur(7px);}",
    "#bk-pause-overlay-v56k.open{display:flex;}",
    "#bk-pause-card-v56k{width:min(560px,calc(100vw - 30px));max-height:min(86vh,720px);overflow:auto;padding:20px;border:2px solid rgba(255,197,66,.62);border-radius:28px;background:radial-gradient(circle at 12% 8%,rgba(255,224,244,.6),transparent 36%),radial-gradient(circle at 90% 9%,rgba(199,255,247,.58),transparent 36%),linear-gradient(145deg,#fff,#fff9f0 58%,#efffff);box-shadow:0 30px 90px rgba(52,30,102,.42),0 0 0 6px rgba(255,255,255,.38);font-family:Quicksand,system-ui,sans-serif;color:#433663;text-align:center;}",
    "#bk-pause-card-v56k img{width:min(190px,50vw);height:170px;object-fit:contain;filter:drop-shadow(0 14px 24px rgba(92,58,150,.18));}",
    "#bk-pause-card-v56k .kicker{display:block;margin-top:2px;font-family:Fredoka,system-ui,sans-serif;font-size:11px;font-weight:900;letter-spacing:1.3px;text-transform:uppercase;color:#ff4fa0;}",
    "#bk-pause-card-v56k h2{margin:5px 0 5px;font-family:Fredoka,system-ui,sans-serif;font-size:clamp(27px,4vw,38px);line-height:1.05;background:linear-gradient(90deg,#ff4fa0,#8a67f4,#00aeb8);-webkit-background-clip:text;background-clip:text;color:transparent;}",
    "#bk-pause-card-v56k .intro{max-width:440px;margin:0 auto;font-size:14px;line-height:1.5;font-weight:700;color:#65558b;}",
    "#bk-pause-phase-v56k{margin:16px 0 8px;padding:16px;border:2px solid rgba(166,107,255,.22);border-radius:20px;background:rgba(255,255,255,.84);font-family:Fredoka,system-ui,sans-serif;font-size:20px;font-weight:850;color:#533c80;}",
    "#bk-pause-time-v56k{display:block;margin-top:4px;font-size:13px;font-weight:800;color:#00807e;}",
    "#bk-pause-actions-v56k{display:flex;justify-content:center;gap:10px;flex-wrap:wrap;margin-top:15px;}",
    "#bk-pause-actions-v56k button{border:0;border-radius:999px;padding:11px 17px;cursor:pointer;font-family:Fredoka,system-ui,sans-serif;font-size:13px;font-weight:900;}",
    "#bk-pause-start-v56k{color:#073c3c;background:linear-gradient(135deg,#8ffcf6,#00c6c6);box-shadow:0 5px 0 #00807e;}",
    "#bk-pause-close-v56k{color:#6d5300;background:linear-gradient(135deg,#fff8df,#ffe08a);box-shadow:0 5px 0 #c9971f;}",
    "@media(max-width:767px){#bk-mood-cue-v56k{font-size:11.5px;max-width:174px;}#bk-pause-overlay-v56k{align-items:flex-end;padding:0;}#bk-pause-card-v56k{width:100%;max-height:88vh;border-radius:28px 28px 0 0;padding:18px 15px calc(22px + env(safe-area-inset-bottom));}#bk-pause-card-v56k img{height:135px;}#bk-pause-actions-v56k{display:grid;grid-template-columns:1fr 1fr;}#bk-pause-actions-v56k button{width:100%;padding:12px 8px;}}",
    "@media(prefers-reduced-motion:reduce){#bk-mood-pill-v56j.bk-mood-discovery-pulse-v56k{animation:none!important;}#bk-mood-cue-v56k{transition:none!important;}}",
    "@media print{#bk-mood-cue-v56k,#bk-pause-overlay-v56k{display:none!important;}}"
  ].join("");
  document.head.appendChild(style);

  /* =====================================================
     PATCH 08B — WEB AUDIO MICRO-SOUNDS
  ===================================================== */
  function audio(){
    try{
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      audioContext = audioContext || new AC();
      if (audioContext.state === "suspended") {
        audioContext.resume().catch(function(){});
      }
      return audioContext;
    }catch(e){
      return null;
    }
  }

  function playMicroSound(kind){
    if (!soundIsOn()) return;

    var nowMs = Date.now();
    if (nowMs - lastSoundAt < 180) return;
    lastSoundAt = nowMs;

    var ac = audio();
    if (!ac) return;

    var start = ac.currentTime + .008;
    var master = ac.createGain();
    master.gain.setValueAtTime(.0001,start);
    master.gain.exponentialRampToValueAtTime(.034,start + .025);
    master.gain.exponentialRampToValueAtTime(.0001,start + .48);
    master.connect(ac.destination);

    var pattern =
      kind === "hug"
        ? [{f:392,d:0,l:.78,t:"sine"},{f:523.25,d:.10,l:.52,t:"sine"}]
        : kind === "save"
        ? [{f:659.25,d:0,l:.85,t:"sine"},{f:880,d:.07,l:.62,t:"sine"},{f:1046.5,d:.14,l:.42,t:"sine"}]
        : kind === "studio"
        ? [{f:523.25,d:0,l:.78,t:"triangle"},{f:783.99,d:.08,l:.55,t:"sine"},{f:1046.5,d:.16,l:.38,t:"sine"}]
        : [{f:587.33,d:0,l:.72,t:"sine"},{f:783.99,d:.08,l:.48,t:"sine"}];

    pattern.forEach(function(item){
      var osc = ac.createOscillator();
      var gain = ac.createGain();
      osc.type = item.t;
      osc.frequency.setValueAtTime(item.f,start + item.d);
      gain.gain.setValueAtTime(.0001,start + item.d);
      gain.gain.exponentialRampToValueAtTime(.030 * item.l,start + item.d + .02);
      gain.gain.exponentialRampToValueAtTime(.0001,start + item.d + .34);
      osc.connect(gain);
      gain.connect(master);
      osc.start(start + item.d);
      osc.stop(start + item.d + .38);
    });
  }

  /* =====================================================
     PATCH 08C — ONE-TIME DISCOVERY CUE
  ===================================================== */
  function cueAlreadySeen(){
    try{
      return localStorage.getItem(CUE_KEY) === "1";
    }catch(e){
      return false;
    }
  }

  function markCueSeen(){
    try{
      localStorage.setItem(CUE_KEY,"1");
    }catch(e){}
  }

  function positionCue(){
    var pill = by("bk-mood-pill-v56j");
    var cue = by("bk-mood-cue-v56k");
    if (!pill || !cue) return;

    var rect = pill.getBoundingClientRect();
    var cueWidth = Math.min(210,window.innerWidth - 24);
    var left = Math.max(12,Math.min(window.innerWidth - cueWidth - 12,rect.left));
    var top = rect.top - 58;
    if (top < 12) top = rect.bottom + 10;

    cue.style.left = left + "px";
    cue.style.top = top + "px";
  }

  function hideCue(){
    var cue = by("bk-mood-cue-v56k");
    var pill = by("bk-mood-pill-v56j");

    if (cue) cue.classList.remove("show");
    if (pill) pill.classList.remove("bk-mood-discovery-pulse-v56k");
    markCueSeen();
  }

  function showOneTimeCue(){
    var pill = by("bk-mood-pill-v56j");
    if (!pill || cueAlreadySeen()) return;

    try{
      if (sessionStorage.getItem("bk_v46_brave_mood_check")) {
        markCueSeen();
        return;
      }
    }catch(e){}

    var cue = by("bk-mood-cue-v56k");

    if (!cue) {
      cue = document.createElement("div");
      cue.id = "bk-mood-cue-v56k";
      cue.setAttribute("role","status");
      cue.setAttribute("aria-live","polite");
      cue.textContent = "💗 Optional mood check";
      document.body.appendChild(cue);
    }

    positionCue();
    pill.classList.add("bk-mood-discovery-pulse-v56k");
    cue.classList.add("show");
    setTimeout(hideCue,4000);
  }

  /* =====================================================
     PATCH 08D — FIRST-INTERACTION RELIABILITY
  ===================================================== */
  function positionMoodFallback(pill, sheet){
    if (!pill || !sheet || window.innerWidth <= 1100) return;

    var rect = pill.getBoundingClientRect();
    var width = Math.min(580,window.innerWidth - 32);
    var half = width / 2;
    var center = Math.max(
      half + 16,
      Math.min(window.innerWidth - half - 16,rect.left + rect.width / 2)
    );
    var top = rect.bottom + 12;
    if (top + 570 > window.innerHeight - 16) {
      top = Math.max(16,rect.top - 582);
    }

    sheet.style.setProperty("--mood-left",center + "px");
    sheet.style.setProperty("--mood-top",top + "px");
  }

  function ensureMoodOpened(pill){
    clearTimeout(openingFallbackTimer);

    openingFallbackTimer = setTimeout(function(){
      var overlay = by("bk-mood-overlay-v56j");
      var sheet = by("bk-mood-sheet-v56j");

      if (!overlay || overlay.classList.contains("open")) return;

      positionMoodFallback(pill,sheet);
      overlay.classList.add("open");
      pill.setAttribute("aria-expanded","true");
      document.body.style.overflow = "hidden";

      var focusTarget =
        qs("#bk-mood-options-v56j button[aria-pressed='true']") ||
        qs("#bk-mood-options-v56j button");

      if (focusTarget) focusTarget.focus();
    },90);
  }

  document.addEventListener("pointerup",function(e){
    var pill = e.target.closest &&
      e.target.closest("#bk-mood-pill-v56j");

    if (!pill) return;

    hideCue();
    ensureMoodOpened(pill);
  },true);

  document.addEventListener("keydown",function(e){
    var pill = e.target &&
      e.target.closest &&
      e.target.closest("#bk-mood-pill-v56j");

    if (!pill || (e.key !== "Enter" && e.key !== " ")) return;

    hideCue();
    ensureMoodOpened(pill);
  },true);

  /* =====================================================
     PATCH 08E — BRANDED RESPONSE ART + CLICK SOUNDS
  ===================================================== */
  function updateSupportArt(label){
    var image = by("bk-mood-support-img-v56j");
    if (!image || !MOOD_IMAGES[label]) return;

    image.src = MOOD_IMAGES[label];
    image.alt = MOOD_ALT[label] || "Bacci mood character";
    image.loading = "lazy";
    image.decoding = "async";
  }

  document.addEventListener("click",function(e){
    var option = e.target.closest &&
      e.target.closest("#bk-mood-options-v56j button");

    if (option) {
      var label = option.dataset.label || "";

      setTimeout(function(){
        updateSupportArt(label);
      },0);

      playMicroSound(
        label === "Low" ||
        label === "Heavy" ||
        label === "Not sure"
          ? "hug"
          : "spark"
      );
      return;
    }

    if (
      e.target.closest &&
      e.target.closest("#bk-mood-save-v56j")
    ) {
      playMicroSound("save");
    }
  },false);

  document.addEventListener("pointerdown",function(e){
    if (
      e.target.closest &&
      e.target.closest(".bk-v55s-studio-dock")
    ) {
      playMicroSound("studio");
    }
  },true);

  document.addEventListener("keydown",function(e){
    if (e.key !== "Enter" && e.key !== " ") return;

    if (
      e.target &&
      e.target.closest &&
      e.target.closest(".bk-v55s-studio-dock")
    ) {
      playMicroSound("studio");
    }
  },true);

  /* =====================================================
     PATCH 08F — SAFE 30-SECOND BACCI PAUSE
  ===================================================== */
  function buildPause(){
    var overlay = by("bk-pause-overlay-v56k");
    if (overlay) return overlay;

    overlay = document.createElement("div");
    overlay.id = "bk-pause-overlay-v56k";
    overlay.setAttribute("role","dialog");
    overlay.setAttribute("aria-modal","true");
    overlay.setAttribute("aria-labelledby","bk-pause-title-v56k");

    overlay.innerHTML =
      '<section id="bk-pause-card-v56k">' +
        '<img src="' + PAUSE_IMAGE + '" alt="Bacci sitting calmly in meditation">' +
        '<span class="kicker">Bacci Pause</span>' +
        '<h2 id="bk-pause-title-v56k">Thirty gentle seconds</h2>' +
        '<p class="intro">Breathe normally. Let your shoulders soften. Keep your eyes open if that feels better. Stop whenever you want.</p>' +
        '<div id="bk-pause-phase-v56k">' +
          '<span id="bk-pause-message-v56k">Begin only when you are ready.</span>' +
          '<span id="bk-pause-time-v56k">30 seconds · no breath holding</span>' +
        '</div>' +
        '<div id="bk-pause-actions-v56k">' +
          '<button id="bk-pause-start-v56k" type="button">Begin quiet pause</button>' +
          '<button id="bk-pause-close-v56k" type="button">Return to coloring</button>' +
        '</div>' +
      '</section>';

    document.body.appendChild(overlay);

    overlay.addEventListener("click",function(e){
      if (e.target === overlay) closePause();
    });

    by("bk-pause-start-v56k").addEventListener("click",startPause);
    by("bk-pause-close-v56k").addEventListener("click",closePause);

    return overlay;
  }

  function resetPause(){
    clearInterval(pauseTimer);
    pauseTimer = null;
    pauseElapsed = 0;

    by("bk-pause-message-v56k").textContent =
      "Begin only when you are ready.";
    by("bk-pause-time-v56k").textContent =
      "30 seconds · no breath holding";
    by("bk-pause-start-v56k").disabled = false;
    by("bk-pause-start-v56k").textContent =
      "Begin quiet pause";
  }

  function openPause(){
    var moodOverlay = by("bk-mood-overlay-v56j");
    if (moodOverlay) moodOverlay.classList.remove("open");

    var moodPill = by("bk-mood-pill-v56j");
    if (moodPill) moodPill.setAttribute("aria-expanded","false");

    var overlay = buildPause();
    resetPause();
    overlay.classList.add("open");
    document.body.style.overflow = "hidden";

    setTimeout(function(){
      by("bk-pause-start-v56k").focus();
    },30);
  }

  function closePause(){
    clearInterval(pauseTimer);
    pauseTimer = null;

    var overlay = by("bk-pause-overlay-v56k");
    if (overlay) overlay.classList.remove("open");

    document.body.style.overflow = "";

    var pill = by("bk-mood-pill-v56j");
    if (pill) pill.focus();
  }

  function pausePhase(elapsed){
    if (elapsed < 10) return "Let your shoulders soften.";
    if (elapsed < 20) {
      return "Breathe in gently, or simply breathe normally.";
    }
    return "Breathe out slowly. There is nowhere to rush.";
  }

  function startPause(){
    var start = by("bk-pause-start-v56k");
    var message = by("bk-pause-message-v56k");
    var time = by("bk-pause-time-v56k");

    start.disabled = true;
    start.textContent = "Pause in progress";
    pauseElapsed = 0;

    message.textContent = pausePhase(0);
    time.textContent = "30 seconds remaining";
    playMicroSound("hug");

    pauseTimer = setInterval(function(){
      pauseElapsed += 1;
      var remaining = Math.max(0,30 - pauseElapsed);

      message.textContent = pausePhase(pauseElapsed);
      time.textContent =
        remaining > 0
          ? remaining + " seconds remaining"
          : "Pause complete";

      if (pauseElapsed === 10 || pauseElapsed === 20) {
        playMicroSound("hug");
      }

      if (pauseElapsed >= 30) {
        clearInterval(pauseTimer);
        pauseTimer = null;

        message.textContent =
          "You did it. Return whenever you are ready.";
        time.textContent = "Pause complete";
        start.disabled = false;
        start.textContent = "Pause again";
        playMicroSound("save");
      }
    },1000);
  }

  document.addEventListener("click",function(e){
    var comfort = e.target.closest &&
      e.target.closest("#bk-mood-comfort-v56j");

    if (!comfort) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    openPause();
  },true);

  /* =====================================================
     PATCH 08G — ENFORCE LABELS + INITIALIZE
  ===================================================== */
  function enforce(){
    var comfort = by("bk-mood-comfort-v56j");
    if (comfort) {
      comfort.textContent =
        "🌙 Take a 30-second Bacci Pause";
      comfort.setAttribute(
        "aria-label",
        "Take an optional thirty-second Bacci Pause"
      );
    }

    buildPause();
  }

  function start(){
    enforce();
    setTimeout(showOneTimeCue,850);

    if ("MutationObserver" in window) {
      var observer = new MutationObserver(enforce);
      observer.observe(root,{
        childList:true,
        subtree:true
      });
    }

    window.addEventListener("resize",function(){
      var cue = by("bk-mood-cue-v56k");
      if (cue && cue.classList.contains("show")) {
        positionCue();
      }
    });

    setTimeout(enforce,500);
    setTimeout(enforce,1300);
    setTimeout(enforce,2800);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {once:true}
    );
  } else {
    start();
  }
})();

/* END BACCI KID BRAVE REPAIR PATCH 08
MOOD DISCOVERY + FIRST-CLICK FIX + SOUND + BACCI PAUSE
========================================================= */






/* =========================================================
BACCI KID BRAVE REPAIR PATCH 09
MOOD PILL LABEL REPAIR + BACCI PAUSE VIDEO PLAYER
Version: v56L
Date: 2026-07-23

SEARCH HEADER:
BACCI KID BRAVE REPAIR PATCH 09

INSTALLATION:
Keep Patches 01 through 08.
Paste this Patch 09 underneath Patch 08 at the absolute bottom
of Assets/bacci-brave.js.

WHAT THIS PATCH DOES:
1. Repairs the strange "Mood: Mood noticed · Change" label.
2. Uses compact labels:
   - before selection: 💗 Mood check
   - saved mood: 💗 Bright · Change
   - unknown older save: 💗 Mood saved · Change
   - skipped: 💗 Skipped · Change
3. Prevents the Change text from spilling outside the pill.
4. Remembers the real selected mood in this browser session.
5. Corrects the older v46 stored value after the next mood save.
6. Replaces the static Bacci Pause image with a controlled video player.
7. Default video mode is Quiet, with no music.
8. Soft Music is an explicit optional choice.
9. Video never autoplays and never loops.
10. Video uses playsinline on mobile.
11. Returning to coloring stops and resets the video.
12. Calm or reduced-motion mode displays the still image instead.
13. The existing 30-second text guide remains active.
14. Adds a soft chime to the top Sound + Color Studio rhino control
    only when the main Brave Sound control is ON.
15. The floating Music Studio control remains governed by Patch 08.
16. Does not alter coloring, Paint Set, WorldGlow, storybook,
    Hype, mood responses, or stored art.

SAFE REMOVAL:
Delete this entire titled block only.
========================================================= */
(function(){
  if (window.BacciBraveRepairPatch09PauseVideoV56L) return;
  window.BacciBraveRepairPatch09PauseVideoV56L = true;

  var MOOD_LABEL_KEY = "bk_v56l_mood_label";
  var ORIGINAL_MOOD_KEY = "bk_v46_brave_mood_check";

  var QUIET_VIDEO =
    "https://baccikid.b-cdn.net/Bacci%20Moods%20and%20Feelings%20Images/Bacci%20s%20Cat%20without%20Music.mp4";

  var MUSIC_VIDEO =
    "https://baccikid.b-cdn.net/Bacci%20Moods%20and%20Feelings%20Images/Bacci%20s%20Cat%20with%20Music.mp4";

  var PAUSE_POSTER =
    "https://cdn.shopify.com/s/files/1/0500/7307/5871/files/Bacci-meditation.png?v=1760395201";

  var KNOWN_MOODS = {
    "Bright":true,
    "Okay":true,
    "Low":true,
    "Heavy":true,
    "Not sure":true
  };

  var pendingMood = "";
  var videoStopTimer = null;
  var studioAudioContext = null;
  var pillObserverBusy = false;

  function by(id){
    return document.getElementById(id);
  }

  function qs(selector, scope){
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope){
    return Array.prototype.slice.call(
      (scope || document).querySelectorAll(selector)
    );
  }

  function cleanText(el){
    return (el && el.textContent ? el.textContent : "")
      .replace(/\s+/g," ")
      .trim();
  }

  function reducedMotion(){
    try{
      return (
        document.documentElement.getAttribute("data-bk-motion") === "calm" ||
        (
          window.matchMedia &&
          window.matchMedia("(prefers-reduced-motion: reduce)").matches
        )
      );
    }catch(e){
      return false;
    }
  }

  /* =====================================================
     PATCH 09A — STYLES
  ===================================================== */
  var style = document.createElement("style");
  style.id = "bk-repair-09-style";
  style.textContent = [
    /* Compact mood pill */
    "#bk-mood-pill-v56j{",
      "max-width:184px!important;",
      "min-width:0!important;",
      "overflow:hidden!important;",
      "padding-left:13px!important;",
      "padding-right:13px!important;",
    "}",

    "#bk-mood-pill-v56j .bk-mood-pill-copy-v56l{",
      "display:inline-flex;",
      "align-items:center;",
      "gap:4px;",
      "min-width:0;",
      "max-width:100%;",
      "overflow:hidden;",
      "white-space:nowrap;",
    "}",

    "#bk-mood-pill-v56j .bk-mood-value-v56l{",
      "display:block;",
      "min-width:0;",
      "overflow:hidden;",
      "text-overflow:ellipsis;",
      "white-space:nowrap;",
    "}",

    "#bk-mood-pill-v56j .bk-mood-change-v56l{",
      "display:block;",
      "flex:0 0 auto;",
      "font-size:.82em;",
      "font-weight:850;",
      "color:#00807e;",
    "}",

    "#bk-mood-pill-v56j[aria-expanded='true'] .bk-mood-change-v56l{",
      "color:#fff;",
    "}",

    /* Video player */
    "#bk-pause-card-v56k > img{display:none!important;}",

    "#bk-pause-media-v56l{",
      "position:relative;",
      "width:min(430px,100%);",
      "margin:0 auto 13px;",
      "border:2px solid rgba(166,107,255,.3);",
      "border-radius:22px;",
      "overflow:hidden;",
      "background:linear-gradient(145deg,#f8f3ff,#fff,#eaffff);",
      "box-shadow:0 14px 34px rgba(79,48,137,.18);",
    "}",

    "#bk-pause-video-v56l{",
      "display:block;",
      "width:100%;",
      "aspect-ratio:16/9;",
      "object-fit:contain;",
      "background:#17131f;",
    "}",

    "#bk-pause-poster-v56l{",
      "display:none;",
      "width:100%;",
      "height:260px;",
      "object-fit:contain;",
      "background:linear-gradient(145deg,#fff7fc,#efffff);",
    "}",

    "#bk-pause-video-status-v56l{",
      "position:absolute;",
      "left:10px;",
      "bottom:10px;",
      "max-width:calc(100% - 20px);",
      "padding:6px 10px;",
      "border-radius:999px;",
      "background:rgba(18,13,31,.72);",
      "color:#fff;",
      "font-family:Fredoka,system-ui,sans-serif;",
      "font-size:11px;",
      "font-weight:800;",
      "backdrop-filter:blur(8px);",
      "-webkit-backdrop-filter:blur(8px);",
    "}",

    "#bk-pause-sound-v56l{",
      "display:flex;",
      "justify-content:center;",
      "gap:8px;",
      "flex-wrap:wrap;",
      "margin:0 auto 11px;",
    "}",

    "#bk-pause-sound-v56l button{",
      "border:2px solid rgba(166,107,255,.24);",
      "border-radius:999px;",
      "padding:8px 13px;",
      "cursor:pointer;",
      "font-family:Fredoka,system-ui,sans-serif;",
      "font-size:12px;",
      "font-weight:850;",
      "color:#4f3b75;",
      "background:#fff;",
      "box-shadow:0 5px 14px rgba(83,56,143,.1);",
    "}",

    "#bk-pause-sound-v56l button[aria-pressed='true']{",
      "border-color:transparent;",
      "color:#073c3c;",
      "background:linear-gradient(135deg,#8ffcf6,#00c6c6);",
      "box-shadow:0 4px 0 #00807e;",
    "}",

    "#bk-pause-media-note-v56l{",
      "margin:0 auto 9px;",
      "font-size:11.5px;",
      "line-height:1.35;",
      "font-weight:750;",
      "color:#756493;",
    "}",

    "@media(min-width:768px) and (max-width:1100px){",
      "#bk-mood-pill-v56j{max-width:158px!important;}",
    "}",

    "@media(max-width:767px){",
      "#bk-mood-pill-v56j{",
        "max-width:132px!important;",
        "padding-left:11px!important;",
        "padding-right:11px!important;",
      "}",
      "#bk-mood-pill-v56j .bk-mood-change-v56l{display:none!important;}",
      "#bk-pause-media-v56l{width:100%;border-radius:18px;}",
      "#bk-pause-poster-v56l{height:210px;}",
      "#bk-pause-sound-v56l{display:grid;grid-template-columns:1fr 1fr;}",
      "#bk-pause-sound-v56l button{width:100%;padding:10px 8px;}",
    "}",

    "@media(prefers-reduced-motion:reduce){",
      "#bk-pause-video-v56l{display:none!important;}",
      "#bk-pause-poster-v56l{display:block!important;}",
      "#bk-pause-sound-v56l{display:none!important;}",
    "}",

    "html[data-bk-motion='calm'] #bk-pause-video-v56l{display:none!important;}",
    "html[data-bk-motion='calm'] #bk-pause-poster-v56l{display:block!important;}",
    "html[data-bk-motion='calm'] #bk-pause-sound-v56l{display:none!important;}",

    "@media print{",
      "#bk-pause-media-v56l,",
      "#bk-pause-sound-v56l,",
      "#bk-pause-media-note-v56l{display:none!important;}",
    "}"
  ].join("");
  document.head.appendChild(style);

  /* =====================================================
     PATCH 09B — MOOD PILL LABEL REPAIR
  ===================================================== */
  function normalizeMoodLabel(label){
    label = (label || "").replace(/\s+/g," ").trim();

    if (!label) return "";
    if (KNOWN_MOODS[label]) return label;
    if (/skipped/i.test(label)) return "Skipped";
    if (/mood noticed/i.test(label)) return "Mood saved";
    if (/mood saved/i.test(label)) return "Mood saved";

    return "Mood saved";
  }

  function readCustomMood(){
    try{
      return sessionStorage.getItem(MOOD_LABEL_KEY) || "";
    }catch(e){
      return "";
    }
  }

  function writeCustomMood(label){
    try{
      if (label) {
        sessionStorage.setItem(MOOD_LABEL_KEY,label);
      } else {
        sessionStorage.removeItem(MOOD_LABEL_KEY);
      }
    }catch(e){}
  }

  function readOriginalMood(){
    try{
      var stored = JSON.parse(
        sessionStorage.getItem(ORIGINAL_MOOD_KEY) || "null"
      );
      return stored && stored.label
        ? normalizeMoodLabel(stored.label)
        : "";
    }catch(e){
      return "";
    }
  }

  function pressedMood(){
    var pressed = qs(
      "#bk-mood-options-v56j button[aria-pressed='true']"
    );

    var label = pressed && pressed.dataset
      ? pressed.dataset.label
      : "";

    return KNOWN_MOODS[label] ? label : "";
  }

  function currentMoodLabel(){
    var custom = normalizeMoodLabel(readCustomMood());
    if (custom) return custom;

    var pressed = pressedMood();
    if (pressed) return pressed;

    return readOriginalMood();
  }

  function repairOriginalMood(label){
    if (!KNOWN_MOODS[label]) return;

    var reply = "";
    var selected = qs(
      "#bk-mood-options-v56j button[data-label='" +
      label.replace(/'/g,"\\'") +
      "']"
    );

    try{
      if (
        window.BK_HX_CONFIG &&
        BK_HX_CONFIG.MOOD &&
        Array.isArray(BK_HX_CONFIG.MOOD.options)
      ) {
        var found = BK_HX_CONFIG.MOOD.options.filter(function(item){
          return item && item.label === label;
        })[0];

        if (found) reply = found.reply || "";
      }
    }catch(e){}

    try{
      sessionStorage.setItem(
        ORIGINAL_MOOD_KEY,
        JSON.stringify({
          label:label,
          msg:reply || "Ready to color with Bacci."
        })
      );
    }catch(e){}
  }

  function renderMoodPill(){
    var pill = by("bk-mood-pill-v56j");
    if (!pill || pillObserverBusy) return;

    pillObserverBusy = true;

    var label = currentMoodLabel();
    var expanded = pill.getAttribute("aria-expanded") === "true";
    var value = "";
    var change = "";

    if (!label) {
      value = "Mood check";
      pill.dataset.hasMood = "false";
      pill.setAttribute("aria-label","Open optional mood check");
    } else if (label === "Skipped") {
      value = "Skipped";
      change = "· Change";
      pill.dataset.hasMood = "true";
      pill.setAttribute(
        "aria-label",
        "Mood check skipped. Open to change."
      );
    } else if (label === "Mood saved") {
      value = "Mood saved";
      change = "· Change";
      pill.dataset.hasMood = "true";
      pill.setAttribute(
        "aria-label",
        "A mood was saved. Open to change."
      );
    } else {
      value = label;
      change = "· Change";
      pill.dataset.hasMood = "true";
      pill.setAttribute(
        "aria-label",
        "Current mood " + label + ". Open to change."
      );
    }

    var signature = value + "|" + change + "|" + expanded;

    if (pill.dataset.bkV56lSignature !== signature) {
      pill.dataset.bkV56lSignature = signature;
      pill.innerHTML =
        '<span class="bk-mood-pill-copy-v56l">' +
          '<span aria-hidden="true">💗</span>' +
          '<span class="bk-mood-value-v56l">' +
            value +
          '</span>' +
          (
            change
              ? '<span class="bk-mood-change-v56l">' +
                  change +
                '</span>'
              : ''
          ) +
        '</span>';
    }

    pillObserverBusy = false;
  }

  document.addEventListener("click",function(e){
    var option = e.target.closest &&
      e.target.closest("#bk-mood-options-v56j button");

    if (option) {
      var label = option.dataset.label || "";
      pendingMood = KNOWN_MOODS[label] ? label : "";
      return;
    }

    var save = e.target.closest &&
      e.target.closest("#bk-mood-save-v56j");

    if (save) {
      var selected = pendingMood || pressedMood();

      if (KNOWN_MOODS[selected]) {
        writeCustomMood(selected);

        setTimeout(function(){
          repairOriginalMood(selected);
          renderMoodPill();
        },60);
      }
      return;
    }

    var skip = e.target.closest &&
      e.target.closest("#bk-mood-skip-v56j");

    if (skip) {
      writeCustomMood("Skipped");
      setTimeout(renderMoodPill,60);
    }
  },true);

  /* =====================================================
     PATCH 09C — BACCI PAUSE VIDEO PLAYER
  ===================================================== */
  function pauseVideo(){
    clearTimeout(videoStopTimer);
    videoStopTimer = null;

    var video = by("bk-pause-video-v56l");
    if (!video) return;

    try{
      video.pause();
      video.currentTime = 0;
    }catch(e){}
  }

  function updateVideoStatus(text){
    var status = by("bk-pause-video-status-v56l");
    if (status) status.textContent = text;
  }

  function setSoundButtons(mode){
    var quiet = by("bk-pause-quiet-v56l");
    var music = by("bk-pause-music-v56l");

    if (quiet) {
      quiet.setAttribute(
        "aria-pressed",
        mode === "quiet" ? "true" : "false"
      );
    }

    if (music) {
      music.setAttribute(
        "aria-pressed",
        mode === "music" ? "true" : "false"
      );
    }
  }

  function changeVideoSource(mode, preservePlayback){
    var video = by("bk-pause-video-v56l");
    if (!video || reducedMotion()) return;

    var wasPlaying = preservePlayback && !video.paused;
    var current = 0;

    try{
      current = video.currentTime || 0;
      video.pause();
    }catch(e){}

    video.src = mode === "music"
      ? MUSIC_VIDEO
      : QUIET_VIDEO;

    video.muted = mode !== "music";
    video.dataset.mode = mode;
    video.load();
    setSoundButtons(mode);

    updateVideoStatus(
      mode === "music"
        ? "Soft Music selected · press Begin Pause"
        : "Quiet selected · press Begin Pause"
    );

    video.addEventListener(
      "loadedmetadata",
      function restore(){
        try{
          if (
            current > 0 &&
            isFinite(video.duration) &&
            video.duration > 0
          ) {
            video.currentTime = Math.min(
              current,
              Math.max(0,video.duration - .1)
            );
          }

          if (wasPlaying) {
            var promise = video.play();
            if (promise && promise.catch) {
              promise.catch(function(){});
            }
          }
        }catch(e){}
      },
      {once:true}
    );
  }

  function beginPauseVideo(){
    var video = by("bk-pause-video-v56l");
    if (!video || reducedMotion()) return;

    clearTimeout(videoStopTimer);

    try{
      if (
        video.ended ||
        (
          isFinite(video.duration) &&
          video.currentTime >= video.duration - .1
        )
      ) {
        video.currentTime = 0;
      }

      var promise = video.play();

      if (promise && promise.catch) {
        promise.catch(function(){
          updateVideoStatus(
            "Press Begin Pause again if your browser blocked playback"
          );
        });
      }

      updateVideoStatus(
        video.dataset.mode === "music"
          ? "Playing with Soft Music"
          : "Playing Quiet"
      );
    }catch(e){}

    videoStopTimer = setTimeout(function(){
      try{
        video.pause();
      }catch(e){}

      updateVideoStatus(
        "Pause complete · return whenever you are ready"
      );
    },30000);
  }

  function decoratePausePlayer(){
    var card = by("bk-pause-card-v56k");
    if (!card || by("bk-pause-media-v56l")) return;

    var oldImage = qs(":scope > img",card);
    if (oldImage) oldImage.style.display = "none";

    var media = document.createElement("div");
    media.id = "bk-pause-media-v56l";
    media.innerHTML =
      '<video id="bk-pause-video-v56l" playsinline preload="metadata" poster="' +
        PAUSE_POSTER +
      '" aria-label="Animated Bacci breathing guide"></video>' +
      '<img id="bk-pause-poster-v56l" src="' +
        PAUSE_POSTER +
      '" alt="Bacci sitting calmly in meditation">' +
      '<span id="bk-pause-video-status-v56l">Quiet selected · press Begin Pause</span>';

    var sound = document.createElement("div");
    sound.id = "bk-pause-sound-v56l";
    sound.setAttribute(
      "role",
      "group"
    );
    sound.setAttribute(
      "aria-label",
      "Bacci Pause sound choice"
    );
    sound.innerHTML =
      '<button id="bk-pause-quiet-v56l" type="button" aria-pressed="true">🔇 Quiet</button>' +
      '<button id="bk-pause-music-v56l" type="button" aria-pressed="false">🎵 Soft Music</button>';

    var note = document.createElement("p");
    note.id = "bk-pause-media-note-v56l";
    note.textContent =
      "Video begins only after you press Begin Pause. It does not loop. Keep your eyes open and breathe normally if that feels better.";

    var kicker = qs(".kicker",card);

    if (kicker) {
      card.insertBefore(media,kicker);
      card.insertBefore(sound,kicker);
      card.insertBefore(note,kicker);
    } else {
      card.insertBefore(media,card.firstChild);
      card.insertBefore(sound,media.nextSibling);
      card.insertBefore(note,sound.nextSibling);
    }

    var video = by("bk-pause-video-v56l");
    video.src = QUIET_VIDEO;
    video.muted = true;
    video.loop = false;
    video.autoplay = false;
    video.dataset.mode = "quiet";

    by("bk-pause-quiet-v56l").addEventListener(
      "click",
      function(){
        changeVideoSource("quiet",true);
      }
    );

    by("bk-pause-music-v56l").addEventListener(
      "click",
      function(){
        changeVideoSource("music",true);
      }
    );

    var start = by("bk-pause-start-v56k");
    if (start) {
      start.addEventListener(
        "click",
        beginPauseVideo,
        true
      );
    }

    var close = by("bk-pause-close-v56k");
    if (close) {
      close.addEventListener(
        "click",
        pauseVideo,
        true
      );
    }

    var overlay = by("bk-pause-overlay-v56k");

    if (overlay && "MutationObserver" in window) {
      new MutationObserver(function(){
        if (overlay.classList.contains("open")) {
          pauseVideo();
          changeVideoSource("quiet",false);
        } else {
          pauseVideo();
        }
      }).observe(overlay,{
        attributes:true,
        attributeFilter:["class"]
      });
    }
  }

  /* =====================================================
     PATCH 09D — TOP RHINO STUDIO CHIME
     The floating Music Studio is already handled by Patch 08.
  ===================================================== */
  function braveSoundOn(){
    var sound = by("bk-sound");
    return !!(
      sound &&
      sound.getAttribute("aria-pressed") === "true"
    );
  }

  function studioChime(){
    if (!braveSoundOn()) return;

    try{
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return;

      studioAudioContext =
        studioAudioContext ||
        new AC();

      if (studioAudioContext.state === "suspended") {
        studioAudioContext.resume().catch(function(){});
      }

      var start = studioAudioContext.currentTime + .006;
      var master = studioAudioContext.createGain();

      master.gain.setValueAtTime(.0001,start);
      master.gain.exponentialRampToValueAtTime(.026,start + .025);
      master.gain.exponentialRampToValueAtTime(.0001,start + .5);
      master.connect(studioAudioContext.destination);

      [
        {f:523.25,d:0,l:.8},
        {f:783.99,d:.08,l:.55},
        {f:1046.5,d:.16,l:.36}
      ].forEach(function(item){
        var osc = studioAudioContext.createOscillator();
        var gain = studioAudioContext.createGain();

        osc.type = "sine";
        osc.frequency.setValueAtTime(
          item.f,
          start + item.d
        );

        gain.gain.setValueAtTime(.0001,start + item.d);
        gain.gain.exponentialRampToValueAtTime(
          .024 * item.l,
          start + item.d + .02
        );
        gain.gain.exponentialRampToValueAtTime(
          .0001,
          start + item.d + .36
        );

        osc.connect(gain);
        gain.connect(master);
        osc.start(start + item.d);
        osc.stop(start + item.d + .4);
      });
    }catch(e){}
  }

  function wireTopStudioChime(){
    qsa("a,button,[role='button']").forEach(function(el){
      if (
        el.classList.contains("bk-v55s-studio-dock") ||
        el.dataset.bkTopStudioChimeV56L === "true"
      ) {
        return;
      }

      var text = cleanText(el).toLowerCase();

      if (
        text.indexOf("sound + color studio") === -1
      ) {
        return;
      }

      el.dataset.bkTopStudioChimeV56L = "true";

      el.addEventListener(
        "pointerdown",
        studioChime,
        {passive:true}
      );

      el.addEventListener(
        "keydown",
        function(e){
          if (e.key === "Enter" || e.key === " ") {
            studioChime();
          }
        }
      );
    });
  }

  /* =====================================================
     PATCH 09E — INITIALIZE + REDRAW PROTECTION
  ===================================================== */
  function enforce(){
    renderMoodPill();
    decoratePausePlayer();
    wireTopStudioChime();
  }

  function start(){
    enforce();

    var pill = by("bk-mood-pill-v56j");

    if (pill && "MutationObserver" in window) {
      new MutationObserver(function(){
        if (!pillObserverBusy) {
          requestAnimationFrame(renderMoodPill);
        }
      }).observe(pill,{
        childList:true,
        subtree:true,
        characterData:true
      });
    }

    if ("MutationObserver" in window) {
      new MutationObserver(function(){
        decoratePausePlayer();
        wireTopStudioChime();
      }).observe(document.documentElement,{
        childList:true,
        subtree:true
      });
    }

    window.addEventListener("pageshow",renderMoodPill);

    setTimeout(enforce,300);
    setTimeout(enforce,900);
    setTimeout(enforce,1800);
    setTimeout(enforce,3500);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {once:true}
    );
  } else {
    start();
  }
})();

/* END BACCI KID BRAVE REPAIR PATCH 09
MOOD PILL LABEL REPAIR + BACCI PAUSE VIDEO PLAYER
========================================================= */






/* =========================================================
BACCI KID BRAVE REPAIR PATCH 10
MOOD PILL FINAL POLISH + TOOLTIP CLEANUP + MUSIC WORDING
Version: v56M
Date: 2026-07-23

SEARCH HEADER:
BACCI KID BRAVE REPAIR PATCH 10

INSTALLATION:
Keep Patches 01 through 09.
Paste this Patch 10 underneath Patch 09 at the absolute bottom
of Assets/bacci-brave.js.

WHAT THIS PATCH DOES:
1. Permanently fixes the Mood pill's visible presentation.
2. The pill displays only:
   💗 Mood check
   💗 Bright
   💗 Okay
   💗 Low
   💗 Heavy
   💗 Not sure
   💗 Mood saved
   💗 Skipped
3. Removes "Change" from inside the pill.
4. On desktop hover/focus, a custom bubble above the pill says:
   "Click to change mood"
5. Removes native black browser tooltips from:
   - Glow Journey
   - WorldGlow Lab
   - the Mood pill
6. Renames "Soft Music" to:
   "Uplifting Bacci Music"
7. Clarifies that Quiet is the calm default and the Bacci theme
   is an optional, more energetic soundtrack.
8. Rewrites the Not sure response:
   "Noticing 'not sure' is a strong check-in."
9. Keeps mood icons consistent between visits; it does not rotate them.
10. Does not alter coloring, Paint Set, video playback, mood storage,
    storybook, Hype, navigation, or previous repair logic.

SAFE REMOVAL:
Delete this entire titled block only.
========================================================= */
(function(){
  if (window.BacciBraveRepairPatch10FinalPolishV56M) return;
  window.BacciBraveRepairPatch10FinalPolishV56M = true;

  var CUSTOM_MOOD_KEY = "bk_v56l_mood_label";
  var ORIGINAL_MOOD_KEY = "bk_v46_brave_mood_check";
  var pendingMood = "";
  var queued = false;

  var KNOWN = {
    "Bright":true,
    "Okay":true,
    "Low":true,
    "Heavy":true,
    "Not sure":true
  };

  function by(id){
    return document.getElementById(id);
  }

  function qs(selector, scope){
    return (scope || document).querySelector(selector);
  }

  function qsa(selector, scope){
    return Array.prototype.slice.call(
      (scope || document).querySelectorAll(selector)
    );
  }

  function normalized(label){
    label = (label || "").replace(/\s+/g," ").trim();

    if (KNOWN[label]) return label;
    if (/skip/i.test(label)) return "Skipped";
    if (/mood noticed/i.test(label)) return "Mood saved";
    if (/mood saved/i.test(label)) return "Mood saved";
    return "";
  }

  function readMood(){
    try{
      var custom = normalized(
        sessionStorage.getItem(CUSTOM_MOOD_KEY) || ""
      );
      if (custom) return custom;
    }catch(e){}

    try{
      var stored = JSON.parse(
        sessionStorage.getItem(ORIGINAL_MOOD_KEY) || "null"
      );
      if (stored && stored.label) {
        return normalized(stored.label);
      }
    }catch(e){}

    return "";
  }

  function writeMood(label){
    try{
      sessionStorage.setItem(CUSTOM_MOOD_KEY,label);
    }catch(e){}
  }

  /* =====================================================
     PATCH 10A — VISUAL STYLES
     The old pill children remain for compatibility but are hidden.
     The final visible label is rendered through data-bk-display.
  ===================================================== */
  var style = document.createElement("style");
  style.id = "bk-repair-10-final-polish-style";
  style.textContent = [
    "#bk-mood-pill-v56j{",
      "position:relative!important;",
      "display:inline-flex!important;",
      "align-items:center!important;",
      "justify-content:center!important;",
      "min-width:132px!important;",
      "width:auto!important;",
      "max-width:170px!important;",
      "overflow:visible!important;",
      "padding:12px 15px!important;",
      "white-space:nowrap!important;",
      "text-overflow:clip!important;",
    "}",

    "#bk-mood-pill-v56j > *{",
      "display:none!important;",
    "}",

    "#bk-mood-pill-v56j::before{",
      "content:attr(data-bk-display);",
      "display:block;",
      "max-width:100%;",
      "overflow:hidden;",
      "text-overflow:ellipsis;",
      "white-space:nowrap;",
      "font-family:Fredoka,'Baloo 2',system-ui,sans-serif;",
      "font-size:calc(13px*var(--fs));",
      "font-weight:850;",
      "line-height:1;",
      "color:inherit;",
    "}",

    "#bk-mood-pill-v56j::after{",
      "content:attr(data-bk-tooltip);",
      "position:absolute;",
      "left:10px;",
      "bottom:calc(100% + 9px);",
      "z-index:2147483400;",
      "display:block;",
      "width:max-content;",
      "max-width:190px;",
      "padding:7px 10px;",
      "border:2px solid rgba(255,111,191,.5);",
      "border-radius:12px;",
      "background:linear-gradient(135deg,#fff,#fff2f9 60%,#eaffff);",
      "box-shadow:0 11px 26px rgba(73,43,135,.22);",
      "font-family:Fredoka,system-ui,sans-serif;",
      "font-size:11px;",
      "font-weight:800;",
      "line-height:1.2;",
      "color:#5c427f;",
      "white-space:normal;",
      "text-align:center;",
      "opacity:0;",
      "visibility:hidden;",
      "pointer-events:none;",
      "transform:translateY(5px) scale(.96);",
      "transition:opacity .16s ease,transform .18s ease,visibility .16s ease;",
    "}",

    "#bk-mood-pill-v56j:hover::after,",
    "#bk-mood-pill-v56j:focus-visible::after{",
      "opacity:1;",
      "visibility:visible;",
      "transform:translateY(0) scale(1);",
    "}",

    "#bk-mood-pill-v56j[aria-expanded='true']::after{",
      "display:none!important;",
    "}",

    "#bk-pause-music-v56l{",
      "min-width:190px;",
    "}",

    "@media(max-width:1100px){",
      "#bk-mood-pill-v56j{",
        "min-width:118px!important;",
        "max-width:146px!important;",
        "padding-left:12px!important;",
        "padding-right:12px!important;",
      "}",
    "}",

    "@media(max-width:767px){",
      "#bk-mood-pill-v56j{",
        "min-width:106px!important;",
        "max-width:126px!important;",
      "}",
      "#bk-mood-pill-v56j::before{font-size:12px;}",
      "#bk-mood-pill-v56j::after{display:none!important;}",
      "#bk-pause-music-v56l{min-width:0;width:100%;}",
    "}",

    "@media(prefers-reduced-motion:reduce){",
      "#bk-mood-pill-v56j::after{transition:none!important;}",
    "}"
  ].join("");
  document.head.appendChild(style);

  /* =====================================================
     PATCH 10B — FINAL MOOD PILL DISPLAY
  ===================================================== */
  function applyMoodPill(){
    var pill = by("bk-mood-pill-v56j");
    if (!pill) return;

    var mood = readMood();
    var display = mood
      ? "💗 " + mood
      : "💗 Mood check";

    var tooltip = mood
      ? "Click to change mood"
      : "Optional mood check";

    if (pill.dataset.bkDisplay !== display) {
      pill.dataset.bkDisplay = display;
    }

    if (pill.dataset.bkTooltip !== tooltip) {
      pill.dataset.bkTooltip = tooltip;
    }

    pill.removeAttribute("title");

    pill.setAttribute(
      "aria-label",
      mood
        ? "Current mood " + mood + ". Open to change mood."
        : "Open optional mood check."
    );
  }

  document.addEventListener("click",function(e){
    var option = e.target.closest &&
      e.target.closest("#bk-mood-options-v56j button");

    if (option) {
      var label = option.dataset.label || "";
      pendingMood = KNOWN[label] ? label : "";
      return;
    }

    if (
      e.target.closest &&
      e.target.closest("#bk-mood-save-v56j")
    ) {
      if (pendingMood) {
        writeMood(pendingMood);
      }

      setTimeout(applyMoodPill,40);
      setTimeout(applyMoodPill,180);
      return;
    }

    if (
      e.target.closest &&
      e.target.closest("#bk-mood-skip-v56j")
    ) {
      writeMood("Skipped");
      setTimeout(applyMoodPill,40);
    }
  },true);

  /* =====================================================
     PATCH 10C — REMOVE NATIVE BLACK TOOLTIPS
  ===================================================== */
  function removeNativeTooltips(){
    [
      by("bk-glow-journey-final-v56g"),
      by("bk-v47-word-btn"),
      by("bk-mood-pill-v56j")
    ].forEach(function(el){
      if (el) el.removeAttribute("title");
    });

    qsa("a[title],button[title],[role='button'][title]").forEach(
      function(el){
        var text = (el.textContent || "")
          .replace(/\s+/g," ")
          .trim()
          .toLowerCase();

        if (
          text.indexOf("glow journey") !== -1 ||
          text.indexOf("worldglow lab") !== -1
        ) {
          el.removeAttribute("title");
        }
      }
    );
  }

  /* =====================================================
     PATCH 10D — ACCURATE MUSIC WORDING
  ===================================================== */
  function polishMusicWording(){
    var button = by("bk-pause-music-v56l");
    var status = by("bk-pause-video-status-v56l");
    var note = by("bk-pause-media-note-v56l");

    if (button) {
      button.textContent = "🎵 Uplifting Bacci Music";
      button.setAttribute(
        "aria-label",
        "Use optional uplifting Bacci Kid music"
      );
    }

    if (status && /soft music/i.test(status.textContent || "")) {
      status.textContent = (status.textContent || "")
        .replace(
          /Soft Music/gi,
          "Uplifting Bacci Music"
        );
    }

    if (note) {
      note.textContent =
        "Quiet is the calm default. Uplifting Bacci Music is an optional, more energetic Bacci Kid soundtrack. Video begins only after Begin Pause and does not loop.";
    }
  }

  document.addEventListener("click",function(e){
    if (
      e.target.closest &&
      e.target.closest("#bk-pause-music-v56l")
    ) {
      setTimeout(polishMusicWording,0);
      setTimeout(polishMusicWording,120);
    }
  });

  /* =====================================================
     PATCH 10E — REFLECTIVE NOT-SURE WORDING
  ===================================================== */
  function applyNotSureCopy(){
    var title = by("bk-mood-support-title-v56j");
    var copy = by("bk-mood-support-copy-v56j");

    if (title) {
      title.textContent =
        "Noticing “not sure” is a strong check-in.";
    }

    if (copy) {
      copy.textContent =
        "The feeling does not need a name yet. You can explore a color, take a pause, or simply observe what is here.";
    }
  }

  document.addEventListener("click",function(e){
    var option = e.target.closest &&
      e.target.closest(
        "#bk-mood-options-v56j button[data-label='Not sure']"
      );

    if (!option) return;

    setTimeout(applyNotSureCopy,0);
    setTimeout(applyNotSureCopy,100);
  });

  /* =====================================================
     PATCH 10F — ENFORCE AFTER OLDER REDRAWS
  ===================================================== */
  function enforce(){
    applyMoodPill();
    removeNativeTooltips();
    polishMusicWording();

    var pressed = qs(
      "#bk-mood-options-v56j button[data-label='Not sure'][aria-pressed='true']"
    );

    if (pressed) {
      applyNotSureCopy();
    }
  }

  function schedule(){
    if (queued) return;
    queued = true;

    requestAnimationFrame(function(){
      queued = false;
      enforce();
    });
  }

  function start(){
    enforce();

    if ("MutationObserver" in window) {
      new MutationObserver(schedule).observe(
        document.documentElement,
        {
          childList:true,
          subtree:true,
          characterData:true,
          attributes:true,
          attributeFilter:[
            "title",
            "aria-pressed",
            "aria-expanded"
          ]
        }
      );
    }

    window.addEventListener("pageshow",schedule);

    setTimeout(enforce,300);
    setTimeout(enforce,900);
    setTimeout(enforce,1800);
    setTimeout(enforce,3500);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      start,
      {once:true}
    );
  } else {
    start();
  }
})();

/* END BACCI KID BRAVE REPAIR PATCH 10
MOOD PILL FINAL POLISH + TOOLTIP CLEANUP + MUSIC WORDING
========================================================= */





/* =========================================================
BACCI KID BRAVE REPAIR PATCH 12
MOBILE RESCUE — UNIFIED WONDERDOCK + MORE SHEET
Version: v57A
Date: 2026-07-29

INSTALLATION:
Keep Patches 01 through 10. Paste this entire Patch 12 block
at the absolute bottom of Assets/bacci-brave.js.

PROTECTED:
This patch does not change the canvas, Paint Set, color-fill
engine, undo history, saved artwork, certificate, museum data,
Story Pod, Living Book content, or localStorage keys.

SAFE REMOVAL:
Delete this entire titled JS block and the matching Patch 12
CSS block.
========================================================= */
(function(){
  "use strict";

  if (window.BacciBraveMobileRescueV57A) return;
  window.BacciBraveMobileRescueV57A = true;

  var root = document.getElementById("bk-hx");
  if (!root) return;

  var html = document.documentElement;
  var body = document.body;
  var mobileQuery = window.matchMedia ?
    window.matchMedia("(max-width: 767px)") :
    null;

  var sheet = null;
  var panel = null;
  var trigger = null;
  var previousFocus = null;
  var previousBodyOverflow = "";
  var observerQueued = false;

  var ROUTES = {
    studio: "/pages/bacci-kid-sound-color-studio",
    glow: "/pages/worldglow-lab"
  };

  function isMobile(){
    return mobileQuery ? mobileQuery.matches : window.innerWidth <= 767;
  }

  function isTextEntry(element){
    if (!element) return false;

    var tag = String(element.tagName || "").toLowerCase();

    return (
      tag === "input" ||
      tag === "textarea" ||
      tag === "select" ||
      element.isContentEditable === true
    );
  }

  function setPageMode(){
    var active = isMobile();

    html.classList.toggle("bk-mobile-rescue-v57",active);
    body.classList.toggle("bk-brave-mobile-rescue-v57",active);

    if (!active) {
      closeMore(false);
      html.classList.remove(
        "bk-mobile-more-open-v57",
        "bk-mobile-keyboard-open-v57"
      );
    }

    wireDock();
  }

  function actionMarkup(action,icon,title,note){
    return (
      '<button type="button" class="bk-v57-more-action" data-bk-v57-action="' +
      action +
      '">' +
        '<span class="bk-v57-more-icon" aria-hidden="true">' +
        icon +
        '</span>' +
        '<span class="bk-v57-more-copy">' +
          '<strong data-bk-v57-title="' +
          action +
          '">' +
          title +
          '</strong>' +
          '<small>' +
          note +
          '</small>' +
        '</span>' +
      '</button>'
    );
  }

  function buildMore(){
    if (sheet) return sheet;

    sheet = document.createElement("div");
    sheet.id = "bk-mobile-more-v57";
    sheet.className = "bk-mobile-more-v57";
    sheet.hidden = true;
    sheet.setAttribute("aria-hidden","true");

    sheet.innerHTML =
      '<button class="bk-v57-more-scrim" type="button" ' +
        'data-bk-v57-close aria-label="Close More controls"></button>' +
      '<section class="bk-v57-more-panel" role="dialog" aria-modal="true" ' +
        'aria-labelledby="bk-v57-more-title" tabindex="-1">' +
        '<header class="bk-v57-more-head">' +
          '<div>' +
            '<p>Bacci Brave controls</p>' +
            '<h2 id="bk-v57-more-title">More</h2>' +
          '</div>' +
          '<button class="bk-v57-more-close" type="button" ' +
            'data-bk-v57-close aria-label="Close More controls">×</button>' +
        '</header>' +
        '<div class="bk-v57-more-grid">' +
          actionMarkup("mood","💗","Mood Check","Optional check-in") +
          actionMarkup("sound","🔇","Sound Off","Bacci page sounds") +
          actionMarkup("studio","🎧","Sound + Color","Open the Studio") +
          actionMarkup("glow","✨","Glow Journey","Open WorldGlow Lab") +
          actionMarkup("hype","📣","Hype Crew","Request encouragement") +
          actionMarkup("language","🌏","한국어","English and Korean") +
          actionMarkup("motion","✦","Motion","Calm, standard, immersive") +
          actionMarkup("text","🔠","Text Size","Standard, large, extra large") +
          actionMarkup("comfort","💧","Comfort Break","Pause at your pace") +
          actionMarkup("night","🌙","Warm Night","Softer appearance") +
          actionMarkup("top","↑","Back to Top","Return to the beginning") +
          actionMarkup("trust","🛡️","Trust & Sources","Privacy and safety notes") +
        '</div>' +
      '</section>';

    body.appendChild(sheet);
    panel = sheet.querySelector(".bk-v57-more-panel");

    sheet.addEventListener("click",function(event){
      var closeButton = event.target.closest &&
        event.target.closest("[data-bk-v57-close]");

      if (closeButton) {
        closeMore(true);
        return;
      }

      var actionButton = event.target.closest &&
        event.target.closest("[data-bk-v57-action]");

      if (!actionButton) return;

      runAction(actionButton.getAttribute("data-bk-v57-action"));
    });

    document.addEventListener("keydown",function(event){
      if (!sheet || sheet.hidden) return;

      if (event.key === "Escape") {
        event.preventDefault();
        closeMore(true);
        return;
      }

      if (event.key !== "Tab") return;

      var focusables = Array.prototype.slice.call(
        panel.querySelectorAll(
          'button:not([disabled]),a[href],input:not([disabled]),' +
          'select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
        )
      ).filter(function(element){
        return element.offsetParent !== null;
      });

      if (!focusables.length) {
        event.preventDefault();
        panel.focus();
        return;
      }

      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    });

    return sheet;
  }

  function openMore(){
    if (!isMobile()) return;

    buildMore();
    syncMoreLabels();

    previousFocus = document.activeElement;
    previousBodyOverflow = body.style.overflow || "";

    sheet.hidden = false;
    sheet.setAttribute("aria-hidden","false");
    html.classList.add("bk-mobile-more-open-v57");
    body.style.overflow = "hidden";

    if (trigger) {
      trigger.setAttribute("aria-expanded","true");
    }

    window.setTimeout(function(){
      if (panel) panel.focus({preventScroll:true});
    },20);
  }

  function closeMore(restoreFocus){
    if (!sheet || sheet.hidden) return;

    sheet.hidden = true;
    sheet.setAttribute("aria-hidden","true");
    html.classList.remove("bk-mobile-more-open-v57");
    body.style.overflow = previousBodyOverflow;

    if (trigger) {
      trigger.setAttribute("aria-expanded","false");
    }

    if (
      restoreFocus &&
      previousFocus &&
      document.contains(previousFocus)
    ) {
      previousFocus.focus({preventScroll:true});
    }
  }

  function activateOriginal(selector,after){
    var element = document.querySelector(selector);

    closeMore(false);

    window.setTimeout(function(){
      if (element && typeof element.click === "function") {
        element.click();
      }

      if (typeof after === "function") {
        after(element);
      }

      window.setTimeout(syncMoreLabels,80);
    },70);
  }

  function scrollToElement(element){
    if (!element) return;

    element.scrollIntoView({
      behavior: (
        window.matchMedia &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ) ? "auto" : "smooth",
      block: "start"
    });
  }

  function runAction(action){
    switch(action){
      case "mood":
        var moodButton = document.getElementById("bk-mood-pill-v56j");

        if (moodButton) {
          activateOriginal("#bk-mood-pill-v56j");
        } else {
          closeMore(false);
          scrollToElement(document.getElementById("bk-mood"));
        }
        break;

      case "sound":
        activateOriginal("#bk-sound");
        break;

      case "studio":
        closeMore(false);
        window.location.href = ROUTES.studio;
        break;

      case "glow":
        closeMore(false);
        window.location.href = ROUTES.glow;
        break;

      case "hype":
        activateOriginal("#bk-hx .bk-hypebtn");
        break;

      case "language":
        activateOriginal("#bk-langtoggle");
        break;

      case "motion":
        activateOriginal("#bk-motiontoggle");
        break;

      case "text":
        activateOriginal("#bk-v50-text");
        break;

      case "comfort":
        activateOriginal("#bk-v50-comfort-open");
        break;

      case "night":
        activateOriginal("#bk-v50-night");
        break;

      case "top":
        closeMore(false);
        window.scrollTo({
          top:0,
          left:0,
          behavior: (
            window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ) ? "auto" : "smooth"
        });
        break;

      case "trust":
        var trust = document.getElementById("bk-v47-trust-btn") ||
          document.getElementById("bk-v47-trustbar-open");

        if (trust) {
          closeMore(false);
          window.setTimeout(function(){ trust.click(); },70);
        } else {
          closeMore(false);
          scrollToElement(document.getElementById("bk-disc"));
        }
        break;
    }
  }

  function cleanLabel(element,fallback){
    if (!element) return fallback;

    var text = String(element.textContent || "")
      .replace(/\s+/g," ")
      .trim();

    return text || fallback;
  }

  function setMoreTitle(action,label){
    if (!sheet) return;

    var title = sheet.querySelector(
      '[data-bk-v57-title="' + action + '"]'
    );

    if (title && title.textContent !== label) {
      title.textContent = label;
    }
  }

  function syncMoreLabels(){
    if (!sheet) return;

    var sound = document.getElementById("bk-sound");
    var soundOn = !!(
      sound &&
      sound.getAttribute("aria-pressed") === "true"
    );

    setMoreTitle(
      "sound",
      soundOn ? "Sound On" : "Sound Off"
    );

    var language = document.getElementById("bk-langtoggle");
    var languageLabel = language &&
      language.querySelector(".lbl");

    setMoreTitle(
      "language",
      cleanLabel(languageLabel,"한국어")
    );

    var motion = document.getElementById("bk-motiontoggle");
    setMoreTitle(
      "motion",
      cleanLabel(motion,"Motion")
    );

    var text = document.getElementById("bk-v50-text");
    setMoreTitle(
      "text",
      cleanLabel(text,"Text Size")
    );

    var night = document.getElementById("bk-v50-night");
    setMoreTitle(
      "night",
      (
        night &&
        night.getAttribute("aria-pressed") === "true"
      ) ? "Warm Night On" : "Warm Night"
    );
  }

  function decorateDockButton(button,icon,label){
    if (!button) return;

    var signature = icon + "|" + label;

    if (button.dataset.bkV57Label === signature) return;

    button.dataset.bkV57Label = signature;
    button.innerHTML =
      '<span class="bk-v57-dock-icon" aria-hidden="true">' +
      icon +
      '</span>' +
      '<span class="bk-v57-dock-label">' +
      label +
      '</span>';
  }

  function wireDock(){
    var dock = document.getElementById("bk-v46-dock");
    if (!dock) return;

    decorateDockButton(
      dock.querySelector('[data-go="color"]'),
      "🎨",
      "Color"
    );

    decorateDockButton(
      dock.querySelector('[data-go="story"]'),
      "📖",
      "Story"
    );

    decorateDockButton(
      dock.querySelector('[data-go="museum"]'),
      "🏛",
      "Museum"
    );

    trigger = dock.querySelector('[data-go="tools"]');

    if (!trigger) return;

    decorateDockButton(trigger,"☰","More");

    if (trigger.getAttribute("aria-haspopup") !== "dialog") {
      trigger.setAttribute("aria-haspopup","dialog");
    }

    if (
      trigger.getAttribute("aria-controls") !==
      "bk-mobile-more-v57"
    ) {
      trigger.setAttribute(
        "aria-controls",
        "bk-mobile-more-v57"
      );
    }

    if (!trigger.hasAttribute("aria-expanded")) {
      trigger.setAttribute("aria-expanded","false");
    }

    if (dock.dataset.bkV57Wired === "true") return;
    dock.dataset.bkV57Wired = "true";

    dock.addEventListener("click",function(event){
      var more = event.target.closest &&
        event.target.closest('[data-go="tools"]');

      if (!more || !isMobile()) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      openMore();
    },true);
  }

  function updateKeyboardState(){
    if (!isMobile()) {
      html.classList.remove("bk-mobile-keyboard-open-v57");
      return;
    }

    var open = isTextEntry(document.activeElement);

    html.classList.toggle(
      "bk-mobile-keyboard-open-v57",
      open
    );

    if (open) closeMore(false);
  }

  function scheduleRefresh(){
    if (observerQueued) return;
    observerQueued = true;

    window.requestAnimationFrame(function(){
      observerQueued = false;
      setPageMode();
      syncMoreLabels();
    });
  }

  buildMore();
  setPageMode();
  syncMoreLabels();

  document.addEventListener("focusin",updateKeyboardState);
  document.addEventListener("focusout",function(){
    window.setTimeout(updateKeyboardState,80);
  });

  window.addEventListener("resize",scheduleRefresh);
  window.addEventListener("orientationchange",scheduleRefresh);
  window.addEventListener("pageshow",scheduleRefresh);

  if (window.visualViewport) {
    window.visualViewport.addEventListener(
      "resize",
      updateKeyboardState
    );
  }

  if (mobileQuery) {
    if (typeof mobileQuery.addEventListener === "function") {
      mobileQuery.addEventListener("change",scheduleRefresh);
    } else if (typeof mobileQuery.addListener === "function") {
      mobileQuery.addListener(scheduleRefresh);
    }
  }

  if ("MutationObserver" in window) {
    new MutationObserver(scheduleRefresh).observe(
      root,
      {
        childList:true,
        subtree:true,
        attributes:true,
        attributeFilter:[
          "aria-pressed",
          "aria-expanded",
          "class"
        ]
      }
    );
  }

  window.setTimeout(scheduleRefresh,300);
  window.setTimeout(scheduleRefresh,900);
  window.setTimeout(scheduleRefresh,1800);
})();

/* END BACCI KID BRAVE REPAIR PATCH 12
MOBILE RESCUE — UNIFIED WONDERDOCK + MORE SHEET
========================================================= */




/* =========================================================
BACCI KID BRAVE REPAIR PATCH 12.1
MORE SHEET CLOSE + SCROLL UNLOCK REPAIR
Version: v57B
Date: 2026-08-01

INSTALLATION:
Keep Patch 12. Paste this entire block at the absolute bottom
of Assets/bacci-brave.js, underneath Patch 12.

WHAT THIS REPAIRS:
- X button closes the mobile More sheet.
- Backdrop tap closes the sheet.
- Escape closes the sheet.
- Page scrolling is restored.
- Focus returns to the More button.
- Reopening the sheet still works.
- Duplicate close events cannot lock the page.

PROTECTED:
No canvas, Paint Set, fill engine, saved art, certificate,
museum, mood, Story Pod, Living Book, or localStorage changes.

SAFE REMOVAL:
Delete this entire titled block only.
========================================================= */
(function(){
  "use strict";

  if (window.BacciBravePatch121MoreCloseV57B) return;
  window.BacciBravePatch121MoreCloseV57B = true;

  var html = document.documentElement;
  var body = document.body;
  var mobileQuery = window.matchMedia ?
    window.matchMedia("(max-width: 767px)") : null;

  function isMobile(){
    return mobileQuery ? mobileQuery.matches : window.innerWidth <= 767;
  }

  function getSheet(){
    return document.getElementById("bk-mobile-more-v57");
  }

  function getTrigger(){
    var dock = document.getElementById("bk-v46-dock");
    return dock ? dock.querySelector('[data-go="tools"]') : null;
  }

  function rememberScrollState(){
    if (!body.dataset.bkV57bPreviousOverflow) {
      body.dataset.bkV57bPreviousOverflow = body.style.overflow || "";
    }
  }

  function prepareToOpen(){
    var sheet = getSheet();
    if (!sheet) return;

    rememberScrollState();

    sheet.style.removeProperty("display");
    sheet.style.removeProperty("visibility");
    sheet.style.removeProperty("opacity");
    sheet.style.removeProperty("pointer-events");
    sheet.classList.remove("bk-v57b-force-closed");
  }

  function forceClose(restoreFocus){
    var sheet = getSheet();
    var trigger = getTrigger();

    html.classList.remove("bk-mobile-more-open-v57");

    if (sheet) {
      sheet.hidden = true;
      sheet.setAttribute("aria-hidden","true");
      sheet.classList.add("bk-v57b-force-closed");
      sheet.style.setProperty("display","none","important");
      sheet.style.setProperty("visibility","hidden","important");
      sheet.style.setProperty("opacity","0","important");
      sheet.style.setProperty("pointer-events","none","important");
    }

    var previousOverflow = body.dataset.bkV57bPreviousOverflow;
    body.style.overflow =
      typeof previousOverflow === "string" ?
      previousOverflow :
      "";

    delete body.dataset.bkV57bPreviousOverflow;

    if (trigger) {
      trigger.setAttribute("aria-expanded","false");
    }

    if (
      restoreFocus &&
      trigger &&
      typeof trigger.focus === "function"
    ) {
      window.setTimeout(function(){
        try {
          trigger.focus({preventScroll:true});
        } catch(error) {
          trigger.focus();
        }
      },0);
    }
  }

  function isCloseControl(target){
    return !!(
      target &&
      target.closest &&
      target.closest(
        "#bk-mobile-more-v57 [data-bk-v57-close]"
      )
    );
  }

  function isMoreTrigger(target){
    return !!(
      target &&
      target.closest &&
      target.closest(
        '#bk-v46-dock [data-go="tools"]'
      )
    );
  }

  function onPointer(event){
    if (!isMobile()) return;

    if (isMoreTrigger(event.target)) {
      prepareToOpen();
      return;
    }

    if (!isCloseControl(event.target)) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    forceClose(true);
  }

  document.addEventListener(
    "pointerdown",
    onPointer,
    true
  );

  document.addEventListener(
    "click",
    onPointer,
    true
  );

  document.addEventListener(
    "touchend",
    onPointer,
    true
  );

  document.addEventListener("keydown",function(event){
    var sheet = getSheet();

    if (!sheet || sheet.hidden) return;

    if (event.key === "Escape") {
      event.preventDefault();
      event.stopImmediatePropagation();
      forceClose(true);
    }
  },true);

  window.addEventListener("pageshow",function(){
    var sheet = getSheet();

    if (sheet && sheet.hidden) {
      forceClose(false);
    }
  });

  window.addEventListener("resize",function(){
    if (!isMobile()) {
      forceClose(false);
    }
  });
})();

/* END BACCI KID BRAVE REPAIR PATCH 12.1
MORE SHEET CLOSE + SCROLL UNLOCK REPAIR
========================================================= */




/* =========================================================
BACCI KID BRAVE REPAIR PATCH 13B
COLOR HUB STORY HANDOFF + MOBILE STORY ROUTE
Version: v58B
Date: 2026-08-02

PURPOSE:
Keeps the Brave Color Hub focused on coloring while preserving
all story code for the separate BraveVerse Living Story page.
========================================================= */
(function(){
  "use strict";

  if (window.BacciBraveStoryHandoffV58B) return;
  window.BacciBraveStoryHandoffV58B = true;

  var STORY_URL = "/pages/bacci-kid-braveverse-living-story";
  var root = document.getElementById("bk-hx");
  if (!root) return;

  var storySelectors = [
    ".bk-v49-bookgate",
    "#bk-v50-comfort-panel",
    "#bk-book",
    "#bk-v50-dictionary",
    "#bk-v50-journal",
    "#bk-v50-branch-cta",
    "#bk-supreme",
    ".bk-supreme"
  ];

  function retireStoryBlocks(){
    root.querySelectorAll(storySelectors.join(",")).forEach(function(block){
      block.hidden = true;
      block.setAttribute("aria-hidden","true");

      block.querySelectorAll("video,audio").forEach(function(media){
        try {
          media.pause();
          media.removeAttribute("autoplay");
          media.removeAttribute("src");
          media.removeAttribute("data-src");
          media.load();
        } catch (error) {}
      });
    });
  }

  function updateColorHubLanguage(){
    var tagline = root.querySelector(".bk-tagline");

    if (tagline) {
      tagline.textContent =
        "Color the courage. Remix the look. Build your museum. A new Brave reveal lands every Tuesday.";
    }

    var nudge = root.querySelector(".bk-v45-nudge span");

    if (nudge) {
      nudge.textContent =
        "Pick one color and tap Bacci. Your world wakes up after your first brave click.";
    }

    var description =
      document.querySelector('meta[name="description"]');

    if (description) {
      description.setAttribute(
        "content",
        "Color Teen Bacci, explore creative palettes and finishes, save your art, and enter the Bacci Kid museum portals. A digital coloring experience by Dr. Jamie J. Karia, DSW, LCSW."
      );
    }
  }

  function wireStoryDoorway(){
    var storyButton =
      root.querySelector('#bk-v46-dock [data-go="story"]');

    if (
      !storyButton ||
      storyButton.dataset.bkStoryHandoff === "true"
    ) return;

    storyButton.dataset.bkStoryHandoff = "true";

    storyButton.setAttribute(
      "aria-label",
      "Open Bacci Kid BraveVerse Living Story"
    );

    storyButton.title =
      "Open the separate BraveVerse Living Story";

    storyButton.addEventListener(
      "click",
      function(event){
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(STORY_URL);
      },
      true
    );
  }

  function apply(){
    root.classList.remove(
      "bk-v49-story-mode",
      "bk-focuson"
    );

    retireStoryBlocks();
    updateColorHubLanguage();
    wireStoryDoorway();
  }

  apply();

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      apply,
      { once:true }
    );
  }

  if ("MutationObserver" in window) {
    new MutationObserver(function(){
      window.requestAnimationFrame(apply);
    }).observe(
      root,
      {
        childList:true,
        subtree:true
      }
    );
  }

  window.setTimeout(apply,300);
  window.setTimeout(apply,900);
  window.setTimeout(apply,1800);
})();

/* END BACCI KID BRAVE REPAIR PATCH 13B
COLOR HUB STORY HANDOFF + MOBILE STORY ROUTE
========================================================= */